/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Sklls API
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccessLevel,
  ActiveCaseDto,
  AddDialogStatisticCommand,
  AddScenarioCommand,
  AddUsersToGroupCommand,
  AdvanceStageDto,
  ApplyExerciseScheduleChangeDto,
  ApplyExerciseScheduleChangeResponseDto,
  ApplyPlaybookItemTimeChangeDto,
  ApplyPlaybookItemTimeChangeResponseDto,
  AttachmentDto,
  AudioResponseDto,
  Avatar,
  BackgroundSoundDto,
  BackgroundSoundsUploadBodyOne,
  BackgroundSoundsUploadBodyTwo,
  BulkRescheduleStoreProvisionalDialogStatisticRequest,
  CallerTurnRequest,
  CloneExerciseResponseDto,
  CompaniesFilterCompaniesParams,
  CompaniesSearchAgentCompaniesParams,
  CompanyDepartmentDto,
  CompanyDto,
  ConversationExportFilterDto,
  ConversationFeedback,
  ConvertFromSharedScenarioCommand,
  CopyScenarioCommand,
  CourseDto,
  CourseGetParams,
  CourseGetUserScheduledCourseResultsParams,
  CreateCompanyCommand,
  CreateCompanyDepartmentCommand,
  CreateCourseCommand,
  CreateEvaluationProtocolCategoryCommand,
  CreateEvaluationProtocolCommand,
  CreateEvaluationProtocolElementCommand,
  CreateExerciseContactDto,
  CreateExerciseDto,
  CreateGlobalAssetCategoryCommand,
  CreateGlobalAssetIntentCommand,
  CreateLicenseAgreementDto,
  CreateOrganizationInvitationCommand,
  CreatePersonaDto,
  CreatePlaybookItemDto,
  CreateRecordingEvaluationRunRequest,
  CreateRoleDto,
  CreateScheduledCallCommand,
  CreateScheduledCourseCommand,
  CreateScheduledCourseNotificationCommand,
  CreateSimulationDto,
  CreateUserGroupCommand,
  CreateVitalSimulationDto,
  DecisionSupportRequest,
  DecisionSupportResponse,
  DecisionSupportStructuredResponseDto,
  DeleteCompanyCommand,
  DeleteGlobalAssetCategoriesCommand,
  DeleteGlobalAssetIntentCommand,
  DeleteScheduledCallsCommand,
  DeleteUserGroupCommand,
  DeleteUsersFromGroupCommand,
  DepartmentInvitationDto,
  DialogFeedbackDto,
  DialogSessionInitSessionParams,
  DialogStatisticDto,
  DialogStatisticKpiDetailsDto,
  DialogStatisticsListDialogStatisticsServiceParams,
  DispatchAmbulanceDto,
  EditUserAudioSettingsCommand,
  EditUserCommand,
  EditUserProfileCommand,
  EndCallCommand,
  EvaluationDto,
  EvaluationProtocolCategoryDto,
  EvaluationProtocolDto,
  EvaluationProtocolElementDto,
  EvaluationProtocolUsageDto,
  ExerciseContactDto,
  ExerciseDto,
  Gender,
  GenerateMagicPersonaPromptCommand,
  GenerateMagicRolePromptCommand,
  GeneratePersonaSentenceRequestDto,
  GeneratePersonaSentenceResponseDto,
  GetLicenseUsageBatchRequest,
  GlobalAssetCategoryDto,
  GlobalAssetConnection,
  GlobalAssetFullDto,
  GlobalAssetIntentDto,
  GlobalAssetsCopyIntentToCompanyParams,
  GlobalAssetsImportDataBodyOne,
  GlobalAssetsImportDataBodyTwo,
  HuginAssistantChatFilterOptionsDto,
  HuginAssistantChatHistoryDto,
  HuginAssistantChatSessionListItemDto,
  HuginAssistantChatsAdminListSessionsParams,
  InitPersonaSessionCommand,
  InviteMultipleUsersCommand,
  JobStatusDto,
  JobStatusGetRecentJobsPagedParams,
  JobStatusGetRecentJobsParams,
  LicenseAgreementDto,
  LicenseAgreementsGetUsageParams,
  LicenseUsageDto,
  LlmUsageAdminSummaryDto,
  LlmUsageGetAdminRowsParams,
  LlmUsageGetAdminScopesParams,
  LlmUsageGetAdminSummaryParams,
  ModelLedEvaluationStrategySettings,
  ModelLedEvaluationStrategySimulationRequest,
  ModelLedEvaluationStrategySimulationResult,
  MonitorGetSessionsParams,
  MonitorSessionBundle,
  MonitorSessionPage,
  OperatorTurnResult,
  PagedResultDtoJobStatusDto,
  PagedResultDtoLlmUsageCostDto,
  PagedResultDtoLlmUsageScopeDto,
  PagedResultDtoPersonaSearchItemDto,
  PagedResultDtoRecordingListItemDto,
  PagedResultDtoScenarioSearchItemDto,
  PartialListCourseDto,
  PartialListDialogStatisticDto,
  PartialListScheduledCallDto,
  PartialListUserGroupDto,
  PersonaAudioResponse,
  PersonaCompanyAccessDto,
  PersonaCompanyAccessInfoDto,
  PersonaCompanyDto,
  PersonaDeletionValidationDto,
  PersonaDto,
  PersonaSearchPersonasParams,
  PersonaSessionInitResult,
  PlaybookItemDto,
  ProblemDetails,
  ProcessDialogCommand,
  ProcessResultDto,
  ProcessScenarioChatTurnStatusParams,
  ProcessSimulatorAudioDialogDto,
  ProcessSimulatorAudioTurnDto,
  ProcessSimulatorDialogDto,
  ProcessStartInboundCallBodyOne,
  ProcessStartInboundCallBodyTwo,
  ProcessTurnAudioParams,
  ProcessTurnAudioStreamParams,
  RecordingAudioLinkDto,
  RecordingDetailDto,
  RecordingEvaluationRunDto,
  RecordingsListParams,
  RecordingsUploadBodyOne,
  RecordingsUploadBodyTwo,
  RespondToUserTurnCommand,
  RespondToUserTurnDto,
  RespondWithPersonaAudioCommand,
  RestoreScenarioVersionCommand,
  RoleCompanyDto,
  RoleDto,
  RolesGetRolesParams,
  ScenarioChatTurnStatusDto,
  ScenarioDialogStatisticDto,
  ScenarioDto,
  ScenarioGroupAddScenarioToGroupParams,
  ScenarioGroupCreateGroupParams,
  ScenarioGroupDto,
  ScenarioGroupRemoveScenesFromGroupParams,
  ScenarioHealthGetReportParams,
  ScenarioHealthReportDto,
  ScenarioNoteDto,
  ScenarioNoteRequest,
  ScenarioUpdateDto,
  ScenariosSearchScenariosParams,
  ScenariosUpdateScenarioPdfBodyOne,
  ScenariosUpdateScenarioPdfBodyTwo,
  ScheduledCallDto,
  ScheduledCallsGetParams,
  ScheduledCallsUpdateStatusParams,
  ScheduledCourseAssignmentCommand,
  ScheduledCourseDto,
  ScheduledCourseNotificationDto,
  ScheduledCourseScenarioResultDto,
  ShareEvaluationProtocolCommand,
  ShareRoleDto,
  SimpleScenarioDto,
  SimulationDto,
  SimulationStageDto,
  Speaker,
  SpeechRecognizeSpeechBodyOne,
  SpeechRecognizeSpeechBodyTwo,
  SpeechRecognizeSpeechParams,
  StartOperatorSessionResult,
  SummaryDto,
  SummaryRequestDto,
  SynthesizeSpeechCommand,
  TaskTemplateDto,
  TenantDto,
  TestExceptionRequest,
  TextToSpeechCommand,
  TrendingScenariosCommand,
  TriggerJobRequest,
  TwilioPhoneNumberDto,
  UnshareEvaluationProtocolCommand,
  UnshareRoleDto,
  UpdateCompanyCommand,
  UpdateCourseCommand,
  UpdateEvaluationProtocolCategoryCommand,
  UpdateEvaluationProtocolCommand,
  UpdateEvaluationProtocolCompanyAccessCommand,
  UpdateEvaluationProtocolElementCommand,
  UpdateExerciseContactDto,
  UpdateExerciseDto,
  UpdateGlobalAssetCategoryCommand,
  UpdateGlobalAssetIntentCommand,
  UpdateLicenseAgreementDto,
  UpdateModelLedEvaluationStrategyCommand,
  UpdatePersonaDto,
  UpdatePlaybookItemDto,
  UpdateRecordingRequest,
  UpdateRoleDto,
  UpdateScenarioContentCommand,
  UpdateScenarioGroupCommand,
  UpdateScenarioSettingsCommand,
  UpdateScheduledCallCommand,
  UpdateScheduledCourseNotificationCommand,
  UpdateScheduledCourseRequestCommand,
  UpdateSimulationDto,
  UpdateSimulationStageRunStateDto,
  UpdateUserGroupCommand,
  UpdateUsersAdvancedSettingsCommand,
  UpdateUsersDepartmentCommand,
  UpdateUsersLicenseFeaturesCommand,
  UsageStatistic,
  UsageStatisticsDto,
  UsageStatisticsQuery,
  UserDto,
  UserGroupDto,
  UserGroupGetParams
} from './api.schemas.ts';

import { customAxiosInstance } from '../api/mutator.ts';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<{ [Q in P]: T[P] }, { -readonly [Q in P]: T[P] }, P>;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object ? NonReadonly<NonNullable<T[P]>> : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key]
    });
  }
  return result;
};

export const accountEditUser = (editUserCommand?: EditUserCommand, signal?: AbortSignal) => {
  return customAxiosInstance<UserDto>({
    url: `/api/Account/EditUser`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: editUserCommand,
    signal
  });
};

export const getAccountEditUserMutationKey = () => ['accountEditUser'] as const;

export const getAccountEditUserMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountEditUser>>,
    TError,
    AccountEditUserMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountEditUser>>,
  TError,
  AccountEditUserMutationVariables,
  TContext
> => {
  const mutationKey = getAccountEditUserMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountEditUser>>, AccountEditUserMutationVariables> = (
    props
  ) => {
    const { data } = props ?? {};

    return accountEditUser(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AccountEditUserMutationResult = NonNullable<Awaited<ReturnType<typeof accountEditUser>>>;
export type AccountEditUserMutationBody = EditUserCommand | undefined;
export type AccountEditUserMutationError = unknown;
export type AccountEditUserMutationVariables = { data?: EditUserCommand };

export const useAccountEditUser = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountEditUser>>,
    TError,
    AccountEditUserMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof accountEditUser>>,
  TError,
  AccountEditUserMutationVariables,
  TContext
> => {
  return useMutation(getAccountEditUserMutationOptions(options));
};

export const accountEditUserProfile = (editUserProfileCommand?: EditUserProfileCommand, signal?: AbortSignal) => {
  return customAxiosInstance<UserDto>({
    url: `/api/Account/EditUserProfile`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: editUserProfileCommand,
    signal
  });
};

export const getAccountEditUserProfileMutationKey = () => ['accountEditUserProfile'] as const;

export const getAccountEditUserProfileMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountEditUserProfile>>,
    TError,
    AccountEditUserProfileMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountEditUserProfile>>,
  TError,
  AccountEditUserProfileMutationVariables,
  TContext
> => {
  const mutationKey = getAccountEditUserProfileMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountEditUserProfile>>,
    AccountEditUserProfileMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return accountEditUserProfile(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AccountEditUserProfileMutationResult = NonNullable<Awaited<ReturnType<typeof accountEditUserProfile>>>;
export type AccountEditUserProfileMutationBody = EditUserProfileCommand | undefined;
export type AccountEditUserProfileMutationError = unknown;
export type AccountEditUserProfileMutationVariables = { data?: EditUserProfileCommand };

export const useAccountEditUserProfile = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountEditUserProfile>>,
    TError,
    AccountEditUserProfileMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof accountEditUserProfile>>,
  TError,
  AccountEditUserProfileMutationVariables,
  TContext
> => {
  return useMutation(getAccountEditUserProfileMutationOptions(options));
};

export const accountEditUserAudioSettings = (
  editUserAudioSettingsCommand?: EditUserAudioSettingsCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<UserDto>({
    url: `/api/Account/EditUserAudioSettings`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: editUserAudioSettingsCommand,
    signal
  });
};

export const getAccountEditUserAudioSettingsMutationKey = () => ['accountEditUserAudioSettings'] as const;

export const getAccountEditUserAudioSettingsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountEditUserAudioSettings>>,
    TError,
    AccountEditUserAudioSettingsMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountEditUserAudioSettings>>,
  TError,
  AccountEditUserAudioSettingsMutationVariables,
  TContext
> => {
  const mutationKey = getAccountEditUserAudioSettingsMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountEditUserAudioSettings>>,
    AccountEditUserAudioSettingsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return accountEditUserAudioSettings(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AccountEditUserAudioSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof accountEditUserAudioSettings>>
>;
export type AccountEditUserAudioSettingsMutationBody = EditUserAudioSettingsCommand | undefined;
export type AccountEditUserAudioSettingsMutationError = unknown;
export type AccountEditUserAudioSettingsMutationVariables = { data?: EditUserAudioSettingsCommand };

export const useAccountEditUserAudioSettings = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountEditUserAudioSettings>>,
    TError,
    AccountEditUserAudioSettingsMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof accountEditUserAudioSettings>>,
  TError,
  AccountEditUserAudioSettingsMutationVariables,
  TContext
> => {
  return useMutation(getAccountEditUserAudioSettingsMutationOptions(options));
};

export const accountUpdateUsersDepartment = (
  updateUsersDepartmentCommand?: UpdateUsersDepartmentCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<UserDto[]>({
    url: `/api/Account/UpdateUsersDepartment/updateUsersDepartment`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateUsersDepartmentCommand,
    signal
  });
};

export const getAccountUpdateUsersDepartmentMutationKey = () => ['accountUpdateUsersDepartment'] as const;

export const getAccountUpdateUsersDepartmentMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountUpdateUsersDepartment>>,
    TError,
    AccountUpdateUsersDepartmentMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountUpdateUsersDepartment>>,
  TError,
  AccountUpdateUsersDepartmentMutationVariables,
  TContext
> => {
  const mutationKey = getAccountUpdateUsersDepartmentMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountUpdateUsersDepartment>>,
    AccountUpdateUsersDepartmentMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return accountUpdateUsersDepartment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AccountUpdateUsersDepartmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof accountUpdateUsersDepartment>>
>;
export type AccountUpdateUsersDepartmentMutationBody = UpdateUsersDepartmentCommand | undefined;
export type AccountUpdateUsersDepartmentMutationError = unknown;
export type AccountUpdateUsersDepartmentMutationVariables = { data?: UpdateUsersDepartmentCommand };

export const useAccountUpdateUsersDepartment = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountUpdateUsersDepartment>>,
    TError,
    AccountUpdateUsersDepartmentMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof accountUpdateUsersDepartment>>,
  TError,
  AccountUpdateUsersDepartmentMutationVariables,
  TContext
> => {
  return useMutation(getAccountUpdateUsersDepartmentMutationOptions(options));
};

export const accountUpdateUsersAdvancedSettings = (
  updateUsersAdvancedSettingsCommand?: UpdateUsersAdvancedSettingsCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<UserDto[]>({
    url: `/api/Account/UpdateUsersAdvancedSettings/updateUsersAdvancedSettings`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateUsersAdvancedSettingsCommand,
    signal
  });
};

export const getAccountUpdateUsersAdvancedSettingsMutationKey = () => ['accountUpdateUsersAdvancedSettings'] as const;

export const getAccountUpdateUsersAdvancedSettingsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountUpdateUsersAdvancedSettings>>,
    TError,
    AccountUpdateUsersAdvancedSettingsMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountUpdateUsersAdvancedSettings>>,
  TError,
  AccountUpdateUsersAdvancedSettingsMutationVariables,
  TContext
> => {
  const mutationKey = getAccountUpdateUsersAdvancedSettingsMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountUpdateUsersAdvancedSettings>>,
    AccountUpdateUsersAdvancedSettingsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return accountUpdateUsersAdvancedSettings(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AccountUpdateUsersAdvancedSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof accountUpdateUsersAdvancedSettings>>
>;
export type AccountUpdateUsersAdvancedSettingsMutationBody = UpdateUsersAdvancedSettingsCommand | undefined;
export type AccountUpdateUsersAdvancedSettingsMutationError = unknown;
export type AccountUpdateUsersAdvancedSettingsMutationVariables = { data?: UpdateUsersAdvancedSettingsCommand };

export const useAccountUpdateUsersAdvancedSettings = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountUpdateUsersAdvancedSettings>>,
    TError,
    AccountUpdateUsersAdvancedSettingsMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof accountUpdateUsersAdvancedSettings>>,
  TError,
  AccountUpdateUsersAdvancedSettingsMutationVariables,
  TContext
> => {
  return useMutation(getAccountUpdateUsersAdvancedSettingsMutationOptions(options));
};

export const accountUpdateUsersLicenseFeatures = (
  updateUsersLicenseFeaturesCommand?: UpdateUsersLicenseFeaturesCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<UserDto[]>({
    url: `/api/Account/UpdateUsersLicenseFeatures/updateUsersLicenseFeatures`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateUsersLicenseFeaturesCommand,
    signal
  });
};

export const getAccountUpdateUsersLicenseFeaturesMutationKey = () => ['accountUpdateUsersLicenseFeatures'] as const;

export const getAccountUpdateUsersLicenseFeaturesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountUpdateUsersLicenseFeatures>>,
    TError,
    AccountUpdateUsersLicenseFeaturesMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountUpdateUsersLicenseFeatures>>,
  TError,
  AccountUpdateUsersLicenseFeaturesMutationVariables,
  TContext
> => {
  const mutationKey = getAccountUpdateUsersLicenseFeaturesMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountUpdateUsersLicenseFeatures>>,
    AccountUpdateUsersLicenseFeaturesMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return accountUpdateUsersLicenseFeatures(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AccountUpdateUsersLicenseFeaturesMutationResult = NonNullable<
  Awaited<ReturnType<typeof accountUpdateUsersLicenseFeatures>>
>;
export type AccountUpdateUsersLicenseFeaturesMutationBody = UpdateUsersLicenseFeaturesCommand | undefined;
export type AccountUpdateUsersLicenseFeaturesMutationError = unknown;
export type AccountUpdateUsersLicenseFeaturesMutationVariables = { data?: UpdateUsersLicenseFeaturesCommand };

export const useAccountUpdateUsersLicenseFeatures = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountUpdateUsersLicenseFeatures>>,
    TError,
    AccountUpdateUsersLicenseFeaturesMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof accountUpdateUsersLicenseFeatures>>,
  TError,
  AccountUpdateUsersLicenseFeaturesMutationVariables,
  TContext
> => {
  return useMutation(getAccountUpdateUsersLicenseFeaturesMutationOptions(options));
};

export const accountAllowRecord = (signal?: AbortSignal) => {
  return customAxiosInstance<UserDto>({ url: `/api/Account/AllowRecord/allowRecord`, method: 'PUT', signal });
};

export const getAccountAllowRecordMutationKey = () => ['accountAllowRecord'] as const;

export const getAccountAllowRecordMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof accountAllowRecord>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof accountAllowRecord>>, TError, void, TContext> => {
  const mutationKey = getAccountAllowRecordMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountAllowRecord>>, void> = () => {
    return accountAllowRecord();
  };

  return { mutationFn, ...mutationOptions };
};

export type AccountAllowRecordMutationResult = NonNullable<Awaited<ReturnType<typeof accountAllowRecord>>>;

export type AccountAllowRecordMutationError = unknown;

export const useAccountAllowRecord = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof accountAllowRecord>>, TError, void, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof accountAllowRecord>>, TError, void, TContext> => {
  return useMutation(getAccountAllowRecordMutationOptions(options));
};

export const avatarGetAllAvatars = (signal?: AbortSignal) => {
  return customAxiosInstance<Avatar[]>({ url: `/api/Avatar/GetAllAvatars`, method: 'GET', signal });
};

export const getAvatarGetAllAvatarsQueryKey = () => {
  return [`/api/Avatar/GetAllAvatars`] as const;
};

export const getAvatarGetAllAvatarsQueryOptions = <
  TData = Awaited<ReturnType<typeof avatarGetAllAvatars>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof avatarGetAllAvatars>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAvatarGetAllAvatarsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof avatarGetAllAvatars>>> = ({ signal }) =>
    avatarGetAllAvatars(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof avatarGetAllAvatars>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AvatarGetAllAvatarsQueryResult = NonNullable<Awaited<ReturnType<typeof avatarGetAllAvatars>>>;
export type AvatarGetAllAvatarsQueryError = unknown;

export function useAvatarGetAllAvatars<
  TData = Awaited<ReturnType<typeof avatarGetAllAvatars>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof avatarGetAllAvatars>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAvatarGetAllAvatarsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Open to Hugin (agent tokens) so it can pick a sound when a user asks for one; uploads and deletes are not.
 */
export const backgroundSoundsList = (signal?: AbortSignal) => {
  return customAxiosInstance<BackgroundSoundDto[]>({ url: `/api/background-sounds`, method: 'GET', signal });
};

export const getBackgroundSoundsListQueryKey = () => {
  return [`/api/background-sounds`] as const;
};

export const getBackgroundSoundsListQueryOptions = <
  TData = Awaited<ReturnType<typeof backgroundSoundsList>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof backgroundSoundsList>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBackgroundSoundsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof backgroundSoundsList>>> = ({ signal }) =>
    backgroundSoundsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof backgroundSoundsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BackgroundSoundsListQueryResult = NonNullable<Awaited<ReturnType<typeof backgroundSoundsList>>>;
export type BackgroundSoundsListQueryError = unknown;

/**
 * @summary Open to Hugin (agent tokens) so it can pick a sound when a user asks for one; uploads and deletes are not.
 */

export function useBackgroundSoundsList<
  TData = Awaited<ReturnType<typeof backgroundSoundsList>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof backgroundSoundsList>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBackgroundSoundsListQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const backgroundSoundsUpload = (
  backgroundSoundsUploadBody?: BackgroundSoundsUploadBodyOne | BackgroundSoundsUploadBodyTwo,
  signal?: AbortSignal
) => {
  return customAxiosInstance<BackgroundSoundDto>({
    url: `/api/background-sounds`,
    method: 'POST',
    data: backgroundSoundsUploadBody,
    signal
  });
};

export const getBackgroundSoundsUploadMutationKey = () => ['backgroundSoundsUpload'] as const;

export const getBackgroundSoundsUploadMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backgroundSoundsUpload>>,
    TError,
    BackgroundSoundsUploadMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof backgroundSoundsUpload>>,
  TError,
  BackgroundSoundsUploadMutationVariables,
  TContext
> => {
  const mutationKey = getBackgroundSoundsUploadMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof backgroundSoundsUpload>>,
    BackgroundSoundsUploadMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return backgroundSoundsUpload(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BackgroundSoundsUploadMutationResult = NonNullable<Awaited<ReturnType<typeof backgroundSoundsUpload>>>;
export type BackgroundSoundsUploadMutationBody =
  | BackgroundSoundsUploadBodyOne
  | BackgroundSoundsUploadBodyTwo
  | undefined;
export type BackgroundSoundsUploadMutationError = unknown;
export type BackgroundSoundsUploadMutationVariables = {
  data?: BackgroundSoundsUploadBodyOne | BackgroundSoundsUploadBodyTwo;
};

export const useBackgroundSoundsUpload = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backgroundSoundsUpload>>,
    TError,
    BackgroundSoundsUploadMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof backgroundSoundsUpload>>,
  TError,
  BackgroundSoundsUploadMutationVariables,
  TContext
> => {
  return useMutation(getBackgroundSoundsUploadMutationOptions(options));
};

/**
 * @summary The WAV itself. The bytes behind an id never change, so the browser may cache it for good.
 */
export const backgroundSoundsAudio = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<Blob>({
    url: `/api/background-sounds/${id}/audio`,
    method: 'GET',
    responseType: 'blob',
    signal
  });
};

export const getBackgroundSoundsAudioQueryKey = (id: number) => {
  return [`/api/background-sounds/${id}/audio`] as const;
};

export const getBackgroundSoundsAudioQueryOptions = <
  TData = Awaited<ReturnType<typeof backgroundSoundsAudio>>,
  TError = Blob | ProblemDetails
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof backgroundSoundsAudio>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBackgroundSoundsAudioQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof backgroundSoundsAudio>>> = ({ signal }) =>
    backgroundSoundsAudio(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof backgroundSoundsAudio>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BackgroundSoundsAudioQueryResult = NonNullable<Awaited<ReturnType<typeof backgroundSoundsAudio>>>;
export type BackgroundSoundsAudioQueryError = Blob | ProblemDetails;

/**
 * @summary The WAV itself. The bytes behind an id never change, so the browser may cache it for good.
 */

export function useBackgroundSoundsAudio<
  TData = Awaited<ReturnType<typeof backgroundSoundsAudio>>,
  TError = Blob | ProblemDetails
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof backgroundSoundsAudio>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBackgroundSoundsAudioQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary 409 while any scenario still uses the sound.
 */
export const backgroundSoundsDelete = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/background-sounds/${id}`, method: 'DELETE', signal });
};

export const getBackgroundSoundsDeleteMutationKey = () => ['backgroundSoundsDelete'] as const;

export const getBackgroundSoundsDeleteMutationOptions = <TError = ProblemDetails, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backgroundSoundsDelete>>,
    TError,
    BackgroundSoundsDeleteMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof backgroundSoundsDelete>>,
  TError,
  BackgroundSoundsDeleteMutationVariables,
  TContext
> => {
  const mutationKey = getBackgroundSoundsDeleteMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof backgroundSoundsDelete>>,
    BackgroundSoundsDeleteMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return backgroundSoundsDelete(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type BackgroundSoundsDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof backgroundSoundsDelete>>>;

export type BackgroundSoundsDeleteMutationError = ProblemDetails;
export type BackgroundSoundsDeleteMutationVariables = { id: number };

/**
 * @summary 409 while any scenario still uses the sound.
 */
export const useBackgroundSoundsDelete = <TError = ProblemDetails, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backgroundSoundsDelete>>,
    TError,
    BackgroundSoundsDeleteMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof backgroundSoundsDelete>>,
  TError,
  BackgroundSoundsDeleteMutationVariables,
  TContext
> => {
  return useMutation(getBackgroundSoundsDeleteMutationOptions(options));
};

export const companiesFilterCompanies = (params?: CompaniesFilterCompaniesParams, signal?: AbortSignal) => {
  return customAxiosInstance<CompanyDto[]>({ url: `/api/Companies/FilterCompanies`, method: 'GET', params, signal });
};

export const getCompaniesFilterCompaniesQueryKey = (params?: CompaniesFilterCompaniesParams) => {
  return [`/api/Companies/FilterCompanies`, ...(params ? [params] : [])] as const;
};

export const getCompaniesFilterCompaniesQueryOptions = <
  TData = Awaited<ReturnType<typeof companiesFilterCompanies>>,
  TError = unknown
>(
  params?: CompaniesFilterCompaniesParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof companiesFilterCompanies>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCompaniesFilterCompaniesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof companiesFilterCompanies>>> = ({ signal }) =>
    companiesFilterCompanies(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof companiesFilterCompanies>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CompaniesFilterCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof companiesFilterCompanies>>>;
export type CompaniesFilterCompaniesQueryError = unknown;

export function useCompaniesFilterCompanies<
  TData = Awaited<ReturnType<typeof companiesFilterCompanies>>,
  TError = unknown
>(
  params?: CompaniesFilterCompaniesParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof companiesFilterCompanies>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCompaniesFilterCompaniesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const companiesSearchAgentCompanies = (params?: CompaniesSearchAgentCompaniesParams, signal?: AbortSignal) => {
  return customAxiosInstance<CompanyDto[]>({
    url: `/api/Companies/SearchAgentCompanies`,
    method: 'GET',
    params,
    signal
  });
};

export const getCompaniesSearchAgentCompaniesQueryKey = (params?: CompaniesSearchAgentCompaniesParams) => {
  return [`/api/Companies/SearchAgentCompanies`, ...(params ? [params] : [])] as const;
};

export const getCompaniesSearchAgentCompaniesQueryOptions = <
  TData = Awaited<ReturnType<typeof companiesSearchAgentCompanies>>,
  TError = unknown
>(
  params?: CompaniesSearchAgentCompaniesParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof companiesSearchAgentCompanies>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCompaniesSearchAgentCompaniesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof companiesSearchAgentCompanies>>> = ({ signal }) =>
    companiesSearchAgentCompanies(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof companiesSearchAgentCompanies>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CompaniesSearchAgentCompaniesQueryResult = NonNullable<
  Awaited<ReturnType<typeof companiesSearchAgentCompanies>>
>;
export type CompaniesSearchAgentCompaniesQueryError = unknown;

export function useCompaniesSearchAgentCompanies<
  TData = Awaited<ReturnType<typeof companiesSearchAgentCompanies>>,
  TError = unknown
>(
  params?: CompaniesSearchAgentCompaniesParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof companiesSearchAgentCompanies>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCompaniesSearchAgentCompaniesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const companiesGetCompany = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<CompanyDto>({ url: `/api/Companies/GetCompany/${id}`, method: 'GET', signal });
};

export const getCompaniesGetCompanyQueryKey = (id: number) => {
  return [`/api/Companies/GetCompany/${id}`] as const;
};

export const getCompaniesGetCompanyQueryOptions = <
  TData = Awaited<ReturnType<typeof companiesGetCompany>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof companiesGetCompany>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCompaniesGetCompanyQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof companiesGetCompany>>> = ({ signal }) =>
    companiesGetCompany(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof companiesGetCompany>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CompaniesGetCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof companiesGetCompany>>>;
export type CompaniesGetCompanyQueryError = unknown;

export function useCompaniesGetCompany<TData = Awaited<ReturnType<typeof companiesGetCompany>>, TError = unknown>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof companiesGetCompany>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCompaniesGetCompanyQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const companiesAddCompany = (createCompanyCommand?: CreateCompanyCommand, signal?: AbortSignal) => {
  return customAxiosInstance<CompanyDto>({
    url: `/api/Companies/AddCompany`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createCompanyCommand,
    signal
  });
};

export const getCompaniesAddCompanyMutationKey = () => ['companiesAddCompany'] as const;

export const getCompaniesAddCompanyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companiesAddCompany>>,
    TError,
    CompaniesAddCompanyMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof companiesAddCompany>>,
  TError,
  CompaniesAddCompanyMutationVariables,
  TContext
> => {
  const mutationKey = getCompaniesAddCompanyMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof companiesAddCompany>>,
    CompaniesAddCompanyMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return companiesAddCompany(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompaniesAddCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof companiesAddCompany>>>;
export type CompaniesAddCompanyMutationBody = CreateCompanyCommand | undefined;
export type CompaniesAddCompanyMutationError = unknown;
export type CompaniesAddCompanyMutationVariables = { data?: CreateCompanyCommand };

export const useCompaniesAddCompany = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companiesAddCompany>>,
    TError,
    CompaniesAddCompanyMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof companiesAddCompany>>,
  TError,
  CompaniesAddCompanyMutationVariables,
  TContext
> => {
  return useMutation(getCompaniesAddCompanyMutationOptions(options));
};

export const companiesEditCompany = (
  updateCompanyCommand?: NonReadonly<UpdateCompanyCommand>,
  signal?: AbortSignal
) => {
  return customAxiosInstance<CompanyDto>({
    url: `/api/Companies/EditCompany`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateCompanyCommand,
    signal
  });
};

export const getCompaniesEditCompanyMutationKey = () => ['companiesEditCompany'] as const;

export const getCompaniesEditCompanyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companiesEditCompany>>,
    TError,
    CompaniesEditCompanyMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof companiesEditCompany>>,
  TError,
  CompaniesEditCompanyMutationVariables,
  TContext
> => {
  const mutationKey = getCompaniesEditCompanyMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof companiesEditCompany>>,
    CompaniesEditCompanyMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return companiesEditCompany(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompaniesEditCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof companiesEditCompany>>>;
export type CompaniesEditCompanyMutationBody = NonReadonly<UpdateCompanyCommand> | undefined;
export type CompaniesEditCompanyMutationError = unknown;
export type CompaniesEditCompanyMutationVariables = { data?: NonReadonly<UpdateCompanyCommand> };

export const useCompaniesEditCompany = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companiesEditCompany>>,
    TError,
    CompaniesEditCompanyMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof companiesEditCompany>>,
  TError,
  CompaniesEditCompanyMutationVariables,
  TContext
> => {
  return useMutation(getCompaniesEditCompanyMutationOptions(options));
};

export const companiesDeleteCompany = (deleteCompanyCommand?: DeleteCompanyCommand, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/Companies/DeleteCompany`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: deleteCompanyCommand,
    signal
  });
};

export const getCompaniesDeleteCompanyMutationKey = () => ['companiesDeleteCompany'] as const;

export const getCompaniesDeleteCompanyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companiesDeleteCompany>>,
    TError,
    CompaniesDeleteCompanyMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof companiesDeleteCompany>>,
  TError,
  CompaniesDeleteCompanyMutationVariables,
  TContext
> => {
  const mutationKey = getCompaniesDeleteCompanyMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof companiesDeleteCompany>>,
    CompaniesDeleteCompanyMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return companiesDeleteCompany(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompaniesDeleteCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof companiesDeleteCompany>>>;
export type CompaniesDeleteCompanyMutationBody = DeleteCompanyCommand | undefined;
export type CompaniesDeleteCompanyMutationError = unknown;
export type CompaniesDeleteCompanyMutationVariables = { data?: DeleteCompanyCommand };

export const useCompaniesDeleteCompany = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companiesDeleteCompany>>,
    TError,
    CompaniesDeleteCompanyMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof companiesDeleteCompany>>,
  TError,
  CompaniesDeleteCompanyMutationVariables,
  TContext
> => {
  return useMutation(getCompaniesDeleteCompanyMutationOptions(options));
};

export const companyGetAllDepartments = (signal?: AbortSignal) => {
  return customAxiosInstance<CompanyDepartmentDto[]>({
    url: `/api/Company/GetAllDepartments/departments`,
    method: 'GET',
    signal
  });
};

export const getCompanyGetAllDepartmentsQueryKey = () => {
  return [`/api/Company/GetAllDepartments/departments`] as const;
};

export const getCompanyGetAllDepartmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof companyGetAllDepartments>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof companyGetAllDepartments>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCompanyGetAllDepartmentsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof companyGetAllDepartments>>> = ({ signal }) =>
    companyGetAllDepartments(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof companyGetAllDepartments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CompanyGetAllDepartmentsQueryResult = NonNullable<Awaited<ReturnType<typeof companyGetAllDepartments>>>;
export type CompanyGetAllDepartmentsQueryError = unknown;

export function useCompanyGetAllDepartments<
  TData = Awaited<ReturnType<typeof companyGetAllDepartments>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof companyGetAllDepartments>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCompanyGetAllDepartmentsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const companyGetDepartments = (companyId: number, signal?: AbortSignal) => {
  return customAxiosInstance<CompanyDepartmentDto[]>({
    url: `/api/Company/GetDepartments/${companyId}/departments`,
    method: 'GET',
    signal
  });
};

export const getCompanyGetDepartmentsQueryKey = (companyId: number) => {
  return [`/api/Company/GetDepartments/${companyId}/departments`] as const;
};

export const getCompanyGetDepartmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof companyGetDepartments>>,
  TError = unknown
>(
  companyId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof companyGetDepartments>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCompanyGetDepartmentsQueryKey(companyId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof companyGetDepartments>>> = ({ signal }) =>
    companyGetDepartments(companyId, signal);

  return {
    queryKey,
    queryFn,
    enabled: companyId !== null && companyId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof companyGetDepartments>>, TError, TData> & { queryKey: QueryKey };
};

export type CompanyGetDepartmentsQueryResult = NonNullable<Awaited<ReturnType<typeof companyGetDepartments>>>;
export type CompanyGetDepartmentsQueryError = unknown;

export function useCompanyGetDepartments<TData = Awaited<ReturnType<typeof companyGetDepartments>>, TError = unknown>(
  companyId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof companyGetDepartments>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCompanyGetDepartmentsQueryOptions(companyId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const companyCreateDepartment = (
  companyId: number,
  createCompanyDepartmentCommand?: CreateCompanyDepartmentCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<CompanyDepartmentDto>({
    url: `/api/Company/CreateDepartment/${companyId}/departments`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: createCompanyDepartmentCommand,
    signal
  });
};

export const getCompanyCreateDepartmentMutationKey = () => ['companyCreateDepartment'] as const;

export const getCompanyCreateDepartmentMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companyCreateDepartment>>,
    TError,
    CompanyCreateDepartmentMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof companyCreateDepartment>>,
  TError,
  CompanyCreateDepartmentMutationVariables,
  TContext
> => {
  const mutationKey = getCompanyCreateDepartmentMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof companyCreateDepartment>>,
    CompanyCreateDepartmentMutationVariables
  > = (props) => {
    const { companyId, data } = props ?? {};

    return companyCreateDepartment(companyId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompanyCreateDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof companyCreateDepartment>>>;
export type CompanyCreateDepartmentMutationBody = CreateCompanyDepartmentCommand | undefined;
export type CompanyCreateDepartmentMutationError = unknown;
export type CompanyCreateDepartmentMutationVariables = { companyId: number; data?: CreateCompanyDepartmentCommand };

export const useCompanyCreateDepartment = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companyCreateDepartment>>,
    TError,
    CompanyCreateDepartmentMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof companyCreateDepartment>>,
  TError,
  CompanyCreateDepartmentMutationVariables,
  TContext
> => {
  return useMutation(getCompanyCreateDepartmentMutationOptions(options));
};

export const companyUpdateDepartment = (
  departmentId: number,
  createCompanyDepartmentCommand?: CreateCompanyDepartmentCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<CompanyDepartmentDto>({
    url: `/api/Company/UpdateDepartment/departments/${departmentId}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createCompanyDepartmentCommand,
    signal
  });
};

export const getCompanyUpdateDepartmentMutationKey = () => ['companyUpdateDepartment'] as const;

export const getCompanyUpdateDepartmentMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companyUpdateDepartment>>,
    TError,
    CompanyUpdateDepartmentMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof companyUpdateDepartment>>,
  TError,
  CompanyUpdateDepartmentMutationVariables,
  TContext
> => {
  const mutationKey = getCompanyUpdateDepartmentMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof companyUpdateDepartment>>,
    CompanyUpdateDepartmentMutationVariables
  > = (props) => {
    const { departmentId, data } = props ?? {};

    return companyUpdateDepartment(departmentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompanyUpdateDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof companyUpdateDepartment>>>;
export type CompanyUpdateDepartmentMutationBody = CreateCompanyDepartmentCommand | undefined;
export type CompanyUpdateDepartmentMutationError = unknown;
export type CompanyUpdateDepartmentMutationVariables = { departmentId: number; data?: CreateCompanyDepartmentCommand };

export const useCompanyUpdateDepartment = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companyUpdateDepartment>>,
    TError,
    CompanyUpdateDepartmentMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof companyUpdateDepartment>>,
  TError,
  CompanyUpdateDepartmentMutationVariables,
  TContext
> => {
  return useMutation(getCompanyUpdateDepartmentMutationOptions(options));
};

export const companyDeleteDepartment = (departmentId: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/Company/DeleteDepartment/departments/${departmentId}`,
    method: 'DELETE',
    signal
  });
};

export const getCompanyDeleteDepartmentMutationKey = () => ['companyDeleteDepartment'] as const;

export const getCompanyDeleteDepartmentMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companyDeleteDepartment>>,
    TError,
    CompanyDeleteDepartmentMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof companyDeleteDepartment>>,
  TError,
  CompanyDeleteDepartmentMutationVariables,
  TContext
> => {
  const mutationKey = getCompanyDeleteDepartmentMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof companyDeleteDepartment>>,
    CompanyDeleteDepartmentMutationVariables
  > = (props) => {
    const { departmentId } = props ?? {};

    return companyDeleteDepartment(departmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompanyDeleteDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof companyDeleteDepartment>>>;

export type CompanyDeleteDepartmentMutationError = unknown;
export type CompanyDeleteDepartmentMutationVariables = { departmentId: number };

export const useCompanyDeleteDepartment = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof companyDeleteDepartment>>,
    TError,
    CompanyDeleteDepartmentMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof companyDeleteDepartment>>,
  TError,
  CompanyDeleteDepartmentMutationVariables,
  TContext
> => {
  return useMutation(getCompanyDeleteDepartmentMutationOptions(options));
};

export const companyGetInvitations = (signal?: AbortSignal) => {
  return customAxiosInstance<DepartmentInvitationDto[]>({
    url: `/api/Company/GetInvitations/invitations`,
    method: 'GET',
    signal
  });
};

export const getCompanyGetInvitationsQueryKey = () => {
  return [`/api/Company/GetInvitations/invitations`] as const;
};

export const getCompanyGetInvitationsQueryOptions = <
  TData = Awaited<ReturnType<typeof companyGetInvitations>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof companyGetInvitations>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCompanyGetInvitationsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof companyGetInvitations>>> = ({ signal }) =>
    companyGetInvitations(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof companyGetInvitations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CompanyGetInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof companyGetInvitations>>>;
export type CompanyGetInvitationsQueryError = unknown;

export function useCompanyGetInvitations<
  TData = Awaited<ReturnType<typeof companyGetInvitations>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof companyGetInvitations>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCompanyGetInvitationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const conversationEvaluationCreateEvaluationProtocol = (
  createEvaluationProtocolCommand?: CreateEvaluationProtocolCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<EvaluationProtocolDto>({
    url: `/api/evaluation/protocols`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createEvaluationProtocolCommand,
    signal
  });
};

export const getConversationEvaluationCreateEvaluationProtocolMutationKey = () =>
  ['conversationEvaluationCreateEvaluationProtocol'] as const;

export const getConversationEvaluationCreateEvaluationProtocolMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocol>>,
    TError,
    ConversationEvaluationCreateEvaluationProtocolMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocol>>,
  TError,
  ConversationEvaluationCreateEvaluationProtocolMutationVariables,
  TContext
> => {
  const mutationKey = getConversationEvaluationCreateEvaluationProtocolMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocol>>,
    ConversationEvaluationCreateEvaluationProtocolMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return conversationEvaluationCreateEvaluationProtocol(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationCreateEvaluationProtocolMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocol>>
>;
export type ConversationEvaluationCreateEvaluationProtocolMutationBody = CreateEvaluationProtocolCommand | undefined;
export type ConversationEvaluationCreateEvaluationProtocolMutationError = unknown;
export type ConversationEvaluationCreateEvaluationProtocolMutationVariables = {
  data?: CreateEvaluationProtocolCommand;
};

export const useConversationEvaluationCreateEvaluationProtocol = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocol>>,
    TError,
    ConversationEvaluationCreateEvaluationProtocolMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocol>>,
  TError,
  ConversationEvaluationCreateEvaluationProtocolMutationVariables,
  TContext
> => {
  return useMutation(getConversationEvaluationCreateEvaluationProtocolMutationOptions(options));
};

export const conversationEvaluationGetEvaluationProtocols = (signal?: AbortSignal) => {
  return customAxiosInstance<EvaluationProtocolDto[]>({ url: `/api/evaluation/protocols`, method: 'GET', signal });
};

export const getConversationEvaluationGetEvaluationProtocolsQueryKey = () => {
  return [`/api/evaluation/protocols`] as const;
};

export const getConversationEvaluationGetEvaluationProtocolsQueryOptions = <
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocols>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocols>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getConversationEvaluationGetEvaluationProtocolsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocols>>> = ({
    signal
  }) => conversationEvaluationGetEvaluationProtocols(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocols>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ConversationEvaluationGetEvaluationProtocolsQueryResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocols>>
>;
export type ConversationEvaluationGetEvaluationProtocolsQueryError = unknown;

export function useConversationEvaluationGetEvaluationProtocols<
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocols>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocols>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getConversationEvaluationGetEvaluationProtocolsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const conversationEvaluationGetEvaluationProtocol = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<EvaluationProtocolDto>({ url: `/api/evaluation/protocols/${id}`, method: 'GET', signal });
};

export const getConversationEvaluationGetEvaluationProtocolQueryKey = (id: number) => {
  return [`/api/evaluation/protocols/${id}`] as const;
};

export const getConversationEvaluationGetEvaluationProtocolQueryOptions = <
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocol>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocol>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getConversationEvaluationGetEvaluationProtocolQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocol>>> = ({
    signal
  }) => conversationEvaluationGetEvaluationProtocol(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocol>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ConversationEvaluationGetEvaluationProtocolQueryResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocol>>
>;
export type ConversationEvaluationGetEvaluationProtocolQueryError = unknown;

export function useConversationEvaluationGetEvaluationProtocol<
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocol>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocol>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getConversationEvaluationGetEvaluationProtocolQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const conversationEvaluationUpdateEvaluationProtocol = (
  id: number,
  updateEvaluationProtocolCommand?: UpdateEvaluationProtocolCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<EvaluationProtocolDto>({
    url: `/api/evaluation/protocols/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateEvaluationProtocolCommand,
    signal
  });
};

export const getConversationEvaluationUpdateEvaluationProtocolMutationKey = () =>
  ['conversationEvaluationUpdateEvaluationProtocol'] as const;

export const getConversationEvaluationUpdateEvaluationProtocolMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocol>>,
    TError,
    ConversationEvaluationUpdateEvaluationProtocolMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocol>>,
  TError,
  ConversationEvaluationUpdateEvaluationProtocolMutationVariables,
  TContext
> => {
  const mutationKey = getConversationEvaluationUpdateEvaluationProtocolMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocol>>,
    ConversationEvaluationUpdateEvaluationProtocolMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return conversationEvaluationUpdateEvaluationProtocol(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationUpdateEvaluationProtocolMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocol>>
>;
export type ConversationEvaluationUpdateEvaluationProtocolMutationBody = UpdateEvaluationProtocolCommand | undefined;
export type ConversationEvaluationUpdateEvaluationProtocolMutationError = unknown;
export type ConversationEvaluationUpdateEvaluationProtocolMutationVariables = {
  id: number;
  data?: UpdateEvaluationProtocolCommand;
};

export const useConversationEvaluationUpdateEvaluationProtocol = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocol>>,
    TError,
    ConversationEvaluationUpdateEvaluationProtocolMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocol>>,
  TError,
  ConversationEvaluationUpdateEvaluationProtocolMutationVariables,
  TContext
> => {
  return useMutation(getConversationEvaluationUpdateEvaluationProtocolMutationOptions(options));
};

export const conversationEvaluationDeleteEvaluationProtocol = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/evaluation/protocols/${id}`, method: 'DELETE', signal });
};

export const getConversationEvaluationDeleteEvaluationProtocolMutationKey = () =>
  ['conversationEvaluationDeleteEvaluationProtocol'] as const;

export const getConversationEvaluationDeleteEvaluationProtocolMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocol>>,
    TError,
    ConversationEvaluationDeleteEvaluationProtocolMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocol>>,
  TError,
  ConversationEvaluationDeleteEvaluationProtocolMutationVariables,
  TContext
> => {
  const mutationKey = getConversationEvaluationDeleteEvaluationProtocolMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocol>>,
    ConversationEvaluationDeleteEvaluationProtocolMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return conversationEvaluationDeleteEvaluationProtocol(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationDeleteEvaluationProtocolMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocol>>
>;

export type ConversationEvaluationDeleteEvaluationProtocolMutationError = unknown;
export type ConversationEvaluationDeleteEvaluationProtocolMutationVariables = { id: number };

export const useConversationEvaluationDeleteEvaluationProtocol = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocol>>,
    TError,
    ConversationEvaluationDeleteEvaluationProtocolMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocol>>,
  TError,
  ConversationEvaluationDeleteEvaluationProtocolMutationVariables,
  TContext
> => {
  return useMutation(getConversationEvaluationDeleteEvaluationProtocolMutationOptions(options));
};

export const conversationEvaluationGetEvaluationStrategy = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<ModelLedEvaluationStrategySettings>({
    url: `/api/evaluation/protocols/${id}/evaluation-strategy`,
    method: 'GET',
    signal
  });
};

export const getConversationEvaluationGetEvaluationStrategyQueryKey = (id: number) => {
  return [`/api/evaluation/protocols/${id}/evaluation-strategy`] as const;
};

export const getConversationEvaluationGetEvaluationStrategyQueryOptions = <
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationStrategy>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof conversationEvaluationGetEvaluationStrategy>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getConversationEvaluationGetEvaluationStrategyQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof conversationEvaluationGetEvaluationStrategy>>> = ({
    signal
  }) => conversationEvaluationGetEvaluationStrategy(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof conversationEvaluationGetEvaluationStrategy>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ConversationEvaluationGetEvaluationStrategyQueryResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationGetEvaluationStrategy>>
>;
export type ConversationEvaluationGetEvaluationStrategyQueryError = unknown;

export function useConversationEvaluationGetEvaluationStrategy<
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationStrategy>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof conversationEvaluationGetEvaluationStrategy>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getConversationEvaluationGetEvaluationStrategyQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const conversationEvaluationUpdateEvaluationStrategy = (
  id: number,
  updateModelLedEvaluationStrategyCommand?: UpdateModelLedEvaluationStrategyCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ModelLedEvaluationStrategySettings>({
    url: `/api/evaluation/protocols/${id}/evaluation-strategy`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateModelLedEvaluationStrategyCommand,
    signal
  });
};

export const getConversationEvaluationUpdateEvaluationStrategyMutationKey = () =>
  ['conversationEvaluationUpdateEvaluationStrategy'] as const;

export const getConversationEvaluationUpdateEvaluationStrategyMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationStrategy>>,
    TError,
    ConversationEvaluationUpdateEvaluationStrategyMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationStrategy>>,
  TError,
  ConversationEvaluationUpdateEvaluationStrategyMutationVariables,
  TContext
> => {
  const mutationKey = getConversationEvaluationUpdateEvaluationStrategyMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationStrategy>>,
    ConversationEvaluationUpdateEvaluationStrategyMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return conversationEvaluationUpdateEvaluationStrategy(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationUpdateEvaluationStrategyMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationStrategy>>
>;
export type ConversationEvaluationUpdateEvaluationStrategyMutationBody =
  | UpdateModelLedEvaluationStrategyCommand
  | undefined;
export type ConversationEvaluationUpdateEvaluationStrategyMutationError = unknown;
export type ConversationEvaluationUpdateEvaluationStrategyMutationVariables = {
  id: number;
  data?: UpdateModelLedEvaluationStrategyCommand;
};

export const useConversationEvaluationUpdateEvaluationStrategy = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationStrategy>>,
    TError,
    ConversationEvaluationUpdateEvaluationStrategyMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationStrategy>>,
  TError,
  ConversationEvaluationUpdateEvaluationStrategyMutationVariables,
  TContext
> => {
  return useMutation(getConversationEvaluationUpdateEvaluationStrategyMutationOptions(options));
};

export const conversationEvaluationSimulateEvaluationStrategy = (
  id: number,
  modelLedEvaluationStrategySimulationRequest?: ModelLedEvaluationStrategySimulationRequest,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ModelLedEvaluationStrategySimulationResult>({
    url: `/api/evaluation/protocols/${id}/evaluation-strategy/simulate`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: modelLedEvaluationStrategySimulationRequest,
    signal
  });
};

export const getConversationEvaluationSimulateEvaluationStrategyMutationKey = () =>
  ['conversationEvaluationSimulateEvaluationStrategy'] as const;

export const getConversationEvaluationSimulateEvaluationStrategyMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationSimulateEvaluationStrategy>>,
    TError,
    ConversationEvaluationSimulateEvaluationStrategyMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationSimulateEvaluationStrategy>>,
  TError,
  ConversationEvaluationSimulateEvaluationStrategyMutationVariables,
  TContext
> => {
  const mutationKey = getConversationEvaluationSimulateEvaluationStrategyMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationSimulateEvaluationStrategy>>,
    ConversationEvaluationSimulateEvaluationStrategyMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return conversationEvaluationSimulateEvaluationStrategy(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationSimulateEvaluationStrategyMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationSimulateEvaluationStrategy>>
>;
export type ConversationEvaluationSimulateEvaluationStrategyMutationBody =
  | ModelLedEvaluationStrategySimulationRequest
  | undefined;
export type ConversationEvaluationSimulateEvaluationStrategyMutationError = unknown;
export type ConversationEvaluationSimulateEvaluationStrategyMutationVariables = {
  id: number;
  data?: ModelLedEvaluationStrategySimulationRequest;
};

export const useConversationEvaluationSimulateEvaluationStrategy = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationSimulateEvaluationStrategy>>,
    TError,
    ConversationEvaluationSimulateEvaluationStrategyMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationSimulateEvaluationStrategy>>,
  TError,
  ConversationEvaluationSimulateEvaluationStrategyMutationVariables,
  TContext
> => {
  return useMutation(getConversationEvaluationSimulateEvaluationStrategyMutationOptions(options));
};

export const conversationEvaluationShareEvaluationProtocol = (
  id: number,
  shareEvaluationProtocolCommand?: ShareEvaluationProtocolCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<EvaluationProtocolDto>({
    url: `/api/evaluation/protocols/${id}/share`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: shareEvaluationProtocolCommand,
    signal
  });
};

export const getConversationEvaluationShareEvaluationProtocolMutationKey = () =>
  ['conversationEvaluationShareEvaluationProtocol'] as const;

export const getConversationEvaluationShareEvaluationProtocolMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationShareEvaluationProtocol>>,
    TError,
    ConversationEvaluationShareEvaluationProtocolMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationShareEvaluationProtocol>>,
  TError,
  ConversationEvaluationShareEvaluationProtocolMutationVariables,
  TContext
> => {
  const mutationKey = getConversationEvaluationShareEvaluationProtocolMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationShareEvaluationProtocol>>,
    ConversationEvaluationShareEvaluationProtocolMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return conversationEvaluationShareEvaluationProtocol(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationShareEvaluationProtocolMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationShareEvaluationProtocol>>
>;
export type ConversationEvaluationShareEvaluationProtocolMutationBody = ShareEvaluationProtocolCommand | undefined;
export type ConversationEvaluationShareEvaluationProtocolMutationError = unknown;
export type ConversationEvaluationShareEvaluationProtocolMutationVariables = {
  id: number;
  data?: ShareEvaluationProtocolCommand;
};

export const useConversationEvaluationShareEvaluationProtocol = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationShareEvaluationProtocol>>,
    TError,
    ConversationEvaluationShareEvaluationProtocolMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationShareEvaluationProtocol>>,
  TError,
  ConversationEvaluationShareEvaluationProtocolMutationVariables,
  TContext
> => {
  return useMutation(getConversationEvaluationShareEvaluationProtocolMutationOptions(options));
};

export const conversationEvaluationUnshareEvaluationProtocol = (
  id: number,
  unshareEvaluationProtocolCommand?: UnshareEvaluationProtocolCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<EvaluationProtocolDto>({
    url: `/api/evaluation/protocols/${id}/unshare`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: unshareEvaluationProtocolCommand,
    signal
  });
};

export const getConversationEvaluationUnshareEvaluationProtocolMutationKey = () =>
  ['conversationEvaluationUnshareEvaluationProtocol'] as const;

export const getConversationEvaluationUnshareEvaluationProtocolMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationUnshareEvaluationProtocol>>,
    TError,
    ConversationEvaluationUnshareEvaluationProtocolMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationUnshareEvaluationProtocol>>,
  TError,
  ConversationEvaluationUnshareEvaluationProtocolMutationVariables,
  TContext
> => {
  const mutationKey = getConversationEvaluationUnshareEvaluationProtocolMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationUnshareEvaluationProtocol>>,
    ConversationEvaluationUnshareEvaluationProtocolMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return conversationEvaluationUnshareEvaluationProtocol(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationUnshareEvaluationProtocolMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationUnshareEvaluationProtocol>>
>;
export type ConversationEvaluationUnshareEvaluationProtocolMutationBody = UnshareEvaluationProtocolCommand | undefined;
export type ConversationEvaluationUnshareEvaluationProtocolMutationError = unknown;
export type ConversationEvaluationUnshareEvaluationProtocolMutationVariables = {
  id: number;
  data?: UnshareEvaluationProtocolCommand;
};

export const useConversationEvaluationUnshareEvaluationProtocol = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationUnshareEvaluationProtocol>>,
    TError,
    ConversationEvaluationUnshareEvaluationProtocolMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationUnshareEvaluationProtocol>>,
  TError,
  ConversationEvaluationUnshareEvaluationProtocolMutationVariables,
  TContext
> => {
  return useMutation(getConversationEvaluationUnshareEvaluationProtocolMutationOptions(options));
};

export const conversationEvaluationGetProtocolUsage = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<EvaluationProtocolUsageDto[]>({
    url: `/api/evaluation/protocols/${id}/usage`,
    method: 'GET',
    signal
  });
};

export const getConversationEvaluationGetProtocolUsageQueryKey = (id: number) => {
  return [`/api/evaluation/protocols/${id}/usage`] as const;
};

export const getConversationEvaluationGetProtocolUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof conversationEvaluationGetProtocolUsage>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof conversationEvaluationGetProtocolUsage>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getConversationEvaluationGetProtocolUsageQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof conversationEvaluationGetProtocolUsage>>> = ({ signal }) =>
    conversationEvaluationGetProtocolUsage(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof conversationEvaluationGetProtocolUsage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ConversationEvaluationGetProtocolUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationGetProtocolUsage>>
>;
export type ConversationEvaluationGetProtocolUsageQueryError = unknown;

export function useConversationEvaluationGetProtocolUsage<
  TData = Awaited<ReturnType<typeof conversationEvaluationGetProtocolUsage>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof conversationEvaluationGetProtocolUsage>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getConversationEvaluationGetProtocolUsageQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const conversationEvaluationCreateEvaluationProtocolCategory = (
  protocolId: number,
  createEvaluationProtocolCategoryCommand?: CreateEvaluationProtocolCategoryCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<EvaluationProtocolCategoryDto>({
    url: `/api/evaluation/protocols/${protocolId}/categories`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createEvaluationProtocolCategoryCommand,
    signal
  });
};

export const getConversationEvaluationCreateEvaluationProtocolCategoryMutationKey = () =>
  ['conversationEvaluationCreateEvaluationProtocolCategory'] as const;

export const getConversationEvaluationCreateEvaluationProtocolCategoryMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolCategory>>,
    TError,
    ConversationEvaluationCreateEvaluationProtocolCategoryMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolCategory>>,
  TError,
  ConversationEvaluationCreateEvaluationProtocolCategoryMutationVariables,
  TContext
> => {
  const mutationKey = getConversationEvaluationCreateEvaluationProtocolCategoryMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolCategory>>,
    ConversationEvaluationCreateEvaluationProtocolCategoryMutationVariables
  > = (props) => {
    const { protocolId, data } = props ?? {};

    return conversationEvaluationCreateEvaluationProtocolCategory(protocolId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationCreateEvaluationProtocolCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolCategory>>
>;
export type ConversationEvaluationCreateEvaluationProtocolCategoryMutationBody =
  | CreateEvaluationProtocolCategoryCommand
  | undefined;
export type ConversationEvaluationCreateEvaluationProtocolCategoryMutationError = unknown;
export type ConversationEvaluationCreateEvaluationProtocolCategoryMutationVariables = {
  protocolId: number;
  data?: CreateEvaluationProtocolCategoryCommand;
};

export const useConversationEvaluationCreateEvaluationProtocolCategory = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolCategory>>,
    TError,
    ConversationEvaluationCreateEvaluationProtocolCategoryMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolCategory>>,
  TError,
  ConversationEvaluationCreateEvaluationProtocolCategoryMutationVariables,
  TContext
> => {
  return useMutation(getConversationEvaluationCreateEvaluationProtocolCategoryMutationOptions(options));
};

export const conversationEvaluationGetEvaluationProtocolCategories = (protocolId: number, signal?: AbortSignal) => {
  return customAxiosInstance<EvaluationProtocolCategoryDto[]>({
    url: `/api/evaluation/protocols/${protocolId}/categories`,
    method: 'GET',
    signal
  });
};

export const getConversationEvaluationGetEvaluationProtocolCategoriesQueryKey = (protocolId: number) => {
  return [`/api/evaluation/protocols/${protocolId}/categories`] as const;
};

export const getConversationEvaluationGetEvaluationProtocolCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategories>>,
  TError = unknown
>(
  protocolId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategories>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getConversationEvaluationGetEvaluationProtocolCategoriesQueryKey(protocolId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategories>>> = ({
    signal
  }) => conversationEvaluationGetEvaluationProtocolCategories(protocolId, signal);

  return {
    queryKey,
    queryFn,
    enabled: protocolId !== null && protocolId !== undefined,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategories>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ConversationEvaluationGetEvaluationProtocolCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategories>>
>;
export type ConversationEvaluationGetEvaluationProtocolCategoriesQueryError = unknown;

export function useConversationEvaluationGetEvaluationProtocolCategories<
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategories>>,
  TError = unknown
>(
  protocolId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategories>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getConversationEvaluationGetEvaluationProtocolCategoriesQueryOptions(protocolId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const conversationEvaluationGetEvaluationProtocolCategory = (categoryId: number, signal?: AbortSignal) => {
  return customAxiosInstance<EvaluationProtocolCategoryDto>({
    url: `/api/evaluation/categories/${categoryId}`,
    method: 'GET',
    signal
  });
};

export const getConversationEvaluationGetEvaluationProtocolCategoryQueryKey = (categoryId: number) => {
  return [`/api/evaluation/categories/${categoryId}`] as const;
};

export const getConversationEvaluationGetEvaluationProtocolCategoryQueryOptions = <
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategory>>,
  TError = unknown
>(
  categoryId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategory>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getConversationEvaluationGetEvaluationProtocolCategoryQueryKey(categoryId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategory>>> = ({
    signal
  }) => conversationEvaluationGetEvaluationProtocolCategory(categoryId, signal);

  return {
    queryKey,
    queryFn,
    enabled: categoryId !== null && categoryId !== undefined,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ConversationEvaluationGetEvaluationProtocolCategoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategory>>
>;
export type ConversationEvaluationGetEvaluationProtocolCategoryQueryError = unknown;

export function useConversationEvaluationGetEvaluationProtocolCategory<
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategory>>,
  TError = unknown
>(
  categoryId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolCategory>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getConversationEvaluationGetEvaluationProtocolCategoryQueryOptions(categoryId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const conversationEvaluationUpdateEvaluationProtocolCategory = (
  categoryId: number,
  updateEvaluationProtocolCategoryCommand?: UpdateEvaluationProtocolCategoryCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<EvaluationProtocolCategoryDto>({
    url: `/api/evaluation/categories/${categoryId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateEvaluationProtocolCategoryCommand,
    signal
  });
};

export const getConversationEvaluationUpdateEvaluationProtocolCategoryMutationKey = () =>
  ['conversationEvaluationUpdateEvaluationProtocolCategory'] as const;

export const getConversationEvaluationUpdateEvaluationProtocolCategoryMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolCategory>>,
    TError,
    ConversationEvaluationUpdateEvaluationProtocolCategoryMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolCategory>>,
  TError,
  ConversationEvaluationUpdateEvaluationProtocolCategoryMutationVariables,
  TContext
> => {
  const mutationKey = getConversationEvaluationUpdateEvaluationProtocolCategoryMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolCategory>>,
    ConversationEvaluationUpdateEvaluationProtocolCategoryMutationVariables
  > = (props) => {
    const { categoryId, data } = props ?? {};

    return conversationEvaluationUpdateEvaluationProtocolCategory(categoryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationUpdateEvaluationProtocolCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolCategory>>
>;
export type ConversationEvaluationUpdateEvaluationProtocolCategoryMutationBody =
  | UpdateEvaluationProtocolCategoryCommand
  | undefined;
export type ConversationEvaluationUpdateEvaluationProtocolCategoryMutationError = unknown;
export type ConversationEvaluationUpdateEvaluationProtocolCategoryMutationVariables = {
  categoryId: number;
  data?: UpdateEvaluationProtocolCategoryCommand;
};

export const useConversationEvaluationUpdateEvaluationProtocolCategory = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolCategory>>,
    TError,
    ConversationEvaluationUpdateEvaluationProtocolCategoryMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolCategory>>,
  TError,
  ConversationEvaluationUpdateEvaluationProtocolCategoryMutationVariables,
  TContext
> => {
  return useMutation(getConversationEvaluationUpdateEvaluationProtocolCategoryMutationOptions(options));
};

export const conversationEvaluationDeleteEvaluationProtocolCategory = (categoryId: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/evaluation/categories/${categoryId}`, method: 'DELETE', signal });
};

export const getConversationEvaluationDeleteEvaluationProtocolCategoryMutationKey = () =>
  ['conversationEvaluationDeleteEvaluationProtocolCategory'] as const;

export const getConversationEvaluationDeleteEvaluationProtocolCategoryMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolCategory>>,
    TError,
    ConversationEvaluationDeleteEvaluationProtocolCategoryMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolCategory>>,
  TError,
  ConversationEvaluationDeleteEvaluationProtocolCategoryMutationVariables,
  TContext
> => {
  const mutationKey = getConversationEvaluationDeleteEvaluationProtocolCategoryMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolCategory>>,
    ConversationEvaluationDeleteEvaluationProtocolCategoryMutationVariables
  > = (props) => {
    const { categoryId } = props ?? {};

    return conversationEvaluationDeleteEvaluationProtocolCategory(categoryId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationDeleteEvaluationProtocolCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolCategory>>
>;

export type ConversationEvaluationDeleteEvaluationProtocolCategoryMutationError = unknown;
export type ConversationEvaluationDeleteEvaluationProtocolCategoryMutationVariables = { categoryId: number };

export const useConversationEvaluationDeleteEvaluationProtocolCategory = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolCategory>>,
    TError,
    ConversationEvaluationDeleteEvaluationProtocolCategoryMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolCategory>>,
  TError,
  ConversationEvaluationDeleteEvaluationProtocolCategoryMutationVariables,
  TContext
> => {
  return useMutation(getConversationEvaluationDeleteEvaluationProtocolCategoryMutationOptions(options));
};

export const conversationEvaluationReorderEvaluationProtocolCategories = (
  protocolId: number,
  conversationEvaluationReorderEvaluationProtocolCategoriesBody?: number[],
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/evaluation/protocols/${protocolId}/categories/reorder`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: conversationEvaluationReorderEvaluationProtocolCategoriesBody,
    signal
  });
};

export const getConversationEvaluationReorderEvaluationProtocolCategoriesMutationKey = () =>
  ['conversationEvaluationReorderEvaluationProtocolCategories'] as const;

export const getConversationEvaluationReorderEvaluationProtocolCategoriesMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolCategories>>,
    TError,
    ConversationEvaluationReorderEvaluationProtocolCategoriesMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolCategories>>,
  TError,
  ConversationEvaluationReorderEvaluationProtocolCategoriesMutationVariables,
  TContext
> => {
  const mutationKey = getConversationEvaluationReorderEvaluationProtocolCategoriesMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolCategories>>,
    ConversationEvaluationReorderEvaluationProtocolCategoriesMutationVariables
  > = (props) => {
    const { protocolId, data } = props ?? {};

    return conversationEvaluationReorderEvaluationProtocolCategories(protocolId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationReorderEvaluationProtocolCategoriesMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolCategories>>
>;
export type ConversationEvaluationReorderEvaluationProtocolCategoriesMutationBody = number[] | undefined;
export type ConversationEvaluationReorderEvaluationProtocolCategoriesMutationError = unknown;
export type ConversationEvaluationReorderEvaluationProtocolCategoriesMutationVariables = {
  protocolId: number;
  data?: number[];
};

export const useConversationEvaluationReorderEvaluationProtocolCategories = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolCategories>>,
    TError,
    ConversationEvaluationReorderEvaluationProtocolCategoriesMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolCategories>>,
  TError,
  ConversationEvaluationReorderEvaluationProtocolCategoriesMutationVariables,
  TContext
> => {
  return useMutation(getConversationEvaluationReorderEvaluationProtocolCategoriesMutationOptions(options));
};

export const conversationEvaluationCreateEvaluationProtocolElement = (
  categoryId: number,
  createEvaluationProtocolElementCommand?: CreateEvaluationProtocolElementCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<EvaluationProtocolElementDto>({
    url: `/api/evaluation/categories/${categoryId}/elements`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createEvaluationProtocolElementCommand,
    signal
  });
};

export const getConversationEvaluationCreateEvaluationProtocolElementMutationKey = () =>
  ['conversationEvaluationCreateEvaluationProtocolElement'] as const;

export const getConversationEvaluationCreateEvaluationProtocolElementMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolElement>>,
    TError,
    ConversationEvaluationCreateEvaluationProtocolElementMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolElement>>,
  TError,
  ConversationEvaluationCreateEvaluationProtocolElementMutationVariables,
  TContext
> => {
  const mutationKey = getConversationEvaluationCreateEvaluationProtocolElementMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolElement>>,
    ConversationEvaluationCreateEvaluationProtocolElementMutationVariables
  > = (props) => {
    const { categoryId, data } = props ?? {};

    return conversationEvaluationCreateEvaluationProtocolElement(categoryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationCreateEvaluationProtocolElementMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolElement>>
>;
export type ConversationEvaluationCreateEvaluationProtocolElementMutationBody =
  | CreateEvaluationProtocolElementCommand
  | undefined;
export type ConversationEvaluationCreateEvaluationProtocolElementMutationError = unknown;
export type ConversationEvaluationCreateEvaluationProtocolElementMutationVariables = {
  categoryId: number;
  data?: CreateEvaluationProtocolElementCommand;
};

export const useConversationEvaluationCreateEvaluationProtocolElement = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolElement>>,
    TError,
    ConversationEvaluationCreateEvaluationProtocolElementMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationCreateEvaluationProtocolElement>>,
  TError,
  ConversationEvaluationCreateEvaluationProtocolElementMutationVariables,
  TContext
> => {
  return useMutation(getConversationEvaluationCreateEvaluationProtocolElementMutationOptions(options));
};

export const conversationEvaluationGetEvaluationProtocolElements = (categoryId: number, signal?: AbortSignal) => {
  return customAxiosInstance<EvaluationProtocolElementDto[]>({
    url: `/api/evaluation/categories/${categoryId}/elements`,
    method: 'GET',
    signal
  });
};

export const getConversationEvaluationGetEvaluationProtocolElementsQueryKey = (categoryId: number) => {
  return [`/api/evaluation/categories/${categoryId}/elements`] as const;
};

export const getConversationEvaluationGetEvaluationProtocolElementsQueryOptions = <
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElements>>,
  TError = unknown
>(
  categoryId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElements>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getConversationEvaluationGetEvaluationProtocolElementsQueryKey(categoryId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElements>>> = ({
    signal
  }) => conversationEvaluationGetEvaluationProtocolElements(categoryId, signal);

  return {
    queryKey,
    queryFn,
    enabled: categoryId !== null && categoryId !== undefined,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElements>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ConversationEvaluationGetEvaluationProtocolElementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElements>>
>;
export type ConversationEvaluationGetEvaluationProtocolElementsQueryError = unknown;

export function useConversationEvaluationGetEvaluationProtocolElements<
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElements>>,
  TError = unknown
>(
  categoryId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElements>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getConversationEvaluationGetEvaluationProtocolElementsQueryOptions(categoryId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const conversationEvaluationGetEvaluationProtocolElement = (elementId: number, signal?: AbortSignal) => {
  return customAxiosInstance<EvaluationProtocolElementDto>({
    url: `/api/evaluation/elements/${elementId}`,
    method: 'GET',
    signal
  });
};

export const getConversationEvaluationGetEvaluationProtocolElementQueryKey = (elementId: number) => {
  return [`/api/evaluation/elements/${elementId}`] as const;
};

export const getConversationEvaluationGetEvaluationProtocolElementQueryOptions = <
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElement>>,
  TError = unknown
>(
  elementId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElement>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getConversationEvaluationGetEvaluationProtocolElementQueryKey(elementId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElement>>> = ({
    signal
  }) => conversationEvaluationGetEvaluationProtocolElement(elementId, signal);

  return {
    queryKey,
    queryFn,
    enabled: elementId !== null && elementId !== undefined,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ConversationEvaluationGetEvaluationProtocolElementQueryResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElement>>
>;
export type ConversationEvaluationGetEvaluationProtocolElementQueryError = unknown;

export function useConversationEvaluationGetEvaluationProtocolElement<
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElement>>,
  TError = unknown
>(
  elementId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof conversationEvaluationGetEvaluationProtocolElement>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getConversationEvaluationGetEvaluationProtocolElementQueryOptions(elementId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const conversationEvaluationUpdateEvaluationProtocolElement = (
  elementId: number,
  updateEvaluationProtocolElementCommand?: UpdateEvaluationProtocolElementCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<EvaluationProtocolElementDto>({
    url: `/api/evaluation/elements/${elementId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateEvaluationProtocolElementCommand,
    signal
  });
};

export const getConversationEvaluationUpdateEvaluationProtocolElementMutationKey = () =>
  ['conversationEvaluationUpdateEvaluationProtocolElement'] as const;

export const getConversationEvaluationUpdateEvaluationProtocolElementMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolElement>>,
    TError,
    ConversationEvaluationUpdateEvaluationProtocolElementMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolElement>>,
  TError,
  ConversationEvaluationUpdateEvaluationProtocolElementMutationVariables,
  TContext
> => {
  const mutationKey = getConversationEvaluationUpdateEvaluationProtocolElementMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolElement>>,
    ConversationEvaluationUpdateEvaluationProtocolElementMutationVariables
  > = (props) => {
    const { elementId, data } = props ?? {};

    return conversationEvaluationUpdateEvaluationProtocolElement(elementId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationUpdateEvaluationProtocolElementMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolElement>>
>;
export type ConversationEvaluationUpdateEvaluationProtocolElementMutationBody =
  | UpdateEvaluationProtocolElementCommand
  | undefined;
export type ConversationEvaluationUpdateEvaluationProtocolElementMutationError = unknown;
export type ConversationEvaluationUpdateEvaluationProtocolElementMutationVariables = {
  elementId: number;
  data?: UpdateEvaluationProtocolElementCommand;
};

export const useConversationEvaluationUpdateEvaluationProtocolElement = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolElement>>,
    TError,
    ConversationEvaluationUpdateEvaluationProtocolElementMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationUpdateEvaluationProtocolElement>>,
  TError,
  ConversationEvaluationUpdateEvaluationProtocolElementMutationVariables,
  TContext
> => {
  return useMutation(getConversationEvaluationUpdateEvaluationProtocolElementMutationOptions(options));
};

export const conversationEvaluationDeleteEvaluationProtocolElement = (elementId: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/evaluation/elements/${elementId}`, method: 'DELETE', signal });
};

export const getConversationEvaluationDeleteEvaluationProtocolElementMutationKey = () =>
  ['conversationEvaluationDeleteEvaluationProtocolElement'] as const;

export const getConversationEvaluationDeleteEvaluationProtocolElementMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolElement>>,
    TError,
    ConversationEvaluationDeleteEvaluationProtocolElementMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolElement>>,
  TError,
  ConversationEvaluationDeleteEvaluationProtocolElementMutationVariables,
  TContext
> => {
  const mutationKey = getConversationEvaluationDeleteEvaluationProtocolElementMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolElement>>,
    ConversationEvaluationDeleteEvaluationProtocolElementMutationVariables
  > = (props) => {
    const { elementId } = props ?? {};

    return conversationEvaluationDeleteEvaluationProtocolElement(elementId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationDeleteEvaluationProtocolElementMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolElement>>
>;

export type ConversationEvaluationDeleteEvaluationProtocolElementMutationError = unknown;
export type ConversationEvaluationDeleteEvaluationProtocolElementMutationVariables = { elementId: number };

export const useConversationEvaluationDeleteEvaluationProtocolElement = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolElement>>,
    TError,
    ConversationEvaluationDeleteEvaluationProtocolElementMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluationProtocolElement>>,
  TError,
  ConversationEvaluationDeleteEvaluationProtocolElementMutationVariables,
  TContext
> => {
  return useMutation(getConversationEvaluationDeleteEvaluationProtocolElementMutationOptions(options));
};

export const conversationEvaluationReorderEvaluationProtocolElements = (
  categoryId: number,
  conversationEvaluationReorderEvaluationProtocolElementsBody?: number[],
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/evaluation/categories/${categoryId}/elements/reorder`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: conversationEvaluationReorderEvaluationProtocolElementsBody,
    signal
  });
};

export const getConversationEvaluationReorderEvaluationProtocolElementsMutationKey = () =>
  ['conversationEvaluationReorderEvaluationProtocolElements'] as const;

export const getConversationEvaluationReorderEvaluationProtocolElementsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolElements>>,
    TError,
    ConversationEvaluationReorderEvaluationProtocolElementsMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolElements>>,
  TError,
  ConversationEvaluationReorderEvaluationProtocolElementsMutationVariables,
  TContext
> => {
  const mutationKey = getConversationEvaluationReorderEvaluationProtocolElementsMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolElements>>,
    ConversationEvaluationReorderEvaluationProtocolElementsMutationVariables
  > = (props) => {
    const { categoryId, data } = props ?? {};

    return conversationEvaluationReorderEvaluationProtocolElements(categoryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationReorderEvaluationProtocolElementsMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolElements>>
>;
export type ConversationEvaluationReorderEvaluationProtocolElementsMutationBody = number[] | undefined;
export type ConversationEvaluationReorderEvaluationProtocolElementsMutationError = unknown;
export type ConversationEvaluationReorderEvaluationProtocolElementsMutationVariables = {
  categoryId: number;
  data?: number[];
};

export const useConversationEvaluationReorderEvaluationProtocolElements = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolElements>>,
    TError,
    ConversationEvaluationReorderEvaluationProtocolElementsMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationReorderEvaluationProtocolElements>>,
  TError,
  ConversationEvaluationReorderEvaluationProtocolElementsMutationVariables,
  TContext
> => {
  return useMutation(getConversationEvaluationReorderEvaluationProtocolElementsMutationOptions(options));
};

export const conversationEvaluationUpdateProtocolCompanyAccess = (
  id: number,
  companyId: number,
  updateEvaluationProtocolCompanyAccessCommand?: UpdateEvaluationProtocolCompanyAccessCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<EvaluationProtocolDto>({
    url: `/api/evaluation/protocols/${id}/companies/${companyId}/access`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateEvaluationProtocolCompanyAccessCommand,
    signal
  });
};

export const getConversationEvaluationUpdateProtocolCompanyAccessMutationKey = () =>
  ['conversationEvaluationUpdateProtocolCompanyAccess'] as const;

export const getConversationEvaluationUpdateProtocolCompanyAccessMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationUpdateProtocolCompanyAccess>>,
    TError,
    ConversationEvaluationUpdateProtocolCompanyAccessMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationUpdateProtocolCompanyAccess>>,
  TError,
  ConversationEvaluationUpdateProtocolCompanyAccessMutationVariables,
  TContext
> => {
  const mutationKey = getConversationEvaluationUpdateProtocolCompanyAccessMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationUpdateProtocolCompanyAccess>>,
    ConversationEvaluationUpdateProtocolCompanyAccessMutationVariables
  > = (props) => {
    const { id, companyId, data } = props ?? {};

    return conversationEvaluationUpdateProtocolCompanyAccess(id, companyId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationUpdateProtocolCompanyAccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationUpdateProtocolCompanyAccess>>
>;
export type ConversationEvaluationUpdateProtocolCompanyAccessMutationBody =
  | UpdateEvaluationProtocolCompanyAccessCommand
  | undefined;
export type ConversationEvaluationUpdateProtocolCompanyAccessMutationError = unknown;
export type ConversationEvaluationUpdateProtocolCompanyAccessMutationVariables = {
  id: number;
  companyId: number;
  data?: UpdateEvaluationProtocolCompanyAccessCommand;
};

export const useConversationEvaluationUpdateProtocolCompanyAccess = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationUpdateProtocolCompanyAccess>>,
    TError,
    ConversationEvaluationUpdateProtocolCompanyAccessMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationUpdateProtocolCompanyAccess>>,
  TError,
  ConversationEvaluationUpdateProtocolCompanyAccessMutationVariables,
  TContext
> => {
  return useMutation(getConversationEvaluationUpdateProtocolCompanyAccessMutationOptions(options));
};

export const conversationEvaluationGetEvaluations = (signal?: AbortSignal) => {
  return customAxiosInstance<EvaluationDto[]>({ url: `/api/evaluation/evaluations`, method: 'GET', signal });
};

export const getConversationEvaluationGetEvaluationsQueryKey = () => {
  return [`/api/evaluation/evaluations`] as const;
};

export const getConversationEvaluationGetEvaluationsQueryOptions = <
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluations>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof conversationEvaluationGetEvaluations>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getConversationEvaluationGetEvaluationsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof conversationEvaluationGetEvaluations>>> = ({ signal }) =>
    conversationEvaluationGetEvaluations(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof conversationEvaluationGetEvaluations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ConversationEvaluationGetEvaluationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationGetEvaluations>>
>;
export type ConversationEvaluationGetEvaluationsQueryError = unknown;

export function useConversationEvaluationGetEvaluations<
  TData = Awaited<ReturnType<typeof conversationEvaluationGetEvaluations>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof conversationEvaluationGetEvaluations>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getConversationEvaluationGetEvaluationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const conversationEvaluationDeleteEvaluation = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/evaluation/DeleteEvaluation/${id}`, method: 'DELETE', signal });
};

export const getConversationEvaluationDeleteEvaluationMutationKey = () =>
  ['conversationEvaluationDeleteEvaluation'] as const;

export const getConversationEvaluationDeleteEvaluationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluation>>,
    TError,
    ConversationEvaluationDeleteEvaluationMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluation>>,
  TError,
  ConversationEvaluationDeleteEvaluationMutationVariables,
  TContext
> => {
  const mutationKey = getConversationEvaluationDeleteEvaluationMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluation>>,
    ConversationEvaluationDeleteEvaluationMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return conversationEvaluationDeleteEvaluation(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConversationEvaluationDeleteEvaluationMutationResult = NonNullable<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluation>>
>;

export type ConversationEvaluationDeleteEvaluationMutationError = unknown;
export type ConversationEvaluationDeleteEvaluationMutationVariables = { id: number };

export const useConversationEvaluationDeleteEvaluation = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluation>>,
    TError,
    ConversationEvaluationDeleteEvaluationMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof conversationEvaluationDeleteEvaluation>>,
  TError,
  ConversationEvaluationDeleteEvaluationMutationVariables,
  TContext
> => {
  return useMutation(getConversationEvaluationDeleteEvaluationMutationOptions(options));
};

export const courseGet = (params?: CourseGetParams, signal?: AbortSignal) => {
  return customAxiosInstance<PartialListCourseDto>({ url: `/api/Course/Get`, method: 'GET', params, signal });
};

export const getCourseGetQueryKey = (params?: CourseGetParams) => {
  return [`/api/Course/Get`, ...(params ? [params] : [])] as const;
};

export const getCourseGetQueryOptions = <TData = Awaited<ReturnType<typeof courseGet>>, TError = unknown>(
  params?: CourseGetParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof courseGet>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCourseGetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof courseGet>>> = ({ signal }) => courseGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof courseGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CourseGetQueryResult = NonNullable<Awaited<ReturnType<typeof courseGet>>>;
export type CourseGetQueryError = unknown;

export function useCourseGet<TData = Awaited<ReturnType<typeof courseGet>>, TError = unknown>(
  params?: CourseGetParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof courseGet>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCourseGetQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const courseGetCourse = (courseId: number, signal?: AbortSignal) => {
  return customAxiosInstance<CourseDto>({ url: `/api/Course/GetCourse/${courseId}`, method: 'GET', signal });
};

export const getCourseGetCourseQueryKey = (courseId: number) => {
  return [`/api/Course/GetCourse/${courseId}`] as const;
};

export const getCourseGetCourseQueryOptions = <TData = Awaited<ReturnType<typeof courseGetCourse>>, TError = unknown>(
  courseId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetCourse>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCourseGetCourseQueryKey(courseId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof courseGetCourse>>> = ({ signal }) =>
    courseGetCourse(courseId, signal);

  return {
    queryKey,
    queryFn,
    enabled: courseId !== null && courseId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof courseGetCourse>>, TError, TData> & { queryKey: QueryKey };
};

export type CourseGetCourseQueryResult = NonNullable<Awaited<ReturnType<typeof courseGetCourse>>>;
export type CourseGetCourseQueryError = unknown;

export function useCourseGetCourse<TData = Awaited<ReturnType<typeof courseGetCourse>>, TError = unknown>(
  courseId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetCourse>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCourseGetCourseQueryOptions(courseId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const courseCreateCourse = (createCourseCommand?: CreateCourseCommand, signal?: AbortSignal) => {
  return customAxiosInstance<CourseDto>({
    url: `/api/Course/CreateCourse`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: createCourseCommand,
    signal
  });
};

export const getCourseCreateCourseMutationKey = () => ['courseCreateCourse'] as const;

export const getCourseCreateCourseMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateCourse>>,
    TError,
    CourseCreateCourseMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseCreateCourse>>,
  TError,
  CourseCreateCourseMutationVariables,
  TContext
> => {
  const mutationKey = getCourseCreateCourseMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseCreateCourse>>,
    CourseCreateCourseMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return courseCreateCourse(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseCreateCourseMutationResult = NonNullable<Awaited<ReturnType<typeof courseCreateCourse>>>;
export type CourseCreateCourseMutationBody = CreateCourseCommand | undefined;
export type CourseCreateCourseMutationError = unknown;
export type CourseCreateCourseMutationVariables = { data?: CreateCourseCommand };

export const useCourseCreateCourse = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateCourse>>,
    TError,
    CourseCreateCourseMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseCreateCourse>>,
  TError,
  CourseCreateCourseMutationVariables,
  TContext
> => {
  return useMutation(getCourseCreateCourseMutationOptions(options));
};

export const courseUpdate = (courseId: number, updateCourseCommand?: UpdateCourseCommand, signal?: AbortSignal) => {
  return customAxiosInstance<CourseDto>({
    url: `/api/Course/Update/${courseId}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateCourseCommand,
    signal
  });
};

export const getCourseUpdateMutationKey = () => ['courseUpdate'] as const;

export const getCourseUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseUpdate>>,
    TError,
    CourseUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof courseUpdate>>, TError, CourseUpdateMutationVariables, TContext> => {
  const mutationKey = getCourseUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof courseUpdate>>, CourseUpdateMutationVariables> = (
    props
  ) => {
    const { courseId, data } = props ?? {};

    return courseUpdate(courseId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof courseUpdate>>>;
export type CourseUpdateMutationBody = UpdateCourseCommand | undefined;
export type CourseUpdateMutationError = unknown;
export type CourseUpdateMutationVariables = { courseId: number; data?: UpdateCourseCommand };

export const useCourseUpdate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseUpdate>>,
    TError,
    CourseUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<Awaited<ReturnType<typeof courseUpdate>>, TError, CourseUpdateMutationVariables, TContext> => {
  return useMutation(getCourseUpdateMutationOptions(options));
};

export const courseGetCourseAvailableScenes = (courseId: number, signal?: AbortSignal) => {
  return customAxiosInstance<ScenarioDto[]>({
    url: `/api/Course/GetCourseAvailableScenes/${courseId}/available-scenes`,
    method: 'GET',
    signal
  });
};

export const getCourseGetCourseAvailableScenesQueryKey = (courseId: number) => {
  return [`/api/Course/GetCourseAvailableScenes/${courseId}/available-scenes`] as const;
};

export const getCourseGetCourseAvailableScenesQueryOptions = <
  TData = Awaited<ReturnType<typeof courseGetCourseAvailableScenes>>,
  TError = unknown
>(
  courseId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetCourseAvailableScenes>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCourseGetCourseAvailableScenesQueryKey(courseId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof courseGetCourseAvailableScenes>>> = ({ signal }) =>
    courseGetCourseAvailableScenes(courseId, signal);

  return {
    queryKey,
    queryFn,
    enabled: courseId !== null && courseId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof courseGetCourseAvailableScenes>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type CourseGetCourseAvailableScenesQueryResult = NonNullable<
  Awaited<ReturnType<typeof courseGetCourseAvailableScenes>>
>;
export type CourseGetCourseAvailableScenesQueryError = unknown;

export function useCourseGetCourseAvailableScenes<
  TData = Awaited<ReturnType<typeof courseGetCourseAvailableScenes>>,
  TError = unknown
>(
  courseId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetCourseAvailableScenes>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCourseGetCourseAvailableScenesQueryOptions(courseId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const courseCreateCourseScene = (courseId: number, scenarioId: number, signal?: AbortSignal) => {
  return customAxiosInstance<CourseDto>({
    url: `/api/Course/CreateCourseScene/${courseId}/scene/${scenarioId}`,
    method: 'POST',
    signal
  });
};

export const getCourseCreateCourseSceneMutationKey = () => ['courseCreateCourseScene'] as const;

export const getCourseCreateCourseSceneMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateCourseScene>>,
    TError,
    CourseCreateCourseSceneMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseCreateCourseScene>>,
  TError,
  CourseCreateCourseSceneMutationVariables,
  TContext
> => {
  const mutationKey = getCourseCreateCourseSceneMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseCreateCourseScene>>,
    CourseCreateCourseSceneMutationVariables
  > = (props) => {
    const { courseId, scenarioId } = props ?? {};

    return courseCreateCourseScene(courseId, scenarioId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseCreateCourseSceneMutationResult = NonNullable<Awaited<ReturnType<typeof courseCreateCourseScene>>>;

export type CourseCreateCourseSceneMutationError = unknown;
export type CourseCreateCourseSceneMutationVariables = { courseId: number; scenarioId: number };

export const useCourseCreateCourseScene = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateCourseScene>>,
    TError,
    CourseCreateCourseSceneMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseCreateCourseScene>>,
  TError,
  CourseCreateCourseSceneMutationVariables,
  TContext
> => {
  return useMutation(getCourseCreateCourseSceneMutationOptions(options));
};

export const courseDeleteCourseScene = (courseId: number, scenarioId: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/Course/DeleteCourseScene/${courseId}/scene/${scenarioId}`,
    method: 'DELETE',
    signal
  });
};

export const getCourseDeleteCourseSceneMutationKey = () => ['courseDeleteCourseScene'] as const;

export const getCourseDeleteCourseSceneMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseDeleteCourseScene>>,
    TError,
    CourseDeleteCourseSceneMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseDeleteCourseScene>>,
  TError,
  CourseDeleteCourseSceneMutationVariables,
  TContext
> => {
  const mutationKey = getCourseDeleteCourseSceneMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseDeleteCourseScene>>,
    CourseDeleteCourseSceneMutationVariables
  > = (props) => {
    const { courseId, scenarioId } = props ?? {};

    return courseDeleteCourseScene(courseId, scenarioId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseDeleteCourseSceneMutationResult = NonNullable<Awaited<ReturnType<typeof courseDeleteCourseScene>>>;

export type CourseDeleteCourseSceneMutationError = unknown;
export type CourseDeleteCourseSceneMutationVariables = { courseId: number; scenarioId: number };

export const useCourseDeleteCourseScene = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseDeleteCourseScene>>,
    TError,
    CourseDeleteCourseSceneMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseDeleteCourseScene>>,
  TError,
  CourseDeleteCourseSceneMutationVariables,
  TContext
> => {
  return useMutation(getCourseDeleteCourseSceneMutationOptions(options));
};

export const courseDeleteCourse = (courseId: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/Course/DeleteCourse/${courseId}`, method: 'DELETE', signal });
};

export const getCourseDeleteCourseMutationKey = () => ['courseDeleteCourse'] as const;

export const getCourseDeleteCourseMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseDeleteCourse>>,
    TError,
    CourseDeleteCourseMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseDeleteCourse>>,
  TError,
  CourseDeleteCourseMutationVariables,
  TContext
> => {
  const mutationKey = getCourseDeleteCourseMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseDeleteCourse>>,
    CourseDeleteCourseMutationVariables
  > = (props) => {
    const { courseId } = props ?? {};

    return courseDeleteCourse(courseId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseDeleteCourseMutationResult = NonNullable<Awaited<ReturnType<typeof courseDeleteCourse>>>;

export type CourseDeleteCourseMutationError = unknown;
export type CourseDeleteCourseMutationVariables = { courseId: number };

export const useCourseDeleteCourse = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseDeleteCourse>>,
    TError,
    CourseDeleteCourseMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseDeleteCourse>>,
  TError,
  CourseDeleteCourseMutationVariables,
  TContext
> => {
  return useMutation(getCourseDeleteCourseMutationOptions(options));
};

export const courseCreateScheduledCourse = (
  courseId: number,
  createScheduledCourseCommand?: CreateScheduledCourseCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScheduledCourseDto>({
    url: `/api/Course/CreateScheduledCourse/schedule/${courseId}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createScheduledCourseCommand,
    signal
  });
};

export const getCourseCreateScheduledCourseMutationKey = () => ['courseCreateScheduledCourse'] as const;

export const getCourseCreateScheduledCourseMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateScheduledCourse>>,
    TError,
    CourseCreateScheduledCourseMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseCreateScheduledCourse>>,
  TError,
  CourseCreateScheduledCourseMutationVariables,
  TContext
> => {
  const mutationKey = getCourseCreateScheduledCourseMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseCreateScheduledCourse>>,
    CourseCreateScheduledCourseMutationVariables
  > = (props) => {
    const { courseId, data } = props ?? {};

    return courseCreateScheduledCourse(courseId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseCreateScheduledCourseMutationResult = NonNullable<
  Awaited<ReturnType<typeof courseCreateScheduledCourse>>
>;
export type CourseCreateScheduledCourseMutationBody = CreateScheduledCourseCommand | undefined;
export type CourseCreateScheduledCourseMutationError = unknown;
export type CourseCreateScheduledCourseMutationVariables = { courseId: number; data?: CreateScheduledCourseCommand };

export const useCourseCreateScheduledCourse = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateScheduledCourse>>,
    TError,
    CourseCreateScheduledCourseMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseCreateScheduledCourse>>,
  TError,
  CourseCreateScheduledCourseMutationVariables,
  TContext
> => {
  return useMutation(getCourseCreateScheduledCourseMutationOptions(options));
};

export const courseUpdateScheduledCourse = (
  scheduledCourseId: number,
  updateScheduledCourseRequestCommand?: UpdateScheduledCourseRequestCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScheduledCourseDto>({
    url: `/api/Course/UpdateScheduledCourse/schedule/${scheduledCourseId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateScheduledCourseRequestCommand,
    signal
  });
};

export const getCourseUpdateScheduledCourseMutationKey = () => ['courseUpdateScheduledCourse'] as const;

export const getCourseUpdateScheduledCourseMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseUpdateScheduledCourse>>,
    TError,
    CourseUpdateScheduledCourseMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseUpdateScheduledCourse>>,
  TError,
  CourseUpdateScheduledCourseMutationVariables,
  TContext
> => {
  const mutationKey = getCourseUpdateScheduledCourseMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseUpdateScheduledCourse>>,
    CourseUpdateScheduledCourseMutationVariables
  > = (props) => {
    const { scheduledCourseId, data } = props ?? {};

    return courseUpdateScheduledCourse(scheduledCourseId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseUpdateScheduledCourseMutationResult = NonNullable<
  Awaited<ReturnType<typeof courseUpdateScheduledCourse>>
>;
export type CourseUpdateScheduledCourseMutationBody = UpdateScheduledCourseRequestCommand | undefined;
export type CourseUpdateScheduledCourseMutationError = unknown;
export type CourseUpdateScheduledCourseMutationVariables = {
  scheduledCourseId: number;
  data?: UpdateScheduledCourseRequestCommand;
};

export const useCourseUpdateScheduledCourse = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseUpdateScheduledCourse>>,
    TError,
    CourseUpdateScheduledCourseMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseUpdateScheduledCourse>>,
  TError,
  CourseUpdateScheduledCourseMutationVariables,
  TContext
> => {
  return useMutation(getCourseUpdateScheduledCourseMutationOptions(options));
};

export const courseDeleteScheduledCourse = (scheduledCourseId: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/Course/DeleteScheduledCourse/schedule/${scheduledCourseId}`,
    method: 'DELETE',
    signal
  });
};

export const getCourseDeleteScheduledCourseMutationKey = () => ['courseDeleteScheduledCourse'] as const;

export const getCourseDeleteScheduledCourseMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseDeleteScheduledCourse>>,
    TError,
    CourseDeleteScheduledCourseMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseDeleteScheduledCourse>>,
  TError,
  CourseDeleteScheduledCourseMutationVariables,
  TContext
> => {
  const mutationKey = getCourseDeleteScheduledCourseMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseDeleteScheduledCourse>>,
    CourseDeleteScheduledCourseMutationVariables
  > = (props) => {
    const { scheduledCourseId } = props ?? {};

    return courseDeleteScheduledCourse(scheduledCourseId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseDeleteScheduledCourseMutationResult = NonNullable<
  Awaited<ReturnType<typeof courseDeleteScheduledCourse>>
>;

export type CourseDeleteScheduledCourseMutationError = unknown;
export type CourseDeleteScheduledCourseMutationVariables = { scheduledCourseId: number };

export const useCourseDeleteScheduledCourse = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseDeleteScheduledCourse>>,
    TError,
    CourseDeleteScheduledCourseMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseDeleteScheduledCourse>>,
  TError,
  CourseDeleteScheduledCourseMutationVariables,
  TContext
> => {
  return useMutation(getCourseDeleteScheduledCourseMutationOptions(options));
};

export const courseCreateScheduledCourseUser = (
  scheduledCourseId: number,
  scheduledCourseAssignmentCommand?: ScheduledCourseAssignmentCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScheduledCourseDto>({
    url: `/api/Course/CreateScheduledCourseUser/schedule/${scheduledCourseId}/user`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: scheduledCourseAssignmentCommand,
    signal
  });
};

export const getCourseCreateScheduledCourseUserMutationKey = () => ['courseCreateScheduledCourseUser'] as const;

export const getCourseCreateScheduledCourseUserMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateScheduledCourseUser>>,
    TError,
    CourseCreateScheduledCourseUserMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseCreateScheduledCourseUser>>,
  TError,
  CourseCreateScheduledCourseUserMutationVariables,
  TContext
> => {
  const mutationKey = getCourseCreateScheduledCourseUserMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseCreateScheduledCourseUser>>,
    CourseCreateScheduledCourseUserMutationVariables
  > = (props) => {
    const { scheduledCourseId, data } = props ?? {};

    return courseCreateScheduledCourseUser(scheduledCourseId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseCreateScheduledCourseUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof courseCreateScheduledCourseUser>>
>;
export type CourseCreateScheduledCourseUserMutationBody = ScheduledCourseAssignmentCommand | undefined;
export type CourseCreateScheduledCourseUserMutationError = unknown;
export type CourseCreateScheduledCourseUserMutationVariables = {
  scheduledCourseId: number;
  data?: ScheduledCourseAssignmentCommand;
};

export const useCourseCreateScheduledCourseUser = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateScheduledCourseUser>>,
    TError,
    CourseCreateScheduledCourseUserMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseCreateScheduledCourseUser>>,
  TError,
  CourseCreateScheduledCourseUserMutationVariables,
  TContext
> => {
  return useMutation(getCourseCreateScheduledCourseUserMutationOptions(options));
};

export const courseDeleteScheduledCourseUser = (scheduledCourseId: number, userId: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/Course/DeleteScheduledCourseUser/schedule/${scheduledCourseId}/user/${userId}`,
    method: 'DELETE',
    signal
  });
};

export const getCourseDeleteScheduledCourseUserMutationKey = () => ['courseDeleteScheduledCourseUser'] as const;

export const getCourseDeleteScheduledCourseUserMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseDeleteScheduledCourseUser>>,
    TError,
    CourseDeleteScheduledCourseUserMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseDeleteScheduledCourseUser>>,
  TError,
  CourseDeleteScheduledCourseUserMutationVariables,
  TContext
> => {
  const mutationKey = getCourseDeleteScheduledCourseUserMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseDeleteScheduledCourseUser>>,
    CourseDeleteScheduledCourseUserMutationVariables
  > = (props) => {
    const { scheduledCourseId, userId } = props ?? {};

    return courseDeleteScheduledCourseUser(scheduledCourseId, userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseDeleteScheduledCourseUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof courseDeleteScheduledCourseUser>>
>;

export type CourseDeleteScheduledCourseUserMutationError = unknown;
export type CourseDeleteScheduledCourseUserMutationVariables = { scheduledCourseId: number; userId: number };

export const useCourseDeleteScheduledCourseUser = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseDeleteScheduledCourseUser>>,
    TError,
    CourseDeleteScheduledCourseUserMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseDeleteScheduledCourseUser>>,
  TError,
  CourseDeleteScheduledCourseUserMutationVariables,
  TContext
> => {
  return useMutation(getCourseDeleteScheduledCourseUserMutationOptions(options));
};

export const courseCreateScheduledCourseUserGroup = (
  scheduledCourseId: number,
  scheduledCourseAssignmentCommand?: ScheduledCourseAssignmentCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScheduledCourseDto>({
    url: `/api/Course/CreateScheduledCourseUserGroup/schedule/${scheduledCourseId}/user-group`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: scheduledCourseAssignmentCommand,
    signal
  });
};

export const getCourseCreateScheduledCourseUserGroupMutationKey = () =>
  ['courseCreateScheduledCourseUserGroup'] as const;

export const getCourseCreateScheduledCourseUserGroupMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateScheduledCourseUserGroup>>,
    TError,
    CourseCreateScheduledCourseUserGroupMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseCreateScheduledCourseUserGroup>>,
  TError,
  CourseCreateScheduledCourseUserGroupMutationVariables,
  TContext
> => {
  const mutationKey = getCourseCreateScheduledCourseUserGroupMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseCreateScheduledCourseUserGroup>>,
    CourseCreateScheduledCourseUserGroupMutationVariables
  > = (props) => {
    const { scheduledCourseId, data } = props ?? {};

    return courseCreateScheduledCourseUserGroup(scheduledCourseId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseCreateScheduledCourseUserGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof courseCreateScheduledCourseUserGroup>>
>;
export type CourseCreateScheduledCourseUserGroupMutationBody = ScheduledCourseAssignmentCommand | undefined;
export type CourseCreateScheduledCourseUserGroupMutationError = unknown;
export type CourseCreateScheduledCourseUserGroupMutationVariables = {
  scheduledCourseId: number;
  data?: ScheduledCourseAssignmentCommand;
};

export const useCourseCreateScheduledCourseUserGroup = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateScheduledCourseUserGroup>>,
    TError,
    CourseCreateScheduledCourseUserGroupMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseCreateScheduledCourseUserGroup>>,
  TError,
  CourseCreateScheduledCourseUserGroupMutationVariables,
  TContext
> => {
  return useMutation(getCourseCreateScheduledCourseUserGroupMutationOptions(options));
};

export const courseDeleteScheduledCourseUserGroup = (
  scheduledCourseId: number,
  userGroupId: number,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/Course/DeleteScheduledCourseUserGroup/schedule/${scheduledCourseId}/user-group/${userGroupId}`,
    method: 'DELETE',
    signal
  });
};

export const getCourseDeleteScheduledCourseUserGroupMutationKey = () =>
  ['courseDeleteScheduledCourseUserGroup'] as const;

export const getCourseDeleteScheduledCourseUserGroupMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseDeleteScheduledCourseUserGroup>>,
    TError,
    CourseDeleteScheduledCourseUserGroupMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseDeleteScheduledCourseUserGroup>>,
  TError,
  CourseDeleteScheduledCourseUserGroupMutationVariables,
  TContext
> => {
  const mutationKey = getCourseDeleteScheduledCourseUserGroupMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseDeleteScheduledCourseUserGroup>>,
    CourseDeleteScheduledCourseUserGroupMutationVariables
  > = (props) => {
    const { scheduledCourseId, userGroupId } = props ?? {};

    return courseDeleteScheduledCourseUserGroup(scheduledCourseId, userGroupId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseDeleteScheduledCourseUserGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof courseDeleteScheduledCourseUserGroup>>
>;

export type CourseDeleteScheduledCourseUserGroupMutationError = unknown;
export type CourseDeleteScheduledCourseUserGroupMutationVariables = { scheduledCourseId: number; userGroupId: number };

export const useCourseDeleteScheduledCourseUserGroup = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseDeleteScheduledCourseUserGroup>>,
    TError,
    CourseDeleteScheduledCourseUserGroupMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseDeleteScheduledCourseUserGroup>>,
  TError,
  CourseDeleteScheduledCourseUserGroupMutationVariables,
  TContext
> => {
  return useMutation(getCourseDeleteScheduledCourseUserGroupMutationOptions(options));
};

export const courseGetScheduledCourseAllAssignedUsers = (scheduledCourseId: number, signal?: AbortSignal) => {
  return customAxiosInstance<UserDto[]>({
    url: `/api/Course/GetScheduledCourseAllAssignedUsers/schedule/${scheduledCourseId}/all-assigned-users`,
    method: 'GET',
    signal
  });
};

export const getCourseGetScheduledCourseAllAssignedUsersQueryKey = (scheduledCourseId: number) => {
  return [`/api/Course/GetScheduledCourseAllAssignedUsers/schedule/${scheduledCourseId}/all-assigned-users`] as const;
};

export const getCourseGetScheduledCourseAllAssignedUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof courseGetScheduledCourseAllAssignedUsers>>,
  TError = unknown
>(
  scheduledCourseId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetScheduledCourseAllAssignedUsers>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCourseGetScheduledCourseAllAssignedUsersQueryKey(scheduledCourseId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof courseGetScheduledCourseAllAssignedUsers>>> = ({ signal }) =>
    courseGetScheduledCourseAllAssignedUsers(scheduledCourseId, signal);

  return {
    queryKey,
    queryFn,
    enabled: scheduledCourseId !== null && scheduledCourseId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof courseGetScheduledCourseAllAssignedUsers>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type CourseGetScheduledCourseAllAssignedUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof courseGetScheduledCourseAllAssignedUsers>>
>;
export type CourseGetScheduledCourseAllAssignedUsersQueryError = unknown;

export function useCourseGetScheduledCourseAllAssignedUsers<
  TData = Awaited<ReturnType<typeof courseGetScheduledCourseAllAssignedUsers>>,
  TError = unknown
>(
  scheduledCourseId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetScheduledCourseAllAssignedUsers>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCourseGetScheduledCourseAllAssignedUsersQueryOptions(scheduledCourseId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const courseGetScheduledCourseAvailableUsers = (scheduledCourseId: number, signal?: AbortSignal) => {
  return customAxiosInstance<UserDto[]>({
    url: `/api/Course/GetScheduledCourseAvailableUsers/schedule/${scheduledCourseId}/available-users`,
    method: 'GET',
    signal
  });
};

export const getCourseGetScheduledCourseAvailableUsersQueryKey = (scheduledCourseId: number) => {
  return [`/api/Course/GetScheduledCourseAvailableUsers/schedule/${scheduledCourseId}/available-users`] as const;
};

export const getCourseGetScheduledCourseAvailableUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUsers>>,
  TError = unknown
>(
  scheduledCourseId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUsers>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCourseGetScheduledCourseAvailableUsersQueryKey(scheduledCourseId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUsers>>> = ({ signal }) =>
    courseGetScheduledCourseAvailableUsers(scheduledCourseId, signal);

  return {
    queryKey,
    queryFn,
    enabled: scheduledCourseId !== null && scheduledCourseId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUsers>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type CourseGetScheduledCourseAvailableUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUsers>>
>;
export type CourseGetScheduledCourseAvailableUsersQueryError = unknown;

export function useCourseGetScheduledCourseAvailableUsers<
  TData = Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUsers>>,
  TError = unknown
>(
  scheduledCourseId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUsers>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCourseGetScheduledCourseAvailableUsersQueryOptions(scheduledCourseId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const courseGetScheduledCourseAvailableUserGroups = (scheduledCourseId: number, signal?: AbortSignal) => {
  return customAxiosInstance<UserGroupDto[]>({
    url: `/api/Course/GetScheduledCourseAvailableUserGroups/schedule/${scheduledCourseId}/available-user-groups`,
    method: 'GET',
    signal
  });
};

export const getCourseGetScheduledCourseAvailableUserGroupsQueryKey = (scheduledCourseId: number) => {
  return [
    `/api/Course/GetScheduledCourseAvailableUserGroups/schedule/${scheduledCourseId}/available-user-groups`
  ] as const;
};

export const getCourseGetScheduledCourseAvailableUserGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUserGroups>>,
  TError = unknown
>(
  scheduledCourseId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUserGroups>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCourseGetScheduledCourseAvailableUserGroupsQueryKey(scheduledCourseId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUserGroups>>> = ({
    signal
  }) => courseGetScheduledCourseAvailableUserGroups(scheduledCourseId, signal);

  return {
    queryKey,
    queryFn,
    enabled: scheduledCourseId !== null && scheduledCourseId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUserGroups>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type CourseGetScheduledCourseAvailableUserGroupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUserGroups>>
>;
export type CourseGetScheduledCourseAvailableUserGroupsQueryError = unknown;

export function useCourseGetScheduledCourseAvailableUserGroups<
  TData = Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUserGroups>>,
  TError = unknown
>(
  scheduledCourseId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetScheduledCourseAvailableUserGroups>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCourseGetScheduledCourseAvailableUserGroupsQueryOptions(scheduledCourseId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const courseGetCurrentUserScheduledCourses = (signal?: AbortSignal) => {
  return customAxiosInstance<ScheduledCourseDto[]>({
    url: `/api/Course/GetCurrentUserScheduledCourses/user/current/schedule`,
    method: 'GET',
    signal
  });
};

export const getCourseGetCurrentUserScheduledCoursesQueryKey = () => {
  return [`/api/Course/GetCurrentUserScheduledCourses/user/current/schedule`] as const;
};

export const getCourseGetCurrentUserScheduledCoursesQueryOptions = <
  TData = Awaited<ReturnType<typeof courseGetCurrentUserScheduledCourses>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetCurrentUserScheduledCourses>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCourseGetCurrentUserScheduledCoursesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof courseGetCurrentUserScheduledCourses>>> = ({ signal }) =>
    courseGetCurrentUserScheduledCourses(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof courseGetCurrentUserScheduledCourses>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CourseGetCurrentUserScheduledCoursesQueryResult = NonNullable<
  Awaited<ReturnType<typeof courseGetCurrentUserScheduledCourses>>
>;
export type CourseGetCurrentUserScheduledCoursesQueryError = unknown;

export function useCourseGetCurrentUserScheduledCourses<
  TData = Awaited<ReturnType<typeof courseGetCurrentUserScheduledCourses>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetCurrentUserScheduledCourses>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCourseGetCurrentUserScheduledCoursesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const courseGetCurrentUserScheduledCoursesForDashboard = (signal?: AbortSignal) => {
  return customAxiosInstance<ScheduledCourseDto[]>({
    url: `/api/Course/GetCurrentUserScheduledCoursesForDashboard/user/current/schedule/dashboard`,
    method: 'GET',
    signal
  });
};

export const getCourseGetCurrentUserScheduledCoursesForDashboardQueryKey = () => {
  return [`/api/Course/GetCurrentUserScheduledCoursesForDashboard/user/current/schedule/dashboard`] as const;
};

export const getCourseGetCurrentUserScheduledCoursesForDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof courseGetCurrentUserScheduledCoursesForDashboard>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetCurrentUserScheduledCoursesForDashboard>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCourseGetCurrentUserScheduledCoursesForDashboardQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof courseGetCurrentUserScheduledCoursesForDashboard>>> = ({
    signal
  }) => courseGetCurrentUserScheduledCoursesForDashboard(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof courseGetCurrentUserScheduledCoursesForDashboard>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CourseGetCurrentUserScheduledCoursesForDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof courseGetCurrentUserScheduledCoursesForDashboard>>
>;
export type CourseGetCurrentUserScheduledCoursesForDashboardQueryError = unknown;

export function useCourseGetCurrentUserScheduledCoursesForDashboard<
  TData = Awaited<ReturnType<typeof courseGetCurrentUserScheduledCoursesForDashboard>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetCurrentUserScheduledCoursesForDashboard>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCourseGetCurrentUserScheduledCoursesForDashboardQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const courseGetUserScheduledCourseResults = (
  scheduledCourseId: number,
  params?: CourseGetUserScheduledCourseResultsParams,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScheduledCourseScenarioResultDto[]>({
    url: `/api/Course/GetUserScheduledCourseResults/user/current/schedule/${scheduledCourseId}`,
    method: 'GET',
    params,
    signal
  });
};

export const getCourseGetUserScheduledCourseResultsQueryKey = (
  scheduledCourseId: number,
  params?: CourseGetUserScheduledCourseResultsParams
) => {
  return [
    `/api/Course/GetUserScheduledCourseResults/user/current/schedule/${scheduledCourseId}`,
    ...(params ? [params] : [])
  ] as const;
};

export const getCourseGetUserScheduledCourseResultsQueryOptions = <
  TData = Awaited<ReturnType<typeof courseGetUserScheduledCourseResults>>,
  TError = unknown
>(
  scheduledCourseId: number,
  params?: CourseGetUserScheduledCourseResultsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetUserScheduledCourseResults>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCourseGetUserScheduledCourseResultsQueryKey(scheduledCourseId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof courseGetUserScheduledCourseResults>>> = ({ signal }) =>
    courseGetUserScheduledCourseResults(scheduledCourseId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: scheduledCourseId !== null && scheduledCourseId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof courseGetUserScheduledCourseResults>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type CourseGetUserScheduledCourseResultsQueryResult = NonNullable<
  Awaited<ReturnType<typeof courseGetUserScheduledCourseResults>>
>;
export type CourseGetUserScheduledCourseResultsQueryError = unknown;

export function useCourseGetUserScheduledCourseResults<
  TData = Awaited<ReturnType<typeof courseGetUserScheduledCourseResults>>,
  TError = unknown
>(
  scheduledCourseId: number,
  params?: CourseGetUserScheduledCourseResultsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetUserScheduledCourseResults>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCourseGetUserScheduledCourseResultsQueryOptions(scheduledCourseId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const courseGetScheduledCourseNotifications = (scheduledCourseId: number, signal?: AbortSignal) => {
  return customAxiosInstance<ScheduledCourseNotificationDto[]>({
    url: `/api/Course/GetScheduledCourseNotifications/schedule/${scheduledCourseId}/notifications`,
    method: 'GET',
    signal
  });
};

export const getCourseGetScheduledCourseNotificationsQueryKey = (scheduledCourseId: number) => {
  return [`/api/Course/GetScheduledCourseNotifications/schedule/${scheduledCourseId}/notifications`] as const;
};

export const getCourseGetScheduledCourseNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof courseGetScheduledCourseNotifications>>,
  TError = unknown
>(
  scheduledCourseId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetScheduledCourseNotifications>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCourseGetScheduledCourseNotificationsQueryKey(scheduledCourseId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof courseGetScheduledCourseNotifications>>> = ({ signal }) =>
    courseGetScheduledCourseNotifications(scheduledCourseId, signal);

  return {
    queryKey,
    queryFn,
    enabled: scheduledCourseId !== null && scheduledCourseId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof courseGetScheduledCourseNotifications>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type CourseGetScheduledCourseNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof courseGetScheduledCourseNotifications>>
>;
export type CourseGetScheduledCourseNotificationsQueryError = unknown;

export function useCourseGetScheduledCourseNotifications<
  TData = Awaited<ReturnType<typeof courseGetScheduledCourseNotifications>>,
  TError = unknown
>(
  scheduledCourseId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof courseGetScheduledCourseNotifications>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCourseGetScheduledCourseNotificationsQueryOptions(scheduledCourseId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const courseCreateScheduledCourseNotification = (
  scheduledCourseId: number,
  createScheduledCourseNotificationCommand?: CreateScheduledCourseNotificationCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/Course/CreateScheduledCourseNotification/schedule/${scheduledCourseId}/notification`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createScheduledCourseNotificationCommand,
    signal
  });
};

export const getCourseCreateScheduledCourseNotificationMutationKey = () =>
  ['courseCreateScheduledCourseNotification'] as const;

export const getCourseCreateScheduledCourseNotificationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateScheduledCourseNotification>>,
    TError,
    CourseCreateScheduledCourseNotificationMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseCreateScheduledCourseNotification>>,
  TError,
  CourseCreateScheduledCourseNotificationMutationVariables,
  TContext
> => {
  const mutationKey = getCourseCreateScheduledCourseNotificationMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseCreateScheduledCourseNotification>>,
    CourseCreateScheduledCourseNotificationMutationVariables
  > = (props) => {
    const { scheduledCourseId, data } = props ?? {};

    return courseCreateScheduledCourseNotification(scheduledCourseId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseCreateScheduledCourseNotificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof courseCreateScheduledCourseNotification>>
>;
export type CourseCreateScheduledCourseNotificationMutationBody = CreateScheduledCourseNotificationCommand | undefined;
export type CourseCreateScheduledCourseNotificationMutationError = unknown;
export type CourseCreateScheduledCourseNotificationMutationVariables = {
  scheduledCourseId: number;
  data?: CreateScheduledCourseNotificationCommand;
};

export const useCourseCreateScheduledCourseNotification = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseCreateScheduledCourseNotification>>,
    TError,
    CourseCreateScheduledCourseNotificationMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseCreateScheduledCourseNotification>>,
  TError,
  CourseCreateScheduledCourseNotificationMutationVariables,
  TContext
> => {
  return useMutation(getCourseCreateScheduledCourseNotificationMutationOptions(options));
};

export const courseUpdateScheduledCourseNotification = (
  scheduledCourseId: number,
  notificationId: number,
  updateScheduledCourseNotificationCommand?: UpdateScheduledCourseNotificationCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/Course/UpdateScheduledCourseNotification/schedule/${scheduledCourseId}/notification/${notificationId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateScheduledCourseNotificationCommand,
    signal
  });
};

export const getCourseUpdateScheduledCourseNotificationMutationKey = () =>
  ['courseUpdateScheduledCourseNotification'] as const;

export const getCourseUpdateScheduledCourseNotificationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseUpdateScheduledCourseNotification>>,
    TError,
    CourseUpdateScheduledCourseNotificationMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseUpdateScheduledCourseNotification>>,
  TError,
  CourseUpdateScheduledCourseNotificationMutationVariables,
  TContext
> => {
  const mutationKey = getCourseUpdateScheduledCourseNotificationMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseUpdateScheduledCourseNotification>>,
    CourseUpdateScheduledCourseNotificationMutationVariables
  > = (props) => {
    const { scheduledCourseId, notificationId, data } = props ?? {};

    return courseUpdateScheduledCourseNotification(scheduledCourseId, notificationId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseUpdateScheduledCourseNotificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof courseUpdateScheduledCourseNotification>>
>;
export type CourseUpdateScheduledCourseNotificationMutationBody = UpdateScheduledCourseNotificationCommand | undefined;
export type CourseUpdateScheduledCourseNotificationMutationError = unknown;
export type CourseUpdateScheduledCourseNotificationMutationVariables = {
  scheduledCourseId: number;
  notificationId: number;
  data?: UpdateScheduledCourseNotificationCommand;
};

export const useCourseUpdateScheduledCourseNotification = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseUpdateScheduledCourseNotification>>,
    TError,
    CourseUpdateScheduledCourseNotificationMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseUpdateScheduledCourseNotification>>,
  TError,
  CourseUpdateScheduledCourseNotificationMutationVariables,
  TContext
> => {
  return useMutation(getCourseUpdateScheduledCourseNotificationMutationOptions(options));
};

export const courseDeleteScheduledCourseNotification = (
  scheduledCourseId: number,
  notificationId: number,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/Course/DeleteScheduledCourseNotification/schedule/${scheduledCourseId}/notification/${notificationId}`,
    method: 'DELETE',
    signal
  });
};

export const getCourseDeleteScheduledCourseNotificationMutationKey = () =>
  ['courseDeleteScheduledCourseNotification'] as const;

export const getCourseDeleteScheduledCourseNotificationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseDeleteScheduledCourseNotification>>,
    TError,
    CourseDeleteScheduledCourseNotificationMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof courseDeleteScheduledCourseNotification>>,
  TError,
  CourseDeleteScheduledCourseNotificationMutationVariables,
  TContext
> => {
  const mutationKey = getCourseDeleteScheduledCourseNotificationMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof courseDeleteScheduledCourseNotification>>,
    CourseDeleteScheduledCourseNotificationMutationVariables
  > = (props) => {
    const { scheduledCourseId, notificationId } = props ?? {};

    return courseDeleteScheduledCourseNotification(scheduledCourseId, notificationId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CourseDeleteScheduledCourseNotificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof courseDeleteScheduledCourseNotification>>
>;

export type CourseDeleteScheduledCourseNotificationMutationError = unknown;
export type CourseDeleteScheduledCourseNotificationMutationVariables = {
  scheduledCourseId: number;
  notificationId: number;
};

export const useCourseDeleteScheduledCourseNotification = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof courseDeleteScheduledCourseNotification>>,
    TError,
    CourseDeleteScheduledCourseNotificationMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof courseDeleteScheduledCourseNotification>>,
  TError,
  CourseDeleteScheduledCourseNotificationMutationVariables,
  TContext
> => {
  return useMutation(getCourseDeleteScheduledCourseNotificationMutationOptions(options));
};

export const decisionSupportStartSession = (signal?: AbortSignal) => {
  return customAxiosInstance<DecisionSupportResponse>({
    url: `/api/v2/decision-support/start-session`,
    method: 'GET',
    signal
  });
};

export const getDecisionSupportStartSessionQueryKey = () => {
  return [`/api/v2/decision-support/start-session`] as const;
};

export const getDecisionSupportStartSessionQueryOptions = <
  TData = Awaited<ReturnType<typeof decisionSupportStartSession>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof decisionSupportStartSession>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDecisionSupportStartSessionQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof decisionSupportStartSession>>> = ({ signal }) =>
    decisionSupportStartSession(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof decisionSupportStartSession>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DecisionSupportStartSessionQueryResult = NonNullable<
  Awaited<ReturnType<typeof decisionSupportStartSession>>
>;
export type DecisionSupportStartSessionQueryError = unknown;

export function useDecisionSupportStartSession<
  TData = Awaited<ReturnType<typeof decisionSupportStartSession>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof decisionSupportStartSession>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDecisionSupportStartSessionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const decisionSupportAdvise = (decisionSupportRequest?: DecisionSupportRequest, signal?: AbortSignal) => {
  return customAxiosInstance<DecisionSupportStructuredResponseDto>({
    url: `/api/v2/decision-support/advise`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: decisionSupportRequest,
    signal
  });
};

export const getDecisionSupportAdviseMutationKey = () => ['decisionSupportAdvise'] as const;

export const getDecisionSupportAdviseMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof decisionSupportAdvise>>,
    TError,
    DecisionSupportAdviseMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof decisionSupportAdvise>>,
  TError,
  DecisionSupportAdviseMutationVariables,
  TContext
> => {
  const mutationKey = getDecisionSupportAdviseMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof decisionSupportAdvise>>,
    DecisionSupportAdviseMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return decisionSupportAdvise(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DecisionSupportAdviseMutationResult = NonNullable<Awaited<ReturnType<typeof decisionSupportAdvise>>>;
export type DecisionSupportAdviseMutationBody = DecisionSupportRequest | undefined;
export type DecisionSupportAdviseMutationError = unknown;
export type DecisionSupportAdviseMutationVariables = { data?: DecisionSupportRequest };

export const useDecisionSupportAdvise = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof decisionSupportAdvise>>,
    TError,
    DecisionSupportAdviseMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof decisionSupportAdvise>>,
  TError,
  DecisionSupportAdviseMutationVariables,
  TContext
> => {
  return useMutation(getDecisionSupportAdviseMutationOptions(options));
};

export const decisionSupportEndSession = (decisionSupportRequest?: DecisionSupportRequest, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/v2/decision-support/end-session`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: decisionSupportRequest,
    signal
  });
};

export const getDecisionSupportEndSessionMutationKey = () => ['decisionSupportEndSession'] as const;

export const getDecisionSupportEndSessionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof decisionSupportEndSession>>,
    TError,
    DecisionSupportEndSessionMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof decisionSupportEndSession>>,
  TError,
  DecisionSupportEndSessionMutationVariables,
  TContext
> => {
  const mutationKey = getDecisionSupportEndSessionMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof decisionSupportEndSession>>,
    DecisionSupportEndSessionMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return decisionSupportEndSession(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DecisionSupportEndSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof decisionSupportEndSession>>
>;
export type DecisionSupportEndSessionMutationBody = DecisionSupportRequest | undefined;
export type DecisionSupportEndSessionMutationError = unknown;
export type DecisionSupportEndSessionMutationVariables = { data?: DecisionSupportRequest };

export const useDecisionSupportEndSession = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof decisionSupportEndSession>>,
    TError,
    DecisionSupportEndSessionMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof decisionSupportEndSession>>,
  TError,
  DecisionSupportEndSessionMutationVariables,
  TContext
> => {
  return useMutation(getDecisionSupportEndSessionMutationOptions(options));
};

export const dialogSessionInitSession = (
  scenarioId: number,
  params?: DialogSessionInitSessionParams,
  signal?: AbortSignal
) => {
  return customAxiosInstance<string>({
    url: `/api/DialogSession/InitSession/${scenarioId}/start`,
    method: 'POST',
    params,
    signal
  });
};

export const getDialogSessionInitSessionMutationKey = () => ['dialogSessionInitSession'] as const;

export const getDialogSessionInitSessionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogSessionInitSession>>,
    TError,
    DialogSessionInitSessionMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dialogSessionInitSession>>,
  TError,
  DialogSessionInitSessionMutationVariables,
  TContext
> => {
  const mutationKey = getDialogSessionInitSessionMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dialogSessionInitSession>>,
    DialogSessionInitSessionMutationVariables
  > = (props) => {
    const { scenarioId, params } = props ?? {};

    return dialogSessionInitSession(scenarioId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type DialogSessionInitSessionMutationResult = NonNullable<Awaited<ReturnType<typeof dialogSessionInitSession>>>;

export type DialogSessionInitSessionMutationError = unknown;
export type DialogSessionInitSessionMutationVariables = { scenarioId: number; params?: DialogSessionInitSessionParams };

export const useDialogSessionInitSession = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogSessionInitSession>>,
    TError,
    DialogSessionInitSessionMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof dialogSessionInitSession>>,
  TError,
  DialogSessionInitSessionMutationVariables,
  TContext
> => {
  return useMutation(getDialogSessionInitSessionMutationOptions(options));
};

export const dialogStatisticsListDialogStatisticsService = (
  params?: DialogStatisticsListDialogStatisticsServiceParams,
  signal?: AbortSignal
) => {
  return customAxiosInstance<PartialListDialogStatisticDto>({
    url: `/api/DialogStatistics/ListDialogStatisticsService`,
    method: 'GET',
    params,
    signal
  });
};

export const getDialogStatisticsListDialogStatisticsServiceQueryKey = (
  params?: DialogStatisticsListDialogStatisticsServiceParams
) => {
  return [`/api/DialogStatistics/ListDialogStatisticsService`, ...(params ? [params] : [])] as const;
};

export const getDialogStatisticsListDialogStatisticsServiceQueryOptions = <
  TData = Awaited<ReturnType<typeof dialogStatisticsListDialogStatisticsService>>,
  TError = unknown
>(
  params?: DialogStatisticsListDialogStatisticsServiceParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsListDialogStatisticsService>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDialogStatisticsListDialogStatisticsServiceQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dialogStatisticsListDialogStatisticsService>>> = ({
    signal
  }) => dialogStatisticsListDialogStatisticsService(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dialogStatisticsListDialogStatisticsService>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DialogStatisticsListDialogStatisticsServiceQueryResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsListDialogStatisticsService>>
>;
export type DialogStatisticsListDialogStatisticsServiceQueryError = unknown;

export function useDialogStatisticsListDialogStatisticsService<
  TData = Awaited<ReturnType<typeof dialogStatisticsListDialogStatisticsService>>,
  TError = unknown
>(
  params?: DialogStatisticsListDialogStatisticsServiceParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsListDialogStatisticsService>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDialogStatisticsListDialogStatisticsServiceQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const dialogStatisticsGetDialogStatistic = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<DialogStatisticDto>({
    url: `/api/DialogStatistics/GetDialogStatistic/${id}`,
    method: 'GET',
    signal
  });
};

export const getDialogStatisticsGetDialogStatisticQueryKey = (id: number) => {
  return [`/api/DialogStatistics/GetDialogStatistic/${id}`] as const;
};

export const getDialogStatisticsGetDialogStatisticQueryOptions = <
  TData = Awaited<ReturnType<typeof dialogStatisticsGetDialogStatistic>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetDialogStatistic>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDialogStatisticsGetDialogStatisticQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dialogStatisticsGetDialogStatistic>>> = ({ signal }) =>
    dialogStatisticsGetDialogStatistic(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dialogStatisticsGetDialogStatistic>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DialogStatisticsGetDialogStatisticQueryResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsGetDialogStatistic>>
>;
export type DialogStatisticsGetDialogStatisticQueryError = unknown;

export function useDialogStatisticsGetDialogStatistic<
  TData = Awaited<ReturnType<typeof dialogStatisticsGetDialogStatistic>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetDialogStatistic>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDialogStatisticsGetDialogStatisticQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const dialogStatisticsAddDialogStatistic = (
  addDialogStatisticCommand?: AddDialogStatisticCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<DialogStatisticDto>({
    url: `/api/DialogStatistics/AddDialogStatistic`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: addDialogStatisticCommand,
    signal
  });
};

export const getDialogStatisticsAddDialogStatisticMutationKey = () => ['dialogStatisticsAddDialogStatistic'] as const;

export const getDialogStatisticsAddDialogStatisticMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsAddDialogStatistic>>,
    TError,
    DialogStatisticsAddDialogStatisticMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dialogStatisticsAddDialogStatistic>>,
  TError,
  DialogStatisticsAddDialogStatisticMutationVariables,
  TContext
> => {
  const mutationKey = getDialogStatisticsAddDialogStatisticMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dialogStatisticsAddDialogStatistic>>,
    DialogStatisticsAddDialogStatisticMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return dialogStatisticsAddDialogStatistic(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DialogStatisticsAddDialogStatisticMutationResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsAddDialogStatistic>>
>;
export type DialogStatisticsAddDialogStatisticMutationBody = AddDialogStatisticCommand | undefined;
export type DialogStatisticsAddDialogStatisticMutationError = unknown;
export type DialogStatisticsAddDialogStatisticMutationVariables = { data?: AddDialogStatisticCommand };

export const useDialogStatisticsAddDialogStatistic = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsAddDialogStatistic>>,
    TError,
    DialogStatisticsAddDialogStatisticMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof dialogStatisticsAddDialogStatistic>>,
  TError,
  DialogStatisticsAddDialogStatisticMutationVariables,
  TContext
> => {
  return useMutation(getDialogStatisticsAddDialogStatisticMutationOptions(options));
};

export const dialogStatisticsDeleteDialogStatistic = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/DialogStatistics/DeleteDialogStatistic/${id}`,
    method: 'DELETE',
    signal
  });
};

export const getDialogStatisticsDeleteDialogStatisticMutationKey = () =>
  ['dialogStatisticsDeleteDialogStatistic'] as const;

export const getDialogStatisticsDeleteDialogStatisticMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistic>>,
    TError,
    DialogStatisticsDeleteDialogStatisticMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistic>>,
  TError,
  DialogStatisticsDeleteDialogStatisticMutationVariables,
  TContext
> => {
  const mutationKey = getDialogStatisticsDeleteDialogStatisticMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistic>>,
    DialogStatisticsDeleteDialogStatisticMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return dialogStatisticsDeleteDialogStatistic(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DialogStatisticsDeleteDialogStatisticMutationResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistic>>
>;

export type DialogStatisticsDeleteDialogStatisticMutationError = unknown;
export type DialogStatisticsDeleteDialogStatisticMutationVariables = { id: number };

export const useDialogStatisticsDeleteDialogStatistic = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistic>>,
    TError,
    DialogStatisticsDeleteDialogStatisticMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistic>>,
  TError,
  DialogStatisticsDeleteDialogStatisticMutationVariables,
  TContext
> => {
  return useMutation(getDialogStatisticsDeleteDialogStatisticMutationOptions(options));
};

export const dialogStatisticsDeleteDialogStatistics = (
  dialogStatisticsDeleteDialogStatisticsBody?: number[],
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/DialogStatistics/DeleteDialogStatistics/deleteDialogStatistics`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: dialogStatisticsDeleteDialogStatisticsBody,
    signal
  });
};

export const getDialogStatisticsDeleteDialogStatisticsMutationKey = () =>
  ['dialogStatisticsDeleteDialogStatistics'] as const;

export const getDialogStatisticsDeleteDialogStatisticsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistics>>,
    TError,
    DialogStatisticsDeleteDialogStatisticsMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistics>>,
  TError,
  DialogStatisticsDeleteDialogStatisticsMutationVariables,
  TContext
> => {
  const mutationKey = getDialogStatisticsDeleteDialogStatisticsMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistics>>,
    DialogStatisticsDeleteDialogStatisticsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return dialogStatisticsDeleteDialogStatistics(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DialogStatisticsDeleteDialogStatisticsMutationResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistics>>
>;
export type DialogStatisticsDeleteDialogStatisticsMutationBody = number[] | undefined;
export type DialogStatisticsDeleteDialogStatisticsMutationError = unknown;
export type DialogStatisticsDeleteDialogStatisticsMutationVariables = { data?: number[] };

export const useDialogStatisticsDeleteDialogStatistics = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistics>>,
    TError,
    DialogStatisticsDeleteDialogStatisticsMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof dialogStatisticsDeleteDialogStatistics>>,
  TError,
  DialogStatisticsDeleteDialogStatisticsMutationVariables,
  TContext
> => {
  return useMutation(getDialogStatisticsDeleteDialogStatisticsMutationOptions(options));
};

export const dialogStatisticsGetKpiDetails = (dialogStatisticsId: number, signal?: AbortSignal) => {
  return customAxiosInstance<DialogStatisticKpiDetailsDto>({
    url: `/api/DialogStatistics/GetKpiDetails/${dialogStatisticsId}/kpidetails`,
    method: 'GET',
    signal
  });
};

export const getDialogStatisticsGetKpiDetailsQueryKey = (dialogStatisticsId: number) => {
  return [`/api/DialogStatistics/GetKpiDetails/${dialogStatisticsId}/kpidetails`] as const;
};

export const getDialogStatisticsGetKpiDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof dialogStatisticsGetKpiDetails>>,
  TError = unknown
>(
  dialogStatisticsId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetKpiDetails>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDialogStatisticsGetKpiDetailsQueryKey(dialogStatisticsId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dialogStatisticsGetKpiDetails>>> = ({ signal }) =>
    dialogStatisticsGetKpiDetails(dialogStatisticsId, signal);

  return {
    queryKey,
    queryFn,
    enabled: dialogStatisticsId !== null && dialogStatisticsId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetKpiDetails>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type DialogStatisticsGetKpiDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsGetKpiDetails>>
>;
export type DialogStatisticsGetKpiDetailsQueryError = unknown;

export function useDialogStatisticsGetKpiDetails<
  TData = Awaited<ReturnType<typeof dialogStatisticsGetKpiDetails>>,
  TError = unknown
>(
  dialogStatisticsId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetKpiDetails>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDialogStatisticsGetKpiDetailsQueryOptions(dialogStatisticsId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const dialogStatisticsGetDialogTranscript = (dialogStatisticsId: number, signal?: AbortSignal) => {
  return customAxiosInstance<string>({
    url: `/api/DialogStatistics/GetDialogTranscript/${dialogStatisticsId}/transcript`,
    method: 'GET',
    signal
  });
};

export const getDialogStatisticsGetDialogTranscriptQueryKey = (dialogStatisticsId: number) => {
  return [`/api/DialogStatistics/GetDialogTranscript/${dialogStatisticsId}/transcript`] as const;
};

export const getDialogStatisticsGetDialogTranscriptQueryOptions = <
  TData = Awaited<ReturnType<typeof dialogStatisticsGetDialogTranscript>>,
  TError = unknown
>(
  dialogStatisticsId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetDialogTranscript>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDialogStatisticsGetDialogTranscriptQueryKey(dialogStatisticsId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dialogStatisticsGetDialogTranscript>>> = ({ signal }) =>
    dialogStatisticsGetDialogTranscript(dialogStatisticsId, signal);

  return {
    queryKey,
    queryFn,
    enabled: dialogStatisticsId !== null && dialogStatisticsId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetDialogTranscript>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type DialogStatisticsGetDialogTranscriptQueryResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsGetDialogTranscript>>
>;
export type DialogStatisticsGetDialogTranscriptQueryError = unknown;

export function useDialogStatisticsGetDialogTranscript<
  TData = Awaited<ReturnType<typeof dialogStatisticsGetDialogTranscript>>,
  TError = unknown
>(
  dialogStatisticsId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetDialogTranscript>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDialogStatisticsGetDialogTranscriptQueryOptions(dialogStatisticsId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const dialogStatisticsStoreFeedback = (
  sessionId: string,
  conversationFeedback?: ConversationFeedback,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/DialogStatistics/StoreFeedback/StoreFeedback/${sessionId}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: conversationFeedback,
    signal
  });
};

export const getDialogStatisticsStoreFeedbackMutationKey = () => ['dialogStatisticsStoreFeedback'] as const;

export const getDialogStatisticsStoreFeedbackMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsStoreFeedback>>,
    TError,
    DialogStatisticsStoreFeedbackMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dialogStatisticsStoreFeedback>>,
  TError,
  DialogStatisticsStoreFeedbackMutationVariables,
  TContext
> => {
  const mutationKey = getDialogStatisticsStoreFeedbackMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dialogStatisticsStoreFeedback>>,
    DialogStatisticsStoreFeedbackMutationVariables
  > = (props) => {
    const { sessionId, data } = props ?? {};

    return dialogStatisticsStoreFeedback(sessionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DialogStatisticsStoreFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsStoreFeedback>>
>;
export type DialogStatisticsStoreFeedbackMutationBody = ConversationFeedback | undefined;
export type DialogStatisticsStoreFeedbackMutationError = unknown;
export type DialogStatisticsStoreFeedbackMutationVariables = { sessionId: string; data?: ConversationFeedback };

export const useDialogStatisticsStoreFeedback = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsStoreFeedback>>,
    TError,
    DialogStatisticsStoreFeedbackMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof dialogStatisticsStoreFeedback>>,
  TError,
  DialogStatisticsStoreFeedbackMutationVariables,
  TContext
> => {
  return useMutation(getDialogStatisticsStoreFeedbackMutationOptions(options));
};

export const dialogStatisticsGetDialogFeedbacks = (dialogStatisticsId: number, signal?: AbortSignal) => {
  return customAxiosInstance<DialogFeedbackDto[]>({
    url: `/api/DialogStatistics/GetDialogFeedbacks/${dialogStatisticsId}/feedback`,
    method: 'GET',
    signal
  });
};

export const getDialogStatisticsGetDialogFeedbacksQueryKey = (dialogStatisticsId: number) => {
  return [`/api/DialogStatistics/GetDialogFeedbacks/${dialogStatisticsId}/feedback`] as const;
};

export const getDialogStatisticsGetDialogFeedbacksQueryOptions = <
  TData = Awaited<ReturnType<typeof dialogStatisticsGetDialogFeedbacks>>,
  TError = unknown
>(
  dialogStatisticsId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetDialogFeedbacks>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDialogStatisticsGetDialogFeedbacksQueryKey(dialogStatisticsId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dialogStatisticsGetDialogFeedbacks>>> = ({ signal }) =>
    dialogStatisticsGetDialogFeedbacks(dialogStatisticsId, signal);

  return {
    queryKey,
    queryFn,
    enabled: dialogStatisticsId !== null && dialogStatisticsId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetDialogFeedbacks>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type DialogStatisticsGetDialogFeedbacksQueryResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsGetDialogFeedbacks>>
>;
export type DialogStatisticsGetDialogFeedbacksQueryError = unknown;

export function useDialogStatisticsGetDialogFeedbacks<
  TData = Awaited<ReturnType<typeof dialogStatisticsGetDialogFeedbacks>>,
  TError = unknown
>(
  dialogStatisticsId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetDialogFeedbacks>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDialogStatisticsGetDialogFeedbacksQueryOptions(dialogStatisticsId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const dialogStatisticsGetScenarioNotes = (sessionId: string, signal?: AbortSignal) => {
  return customAxiosInstance<ScenarioNoteDto>({
    url: `/api/DialogStatistics/${sessionId}/notes`,
    method: 'GET',
    signal
  });
};

export const getDialogStatisticsGetScenarioNotesQueryKey = (sessionId: string) => {
  return [`/api/DialogStatistics/${sessionId}/notes`] as const;
};

export const getDialogStatisticsGetScenarioNotesQueryOptions = <
  TData = Awaited<ReturnType<typeof dialogStatisticsGetScenarioNotes>>,
  TError = unknown
>(
  sessionId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetScenarioNotes>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDialogStatisticsGetScenarioNotesQueryKey(sessionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dialogStatisticsGetScenarioNotes>>> = ({ signal }) =>
    dialogStatisticsGetScenarioNotes(sessionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: sessionId !== null && sessionId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetScenarioNotes>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type DialogStatisticsGetScenarioNotesQueryResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsGetScenarioNotes>>
>;
export type DialogStatisticsGetScenarioNotesQueryError = unknown;

export function useDialogStatisticsGetScenarioNotes<
  TData = Awaited<ReturnType<typeof dialogStatisticsGetScenarioNotes>>,
  TError = unknown
>(
  sessionId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetScenarioNotes>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDialogStatisticsGetScenarioNotesQueryOptions(sessionId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const dialogStatisticsStoreScenarioNotes = (
  sessionId: string,
  scenarioNoteRequest?: ScenarioNoteRequest,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScenarioNoteDto>({
    url: `/api/DialogStatistics/${sessionId}/notes`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: scenarioNoteRequest,
    signal
  });
};

export const getDialogStatisticsStoreScenarioNotesMutationKey = () => ['dialogStatisticsStoreScenarioNotes'] as const;

export const getDialogStatisticsStoreScenarioNotesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsStoreScenarioNotes>>,
    TError,
    DialogStatisticsStoreScenarioNotesMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dialogStatisticsStoreScenarioNotes>>,
  TError,
  DialogStatisticsStoreScenarioNotesMutationVariables,
  TContext
> => {
  const mutationKey = getDialogStatisticsStoreScenarioNotesMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dialogStatisticsStoreScenarioNotes>>,
    DialogStatisticsStoreScenarioNotesMutationVariables
  > = (props) => {
    const { sessionId, data } = props ?? {};

    return dialogStatisticsStoreScenarioNotes(sessionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DialogStatisticsStoreScenarioNotesMutationResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsStoreScenarioNotes>>
>;
export type DialogStatisticsStoreScenarioNotesMutationBody = ScenarioNoteRequest | undefined;
export type DialogStatisticsStoreScenarioNotesMutationError = unknown;
export type DialogStatisticsStoreScenarioNotesMutationVariables = { sessionId: string; data?: ScenarioNoteRequest };

export const useDialogStatisticsStoreScenarioNotes = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsStoreScenarioNotes>>,
    TError,
    DialogStatisticsStoreScenarioNotesMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof dialogStatisticsStoreScenarioNotes>>,
  TError,
  DialogStatisticsStoreScenarioNotesMutationVariables,
  TContext
> => {
  return useMutation(getDialogStatisticsStoreScenarioNotesMutationOptions(options));
};

export const dialogStatisticsSubmitScenarioNotes = (sessionId: string, signal?: AbortSignal) => {
  return customAxiosInstance<ScenarioNoteDto>({
    url: `/api/DialogStatistics/${sessionId}/notes/submit`,
    method: 'POST',
    signal
  });
};

export const getDialogStatisticsSubmitScenarioNotesMutationKey = () => ['dialogStatisticsSubmitScenarioNotes'] as const;

export const getDialogStatisticsSubmitScenarioNotesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsSubmitScenarioNotes>>,
    TError,
    DialogStatisticsSubmitScenarioNotesMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dialogStatisticsSubmitScenarioNotes>>,
  TError,
  DialogStatisticsSubmitScenarioNotesMutationVariables,
  TContext
> => {
  const mutationKey = getDialogStatisticsSubmitScenarioNotesMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dialogStatisticsSubmitScenarioNotes>>,
    DialogStatisticsSubmitScenarioNotesMutationVariables
  > = (props) => {
    const { sessionId } = props ?? {};

    return dialogStatisticsSubmitScenarioNotes(sessionId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DialogStatisticsSubmitScenarioNotesMutationResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsSubmitScenarioNotes>>
>;

export type DialogStatisticsSubmitScenarioNotesMutationError = unknown;
export type DialogStatisticsSubmitScenarioNotesMutationVariables = { sessionId: string };

export const useDialogStatisticsSubmitScenarioNotes = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsSubmitScenarioNotes>>,
    TError,
    DialogStatisticsSubmitScenarioNotesMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof dialogStatisticsSubmitScenarioNotes>>,
  TError,
  DialogStatisticsSubmitScenarioNotesMutationVariables,
  TContext
> => {
  return useMutation(getDialogStatisticsSubmitScenarioNotesMutationOptions(options));
};

export const dialogStatisticsGetUsageStatistics = (signal?: AbortSignal) => {
  return customAxiosInstance<UsageStatistic[]>({
    url: `/api/DialogStatistics/GetUsageStatistics/usage`,
    method: 'GET',
    signal
  });
};

export const getDialogStatisticsGetUsageStatisticsQueryKey = () => {
  return [`/api/DialogStatistics/GetUsageStatistics/usage`] as const;
};

export const getDialogStatisticsGetUsageStatisticsQueryOptions = <
  TData = Awaited<ReturnType<typeof dialogStatisticsGetUsageStatistics>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetUsageStatistics>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDialogStatisticsGetUsageStatisticsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dialogStatisticsGetUsageStatistics>>> = ({ signal }) =>
    dialogStatisticsGetUsageStatistics(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dialogStatisticsGetUsageStatistics>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DialogStatisticsGetUsageStatisticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsGetUsageStatistics>>
>;
export type DialogStatisticsGetUsageStatisticsQueryError = unknown;

export function useDialogStatisticsGetUsageStatistics<
  TData = Awaited<ReturnType<typeof dialogStatisticsGetUsageStatistics>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsGetUsageStatistics>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDialogStatisticsGetUsageStatisticsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const dialogStatisticsExportEvaluationsToExcel = (dialogStatisticsId: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/DialogStatistics/ExportEvaluationsToExcel/${dialogStatisticsId}/evaluations/export`,
    method: 'GET',
    signal
  });
};

export const getDialogStatisticsExportEvaluationsToExcelQueryKey = (dialogStatisticsId: number) => {
  return [`/api/DialogStatistics/ExportEvaluationsToExcel/${dialogStatisticsId}/evaluations/export`] as const;
};

export const getDialogStatisticsExportEvaluationsToExcelQueryOptions = <
  TData = Awaited<ReturnType<typeof dialogStatisticsExportEvaluationsToExcel>>,
  TError = unknown
>(
  dialogStatisticsId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsExportEvaluationsToExcel>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDialogStatisticsExportEvaluationsToExcelQueryKey(dialogStatisticsId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dialogStatisticsExportEvaluationsToExcel>>> = ({ signal }) =>
    dialogStatisticsExportEvaluationsToExcel(dialogStatisticsId, signal);

  return {
    queryKey,
    queryFn,
    enabled: dialogStatisticsId !== null && dialogStatisticsId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsExportEvaluationsToExcel>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type DialogStatisticsExportEvaluationsToExcelQueryResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsExportEvaluationsToExcel>>
>;
export type DialogStatisticsExportEvaluationsToExcelQueryError = unknown;

export function useDialogStatisticsExportEvaluationsToExcel<
  TData = Awaited<ReturnType<typeof dialogStatisticsExportEvaluationsToExcel>>,
  TError = unknown
>(
  dialogStatisticsId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof dialogStatisticsExportEvaluationsToExcel>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDialogStatisticsExportEvaluationsToExcelQueryOptions(dialogStatisticsId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const dialogStatisticsTriggerConversationEvaluation = (sessionId: string, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/DialogStatistics/TriggerConversationEvaluation/${sessionId}/evaluations/trigger`,
    method: 'POST',
    signal
  });
};

export const getDialogStatisticsTriggerConversationEvaluationMutationKey = () =>
  ['dialogStatisticsTriggerConversationEvaluation'] as const;

export const getDialogStatisticsTriggerConversationEvaluationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsTriggerConversationEvaluation>>,
    TError,
    DialogStatisticsTriggerConversationEvaluationMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dialogStatisticsTriggerConversationEvaluation>>,
  TError,
  DialogStatisticsTriggerConversationEvaluationMutationVariables,
  TContext
> => {
  const mutationKey = getDialogStatisticsTriggerConversationEvaluationMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dialogStatisticsTriggerConversationEvaluation>>,
    DialogStatisticsTriggerConversationEvaluationMutationVariables
  > = (props) => {
    const { sessionId } = props ?? {};

    return dialogStatisticsTriggerConversationEvaluation(sessionId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DialogStatisticsTriggerConversationEvaluationMutationResult = NonNullable<
  Awaited<ReturnType<typeof dialogStatisticsTriggerConversationEvaluation>>
>;

export type DialogStatisticsTriggerConversationEvaluationMutationError = unknown;
export type DialogStatisticsTriggerConversationEvaluationMutationVariables = { sessionId: string };

export const useDialogStatisticsTriggerConversationEvaluation = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dialogStatisticsTriggerConversationEvaluation>>,
    TError,
    DialogStatisticsTriggerConversationEvaluationMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof dialogStatisticsTriggerConversationEvaluation>>,
  TError,
  DialogStatisticsTriggerConversationEvaluationMutationVariables,
  TContext
> => {
  return useMutation(getDialogStatisticsTriggerConversationEvaluationMutationOptions(options));
};

export const exerciseGetAll = (signal?: AbortSignal) => {
  return customAxiosInstance<ExerciseDto[]>({ url: `/api/Exercise`, method: 'GET', signal });
};

export const getExerciseGetAllQueryKey = () => {
  return [`/api/Exercise`] as const;
};

export const getExerciseGetAllQueryOptions = <
  TData = Awaited<ReturnType<typeof exerciseGetAll>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof exerciseGetAll>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExerciseGetAllQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exerciseGetAll>>> = ({ signal }) => exerciseGetAll(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exerciseGetAll>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExerciseGetAllQueryResult = NonNullable<Awaited<ReturnType<typeof exerciseGetAll>>>;
export type ExerciseGetAllQueryError = unknown;

export function useExerciseGetAll<TData = Awaited<ReturnType<typeof exerciseGetAll>>, TError = unknown>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof exerciseGetAll>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getExerciseGetAllQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const exerciseCreate = (createExerciseDto?: CreateExerciseDto, signal?: AbortSignal) => {
  return customAxiosInstance<ExerciseDto>({
    url: `/api/Exercise`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createExerciseDto,
    signal
  });
};

export const getExerciseCreateMutationKey = () => ['exerciseCreate'] as const;

export const getExerciseCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseCreate>>,
    TError,
    ExerciseCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exerciseCreate>>,
  TError,
  ExerciseCreateMutationVariables,
  TContext
> => {
  const mutationKey = getExerciseCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof exerciseCreate>>, ExerciseCreateMutationVariables> = (
    props
  ) => {
    const { data } = props ?? {};

    return exerciseCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseCreateMutationResult = NonNullable<Awaited<ReturnType<typeof exerciseCreate>>>;
export type ExerciseCreateMutationBody = CreateExerciseDto | undefined;
export type ExerciseCreateMutationError = unknown;
export type ExerciseCreateMutationVariables = { data?: CreateExerciseDto };

export const useExerciseCreate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseCreate>>,
    TError,
    ExerciseCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exerciseCreate>>,
  TError,
  ExerciseCreateMutationVariables,
  TContext
> => {
  return useMutation(getExerciseCreateMutationOptions(options));
};

export const exerciseGetById = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<ExerciseDto>({ url: `/api/Exercise/${id}`, method: 'GET', signal });
};

export const getExerciseGetByIdQueryKey = (id: number) => {
  return [`/api/Exercise/${id}`] as const;
};

export const getExerciseGetByIdQueryOptions = <TData = Awaited<ReturnType<typeof exerciseGetById>>, TError = unknown>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof exerciseGetById>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExerciseGetByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exerciseGetById>>> = ({ signal }) =>
    exerciseGetById(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exerciseGetById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExerciseGetByIdQueryResult = NonNullable<Awaited<ReturnType<typeof exerciseGetById>>>;
export type ExerciseGetByIdQueryError = unknown;

export function useExerciseGetById<TData = Awaited<ReturnType<typeof exerciseGetById>>, TError = unknown>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof exerciseGetById>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getExerciseGetByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const exerciseUpdate = (id: number, updateExerciseDto?: UpdateExerciseDto, signal?: AbortSignal) => {
  return customAxiosInstance<ExerciseDto>({
    url: `/api/Exercise/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateExerciseDto,
    signal
  });
};

export const getExerciseUpdateMutationKey = () => ['exerciseUpdate'] as const;

export const getExerciseUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseUpdate>>,
    TError,
    ExerciseUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exerciseUpdate>>,
  TError,
  ExerciseUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getExerciseUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof exerciseUpdate>>, ExerciseUpdateMutationVariables> = (
    props
  ) => {
    const { id, data } = props ?? {};

    return exerciseUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof exerciseUpdate>>>;
export type ExerciseUpdateMutationBody = UpdateExerciseDto | undefined;
export type ExerciseUpdateMutationError = unknown;
export type ExerciseUpdateMutationVariables = { id: number; data?: UpdateExerciseDto };

export const useExerciseUpdate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseUpdate>>,
    TError,
    ExerciseUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exerciseUpdate>>,
  TError,
  ExerciseUpdateMutationVariables,
  TContext
> => {
  return useMutation(getExerciseUpdateMutationOptions(options));
};

export const exerciseDelete = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/Exercise/${id}`, method: 'DELETE', signal });
};

export const getExerciseDeleteMutationKey = () => ['exerciseDelete'] as const;

export const getExerciseDeleteMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseDelete>>,
    TError,
    ExerciseDeleteMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exerciseDelete>>,
  TError,
  ExerciseDeleteMutationVariables,
  TContext
> => {
  const mutationKey = getExerciseDeleteMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof exerciseDelete>>, ExerciseDeleteMutationVariables> = (
    props
  ) => {
    const { id } = props ?? {};

    return exerciseDelete(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof exerciseDelete>>>;

export type ExerciseDeleteMutationError = unknown;
export type ExerciseDeleteMutationVariables = { id: number };

export const useExerciseDelete = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseDelete>>,
    TError,
    ExerciseDeleteMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exerciseDelete>>,
  TError,
  ExerciseDeleteMutationVariables,
  TContext
> => {
  return useMutation(getExerciseDeleteMutationOptions(options));
};

export const exerciseApplyScheduleChange = (
  exerciseId: number,
  applyExerciseScheduleChangeDto?: ApplyExerciseScheduleChangeDto,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ApplyExerciseScheduleChangeResponseDto>({
    url: `/api/Exercise/${exerciseId}/apply-schedule-change`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: applyExerciseScheduleChangeDto,
    signal
  });
};

export const getExerciseApplyScheduleChangeMutationKey = () => ['exerciseApplyScheduleChange'] as const;

export const getExerciseApplyScheduleChangeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseApplyScheduleChange>>,
    TError,
    ExerciseApplyScheduleChangeMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exerciseApplyScheduleChange>>,
  TError,
  ExerciseApplyScheduleChangeMutationVariables,
  TContext
> => {
  const mutationKey = getExerciseApplyScheduleChangeMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exerciseApplyScheduleChange>>,
    ExerciseApplyScheduleChangeMutationVariables
  > = (props) => {
    const { exerciseId, data } = props ?? {};

    return exerciseApplyScheduleChange(exerciseId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseApplyScheduleChangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof exerciseApplyScheduleChange>>
>;
export type ExerciseApplyScheduleChangeMutationBody = ApplyExerciseScheduleChangeDto | undefined;
export type ExerciseApplyScheduleChangeMutationError = unknown;
export type ExerciseApplyScheduleChangeMutationVariables = {
  exerciseId: number;
  data?: ApplyExerciseScheduleChangeDto;
};

export const useExerciseApplyScheduleChange = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseApplyScheduleChange>>,
    TError,
    ExerciseApplyScheduleChangeMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exerciseApplyScheduleChange>>,
  TError,
  ExerciseApplyScheduleChangeMutationVariables,
  TContext
> => {
  return useMutation(getExerciseApplyScheduleChangeMutationOptions(options));
};

export const exerciseClone = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<CloneExerciseResponseDto>({ url: `/api/Exercise/${id}/clone`, method: 'POST', signal });
};

export const getExerciseCloneMutationKey = () => ['exerciseClone'] as const;

export const getExerciseCloneMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseClone>>,
    TError,
    ExerciseCloneMutationVariables,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof exerciseClone>>, TError, ExerciseCloneMutationVariables, TContext> => {
  const mutationKey = getExerciseCloneMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof exerciseClone>>, ExerciseCloneMutationVariables> = (
    props
  ) => {
    const { id } = props ?? {};

    return exerciseClone(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseCloneMutationResult = NonNullable<Awaited<ReturnType<typeof exerciseClone>>>;

export type ExerciseCloneMutationError = unknown;
export type ExerciseCloneMutationVariables = { id: number };

export const useExerciseClone = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseClone>>,
    TError,
    ExerciseCloneMutationVariables,
    TContext
  >;
}): UseMutationResult<Awaited<ReturnType<typeof exerciseClone>>, TError, ExerciseCloneMutationVariables, TContext> => {
  return useMutation(getExerciseCloneMutationOptions(options));
};

export const exerciseAddContact = (
  exerciseId: number,
  createExerciseContactDto?: CreateExerciseContactDto,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ExerciseContactDto>({
    url: `/api/Exercise/${exerciseId}/contacts`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createExerciseContactDto,
    signal
  });
};

export const getExerciseAddContactMutationKey = () => ['exerciseAddContact'] as const;

export const getExerciseAddContactMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseAddContact>>,
    TError,
    ExerciseAddContactMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exerciseAddContact>>,
  TError,
  ExerciseAddContactMutationVariables,
  TContext
> => {
  const mutationKey = getExerciseAddContactMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exerciseAddContact>>,
    ExerciseAddContactMutationVariables
  > = (props) => {
    const { exerciseId, data } = props ?? {};

    return exerciseAddContact(exerciseId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseAddContactMutationResult = NonNullable<Awaited<ReturnType<typeof exerciseAddContact>>>;
export type ExerciseAddContactMutationBody = CreateExerciseContactDto | undefined;
export type ExerciseAddContactMutationError = unknown;
export type ExerciseAddContactMutationVariables = { exerciseId: number; data?: CreateExerciseContactDto };

export const useExerciseAddContact = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseAddContact>>,
    TError,
    ExerciseAddContactMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exerciseAddContact>>,
  TError,
  ExerciseAddContactMutationVariables,
  TContext
> => {
  return useMutation(getExerciseAddContactMutationOptions(options));
};

export const exerciseUpdateContact = (
  exerciseId: number,
  contactId: number,
  updateExerciseContactDto?: UpdateExerciseContactDto,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ExerciseContactDto>({
    url: `/api/Exercise/${exerciseId}/contacts/${contactId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateExerciseContactDto,
    signal
  });
};

export const getExerciseUpdateContactMutationKey = () => ['exerciseUpdateContact'] as const;

export const getExerciseUpdateContactMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseUpdateContact>>,
    TError,
    ExerciseUpdateContactMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exerciseUpdateContact>>,
  TError,
  ExerciseUpdateContactMutationVariables,
  TContext
> => {
  const mutationKey = getExerciseUpdateContactMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exerciseUpdateContact>>,
    ExerciseUpdateContactMutationVariables
  > = (props) => {
    const { exerciseId, contactId, data } = props ?? {};

    return exerciseUpdateContact(exerciseId, contactId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseUpdateContactMutationResult = NonNullable<Awaited<ReturnType<typeof exerciseUpdateContact>>>;
export type ExerciseUpdateContactMutationBody = UpdateExerciseContactDto | undefined;
export type ExerciseUpdateContactMutationError = unknown;
export type ExerciseUpdateContactMutationVariables = {
  exerciseId: number;
  contactId: number;
  data?: UpdateExerciseContactDto;
};

export const useExerciseUpdateContact = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseUpdateContact>>,
    TError,
    ExerciseUpdateContactMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exerciseUpdateContact>>,
  TError,
  ExerciseUpdateContactMutationVariables,
  TContext
> => {
  return useMutation(getExerciseUpdateContactMutationOptions(options));
};

export const exerciseDeleteContact = (exerciseId: number, contactId: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/Exercise/${exerciseId}/contacts/${contactId}`,
    method: 'DELETE',
    signal
  });
};

export const getExerciseDeleteContactMutationKey = () => ['exerciseDeleteContact'] as const;

export const getExerciseDeleteContactMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseDeleteContact>>,
    TError,
    ExerciseDeleteContactMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exerciseDeleteContact>>,
  TError,
  ExerciseDeleteContactMutationVariables,
  TContext
> => {
  const mutationKey = getExerciseDeleteContactMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exerciseDeleteContact>>,
    ExerciseDeleteContactMutationVariables
  > = (props) => {
    const { exerciseId, contactId } = props ?? {};

    return exerciseDeleteContact(exerciseId, contactId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseDeleteContactMutationResult = NonNullable<Awaited<ReturnType<typeof exerciseDeleteContact>>>;

export type ExerciseDeleteContactMutationError = unknown;
export type ExerciseDeleteContactMutationVariables = { exerciseId: number; contactId: number };

export const useExerciseDeleteContact = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseDeleteContact>>,
    TError,
    ExerciseDeleteContactMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exerciseDeleteContact>>,
  TError,
  ExerciseDeleteContactMutationVariables,
  TContext
> => {
  return useMutation(getExerciseDeleteContactMutationOptions(options));
};

export const exerciseAddPlaybookItem = (
  exerciseId: number,
  createPlaybookItemDto?: CreatePlaybookItemDto,
  signal?: AbortSignal
) => {
  return customAxiosInstance<PlaybookItemDto>({
    url: `/api/Exercise/${exerciseId}/playbook`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createPlaybookItemDto,
    signal
  });
};

export const getExerciseAddPlaybookItemMutationKey = () => ['exerciseAddPlaybookItem'] as const;

export const getExerciseAddPlaybookItemMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseAddPlaybookItem>>,
    TError,
    ExerciseAddPlaybookItemMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exerciseAddPlaybookItem>>,
  TError,
  ExerciseAddPlaybookItemMutationVariables,
  TContext
> => {
  const mutationKey = getExerciseAddPlaybookItemMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exerciseAddPlaybookItem>>,
    ExerciseAddPlaybookItemMutationVariables
  > = (props) => {
    const { exerciseId, data } = props ?? {};

    return exerciseAddPlaybookItem(exerciseId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseAddPlaybookItemMutationResult = NonNullable<Awaited<ReturnType<typeof exerciseAddPlaybookItem>>>;
export type ExerciseAddPlaybookItemMutationBody = CreatePlaybookItemDto | undefined;
export type ExerciseAddPlaybookItemMutationError = unknown;
export type ExerciseAddPlaybookItemMutationVariables = { exerciseId: number; data?: CreatePlaybookItemDto };

export const useExerciseAddPlaybookItem = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseAddPlaybookItem>>,
    TError,
    ExerciseAddPlaybookItemMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exerciseAddPlaybookItem>>,
  TError,
  ExerciseAddPlaybookItemMutationVariables,
  TContext
> => {
  return useMutation(getExerciseAddPlaybookItemMutationOptions(options));
};

export const exerciseApplyPlaybookItemTimeChange = (
  exerciseId: number,
  itemId: number,
  applyPlaybookItemTimeChangeDto?: ApplyPlaybookItemTimeChangeDto,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ApplyPlaybookItemTimeChangeResponseDto>({
    url: `/api/Exercise/${exerciseId}/playbook/${itemId}/apply-time-change`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: applyPlaybookItemTimeChangeDto,
    signal
  });
};

export const getExerciseApplyPlaybookItemTimeChangeMutationKey = () => ['exerciseApplyPlaybookItemTimeChange'] as const;

export const getExerciseApplyPlaybookItemTimeChangeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseApplyPlaybookItemTimeChange>>,
    TError,
    ExerciseApplyPlaybookItemTimeChangeMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exerciseApplyPlaybookItemTimeChange>>,
  TError,
  ExerciseApplyPlaybookItemTimeChangeMutationVariables,
  TContext
> => {
  const mutationKey = getExerciseApplyPlaybookItemTimeChangeMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exerciseApplyPlaybookItemTimeChange>>,
    ExerciseApplyPlaybookItemTimeChangeMutationVariables
  > = (props) => {
    const { exerciseId, itemId, data } = props ?? {};

    return exerciseApplyPlaybookItemTimeChange(exerciseId, itemId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseApplyPlaybookItemTimeChangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof exerciseApplyPlaybookItemTimeChange>>
>;
export type ExerciseApplyPlaybookItemTimeChangeMutationBody = ApplyPlaybookItemTimeChangeDto | undefined;
export type ExerciseApplyPlaybookItemTimeChangeMutationError = unknown;
export type ExerciseApplyPlaybookItemTimeChangeMutationVariables = {
  exerciseId: number;
  itemId: number;
  data?: ApplyPlaybookItemTimeChangeDto;
};

export const useExerciseApplyPlaybookItemTimeChange = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseApplyPlaybookItemTimeChange>>,
    TError,
    ExerciseApplyPlaybookItemTimeChangeMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exerciseApplyPlaybookItemTimeChange>>,
  TError,
  ExerciseApplyPlaybookItemTimeChangeMutationVariables,
  TContext
> => {
  return useMutation(getExerciseApplyPlaybookItemTimeChangeMutationOptions(options));
};

export const exerciseUpdatePlaybookItem = (
  exerciseId: number,
  itemId: number,
  updatePlaybookItemDto?: UpdatePlaybookItemDto,
  signal?: AbortSignal
) => {
  return customAxiosInstance<PlaybookItemDto>({
    url: `/api/Exercise/${exerciseId}/playbook/${itemId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updatePlaybookItemDto,
    signal
  });
};

export const getExerciseUpdatePlaybookItemMutationKey = () => ['exerciseUpdatePlaybookItem'] as const;

export const getExerciseUpdatePlaybookItemMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseUpdatePlaybookItem>>,
    TError,
    ExerciseUpdatePlaybookItemMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exerciseUpdatePlaybookItem>>,
  TError,
  ExerciseUpdatePlaybookItemMutationVariables,
  TContext
> => {
  const mutationKey = getExerciseUpdatePlaybookItemMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exerciseUpdatePlaybookItem>>,
    ExerciseUpdatePlaybookItemMutationVariables
  > = (props) => {
    const { exerciseId, itemId, data } = props ?? {};

    return exerciseUpdatePlaybookItem(exerciseId, itemId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseUpdatePlaybookItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof exerciseUpdatePlaybookItem>>
>;
export type ExerciseUpdatePlaybookItemMutationBody = UpdatePlaybookItemDto | undefined;
export type ExerciseUpdatePlaybookItemMutationError = unknown;
export type ExerciseUpdatePlaybookItemMutationVariables = {
  exerciseId: number;
  itemId: number;
  data?: UpdatePlaybookItemDto;
};

export const useExerciseUpdatePlaybookItem = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseUpdatePlaybookItem>>,
    TError,
    ExerciseUpdatePlaybookItemMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exerciseUpdatePlaybookItem>>,
  TError,
  ExerciseUpdatePlaybookItemMutationVariables,
  TContext
> => {
  return useMutation(getExerciseUpdatePlaybookItemMutationOptions(options));
};

export const exerciseDeletePlaybookItem = (exerciseId: number, itemId: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/Exercise/${exerciseId}/playbook/${itemId}`, method: 'DELETE', signal });
};

export const getExerciseDeletePlaybookItemMutationKey = () => ['exerciseDeletePlaybookItem'] as const;

export const getExerciseDeletePlaybookItemMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseDeletePlaybookItem>>,
    TError,
    ExerciseDeletePlaybookItemMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exerciseDeletePlaybookItem>>,
  TError,
  ExerciseDeletePlaybookItemMutationVariables,
  TContext
> => {
  const mutationKey = getExerciseDeletePlaybookItemMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exerciseDeletePlaybookItem>>,
    ExerciseDeletePlaybookItemMutationVariables
  > = (props) => {
    const { exerciseId, itemId } = props ?? {};

    return exerciseDeletePlaybookItem(exerciseId, itemId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExerciseDeletePlaybookItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof exerciseDeletePlaybookItem>>
>;

export type ExerciseDeletePlaybookItemMutationError = unknown;
export type ExerciseDeletePlaybookItemMutationVariables = { exerciseId: number; itemId: number };

export const useExerciseDeletePlaybookItem = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exerciseDeletePlaybookItem>>,
    TError,
    ExerciseDeletePlaybookItemMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof exerciseDeletePlaybookItem>>,
  TError,
  ExerciseDeletePlaybookItemMutationVariables,
  TContext
> => {
  return useMutation(getExerciseDeletePlaybookItemMutationOptions(options));
};

export const exportExport = (conversationExportFilterDto?: ConversationExportFilterDto, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/conversations/export`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: conversationExportFilterDto,
    signal
  });
};

export const getExportExportMutationKey = () => ['exportExport'] as const;

export const getExportExportMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportExport>>,
    TError,
    ExportExportMutationVariables,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof exportExport>>, TError, ExportExportMutationVariables, TContext> => {
  const mutationKey = getExportExportMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportExport>>, ExportExportMutationVariables> = (
    props
  ) => {
    const { data } = props ?? {};

    return exportExport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportExportMutationResult = NonNullable<Awaited<ReturnType<typeof exportExport>>>;
export type ExportExportMutationBody = ConversationExportFilterDto | undefined;
export type ExportExportMutationError = unknown;
export type ExportExportMutationVariables = { data?: ConversationExportFilterDto };

export const useExportExport = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportExport>>,
    TError,
    ExportExportMutationVariables,
    TContext
  >;
}): UseMutationResult<Awaited<ReturnType<typeof exportExport>>, TError, ExportExportMutationVariables, TContext> => {
  return useMutation(getExportExportMutationOptions(options));
};

export const globalAssetsGetCategories = (signal?: AbortSignal) => {
  return customAxiosInstance<GlobalAssetCategoryDto[]>({
    url: `/api/GlobalAssets/GetCategories`,
    method: 'GET',
    signal
  });
};

export const getGlobalAssetsGetCategoriesQueryKey = () => {
  return [`/api/GlobalAssets/GetCategories`] as const;
};

export const getGlobalAssetsGetCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof globalAssetsGetCategories>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof globalAssetsGetCategories>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGlobalAssetsGetCategoriesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof globalAssetsGetCategories>>> = ({ signal }) =>
    globalAssetsGetCategories(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof globalAssetsGetCategories>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GlobalAssetsGetCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof globalAssetsGetCategories>>>;
export type GlobalAssetsGetCategoriesQueryError = unknown;

export function useGlobalAssetsGetCategories<
  TData = Awaited<ReturnType<typeof globalAssetsGetCategories>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof globalAssetsGetCategories>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGlobalAssetsGetCategoriesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const globalAssetsGetFullData = (signal?: AbortSignal) => {
  return customAxiosInstance<GlobalAssetFullDto[]>({
    url: `/api/GlobalAssets/GetFullData/full`,
    method: 'GET',
    signal
  });
};

export const getGlobalAssetsGetFullDataQueryKey = () => {
  return [`/api/GlobalAssets/GetFullData/full`] as const;
};

export const getGlobalAssetsGetFullDataQueryOptions = <
  TData = Awaited<ReturnType<typeof globalAssetsGetFullData>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof globalAssetsGetFullData>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGlobalAssetsGetFullDataQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof globalAssetsGetFullData>>> = ({ signal }) =>
    globalAssetsGetFullData(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof globalAssetsGetFullData>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GlobalAssetsGetFullDataQueryResult = NonNullable<Awaited<ReturnType<typeof globalAssetsGetFullData>>>;
export type GlobalAssetsGetFullDataQueryError = unknown;

export function useGlobalAssetsGetFullData<
  TData = Awaited<ReturnType<typeof globalAssetsGetFullData>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof globalAssetsGetFullData>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGlobalAssetsGetFullDataQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const globalAssetsCreateCategory = (
  createGlobalAssetCategoryCommand?: CreateGlobalAssetCategoryCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<GlobalAssetFullDto>({
    url: `/api/GlobalAssets/CreateCategory`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createGlobalAssetCategoryCommand,
    signal
  });
};

export const getGlobalAssetsCreateCategoryMutationKey = () => ['globalAssetsCreateCategory'] as const;

export const getGlobalAssetsCreateCategoryMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsCreateCategory>>,
    TError,
    GlobalAssetsCreateCategoryMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsCreateCategory>>,
  TError,
  GlobalAssetsCreateCategoryMutationVariables,
  TContext
> => {
  const mutationKey = getGlobalAssetsCreateCategoryMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsCreateCategory>>,
    GlobalAssetsCreateCategoryMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return globalAssetsCreateCategory(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsCreateCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof globalAssetsCreateCategory>>
>;
export type GlobalAssetsCreateCategoryMutationBody = CreateGlobalAssetCategoryCommand | undefined;
export type GlobalAssetsCreateCategoryMutationError = void;
export type GlobalAssetsCreateCategoryMutationVariables = { data?: CreateGlobalAssetCategoryCommand };

export const useGlobalAssetsCreateCategory = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsCreateCategory>>,
    TError,
    GlobalAssetsCreateCategoryMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsCreateCategory>>,
  TError,
  GlobalAssetsCreateCategoryMutationVariables,
  TContext
> => {
  return useMutation(getGlobalAssetsCreateCategoryMutationOptions(options));
};

export const globalAssetsUpdateCategory = (
  categoryId: number,
  updateGlobalAssetCategoryCommand?: UpdateGlobalAssetCategoryCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<GlobalAssetFullDto>({
    url: `/api/GlobalAssets/UpdateCategory/${categoryId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateGlobalAssetCategoryCommand,
    signal
  });
};

export const getGlobalAssetsUpdateCategoryMutationKey = () => ['globalAssetsUpdateCategory'] as const;

export const getGlobalAssetsUpdateCategoryMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsUpdateCategory>>,
    TError,
    GlobalAssetsUpdateCategoryMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsUpdateCategory>>,
  TError,
  GlobalAssetsUpdateCategoryMutationVariables,
  TContext
> => {
  const mutationKey = getGlobalAssetsUpdateCategoryMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsUpdateCategory>>,
    GlobalAssetsUpdateCategoryMutationVariables
  > = (props) => {
    const { categoryId, data } = props ?? {};

    return globalAssetsUpdateCategory(categoryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsUpdateCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof globalAssetsUpdateCategory>>
>;
export type GlobalAssetsUpdateCategoryMutationBody = UpdateGlobalAssetCategoryCommand | undefined;
export type GlobalAssetsUpdateCategoryMutationError = unknown;
export type GlobalAssetsUpdateCategoryMutationVariables = {
  categoryId: number;
  data?: UpdateGlobalAssetCategoryCommand;
};

export const useGlobalAssetsUpdateCategory = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsUpdateCategory>>,
    TError,
    GlobalAssetsUpdateCategoryMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsUpdateCategory>>,
  TError,
  GlobalAssetsUpdateCategoryMutationVariables,
  TContext
> => {
  return useMutation(getGlobalAssetsUpdateCategoryMutationOptions(options));
};

export const globalAssetsDeleteCategories = (
  deleteGlobalAssetCategoriesCommand?: DeleteGlobalAssetCategoriesCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/GlobalAssets/DeleteCategories`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: deleteGlobalAssetCategoriesCommand,
    signal
  });
};

export const getGlobalAssetsDeleteCategoriesMutationKey = () => ['globalAssetsDeleteCategories'] as const;

export const getGlobalAssetsDeleteCategoriesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsDeleteCategories>>,
    TError,
    GlobalAssetsDeleteCategoriesMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsDeleteCategories>>,
  TError,
  GlobalAssetsDeleteCategoriesMutationVariables,
  TContext
> => {
  const mutationKey = getGlobalAssetsDeleteCategoriesMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsDeleteCategories>>,
    GlobalAssetsDeleteCategoriesMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return globalAssetsDeleteCategories(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsDeleteCategoriesMutationResult = NonNullable<
  Awaited<ReturnType<typeof globalAssetsDeleteCategories>>
>;
export type GlobalAssetsDeleteCategoriesMutationBody = DeleteGlobalAssetCategoriesCommand | undefined;
export type GlobalAssetsDeleteCategoriesMutationError = unknown;
export type GlobalAssetsDeleteCategoriesMutationVariables = { data?: DeleteGlobalAssetCategoriesCommand };

export const useGlobalAssetsDeleteCategories = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsDeleteCategories>>,
    TError,
    GlobalAssetsDeleteCategoriesMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsDeleteCategories>>,
  TError,
  GlobalAssetsDeleteCategoriesMutationVariables,
  TContext
> => {
  return useMutation(getGlobalAssetsDeleteCategoriesMutationOptions(options));
};

export const globalAssetsGetIntents = (categoryId: number, signal?: AbortSignal) => {
  return customAxiosInstance<GlobalAssetIntentDto[]>({
    url: `/api/GlobalAssets/GetIntents/${categoryId}/intents`,
    method: 'GET',
    signal
  });
};

export const getGlobalAssetsGetIntentsQueryKey = (categoryId: number) => {
  return [`/api/GlobalAssets/GetIntents/${categoryId}/intents`] as const;
};

export const getGlobalAssetsGetIntentsQueryOptions = <
  TData = Awaited<ReturnType<typeof globalAssetsGetIntents>>,
  TError = unknown
>(
  categoryId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof globalAssetsGetIntents>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGlobalAssetsGetIntentsQueryKey(categoryId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof globalAssetsGetIntents>>> = ({ signal }) =>
    globalAssetsGetIntents(categoryId, signal);

  return {
    queryKey,
    queryFn,
    enabled: categoryId !== null && categoryId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof globalAssetsGetIntents>>, TError, TData> & { queryKey: QueryKey };
};

export type GlobalAssetsGetIntentsQueryResult = NonNullable<Awaited<ReturnType<typeof globalAssetsGetIntents>>>;
export type GlobalAssetsGetIntentsQueryError = unknown;

export function useGlobalAssetsGetIntents<TData = Awaited<ReturnType<typeof globalAssetsGetIntents>>, TError = unknown>(
  categoryId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof globalAssetsGetIntents>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGlobalAssetsGetIntentsQueryOptions(categoryId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const globalAssetsCreateIntent = (
  categoryId: number,
  createGlobalAssetIntentCommand?: CreateGlobalAssetIntentCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<GlobalAssetIntentDto>({
    url: `/api/GlobalAssets/CreateIntent/${categoryId}/intent`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createGlobalAssetIntentCommand,
    signal
  });
};

export const getGlobalAssetsCreateIntentMutationKey = () => ['globalAssetsCreateIntent'] as const;

export const getGlobalAssetsCreateIntentMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsCreateIntent>>,
    TError,
    GlobalAssetsCreateIntentMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsCreateIntent>>,
  TError,
  GlobalAssetsCreateIntentMutationVariables,
  TContext
> => {
  const mutationKey = getGlobalAssetsCreateIntentMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsCreateIntent>>,
    GlobalAssetsCreateIntentMutationVariables
  > = (props) => {
    const { categoryId, data } = props ?? {};

    return globalAssetsCreateIntent(categoryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsCreateIntentMutationResult = NonNullable<Awaited<ReturnType<typeof globalAssetsCreateIntent>>>;
export type GlobalAssetsCreateIntentMutationBody = CreateGlobalAssetIntentCommand | undefined;
export type GlobalAssetsCreateIntentMutationError = unknown;
export type GlobalAssetsCreateIntentMutationVariables = { categoryId: number; data?: CreateGlobalAssetIntentCommand };

export const useGlobalAssetsCreateIntent = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsCreateIntent>>,
    TError,
    GlobalAssetsCreateIntentMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsCreateIntent>>,
  TError,
  GlobalAssetsCreateIntentMutationVariables,
  TContext
> => {
  return useMutation(getGlobalAssetsCreateIntentMutationOptions(options));
};

export const globalAssetsUpdateIntent = (
  intentId: number,
  updateGlobalAssetIntentCommand?: UpdateGlobalAssetIntentCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<GlobalAssetIntentDto>({
    url: `/api/GlobalAssets/UpdateIntent/intents/${intentId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateGlobalAssetIntentCommand,
    signal
  });
};

export const getGlobalAssetsUpdateIntentMutationKey = () => ['globalAssetsUpdateIntent'] as const;

export const getGlobalAssetsUpdateIntentMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsUpdateIntent>>,
    TError,
    GlobalAssetsUpdateIntentMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsUpdateIntent>>,
  TError,
  GlobalAssetsUpdateIntentMutationVariables,
  TContext
> => {
  const mutationKey = getGlobalAssetsUpdateIntentMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsUpdateIntent>>,
    GlobalAssetsUpdateIntentMutationVariables
  > = (props) => {
    const { intentId, data } = props ?? {};

    return globalAssetsUpdateIntent(intentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsUpdateIntentMutationResult = NonNullable<Awaited<ReturnType<typeof globalAssetsUpdateIntent>>>;
export type GlobalAssetsUpdateIntentMutationBody = UpdateGlobalAssetIntentCommand | undefined;
export type GlobalAssetsUpdateIntentMutationError = unknown;
export type GlobalAssetsUpdateIntentMutationVariables = { intentId: number; data?: UpdateGlobalAssetIntentCommand };

export const useGlobalAssetsUpdateIntent = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsUpdateIntent>>,
    TError,
    GlobalAssetsUpdateIntentMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsUpdateIntent>>,
  TError,
  GlobalAssetsUpdateIntentMutationVariables,
  TContext
> => {
  return useMutation(getGlobalAssetsUpdateIntentMutationOptions(options));
};

export const globalAssetsDeleteIntents = (
  deleteGlobalAssetIntentCommand?: DeleteGlobalAssetIntentCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/GlobalAssets/DeleteIntents/intents`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: deleteGlobalAssetIntentCommand,
    signal
  });
};

export const getGlobalAssetsDeleteIntentsMutationKey = () => ['globalAssetsDeleteIntents'] as const;

export const getGlobalAssetsDeleteIntentsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsDeleteIntents>>,
    TError,
    GlobalAssetsDeleteIntentsMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsDeleteIntents>>,
  TError,
  GlobalAssetsDeleteIntentsMutationVariables,
  TContext
> => {
  const mutationKey = getGlobalAssetsDeleteIntentsMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsDeleteIntents>>,
    GlobalAssetsDeleteIntentsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return globalAssetsDeleteIntents(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsDeleteIntentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof globalAssetsDeleteIntents>>
>;
export type GlobalAssetsDeleteIntentsMutationBody = DeleteGlobalAssetIntentCommand | undefined;
export type GlobalAssetsDeleteIntentsMutationError = unknown;
export type GlobalAssetsDeleteIntentsMutationVariables = { data?: DeleteGlobalAssetIntentCommand };

export const useGlobalAssetsDeleteIntents = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsDeleteIntents>>,
    TError,
    GlobalAssetsDeleteIntentsMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsDeleteIntents>>,
  TError,
  GlobalAssetsDeleteIntentsMutationVariables,
  TContext
> => {
  return useMutation(getGlobalAssetsDeleteIntentsMutationOptions(options));
};

export const globalAssetsCopyIntentToCompany = (
  intentId: number,
  params?: GlobalAssetsCopyIntentToCompanyParams,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/GlobalAssets/CopyIntentToCompany/intents/${intentId}`,
    method: 'POST',
    params,
    signal
  });
};

export const getGlobalAssetsCopyIntentToCompanyMutationKey = () => ['globalAssetsCopyIntentToCompany'] as const;

export const getGlobalAssetsCopyIntentToCompanyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsCopyIntentToCompany>>,
    TError,
    GlobalAssetsCopyIntentToCompanyMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsCopyIntentToCompany>>,
  TError,
  GlobalAssetsCopyIntentToCompanyMutationVariables,
  TContext
> => {
  const mutationKey = getGlobalAssetsCopyIntentToCompanyMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsCopyIntentToCompany>>,
    GlobalAssetsCopyIntentToCompanyMutationVariables
  > = (props) => {
    const { intentId, params } = props ?? {};

    return globalAssetsCopyIntentToCompany(intentId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsCopyIntentToCompanyMutationResult = NonNullable<
  Awaited<ReturnType<typeof globalAssetsCopyIntentToCompany>>
>;

export type GlobalAssetsCopyIntentToCompanyMutationError = unknown;
export type GlobalAssetsCopyIntentToCompanyMutationVariables = {
  intentId: number;
  params?: GlobalAssetsCopyIntentToCompanyParams;
};

export const useGlobalAssetsCopyIntentToCompany = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsCopyIntentToCompany>>,
    TError,
    GlobalAssetsCopyIntentToCompanyMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsCopyIntentToCompany>>,
  TError,
  GlobalAssetsCopyIntentToCompanyMutationVariables,
  TContext
> => {
  return useMutation(getGlobalAssetsCopyIntentToCompanyMutationOptions(options));
};

export const globalAssetsMoveAndMergeIntentToCategory = (
  intentId: number,
  globalAssetsMoveAndMergeIntentToCategoryBody?: number,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/GlobalAssets/MoveAndMergeIntentToCategory/intents/${intentId}/move`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: globalAssetsMoveAndMergeIntentToCategoryBody,
    signal
  });
};

export const getGlobalAssetsMoveAndMergeIntentToCategoryMutationKey = () =>
  ['globalAssetsMoveAndMergeIntentToCategory'] as const;

export const getGlobalAssetsMoveAndMergeIntentToCategoryMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsMoveAndMergeIntentToCategory>>,
    TError,
    GlobalAssetsMoveAndMergeIntentToCategoryMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsMoveAndMergeIntentToCategory>>,
  TError,
  GlobalAssetsMoveAndMergeIntentToCategoryMutationVariables,
  TContext
> => {
  const mutationKey = getGlobalAssetsMoveAndMergeIntentToCategoryMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsMoveAndMergeIntentToCategory>>,
    GlobalAssetsMoveAndMergeIntentToCategoryMutationVariables
  > = (props) => {
    const { intentId, data } = props ?? {};

    return globalAssetsMoveAndMergeIntentToCategory(intentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsMoveAndMergeIntentToCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof globalAssetsMoveAndMergeIntentToCategory>>
>;
export type GlobalAssetsMoveAndMergeIntentToCategoryMutationBody = number | undefined;
export type GlobalAssetsMoveAndMergeIntentToCategoryMutationError = unknown;
export type GlobalAssetsMoveAndMergeIntentToCategoryMutationVariables = { intentId: number; data?: number };

export const useGlobalAssetsMoveAndMergeIntentToCategory = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsMoveAndMergeIntentToCategory>>,
    TError,
    GlobalAssetsMoveAndMergeIntentToCategoryMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsMoveAndMergeIntentToCategory>>,
  TError,
  GlobalAssetsMoveAndMergeIntentToCategoryMutationVariables,
  TContext
> => {
  return useMutation(getGlobalAssetsMoveAndMergeIntentToCategoryMutationOptions(options));
};

export const globalAssetsCreateSample = (
  intentId: number,
  globalAssetsCreateSampleBody?: string,
  signal?: AbortSignal
) => {
  return customAxiosInstance<GlobalAssetIntentDto>({
    url: `/api/GlobalAssets/CreateSample/intents/${intentId}/sample`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: globalAssetsCreateSampleBody,
    signal
  });
};

export const getGlobalAssetsCreateSampleMutationKey = () => ['globalAssetsCreateSample'] as const;

export const getGlobalAssetsCreateSampleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsCreateSample>>,
    TError,
    GlobalAssetsCreateSampleMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsCreateSample>>,
  TError,
  GlobalAssetsCreateSampleMutationVariables,
  TContext
> => {
  const mutationKey = getGlobalAssetsCreateSampleMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsCreateSample>>,
    GlobalAssetsCreateSampleMutationVariables
  > = (props) => {
    const { intentId, data } = props ?? {};

    return globalAssetsCreateSample(intentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsCreateSampleMutationResult = NonNullable<Awaited<ReturnType<typeof globalAssetsCreateSample>>>;
export type GlobalAssetsCreateSampleMutationBody = string | undefined;
export type GlobalAssetsCreateSampleMutationError = unknown;
export type GlobalAssetsCreateSampleMutationVariables = { intentId: number; data?: string };

export const useGlobalAssetsCreateSample = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsCreateSample>>,
    TError,
    GlobalAssetsCreateSampleMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsCreateSample>>,
  TError,
  GlobalAssetsCreateSampleMutationVariables,
  TContext
> => {
  return useMutation(getGlobalAssetsCreateSampleMutationOptions(options));
};

export const globalAssetsUpdateSample = (
  intentId: number,
  sampleId: number,
  globalAssetsUpdateSampleBody?: string,
  signal?: AbortSignal
) => {
  return customAxiosInstance<GlobalAssetIntentDto>({
    url: `/api/GlobalAssets/UpdateSample/intents/${intentId}/${sampleId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: globalAssetsUpdateSampleBody,
    signal
  });
};

export const getGlobalAssetsUpdateSampleMutationKey = () => ['globalAssetsUpdateSample'] as const;

export const getGlobalAssetsUpdateSampleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsUpdateSample>>,
    TError,
    GlobalAssetsUpdateSampleMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsUpdateSample>>,
  TError,
  GlobalAssetsUpdateSampleMutationVariables,
  TContext
> => {
  const mutationKey = getGlobalAssetsUpdateSampleMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsUpdateSample>>,
    GlobalAssetsUpdateSampleMutationVariables
  > = (props) => {
    const { intentId, sampleId, data } = props ?? {};

    return globalAssetsUpdateSample(intentId, sampleId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsUpdateSampleMutationResult = NonNullable<Awaited<ReturnType<typeof globalAssetsUpdateSample>>>;
export type GlobalAssetsUpdateSampleMutationBody = string | undefined;
export type GlobalAssetsUpdateSampleMutationError = unknown;
export type GlobalAssetsUpdateSampleMutationVariables = { intentId: number; sampleId: number; data?: string };

export const useGlobalAssetsUpdateSample = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsUpdateSample>>,
    TError,
    GlobalAssetsUpdateSampleMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsUpdateSample>>,
  TError,
  GlobalAssetsUpdateSampleMutationVariables,
  TContext
> => {
  return useMutation(getGlobalAssetsUpdateSampleMutationOptions(options));
};

export const globalAssetsDeleteSample = (intentId: number, sampleId: number, signal?: AbortSignal) => {
  return customAxiosInstance<GlobalAssetIntentDto>({
    url: `/api/GlobalAssets/DeleteSample/intents/${intentId}/${sampleId}`,
    method: 'DELETE',
    signal
  });
};

export const getGlobalAssetsDeleteSampleMutationKey = () => ['globalAssetsDeleteSample'] as const;

export const getGlobalAssetsDeleteSampleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsDeleteSample>>,
    TError,
    GlobalAssetsDeleteSampleMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsDeleteSample>>,
  TError,
  GlobalAssetsDeleteSampleMutationVariables,
  TContext
> => {
  const mutationKey = getGlobalAssetsDeleteSampleMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsDeleteSample>>,
    GlobalAssetsDeleteSampleMutationVariables
  > = (props) => {
    const { intentId, sampleId } = props ?? {};

    return globalAssetsDeleteSample(intentId, sampleId);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsDeleteSampleMutationResult = NonNullable<Awaited<ReturnType<typeof globalAssetsDeleteSample>>>;

export type GlobalAssetsDeleteSampleMutationError = unknown;
export type GlobalAssetsDeleteSampleMutationVariables = { intentId: number; sampleId: number };

export const useGlobalAssetsDeleteSample = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsDeleteSample>>,
    TError,
    GlobalAssetsDeleteSampleMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsDeleteSample>>,
  TError,
  GlobalAssetsDeleteSampleMutationVariables,
  TContext
> => {
  return useMutation(getGlobalAssetsDeleteSampleMutationOptions(options));
};

export const globalAssetsGetTemplatesConnections = (intentId: number, signal?: AbortSignal) => {
  return customAxiosInstance<GlobalAssetConnection[]>({
    url: `/api/GlobalAssets/GetTemplatesConnections/intents/${intentId}/connections`,
    method: 'GET',
    signal
  });
};

export const getGlobalAssetsGetTemplatesConnectionsQueryKey = (intentId: number) => {
  return [`/api/GlobalAssets/GetTemplatesConnections/intents/${intentId}/connections`] as const;
};

export const getGlobalAssetsGetTemplatesConnectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof globalAssetsGetTemplatesConnections>>,
  TError = unknown
>(
  intentId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof globalAssetsGetTemplatesConnections>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGlobalAssetsGetTemplatesConnectionsQueryKey(intentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof globalAssetsGetTemplatesConnections>>> = ({ signal }) =>
    globalAssetsGetTemplatesConnections(intentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: intentId !== null && intentId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof globalAssetsGetTemplatesConnections>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GlobalAssetsGetTemplatesConnectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof globalAssetsGetTemplatesConnections>>
>;
export type GlobalAssetsGetTemplatesConnectionsQueryError = unknown;

export function useGlobalAssetsGetTemplatesConnections<
  TData = Awaited<ReturnType<typeof globalAssetsGetTemplatesConnections>>,
  TError = unknown
>(
  intentId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof globalAssetsGetTemplatesConnections>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGlobalAssetsGetTemplatesConnectionsQueryOptions(intentId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const globalAssetsImportData = (
  globalAssetsImportDataBody?: GlobalAssetsImportDataBodyOne | GlobalAssetsImportDataBodyTwo,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/GlobalAssets/ImportData/import`,
    method: 'POST',
    data: globalAssetsImportDataBody,
    signal
  });
};

export const getGlobalAssetsImportDataMutationKey = () => ['globalAssetsImportData'] as const;

export const getGlobalAssetsImportDataMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsImportData>>,
    TError,
    GlobalAssetsImportDataMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof globalAssetsImportData>>,
  TError,
  GlobalAssetsImportDataMutationVariables,
  TContext
> => {
  const mutationKey = getGlobalAssetsImportDataMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof globalAssetsImportData>>,
    GlobalAssetsImportDataMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return globalAssetsImportData(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalAssetsImportDataMutationResult = NonNullable<Awaited<ReturnType<typeof globalAssetsImportData>>>;
export type GlobalAssetsImportDataMutationBody =
  | GlobalAssetsImportDataBodyOne
  | GlobalAssetsImportDataBodyTwo
  | undefined;
export type GlobalAssetsImportDataMutationError = unknown;
export type GlobalAssetsImportDataMutationVariables = {
  data?: GlobalAssetsImportDataBodyOne | GlobalAssetsImportDataBodyTwo;
};

export const useGlobalAssetsImportData = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof globalAssetsImportData>>,
    TError,
    GlobalAssetsImportDataMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof globalAssetsImportData>>,
  TError,
  GlobalAssetsImportDataMutationVariables,
  TContext
> => {
  return useMutation(getGlobalAssetsImportDataMutationOptions(options));
};

export const globalAssetsExportData = (selectedLanguage: string, signal?: AbortSignal) => {
  return customAxiosInstance<Blob>({
    url: `/api/GlobalAssets/ExportData/export/${selectedLanguage}`,
    method: 'GET',
    responseType: 'blob',
    signal
  });
};

export const getGlobalAssetsExportDataQueryKey = (selectedLanguage: string) => {
  return [`/api/GlobalAssets/ExportData/export/${selectedLanguage}`] as const;
};

export const getGlobalAssetsExportDataQueryOptions = <
  TData = Awaited<ReturnType<typeof globalAssetsExportData>>,
  TError = unknown
>(
  selectedLanguage: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof globalAssetsExportData>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGlobalAssetsExportDataQueryKey(selectedLanguage);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof globalAssetsExportData>>> = ({ signal }) =>
    globalAssetsExportData(selectedLanguage, signal);

  return {
    queryKey,
    queryFn,
    enabled: selectedLanguage !== null && selectedLanguage !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof globalAssetsExportData>>, TError, TData> & { queryKey: QueryKey };
};

export type GlobalAssetsExportDataQueryResult = NonNullable<Awaited<ReturnType<typeof globalAssetsExportData>>>;
export type GlobalAssetsExportDataQueryError = unknown;

export function useGlobalAssetsExportData<TData = Awaited<ReturnType<typeof globalAssetsExportData>>, TError = unknown>(
  selectedLanguage: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof globalAssetsExportData>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGlobalAssetsExportDataQueryOptions(selectedLanguage, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const huginAssistantChatsAdminListSessions = (
  params?: HuginAssistantChatsAdminListSessionsParams,
  signal?: AbortSignal
) => {
  return customAxiosInstance<HuginAssistantChatSessionListItemDto[]>({
    url: `/api/admin/hugin-assistant/chats/sessions`,
    method: 'GET',
    params,
    signal
  });
};

export const getHuginAssistantChatsAdminListSessionsQueryKey = (
  params?: HuginAssistantChatsAdminListSessionsParams
) => {
  return [`/api/admin/hugin-assistant/chats/sessions`, ...(params ? [params] : [])] as const;
};

export const getHuginAssistantChatsAdminListSessionsQueryOptions = <
  TData = Awaited<ReturnType<typeof huginAssistantChatsAdminListSessions>>,
  TError = unknown
>(
  params?: HuginAssistantChatsAdminListSessionsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof huginAssistantChatsAdminListSessions>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHuginAssistantChatsAdminListSessionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof huginAssistantChatsAdminListSessions>>> = ({ signal }) =>
    huginAssistantChatsAdminListSessions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof huginAssistantChatsAdminListSessions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HuginAssistantChatsAdminListSessionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof huginAssistantChatsAdminListSessions>>
>;
export type HuginAssistantChatsAdminListSessionsQueryError = unknown;

export function useHuginAssistantChatsAdminListSessions<
  TData = Awaited<ReturnType<typeof huginAssistantChatsAdminListSessions>>,
  TError = unknown
>(
  params?: HuginAssistantChatsAdminListSessionsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof huginAssistantChatsAdminListSessions>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHuginAssistantChatsAdminListSessionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const huginAssistantChatsAdminGetFilterOptions = (signal?: AbortSignal) => {
  return customAxiosInstance<HuginAssistantChatFilterOptionsDto>({
    url: `/api/admin/hugin-assistant/chats/filter-options`,
    method: 'GET',
    signal
  });
};

export const getHuginAssistantChatsAdminGetFilterOptionsQueryKey = () => {
  return [`/api/admin/hugin-assistant/chats/filter-options`] as const;
};

export const getHuginAssistantChatsAdminGetFilterOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof huginAssistantChatsAdminGetFilterOptions>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof huginAssistantChatsAdminGetFilterOptions>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHuginAssistantChatsAdminGetFilterOptionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof huginAssistantChatsAdminGetFilterOptions>>> = ({ signal }) =>
    huginAssistantChatsAdminGetFilterOptions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof huginAssistantChatsAdminGetFilterOptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HuginAssistantChatsAdminGetFilterOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof huginAssistantChatsAdminGetFilterOptions>>
>;
export type HuginAssistantChatsAdminGetFilterOptionsQueryError = unknown;

export function useHuginAssistantChatsAdminGetFilterOptions<
  TData = Awaited<ReturnType<typeof huginAssistantChatsAdminGetFilterOptions>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof huginAssistantChatsAdminGetFilterOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHuginAssistantChatsAdminGetFilterOptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const huginAssistantChatsAdminGetSession = (sessionId: string, signal?: AbortSignal) => {
  return customAxiosInstance<HuginAssistantChatSessionListItemDto>({
    url: `/api/admin/hugin-assistant/chats/sessions/${sessionId}`,
    method: 'GET',
    signal
  });
};

export const getHuginAssistantChatsAdminGetSessionQueryKey = (sessionId: string) => {
  return [`/api/admin/hugin-assistant/chats/sessions/${sessionId}`] as const;
};

export const getHuginAssistantChatsAdminGetSessionQueryOptions = <
  TData = Awaited<ReturnType<typeof huginAssistantChatsAdminGetSession>>,
  TError = ProblemDetails
>(
  sessionId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof huginAssistantChatsAdminGetSession>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHuginAssistantChatsAdminGetSessionQueryKey(sessionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof huginAssistantChatsAdminGetSession>>> = ({ signal }) =>
    huginAssistantChatsAdminGetSession(sessionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: sessionId !== null && sessionId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof huginAssistantChatsAdminGetSession>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type HuginAssistantChatsAdminGetSessionQueryResult = NonNullable<
  Awaited<ReturnType<typeof huginAssistantChatsAdminGetSession>>
>;
export type HuginAssistantChatsAdminGetSessionQueryError = ProblemDetails;

export function useHuginAssistantChatsAdminGetSession<
  TData = Awaited<ReturnType<typeof huginAssistantChatsAdminGetSession>>,
  TError = ProblemDetails
>(
  sessionId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof huginAssistantChatsAdminGetSession>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHuginAssistantChatsAdminGetSessionQueryOptions(sessionId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const huginAssistantChatsAdminGetHistory = (sessionId: string, signal?: AbortSignal) => {
  return customAxiosInstance<HuginAssistantChatHistoryDto>({
    url: `/api/admin/hugin-assistant/chats/sessions/${sessionId}/history`,
    method: 'GET',
    signal
  });
};

export const getHuginAssistantChatsAdminGetHistoryQueryKey = (sessionId: string) => {
  return [`/api/admin/hugin-assistant/chats/sessions/${sessionId}/history`] as const;
};

export const getHuginAssistantChatsAdminGetHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof huginAssistantChatsAdminGetHistory>>,
  TError = ProblemDetails
>(
  sessionId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof huginAssistantChatsAdminGetHistory>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHuginAssistantChatsAdminGetHistoryQueryKey(sessionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof huginAssistantChatsAdminGetHistory>>> = ({ signal }) =>
    huginAssistantChatsAdminGetHistory(sessionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: sessionId !== null && sessionId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof huginAssistantChatsAdminGetHistory>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type HuginAssistantChatsAdminGetHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof huginAssistantChatsAdminGetHistory>>
>;
export type HuginAssistantChatsAdminGetHistoryQueryError = ProblemDetails;

export function useHuginAssistantChatsAdminGetHistory<
  TData = Awaited<ReturnType<typeof huginAssistantChatsAdminGetHistory>>,
  TError = ProblemDetails
>(
  sessionId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof huginAssistantChatsAdminGetHistory>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHuginAssistantChatsAdminGetHistoryQueryOptions(sessionId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Gets the status of a job by ID
 */
export const jobStatusGetJobStatus = (jobId: string, signal?: AbortSignal) => {
  return customAxiosInstance<JobStatusDto>({ url: `/api/JobStatus/${jobId}`, method: 'GET', signal });
};

export const getJobStatusGetJobStatusQueryKey = (jobId: string) => {
  return [`/api/JobStatus/${jobId}`] as const;
};

export const getJobStatusGetJobStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof jobStatusGetJobStatus>>,
  TError = ProblemDetails
>(
  jobId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof jobStatusGetJobStatus>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getJobStatusGetJobStatusQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof jobStatusGetJobStatus>>> = ({ signal }) =>
    jobStatusGetJobStatus(jobId, signal);

  return { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof jobStatusGetJobStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type JobStatusGetJobStatusQueryResult = NonNullable<Awaited<ReturnType<typeof jobStatusGetJobStatus>>>;
export type JobStatusGetJobStatusQueryError = ProblemDetails;

/**
 * @summary Gets the status of a job by ID
 */

export function useJobStatusGetJobStatus<
  TData = Awaited<ReturnType<typeof jobStatusGetJobStatus>>,
  TError = ProblemDetails
>(
  jobId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof jobStatusGetJobStatus>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getJobStatusGetJobStatusQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Gets recent jobs that have an error message.
 */
export const jobStatusGetRecentJobsWithErrors = (signal?: AbortSignal) => {
  return customAxiosInstance<JobStatusDto[]>({ url: `/api/JobStatus/errors`, method: 'GET', signal });
};

export const getJobStatusGetRecentJobsWithErrorsQueryKey = () => {
  return [`/api/JobStatus/errors`] as const;
};

export const getJobStatusGetRecentJobsWithErrorsQueryOptions = <
  TData = Awaited<ReturnType<typeof jobStatusGetRecentJobsWithErrors>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof jobStatusGetRecentJobsWithErrors>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getJobStatusGetRecentJobsWithErrorsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof jobStatusGetRecentJobsWithErrors>>> = ({ signal }) =>
    jobStatusGetRecentJobsWithErrors(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof jobStatusGetRecentJobsWithErrors>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type JobStatusGetRecentJobsWithErrorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof jobStatusGetRecentJobsWithErrors>>
>;
export type JobStatusGetRecentJobsWithErrorsQueryError = unknown;

/**
 * @summary Gets recent jobs that have an error message.
 */

export function useJobStatusGetRecentJobsWithErrors<
  TData = Awaited<ReturnType<typeof jobStatusGetRecentJobsWithErrors>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof jobStatusGetRecentJobsWithErrors>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getJobStatusGetRecentJobsWithErrorsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Gets a list of recent jobs, optionally filtered by count.
 */
export const jobStatusGetRecentJobs = (params?: JobStatusGetRecentJobsParams, signal?: AbortSignal) => {
  return customAxiosInstance<JobStatusDto[]>({ url: `/api/JobStatus/recent`, method: 'GET', params, signal });
};

export const getJobStatusGetRecentJobsQueryKey = (params?: JobStatusGetRecentJobsParams) => {
  return [`/api/JobStatus/recent`, ...(params ? [params] : [])] as const;
};

export const getJobStatusGetRecentJobsQueryOptions = <
  TData = Awaited<ReturnType<typeof jobStatusGetRecentJobs>>,
  TError = unknown
>(
  params?: JobStatusGetRecentJobsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof jobStatusGetRecentJobs>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getJobStatusGetRecentJobsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof jobStatusGetRecentJobs>>> = ({ signal }) =>
    jobStatusGetRecentJobs(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof jobStatusGetRecentJobs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type JobStatusGetRecentJobsQueryResult = NonNullable<Awaited<ReturnType<typeof jobStatusGetRecentJobs>>>;
export type JobStatusGetRecentJobsQueryError = unknown;

/**
 * @summary Gets a list of recent jobs, optionally filtered by count.
 */

export function useJobStatusGetRecentJobs<TData = Awaited<ReturnType<typeof jobStatusGetRecentJobs>>, TError = unknown>(
  params?: JobStatusGetRecentJobsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof jobStatusGetRecentJobs>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getJobStatusGetRecentJobsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Server-side paged list of recent jobs.
 */
export const jobStatusGetRecentJobsPaged = (params?: JobStatusGetRecentJobsPagedParams, signal?: AbortSignal) => {
  return customAxiosInstance<PagedResultDtoJobStatusDto>({
    url: `/api/JobStatus/recent-paged`,
    method: 'GET',
    params,
    signal
  });
};

export const getJobStatusGetRecentJobsPagedQueryKey = (params?: JobStatusGetRecentJobsPagedParams) => {
  return [`/api/JobStatus/recent-paged`, ...(params ? [params] : [])] as const;
};

export const getJobStatusGetRecentJobsPagedQueryOptions = <
  TData = Awaited<ReturnType<typeof jobStatusGetRecentJobsPaged>>,
  TError = unknown
>(
  params?: JobStatusGetRecentJobsPagedParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof jobStatusGetRecentJobsPaged>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getJobStatusGetRecentJobsPagedQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof jobStatusGetRecentJobsPaged>>> = ({ signal }) =>
    jobStatusGetRecentJobsPaged(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof jobStatusGetRecentJobsPaged>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type JobStatusGetRecentJobsPagedQueryResult = NonNullable<
  Awaited<ReturnType<typeof jobStatusGetRecentJobsPaged>>
>;
export type JobStatusGetRecentJobsPagedQueryError = unknown;

/**
 * @summary Server-side paged list of recent jobs.
 */

export function useJobStatusGetRecentJobsPaged<
  TData = Awaited<ReturnType<typeof jobStatusGetRecentJobsPaged>>,
  TError = unknown
>(
  params?: JobStatusGetRecentJobsPagedParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof jobStatusGetRecentJobsPaged>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getJobStatusGetRecentJobsPagedQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Gets all possible task types that can be used for filtering.
 */
export const jobStatusGetTaskTypes = (signal?: AbortSignal) => {
  return customAxiosInstance<string[]>({ url: `/api/JobStatus/task-types`, method: 'GET', signal });
};

export const getJobStatusGetTaskTypesQueryKey = () => {
  return [`/api/JobStatus/task-types`] as const;
};

export const getJobStatusGetTaskTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof jobStatusGetTaskTypes>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof jobStatusGetTaskTypes>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getJobStatusGetTaskTypesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof jobStatusGetTaskTypes>>> = ({ signal }) =>
    jobStatusGetTaskTypes(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof jobStatusGetTaskTypes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type JobStatusGetTaskTypesQueryResult = NonNullable<Awaited<ReturnType<typeof jobStatusGetTaskTypes>>>;
export type JobStatusGetTaskTypesQueryError = unknown;

/**
 * @summary Gets all possible task types that can be used for filtering.
 */

export function useJobStatusGetTaskTypes<
  TData = Awaited<ReturnType<typeof jobStatusGetTaskTypes>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof jobStatusGetTaskTypes>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getJobStatusGetTaskTypesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Gets all distinct topics that can be used for filtering.
 */
export const jobStatusGetTopics = (signal?: AbortSignal) => {
  return customAxiosInstance<string[]>({ url: `/api/JobStatus/topics`, method: 'GET', signal });
};

export const getJobStatusGetTopicsQueryKey = () => {
  return [`/api/JobStatus/topics`] as const;
};

export const getJobStatusGetTopicsQueryOptions = <
  TData = Awaited<ReturnType<typeof jobStatusGetTopics>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof jobStatusGetTopics>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getJobStatusGetTopicsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof jobStatusGetTopics>>> = ({ signal }) =>
    jobStatusGetTopics(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof jobStatusGetTopics>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type JobStatusGetTopicsQueryResult = NonNullable<Awaited<ReturnType<typeof jobStatusGetTopics>>>;
export type JobStatusGetTopicsQueryError = unknown;

/**
 * @summary Gets all distinct topics that can be used for filtering.
 */

export function useJobStatusGetTopics<
  TData = Awaited<ReturnType<typeof jobStatusGetTopics>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof jobStatusGetTopics>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getJobStatusGetTopicsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Reschedules a failed job.
 */
export const jobStatusRescheduleJob = (jobId: string, signal?: AbortSignal) => {
  return customAxiosInstance<unknown>({ url: `/api/JobStatus/${jobId}/reschedule`, method: 'POST', signal });
};

export const getJobStatusRescheduleJobMutationKey = () => ['jobStatusRescheduleJob'] as const;

export const getJobStatusRescheduleJobMutationOptions = <TError = ProblemDetails | void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof jobStatusRescheduleJob>>,
    TError,
    JobStatusRescheduleJobMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof jobStatusRescheduleJob>>,
  TError,
  JobStatusRescheduleJobMutationVariables,
  TContext
> => {
  const mutationKey = getJobStatusRescheduleJobMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof jobStatusRescheduleJob>>,
    JobStatusRescheduleJobMutationVariables
  > = (props) => {
    const { jobId } = props ?? {};

    return jobStatusRescheduleJob(jobId);
  };

  return { mutationFn, ...mutationOptions };
};

export type JobStatusRescheduleJobMutationResult = NonNullable<Awaited<ReturnType<typeof jobStatusRescheduleJob>>>;

export type JobStatusRescheduleJobMutationError = ProblemDetails | void;
export type JobStatusRescheduleJobMutationVariables = { jobId: string };

/**
 * @summary Reschedules a failed job.
 */
export const useJobStatusRescheduleJob = <TError = ProblemDetails | void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof jobStatusRescheduleJob>>,
    TError,
    JobStatusRescheduleJobMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof jobStatusRescheduleJob>>,
  TError,
  JobStatusRescheduleJobMutationVariables,
  TContext
> => {
  return useMutation(getJobStatusRescheduleJobMutationOptions(options));
};

/**
 * @summary Reschedules StoreProvisionalDialogStatistic jobs from a recent window.
Only the most recent job per SessionId is considered.
 */
export const jobStatusRescheduleStoreProvisionalDialogStatistics = (
  bulkRescheduleStoreProvisionalDialogStatisticRequest?: BulkRescheduleStoreProvisionalDialogStatisticRequest,
  signal?: AbortSignal
) => {
  return customAxiosInstance<unknown>({
    url: `/api/JobStatus/reschedule/store-provisional-dialog-statistics`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkRescheduleStoreProvisionalDialogStatisticRequest,
    signal
  });
};

export const getJobStatusRescheduleStoreProvisionalDialogStatisticsMutationKey = () =>
  ['jobStatusRescheduleStoreProvisionalDialogStatistics'] as const;

export const getJobStatusRescheduleStoreProvisionalDialogStatisticsMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof jobStatusRescheduleStoreProvisionalDialogStatistics>>,
    TError,
    JobStatusRescheduleStoreProvisionalDialogStatisticsMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof jobStatusRescheduleStoreProvisionalDialogStatistics>>,
  TError,
  JobStatusRescheduleStoreProvisionalDialogStatisticsMutationVariables,
  TContext
> => {
  const mutationKey = getJobStatusRescheduleStoreProvisionalDialogStatisticsMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof jobStatusRescheduleStoreProvisionalDialogStatistics>>,
    JobStatusRescheduleStoreProvisionalDialogStatisticsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return jobStatusRescheduleStoreProvisionalDialogStatistics(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type JobStatusRescheduleStoreProvisionalDialogStatisticsMutationResult = NonNullable<
  Awaited<ReturnType<typeof jobStatusRescheduleStoreProvisionalDialogStatistics>>
>;
export type JobStatusRescheduleStoreProvisionalDialogStatisticsMutationBody =
  | BulkRescheduleStoreProvisionalDialogStatisticRequest
  | undefined;
export type JobStatusRescheduleStoreProvisionalDialogStatisticsMutationError = ProblemDetails;
export type JobStatusRescheduleStoreProvisionalDialogStatisticsMutationVariables = {
  data?: BulkRescheduleStoreProvisionalDialogStatisticRequest;
};

/**
 * @summary Reschedules StoreProvisionalDialogStatistic jobs from a recent window.
Only the most recent job per SessionId is considered.
 */
export const useJobStatusRescheduleStoreProvisionalDialogStatistics = <
  TError = ProblemDetails,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof jobStatusRescheduleStoreProvisionalDialogStatistics>>,
    TError,
    JobStatusRescheduleStoreProvisionalDialogStatisticsMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof jobStatusRescheduleStoreProvisionalDialogStatistics>>,
  TError,
  JobStatusRescheduleStoreProvisionalDialogStatisticsMutationVariables,
  TContext
> => {
  return useMutation(getJobStatusRescheduleStoreProvisionalDialogStatisticsMutationOptions(options));
};

export const licenseAgreementsGetAll = (signal?: AbortSignal) => {
  return customAxiosInstance<LicenseAgreementDto[]>({ url: `/api/LicenseAgreements`, method: 'GET', signal });
};

export const getLicenseAgreementsGetAllQueryKey = () => {
  return [`/api/LicenseAgreements`] as const;
};

export const getLicenseAgreementsGetAllQueryOptions = <
  TData = Awaited<ReturnType<typeof licenseAgreementsGetAll>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof licenseAgreementsGetAll>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLicenseAgreementsGetAllQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof licenseAgreementsGetAll>>> = ({ signal }) =>
    licenseAgreementsGetAll(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof licenseAgreementsGetAll>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type LicenseAgreementsGetAllQueryResult = NonNullable<Awaited<ReturnType<typeof licenseAgreementsGetAll>>>;
export type LicenseAgreementsGetAllQueryError = unknown;

export function useLicenseAgreementsGetAll<
  TData = Awaited<ReturnType<typeof licenseAgreementsGetAll>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof licenseAgreementsGetAll>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getLicenseAgreementsGetAllQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const licenseAgreementsCreate = (
  createLicenseAgreementDto?: CreateLicenseAgreementDto,
  signal?: AbortSignal
) => {
  return customAxiosInstance<LicenseAgreementDto>({
    url: `/api/LicenseAgreements`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createLicenseAgreementDto,
    signal
  });
};

export const getLicenseAgreementsCreateMutationKey = () => ['licenseAgreementsCreate'] as const;

export const getLicenseAgreementsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof licenseAgreementsCreate>>,
    TError,
    LicenseAgreementsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof licenseAgreementsCreate>>,
  TError,
  LicenseAgreementsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getLicenseAgreementsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof licenseAgreementsCreate>>,
    LicenseAgreementsCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return licenseAgreementsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LicenseAgreementsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof licenseAgreementsCreate>>>;
export type LicenseAgreementsCreateMutationBody = CreateLicenseAgreementDto | undefined;
export type LicenseAgreementsCreateMutationError = unknown;
export type LicenseAgreementsCreateMutationVariables = { data?: CreateLicenseAgreementDto };

export const useLicenseAgreementsCreate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof licenseAgreementsCreate>>,
    TError,
    LicenseAgreementsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof licenseAgreementsCreate>>,
  TError,
  LicenseAgreementsCreateMutationVariables,
  TContext
> => {
  return useMutation(getLicenseAgreementsCreateMutationOptions(options));
};

export const licenseAgreementsGetById = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<LicenseAgreementDto>({ url: `/api/LicenseAgreements/${id}`, method: 'GET', signal });
};

export const getLicenseAgreementsGetByIdQueryKey = (id: number) => {
  return [`/api/LicenseAgreements/${id}`] as const;
};

export const getLicenseAgreementsGetByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof licenseAgreementsGetById>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof licenseAgreementsGetById>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLicenseAgreementsGetByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof licenseAgreementsGetById>>> = ({ signal }) =>
    licenseAgreementsGetById(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof licenseAgreementsGetById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type LicenseAgreementsGetByIdQueryResult = NonNullable<Awaited<ReturnType<typeof licenseAgreementsGetById>>>;
export type LicenseAgreementsGetByIdQueryError = unknown;

export function useLicenseAgreementsGetById<
  TData = Awaited<ReturnType<typeof licenseAgreementsGetById>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof licenseAgreementsGetById>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getLicenseAgreementsGetByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const licenseAgreementsUpdate = (
  id: number,
  updateLicenseAgreementDto?: UpdateLicenseAgreementDto,
  signal?: AbortSignal
) => {
  return customAxiosInstance<LicenseAgreementDto>({
    url: `/api/LicenseAgreements/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateLicenseAgreementDto,
    signal
  });
};

export const getLicenseAgreementsUpdateMutationKey = () => ['licenseAgreementsUpdate'] as const;

export const getLicenseAgreementsUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof licenseAgreementsUpdate>>,
    TError,
    LicenseAgreementsUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof licenseAgreementsUpdate>>,
  TError,
  LicenseAgreementsUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getLicenseAgreementsUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof licenseAgreementsUpdate>>,
    LicenseAgreementsUpdateMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return licenseAgreementsUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LicenseAgreementsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof licenseAgreementsUpdate>>>;
export type LicenseAgreementsUpdateMutationBody = UpdateLicenseAgreementDto | undefined;
export type LicenseAgreementsUpdateMutationError = unknown;
export type LicenseAgreementsUpdateMutationVariables = { id: number; data?: UpdateLicenseAgreementDto };

export const useLicenseAgreementsUpdate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof licenseAgreementsUpdate>>,
    TError,
    LicenseAgreementsUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof licenseAgreementsUpdate>>,
  TError,
  LicenseAgreementsUpdateMutationVariables,
  TContext
> => {
  return useMutation(getLicenseAgreementsUpdateMutationOptions(options));
};

export const licenseAgreementsDelete = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/LicenseAgreements/${id}`, method: 'DELETE', signal });
};

export const getLicenseAgreementsDeleteMutationKey = () => ['licenseAgreementsDelete'] as const;

export const getLicenseAgreementsDeleteMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof licenseAgreementsDelete>>,
    TError,
    LicenseAgreementsDeleteMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof licenseAgreementsDelete>>,
  TError,
  LicenseAgreementsDeleteMutationVariables,
  TContext
> => {
  const mutationKey = getLicenseAgreementsDeleteMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof licenseAgreementsDelete>>,
    LicenseAgreementsDeleteMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return licenseAgreementsDelete(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type LicenseAgreementsDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof licenseAgreementsDelete>>>;

export type LicenseAgreementsDeleteMutationError = unknown;
export type LicenseAgreementsDeleteMutationVariables = { id: number };

export const useLicenseAgreementsDelete = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof licenseAgreementsDelete>>,
    TError,
    LicenseAgreementsDeleteMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof licenseAgreementsDelete>>,
  TError,
  LicenseAgreementsDeleteMutationVariables,
  TContext
> => {
  return useMutation(getLicenseAgreementsDeleteMutationOptions(options));
};

export const licenseAgreementsGetByCompanyId = (companyId: number, signal?: AbortSignal) => {
  return customAxiosInstance<LicenseAgreementDto[]>({
    url: `/api/LicenseAgreements/company/${companyId}`,
    method: 'GET',
    signal
  });
};

export const getLicenseAgreementsGetByCompanyIdQueryKey = (companyId: number) => {
  return [`/api/LicenseAgreements/company/${companyId}`] as const;
};

export const getLicenseAgreementsGetByCompanyIdQueryOptions = <
  TData = Awaited<ReturnType<typeof licenseAgreementsGetByCompanyId>>,
  TError = unknown
>(
  companyId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof licenseAgreementsGetByCompanyId>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLicenseAgreementsGetByCompanyIdQueryKey(companyId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof licenseAgreementsGetByCompanyId>>> = ({ signal }) =>
    licenseAgreementsGetByCompanyId(companyId, signal);

  return {
    queryKey,
    queryFn,
    enabled: companyId !== null && companyId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof licenseAgreementsGetByCompanyId>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type LicenseAgreementsGetByCompanyIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof licenseAgreementsGetByCompanyId>>
>;
export type LicenseAgreementsGetByCompanyIdQueryError = unknown;

export function useLicenseAgreementsGetByCompanyId<
  TData = Awaited<ReturnType<typeof licenseAgreementsGetByCompanyId>>,
  TError = unknown
>(
  companyId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof licenseAgreementsGetByCompanyId>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getLicenseAgreementsGetByCompanyIdQueryOptions(companyId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const licenseAgreementsGetByDepartmentId = (departmentId: number, signal?: AbortSignal) => {
  return customAxiosInstance<LicenseAgreementDto[]>({
    url: `/api/LicenseAgreements/department/${departmentId}`,
    method: 'GET',
    signal
  });
};

export const getLicenseAgreementsGetByDepartmentIdQueryKey = (departmentId: number) => {
  return [`/api/LicenseAgreements/department/${departmentId}`] as const;
};

export const getLicenseAgreementsGetByDepartmentIdQueryOptions = <
  TData = Awaited<ReturnType<typeof licenseAgreementsGetByDepartmentId>>,
  TError = unknown
>(
  departmentId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof licenseAgreementsGetByDepartmentId>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLicenseAgreementsGetByDepartmentIdQueryKey(departmentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof licenseAgreementsGetByDepartmentId>>> = ({ signal }) =>
    licenseAgreementsGetByDepartmentId(departmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: departmentId !== null && departmentId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof licenseAgreementsGetByDepartmentId>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type LicenseAgreementsGetByDepartmentIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof licenseAgreementsGetByDepartmentId>>
>;
export type LicenseAgreementsGetByDepartmentIdQueryError = unknown;

export function useLicenseAgreementsGetByDepartmentId<
  TData = Awaited<ReturnType<typeof licenseAgreementsGetByDepartmentId>>,
  TError = unknown
>(
  departmentId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof licenseAgreementsGetByDepartmentId>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getLicenseAgreementsGetByDepartmentIdQueryOptions(departmentId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const licenseAgreementsGetUsage = (params?: LicenseAgreementsGetUsageParams, signal?: AbortSignal) => {
  return customAxiosInstance<LicenseUsageDto>({ url: `/api/LicenseAgreements/usage`, method: 'GET', params, signal });
};

export const getLicenseAgreementsGetUsageQueryKey = (params?: LicenseAgreementsGetUsageParams) => {
  return [`/api/LicenseAgreements/usage`, ...(params ? [params] : [])] as const;
};

export const getLicenseAgreementsGetUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof licenseAgreementsGetUsage>>,
  TError = unknown
>(
  params?: LicenseAgreementsGetUsageParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof licenseAgreementsGetUsage>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLicenseAgreementsGetUsageQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof licenseAgreementsGetUsage>>> = ({ signal }) =>
    licenseAgreementsGetUsage(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof licenseAgreementsGetUsage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type LicenseAgreementsGetUsageQueryResult = NonNullable<Awaited<ReturnType<typeof licenseAgreementsGetUsage>>>;
export type LicenseAgreementsGetUsageQueryError = unknown;

export function useLicenseAgreementsGetUsage<
  TData = Awaited<ReturnType<typeof licenseAgreementsGetUsage>>,
  TError = unknown
>(
  params?: LicenseAgreementsGetUsageParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof licenseAgreementsGetUsage>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getLicenseAgreementsGetUsageQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const licenseAgreementsGetBatchUsage = (
  getLicenseUsageBatchRequest?: GetLicenseUsageBatchRequest,
  signal?: AbortSignal
) => {
  return customAxiosInstance<LicenseUsageDto[]>({
    url: `/api/LicenseAgreements/usage/batch`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: getLicenseUsageBatchRequest,
    signal
  });
};

export const getLicenseAgreementsGetBatchUsageMutationKey = () => ['licenseAgreementsGetBatchUsage'] as const;

export const getLicenseAgreementsGetBatchUsageMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof licenseAgreementsGetBatchUsage>>,
    TError,
    LicenseAgreementsGetBatchUsageMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof licenseAgreementsGetBatchUsage>>,
  TError,
  LicenseAgreementsGetBatchUsageMutationVariables,
  TContext
> => {
  const mutationKey = getLicenseAgreementsGetBatchUsageMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof licenseAgreementsGetBatchUsage>>,
    LicenseAgreementsGetBatchUsageMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return licenseAgreementsGetBatchUsage(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LicenseAgreementsGetBatchUsageMutationResult = NonNullable<
  Awaited<ReturnType<typeof licenseAgreementsGetBatchUsage>>
>;
export type LicenseAgreementsGetBatchUsageMutationBody = GetLicenseUsageBatchRequest | undefined;
export type LicenseAgreementsGetBatchUsageMutationError = unknown;
export type LicenseAgreementsGetBatchUsageMutationVariables = { data?: GetLicenseUsageBatchRequest };

export const useLicenseAgreementsGetBatchUsage = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof licenseAgreementsGetBatchUsage>>,
    TError,
    LicenseAgreementsGetBatchUsageMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof licenseAgreementsGetBatchUsage>>,
  TError,
  LicenseAgreementsGetBatchUsageMutationVariables,
  TContext
> => {
  return useMutation(getLicenseAgreementsGetBatchUsageMutationOptions(options));
};

/**
 * @summary Totals and breakdowns for the report; no raw rows.
 */
export const llmUsageGetAdminSummary = (params?: LlmUsageGetAdminSummaryParams, signal?: AbortSignal) => {
  return customAxiosInstance<LlmUsageAdminSummaryDto>({
    url: `/api/llm-usage/admin/summary`,
    method: 'GET',
    params,
    signal
  });
};

export const getLlmUsageGetAdminSummaryQueryKey = (params?: LlmUsageGetAdminSummaryParams) => {
  return [`/api/llm-usage/admin/summary`, ...(params ? [params] : [])] as const;
};

export const getLlmUsageGetAdminSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof llmUsageGetAdminSummary>>,
  TError = unknown
>(
  params?: LlmUsageGetAdminSummaryParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof llmUsageGetAdminSummary>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLlmUsageGetAdminSummaryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof llmUsageGetAdminSummary>>> = ({ signal }) =>
    llmUsageGetAdminSummary(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof llmUsageGetAdminSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type LlmUsageGetAdminSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof llmUsageGetAdminSummary>>>;
export type LlmUsageGetAdminSummaryQueryError = unknown;

/**
 * @summary Totals and breakdowns for the report; no raw rows.
 */

export function useLlmUsageGetAdminSummary<
  TData = Awaited<ReturnType<typeof llmUsageGetAdminSummary>>,
  TError = unknown
>(
  params?: LlmUsageGetAdminSummaryParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof llmUsageGetAdminSummary>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getLlmUsageGetAdminSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary One page of scopes (a conversation, assistant session, recording or evaluation run), with
search over scope id, organization and user name.
 */
export const llmUsageGetAdminScopes = (params?: LlmUsageGetAdminScopesParams, signal?: AbortSignal) => {
  return customAxiosInstance<PagedResultDtoLlmUsageScopeDto>({
    url: `/api/llm-usage/admin/scopes`,
    method: 'GET',
    params,
    signal
  });
};

export const getLlmUsageGetAdminScopesQueryKey = (params?: LlmUsageGetAdminScopesParams) => {
  return [`/api/llm-usage/admin/scopes`, ...(params ? [params] : [])] as const;
};

export const getLlmUsageGetAdminScopesQueryOptions = <
  TData = Awaited<ReturnType<typeof llmUsageGetAdminScopes>>,
  TError = unknown
>(
  params?: LlmUsageGetAdminScopesParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof llmUsageGetAdminScopes>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLlmUsageGetAdminScopesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof llmUsageGetAdminScopes>>> = ({ signal }) =>
    llmUsageGetAdminScopes(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof llmUsageGetAdminScopes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type LlmUsageGetAdminScopesQueryResult = NonNullable<Awaited<ReturnType<typeof llmUsageGetAdminScopes>>>;
export type LlmUsageGetAdminScopesQueryError = unknown;

/**
 * @summary One page of scopes (a conversation, assistant session, recording or evaluation run), with
search over scope id, organization and user name.
 */

export function useLlmUsageGetAdminScopes<TData = Awaited<ReturnType<typeof llmUsageGetAdminScopes>>, TError = unknown>(
  params?: LlmUsageGetAdminScopesParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof llmUsageGetAdminScopes>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getLlmUsageGetAdminScopesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary One page of raw usage rows, newest first. Pass `scopeId` for every call in one scope.
 */
export const llmUsageGetAdminRows = (params?: LlmUsageGetAdminRowsParams, signal?: AbortSignal) => {
  return customAxiosInstance<PagedResultDtoLlmUsageCostDto>({
    url: `/api/llm-usage/admin/rows`,
    method: 'GET',
    params,
    signal
  });
};

export const getLlmUsageGetAdminRowsQueryKey = (params?: LlmUsageGetAdminRowsParams) => {
  return [`/api/llm-usage/admin/rows`, ...(params ? [params] : [])] as const;
};

export const getLlmUsageGetAdminRowsQueryOptions = <
  TData = Awaited<ReturnType<typeof llmUsageGetAdminRows>>,
  TError = unknown
>(
  params?: LlmUsageGetAdminRowsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof llmUsageGetAdminRows>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLlmUsageGetAdminRowsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof llmUsageGetAdminRows>>> = ({ signal }) =>
    llmUsageGetAdminRows(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof llmUsageGetAdminRows>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type LlmUsageGetAdminRowsQueryResult = NonNullable<Awaited<ReturnType<typeof llmUsageGetAdminRows>>>;
export type LlmUsageGetAdminRowsQueryError = unknown;

/**
 * @summary One page of raw usage rows, newest first. Pass `scopeId` for every call in one scope.
 */

export function useLlmUsageGetAdminRows<TData = Awaited<ReturnType<typeof llmUsageGetAdminRows>>, TError = unknown>(
  params?: LlmUsageGetAdminRowsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof llmUsageGetAdminRows>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getLlmUsageGetAdminRowsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Throws a test exception to verify error reporting (e.g. Application Insights).
Restricted to SuperAdmin role.
 */
export const maintenanceThrowTestException = (testExceptionRequest?: TestExceptionRequest, signal?: AbortSignal) => {
  return customAxiosInstance<unknown>({
    url: `/api/maintenance/test-exception`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: testExceptionRequest,
    signal
  });
};

export const getMaintenanceThrowTestExceptionMutationKey = () => ['maintenanceThrowTestException'] as const;

export const getMaintenanceThrowTestExceptionMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof maintenanceThrowTestException>>,
    TError,
    MaintenanceThrowTestExceptionMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof maintenanceThrowTestException>>,
  TError,
  MaintenanceThrowTestExceptionMutationVariables,
  TContext
> => {
  const mutationKey = getMaintenanceThrowTestExceptionMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof maintenanceThrowTestException>>,
    MaintenanceThrowTestExceptionMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return maintenanceThrowTestException(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MaintenanceThrowTestExceptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof maintenanceThrowTestException>>
>;
export type MaintenanceThrowTestExceptionMutationBody = TestExceptionRequest | undefined;
export type MaintenanceThrowTestExceptionMutationError = void;
export type MaintenanceThrowTestExceptionMutationVariables = { data?: TestExceptionRequest };

/**
 * @summary Throws a test exception to verify error reporting (e.g. Application Insights).
Restricted to SuperAdmin role.
 */
export const useMaintenanceThrowTestException = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof maintenanceThrowTestException>>,
    TError,
    MaintenanceThrowTestExceptionMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof maintenanceThrowTestException>>,
  TError,
  MaintenanceThrowTestExceptionMutationVariables,
  TContext
> => {
  return useMutation(getMaintenanceThrowTestExceptionMutationOptions(options));
};

/**
 * @summary Lists available task types with example payload templates to prefill the UI.
 */
export const maintenanceGetTaskTemplates = (signal?: AbortSignal) => {
  return customAxiosInstance<TaskTemplateDto[]>({ url: `/api/maintenance/tasks`, method: 'GET', signal });
};

export const getMaintenanceGetTaskTemplatesQueryKey = () => {
  return [`/api/maintenance/tasks`] as const;
};

export const getMaintenanceGetTaskTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof maintenanceGetTaskTemplates>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof maintenanceGetTaskTemplates>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMaintenanceGetTaskTemplatesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof maintenanceGetTaskTemplates>>> = ({ signal }) =>
    maintenanceGetTaskTemplates(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof maintenanceGetTaskTemplates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MaintenanceGetTaskTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof maintenanceGetTaskTemplates>>
>;
export type MaintenanceGetTaskTemplatesQueryError = unknown;

/**
 * @summary Lists available task types with example payload templates to prefill the UI.
 */

export function useMaintenanceGetTaskTemplates<
  TData = Awaited<ReturnType<typeof maintenanceGetTaskTemplates>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof maintenanceGetTaskTemplates>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getMaintenanceGetTaskTemplatesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Triggers any task by taskType with an arbitrary JSON payload.
 */
export const maintenanceTrigger = (triggerJobRequest?: TriggerJobRequest, signal?: AbortSignal) => {
  return customAxiosInstance<unknown>({
    url: `/api/maintenance/trigger`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: triggerJobRequest,
    signal
  });
};

export const getMaintenanceTriggerMutationKey = () => ['maintenanceTrigger'] as const;

export const getMaintenanceTriggerMutationOptions = <TError = ProblemDetails, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof maintenanceTrigger>>,
    TError,
    MaintenanceTriggerMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof maintenanceTrigger>>,
  TError,
  MaintenanceTriggerMutationVariables,
  TContext
> => {
  const mutationKey = getMaintenanceTriggerMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof maintenanceTrigger>>,
    MaintenanceTriggerMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return maintenanceTrigger(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MaintenanceTriggerMutationResult = NonNullable<Awaited<ReturnType<typeof maintenanceTrigger>>>;
export type MaintenanceTriggerMutationBody = TriggerJobRequest | undefined;
export type MaintenanceTriggerMutationError = ProblemDetails;
export type MaintenanceTriggerMutationVariables = { data?: TriggerJobRequest };

/**
 * @summary Triggers any task by taskType with an arbitrary JSON payload.
 */
export const useMaintenanceTrigger = <TError = ProblemDetails, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof maintenanceTrigger>>,
    TError,
    MaintenanceTriggerMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof maintenanceTrigger>>,
  TError,
  MaintenanceTriggerMutationVariables,
  TContext
> => {
  return useMutation(getMaintenanceTriggerMutationOptions(options));
};

/**
 * Ids are assigned when a session starts, so a long session that ends after a higher-Id session
 * has already been paged past is skipped by the Id cursor alone. Rescan recent endings with
 * endedAfter (typically with afterId=0); results are still ordered by Id.
 * @summary Finished conversations with Id greater than afterId, ascending by Id.
Pass the returned `nextAfterId` as the next afterId.
 */
export const monitorGetSessions = (params?: MonitorGetSessionsParams, signal?: AbortSignal) => {
  return customAxiosInstance<MonitorSessionPage>({ url: `/api/monitor/sessions`, method: 'GET', params, signal });
};

export const getMonitorGetSessionsQueryKey = (params?: MonitorGetSessionsParams) => {
  return [`/api/monitor/sessions`, ...(params ? [params] : [])] as const;
};

export const getMonitorGetSessionsQueryOptions = <
  TData = Awaited<ReturnType<typeof monitorGetSessions>>,
  TError = ProblemDetails
>(
  params?: MonitorGetSessionsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof monitorGetSessions>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMonitorGetSessionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof monitorGetSessions>>> = ({ signal }) =>
    monitorGetSessions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof monitorGetSessions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MonitorGetSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof monitorGetSessions>>>;
export type MonitorGetSessionsQueryError = ProblemDetails;

/**
 * @summary Finished conversations with Id greater than afterId, ascending by Id.
Pass the returned `nextAfterId` as the next afterId.
 */

export function useMonitorGetSessions<TData = Awaited<ReturnType<typeof monitorGetSessions>>, TError = ProblemDetails>(
  params?: MonitorGetSessionsParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof monitorGetSessions>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getMonitorGetSessionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Review bundle for one conversation: turns, scenario version, feedback, evaluations and event timeline.
 */
export const monitorGetSession = (sessionId: string, signal?: AbortSignal) => {
  return customAxiosInstance<MonitorSessionBundle>({
    url: `/api/monitor/sessions/${sessionId}`,
    method: 'GET',
    signal
  });
};

export const getMonitorGetSessionQueryKey = (sessionId: string) => {
  return [`/api/monitor/sessions/${sessionId}`] as const;
};

export const getMonitorGetSessionQueryOptions = <
  TData = Awaited<ReturnType<typeof monitorGetSession>>,
  TError = ProblemDetails
>(
  sessionId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof monitorGetSession>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMonitorGetSessionQueryKey(sessionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof monitorGetSession>>> = ({ signal }) =>
    monitorGetSession(sessionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: sessionId !== null && sessionId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof monitorGetSession>>, TError, TData> & { queryKey: QueryKey };
};

export type MonitorGetSessionQueryResult = NonNullable<Awaited<ReturnType<typeof monitorGetSession>>>;
export type MonitorGetSessionQueryError = ProblemDetails;

/**
 * @summary Review bundle for one conversation: turns, scenario version, feedback, evaluations and event timeline.
 */

export function useMonitorGetSession<TData = Awaited<ReturnType<typeof monitorGetSession>>, TError = ProblemDetails>(
  sessionId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof monitorGetSession>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getMonitorGetSessionQueryOptions(sessionId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Starts a new operator session and returns the session id plus the operator's greeting.
 */
export const operatorSimStartSession = (signal?: AbortSignal) => {
  return customAxiosInstance<StartOperatorSessionResult>({
    url: `/api/OperatorSim/StartSession`,
    method: 'POST',
    signal
  });
};

export const getOperatorSimStartSessionMutationKey = () => ['operatorSimStartSession'] as const;

export const getOperatorSimStartSessionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof operatorSimStartSession>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof operatorSimStartSession>>, TError, void, TContext> => {
  const mutationKey = getOperatorSimStartSessionMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof operatorSimStartSession>>, void> = () => {
    return operatorSimStartSession();
  };

  return { mutationFn, ...mutationOptions };
};

export type OperatorSimStartSessionMutationResult = NonNullable<Awaited<ReturnType<typeof operatorSimStartSession>>>;

export type OperatorSimStartSessionMutationError = unknown;

/**
 * @summary Starts a new operator session and returns the session id plus the operator's greeting.
 */
export const useOperatorSimStartSession = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof operatorSimStartSession>>, TError, void, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof operatorSimStartSession>>, TError, void, TContext> => {
  return useMutation(getOperatorSimStartSessionMutationOptions(options));
};

/**
 * @summary Advances an operator session with the caller's latest utterance and returns the
operator's text reply.
 */
export const operatorSimRespondToCaller = (
  sessionId: string,
  callerTurnRequest?: CallerTurnRequest,
  signal?: AbortSignal
) => {
  return customAxiosInstance<OperatorTurnResult>({
    url: `/api/OperatorSim/RespondToCaller/${sessionId}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: callerTurnRequest,
    signal
  });
};

export const getOperatorSimRespondToCallerMutationKey = () => ['operatorSimRespondToCaller'] as const;

export const getOperatorSimRespondToCallerMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof operatorSimRespondToCaller>>,
    TError,
    OperatorSimRespondToCallerMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof operatorSimRespondToCaller>>,
  TError,
  OperatorSimRespondToCallerMutationVariables,
  TContext
> => {
  const mutationKey = getOperatorSimRespondToCallerMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof operatorSimRespondToCaller>>,
    OperatorSimRespondToCallerMutationVariables
  > = (props) => {
    const { sessionId, data } = props ?? {};

    return operatorSimRespondToCaller(sessionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type OperatorSimRespondToCallerMutationResult = NonNullable<
  Awaited<ReturnType<typeof operatorSimRespondToCaller>>
>;
export type OperatorSimRespondToCallerMutationBody = CallerTurnRequest | undefined;
export type OperatorSimRespondToCallerMutationError = unknown;
export type OperatorSimRespondToCallerMutationVariables = { sessionId: string; data?: CallerTurnRequest };

/**
 * @summary Advances an operator session with the caller's latest utterance and returns the
operator's text reply.
 */
export const useOperatorSimRespondToCaller = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof operatorSimRespondToCaller>>,
    TError,
    OperatorSimRespondToCallerMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof operatorSimRespondToCaller>>,
  TError,
  OperatorSimRespondToCallerMutationVariables,
  TContext
> => {
  return useMutation(getOperatorSimRespondToCallerMutationOptions(options));
};

export const personaGenerateMagicPersonaPrompt = (
  generateMagicPersonaPromptCommand?: GenerateMagicPersonaPromptCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<string>({
    url: `/api/personas/GenerateMagicPersonaPrompt`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: generateMagicPersonaPromptCommand,
    signal
  });
};

export const getPersonaGenerateMagicPersonaPromptMutationKey = () => ['personaGenerateMagicPersonaPrompt'] as const;

export const getPersonaGenerateMagicPersonaPromptMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaGenerateMagicPersonaPrompt>>,
    TError,
    PersonaGenerateMagicPersonaPromptMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof personaGenerateMagicPersonaPrompt>>,
  TError,
  PersonaGenerateMagicPersonaPromptMutationVariables,
  TContext
> => {
  const mutationKey = getPersonaGenerateMagicPersonaPromptMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof personaGenerateMagicPersonaPrompt>>,
    PersonaGenerateMagicPersonaPromptMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return personaGenerateMagicPersonaPrompt(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PersonaGenerateMagicPersonaPromptMutationResult = NonNullable<
  Awaited<ReturnType<typeof personaGenerateMagicPersonaPrompt>>
>;
export type PersonaGenerateMagicPersonaPromptMutationBody = GenerateMagicPersonaPromptCommand | undefined;
export type PersonaGenerateMagicPersonaPromptMutationError = unknown;
export type PersonaGenerateMagicPersonaPromptMutationVariables = { data?: GenerateMagicPersonaPromptCommand };

export const usePersonaGenerateMagicPersonaPrompt = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaGenerateMagicPersonaPrompt>>,
    TError,
    PersonaGenerateMagicPersonaPromptMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof personaGenerateMagicPersonaPrompt>>,
  TError,
  PersonaGenerateMagicPersonaPromptMutationVariables,
  TContext
> => {
  return useMutation(getPersonaGenerateMagicPersonaPromptMutationOptions(options));
};

export const personaInitPersonaSession = (
  initPersonaSessionCommand?: InitPersonaSessionCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<PersonaSessionInitResult>({
    url: `/api/personas/InitPersonaSession`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: initPersonaSessionCommand,
    signal
  });
};

export const getPersonaInitPersonaSessionMutationKey = () => ['personaInitPersonaSession'] as const;

export const getPersonaInitPersonaSessionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaInitPersonaSession>>,
    TError,
    PersonaInitPersonaSessionMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof personaInitPersonaSession>>,
  TError,
  PersonaInitPersonaSessionMutationVariables,
  TContext
> => {
  const mutationKey = getPersonaInitPersonaSessionMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof personaInitPersonaSession>>,
    PersonaInitPersonaSessionMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return personaInitPersonaSession(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PersonaInitPersonaSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof personaInitPersonaSession>>
>;
export type PersonaInitPersonaSessionMutationBody = InitPersonaSessionCommand | undefined;
export type PersonaInitPersonaSessionMutationError = unknown;
export type PersonaInitPersonaSessionMutationVariables = { data?: InitPersonaSessionCommand };

export const usePersonaInitPersonaSession = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaInitPersonaSession>>,
    TError,
    PersonaInitPersonaSessionMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof personaInitPersonaSession>>,
  TError,
  PersonaInitPersonaSessionMutationVariables,
  TContext
> => {
  return useMutation(getPersonaInitPersonaSessionMutationOptions(options));
};

export const personaRespondWithPersonaAudio = (
  respondWithPersonaAudioCommand?: RespondWithPersonaAudioCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<PersonaAudioResponse>({
    url: `/api/personas/RespondWithPersonaAudio`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: respondWithPersonaAudioCommand,
    signal
  });
};

export const getPersonaRespondWithPersonaAudioMutationKey = () => ['personaRespondWithPersonaAudio'] as const;

export const getPersonaRespondWithPersonaAudioMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaRespondWithPersonaAudio>>,
    TError,
    PersonaRespondWithPersonaAudioMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof personaRespondWithPersonaAudio>>,
  TError,
  PersonaRespondWithPersonaAudioMutationVariables,
  TContext
> => {
  const mutationKey = getPersonaRespondWithPersonaAudioMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof personaRespondWithPersonaAudio>>,
    PersonaRespondWithPersonaAudioMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return personaRespondWithPersonaAudio(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PersonaRespondWithPersonaAudioMutationResult = NonNullable<
  Awaited<ReturnType<typeof personaRespondWithPersonaAudio>>
>;
export type PersonaRespondWithPersonaAudioMutationBody = RespondWithPersonaAudioCommand | undefined;
export type PersonaRespondWithPersonaAudioMutationError = unknown;
export type PersonaRespondWithPersonaAudioMutationVariables = { data?: RespondWithPersonaAudioCommand };

export const usePersonaRespondWithPersonaAudio = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaRespondWithPersonaAudio>>,
    TError,
    PersonaRespondWithPersonaAudioMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof personaRespondWithPersonaAudio>>,
  TError,
  PersonaRespondWithPersonaAudioMutationVariables,
  TContext
> => {
  return useMutation(getPersonaRespondWithPersonaAudioMutationOptions(options));
};

export const personaGeneratePersonaSentence = (
  generatePersonaSentenceRequestDto?: GeneratePersonaSentenceRequestDto,
  signal?: AbortSignal
) => {
  return customAxiosInstance<GeneratePersonaSentenceResponseDto>({
    url: `/api/personas/generate-sentence`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: generatePersonaSentenceRequestDto,
    signal
  });
};

export const getPersonaGeneratePersonaSentenceMutationKey = () => ['personaGeneratePersonaSentence'] as const;

export const getPersonaGeneratePersonaSentenceMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaGeneratePersonaSentence>>,
    TError,
    PersonaGeneratePersonaSentenceMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof personaGeneratePersonaSentence>>,
  TError,
  PersonaGeneratePersonaSentenceMutationVariables,
  TContext
> => {
  const mutationKey = getPersonaGeneratePersonaSentenceMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof personaGeneratePersonaSentence>>,
    PersonaGeneratePersonaSentenceMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return personaGeneratePersonaSentence(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PersonaGeneratePersonaSentenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof personaGeneratePersonaSentence>>
>;
export type PersonaGeneratePersonaSentenceMutationBody = GeneratePersonaSentenceRequestDto | undefined;
export type PersonaGeneratePersonaSentenceMutationError = unknown;
export type PersonaGeneratePersonaSentenceMutationVariables = { data?: GeneratePersonaSentenceRequestDto };

export const usePersonaGeneratePersonaSentence = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaGeneratePersonaSentence>>,
    TError,
    PersonaGeneratePersonaSentenceMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof personaGeneratePersonaSentence>>,
  TError,
  PersonaGeneratePersonaSentenceMutationVariables,
  TContext
> => {
  return useMutation(getPersonaGeneratePersonaSentenceMutationOptions(options));
};

/**
 * @summary Creates a new persona with the specified properties.
 */
export const personaCreatePersona = (createPersonaDto?: CreatePersonaDto, signal?: AbortSignal) => {
  return customAxiosInstance<PersonaDto | void>({
    url: `/api/personas`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createPersonaDto,
    signal
  });
};

export const getPersonaCreatePersonaMutationKey = () => ['personaCreatePersona'] as const;

export const getPersonaCreatePersonaMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaCreatePersona>>,
    TError,
    PersonaCreatePersonaMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof personaCreatePersona>>,
  TError,
  PersonaCreatePersonaMutationVariables,
  TContext
> => {
  const mutationKey = getPersonaCreatePersonaMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof personaCreatePersona>>,
    PersonaCreatePersonaMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return personaCreatePersona(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PersonaCreatePersonaMutationResult = NonNullable<Awaited<ReturnType<typeof personaCreatePersona>>>;
export type PersonaCreatePersonaMutationBody = CreatePersonaDto | undefined;
export type PersonaCreatePersonaMutationError = void;
export type PersonaCreatePersonaMutationVariables = { data?: CreatePersonaDto };

/**
 * @summary Creates a new persona with the specified properties.
 */
export const usePersonaCreatePersona = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaCreatePersona>>,
    TError,
    PersonaCreatePersonaMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof personaCreatePersona>>,
  TError,
  PersonaCreatePersonaMutationVariables,
  TContext
> => {
  return useMutation(getPersonaCreatePersonaMutationOptions(options));
};

/**
 * @summary Retrieves all personas accessible to the current user's company.
 */
export const personaGetPersonas = (signal?: AbortSignal) => {
  return customAxiosInstance<PersonaDto[]>({ url: `/api/personas`, method: 'GET', signal });
};

export const getPersonaGetPersonasQueryKey = () => {
  return [`/api/personas`] as const;
};

export const getPersonaGetPersonasQueryOptions = <
  TData = Awaited<ReturnType<typeof personaGetPersonas>>,
  TError = void
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof personaGetPersonas>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPersonaGetPersonasQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof personaGetPersonas>>> = ({ signal }) =>
    personaGetPersonas(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof personaGetPersonas>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PersonaGetPersonasQueryResult = NonNullable<Awaited<ReturnType<typeof personaGetPersonas>>>;
export type PersonaGetPersonasQueryError = void;

/**
 * @summary Retrieves all personas accessible to the current user's company.
 */

export function usePersonaGetPersonas<TData = Awaited<ReturnType<typeof personaGetPersonas>>, TError = void>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof personaGetPersonas>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPersonaGetPersonasQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Searches personas accessible to the current user and returns a compact paged result.
 */
export const personaSearchPersonas = (params?: PersonaSearchPersonasParams, signal?: AbortSignal) => {
  return customAxiosInstance<PagedResultDtoPersonaSearchItemDto>({
    url: `/api/personas/search`,
    method: 'GET',
    params,
    signal
  });
};

export const getPersonaSearchPersonasQueryKey = (params?: PersonaSearchPersonasParams) => {
  return [`/api/personas/search`, ...(params ? [params] : [])] as const;
};

export const getPersonaSearchPersonasQueryOptions = <
  TData = Awaited<ReturnType<typeof personaSearchPersonas>>,
  TError = void
>(
  params?: PersonaSearchPersonasParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof personaSearchPersonas>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPersonaSearchPersonasQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof personaSearchPersonas>>> = ({ signal }) =>
    personaSearchPersonas(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof personaSearchPersonas>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PersonaSearchPersonasQueryResult = NonNullable<Awaited<ReturnType<typeof personaSearchPersonas>>>;
export type PersonaSearchPersonasQueryError = void;

/**
 * @summary Searches personas accessible to the current user and returns a compact paged result.
 */

export function usePersonaSearchPersonas<TData = Awaited<ReturnType<typeof personaSearchPersonas>>, TError = void>(
  params?: PersonaSearchPersonasParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof personaSearchPersonas>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPersonaSearchPersonasQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Retrieves a specific persona by ID.
 */
export const personaGetPersona = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<PersonaDto>({ url: `/api/personas/${id}`, method: 'GET', signal });
};

export const getPersonaGetPersonaQueryKey = (id: number) => {
  return [`/api/personas/${id}`] as const;
};

export const getPersonaGetPersonaQueryOptions = <TData = Awaited<ReturnType<typeof personaGetPersona>>, TError = void>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof personaGetPersona>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPersonaGetPersonaQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof personaGetPersona>>> = ({ signal }) =>
    personaGetPersona(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof personaGetPersona>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PersonaGetPersonaQueryResult = NonNullable<Awaited<ReturnType<typeof personaGetPersona>>>;
export type PersonaGetPersonaQueryError = void;

/**
 * @summary Retrieves a specific persona by ID.
 */

export function usePersonaGetPersona<TData = Awaited<ReturnType<typeof personaGetPersona>>, TError = void>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof personaGetPersona>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPersonaGetPersonaQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Updates an existing persona with the specified properties.
 */
export const personaUpdatePersona = (id: number, updatePersonaDto?: UpdatePersonaDto, signal?: AbortSignal) => {
  return customAxiosInstance<PersonaDto>({
    url: `/api/personas/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updatePersonaDto,
    signal
  });
};

export const getPersonaUpdatePersonaMutationKey = () => ['personaUpdatePersona'] as const;

export const getPersonaUpdatePersonaMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaUpdatePersona>>,
    TError,
    PersonaUpdatePersonaMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof personaUpdatePersona>>,
  TError,
  PersonaUpdatePersonaMutationVariables,
  TContext
> => {
  const mutationKey = getPersonaUpdatePersonaMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof personaUpdatePersona>>,
    PersonaUpdatePersonaMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return personaUpdatePersona(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PersonaUpdatePersonaMutationResult = NonNullable<Awaited<ReturnType<typeof personaUpdatePersona>>>;
export type PersonaUpdatePersonaMutationBody = UpdatePersonaDto | undefined;
export type PersonaUpdatePersonaMutationError = void;
export type PersonaUpdatePersonaMutationVariables = { id: number; data?: UpdatePersonaDto };

/**
 * @summary Updates an existing persona with the specified properties.
 */
export const usePersonaUpdatePersona = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaUpdatePersona>>,
    TError,
    PersonaUpdatePersonaMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof personaUpdatePersona>>,
  TError,
  PersonaUpdatePersonaMutationVariables,
  TContext
> => {
  return useMutation(getPersonaUpdatePersonaMutationOptions(options));
};

/**
 * @summary Deletes a persona by ID. Performs validation before deletion.
 */
export const personaDeletePersona = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/personas/${id}`, method: 'DELETE', signal });
};

export const getPersonaDeletePersonaMutationKey = () => ['personaDeletePersona'] as const;

export const getPersonaDeletePersonaMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaDeletePersona>>,
    TError,
    PersonaDeletePersonaMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof personaDeletePersona>>,
  TError,
  PersonaDeletePersonaMutationVariables,
  TContext
> => {
  const mutationKey = getPersonaDeletePersonaMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof personaDeletePersona>>,
    PersonaDeletePersonaMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return personaDeletePersona(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PersonaDeletePersonaMutationResult = NonNullable<Awaited<ReturnType<typeof personaDeletePersona>>>;

export type PersonaDeletePersonaMutationError = void;
export type PersonaDeletePersonaMutationVariables = { id: number };

/**
 * @summary Deletes a persona by ID. Performs validation before deletion.
 */
export const usePersonaDeletePersona = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaDeletePersona>>,
    TError,
    PersonaDeletePersonaMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof personaDeletePersona>>,
  TError,
  PersonaDeletePersonaMutationVariables,
  TContext
> => {
  return useMutation(getPersonaDeletePersonaMutationOptions(options));
};

/**
 * @summary Shares a persona with additional companies and their access levels.
 */
export const personaSharePersonaWithCompanies = (
  id: number,
  personaCompanyAccessDto?: PersonaCompanyAccessDto[],
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/personas/${id}/share`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: personaCompanyAccessDto,
    signal
  });
};

export const getPersonaSharePersonaWithCompaniesMutationKey = () => ['personaSharePersonaWithCompanies'] as const;

export const getPersonaSharePersonaWithCompaniesMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaSharePersonaWithCompanies>>,
    TError,
    PersonaSharePersonaWithCompaniesMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof personaSharePersonaWithCompanies>>,
  TError,
  PersonaSharePersonaWithCompaniesMutationVariables,
  TContext
> => {
  const mutationKey = getPersonaSharePersonaWithCompaniesMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof personaSharePersonaWithCompanies>>,
    PersonaSharePersonaWithCompaniesMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return personaSharePersonaWithCompanies(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PersonaSharePersonaWithCompaniesMutationResult = NonNullable<
  Awaited<ReturnType<typeof personaSharePersonaWithCompanies>>
>;
export type PersonaSharePersonaWithCompaniesMutationBody = PersonaCompanyAccessDto[] | undefined;
export type PersonaSharePersonaWithCompaniesMutationError = void;
export type PersonaSharePersonaWithCompaniesMutationVariables = { id: number; data?: PersonaCompanyAccessDto[] };

/**
 * @summary Shares a persona with additional companies and their access levels.
 */
export const usePersonaSharePersonaWithCompanies = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaSharePersonaWithCompanies>>,
    TError,
    PersonaSharePersonaWithCompaniesMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof personaSharePersonaWithCompanies>>,
  TError,
  PersonaSharePersonaWithCompaniesMutationVariables,
  TContext
> => {
  return useMutation(getPersonaSharePersonaWithCompaniesMutationOptions(options));
};

export const personaUnsharePersonaFromCompanies = (
  id: number,
  personaUnsharePersonaFromCompaniesBody?: number[],
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/personas/${id}/unshare`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: personaUnsharePersonaFromCompaniesBody,
    signal
  });
};

export const getPersonaUnsharePersonaFromCompaniesMutationKey = () => ['personaUnsharePersonaFromCompanies'] as const;

export const getPersonaUnsharePersonaFromCompaniesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaUnsharePersonaFromCompanies>>,
    TError,
    PersonaUnsharePersonaFromCompaniesMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof personaUnsharePersonaFromCompanies>>,
  TError,
  PersonaUnsharePersonaFromCompaniesMutationVariables,
  TContext
> => {
  const mutationKey = getPersonaUnsharePersonaFromCompaniesMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof personaUnsharePersonaFromCompanies>>,
    PersonaUnsharePersonaFromCompaniesMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return personaUnsharePersonaFromCompanies(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PersonaUnsharePersonaFromCompaniesMutationResult = NonNullable<
  Awaited<ReturnType<typeof personaUnsharePersonaFromCompanies>>
>;
export type PersonaUnsharePersonaFromCompaniesMutationBody = number[] | undefined;
export type PersonaUnsharePersonaFromCompaniesMutationError = unknown;
export type PersonaUnsharePersonaFromCompaniesMutationVariables = { id: number; data?: number[] };

export const usePersonaUnsharePersonaFromCompanies = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaUnsharePersonaFromCompanies>>,
    TError,
    PersonaUnsharePersonaFromCompaniesMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof personaUnsharePersonaFromCompanies>>,
  TError,
  PersonaUnsharePersonaFromCompaniesMutationVariables,
  TContext
> => {
  return useMutation(getPersonaUnsharePersonaFromCompaniesMutationOptions(options));
};

export const personaGetPersonaCompanies = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<PersonaCompanyDto[]>({ url: `/api/personas/${id}/companies`, method: 'GET', signal });
};

export const getPersonaGetPersonaCompaniesQueryKey = (id: number) => {
  return [`/api/personas/${id}/companies`] as const;
};

export const getPersonaGetPersonaCompaniesQueryOptions = <
  TData = Awaited<ReturnType<typeof personaGetPersonaCompanies>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof personaGetPersonaCompanies>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPersonaGetPersonaCompaniesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof personaGetPersonaCompanies>>> = ({ signal }) =>
    personaGetPersonaCompanies(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof personaGetPersonaCompanies>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PersonaGetPersonaCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof personaGetPersonaCompanies>>>;
export type PersonaGetPersonaCompaniesQueryError = unknown;

export function usePersonaGetPersonaCompanies<
  TData = Awaited<ReturnType<typeof personaGetPersonaCompanies>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof personaGetPersonaCompanies>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPersonaGetPersonaCompaniesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const personaUpdatePersonaCompanyAccess = (
  personaId: number,
  companyId: number,
  accessLevel?: AccessLevel,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/personas/${personaId}/companies/${companyId}/access`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: accessLevel,
    signal
  });
};

export const getPersonaUpdatePersonaCompanyAccessMutationKey = () => ['personaUpdatePersonaCompanyAccess'] as const;

export const getPersonaUpdatePersonaCompanyAccessMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaUpdatePersonaCompanyAccess>>,
    TError,
    PersonaUpdatePersonaCompanyAccessMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof personaUpdatePersonaCompanyAccess>>,
  TError,
  PersonaUpdatePersonaCompanyAccessMutationVariables,
  TContext
> => {
  const mutationKey = getPersonaUpdatePersonaCompanyAccessMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof personaUpdatePersonaCompanyAccess>>,
    PersonaUpdatePersonaCompanyAccessMutationVariables
  > = (props) => {
    const { personaId, companyId, data } = props ?? {};

    return personaUpdatePersonaCompanyAccess(personaId, companyId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PersonaUpdatePersonaCompanyAccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof personaUpdatePersonaCompanyAccess>>
>;
export type PersonaUpdatePersonaCompanyAccessMutationBody = AccessLevel | undefined;
export type PersonaUpdatePersonaCompanyAccessMutationError = unknown;
export type PersonaUpdatePersonaCompanyAccessMutationVariables = {
  personaId: number;
  companyId: number;
  data?: AccessLevel;
};

export const usePersonaUpdatePersonaCompanyAccess = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof personaUpdatePersonaCompanyAccess>>,
    TError,
    PersonaUpdatePersonaCompanyAccessMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof personaUpdatePersonaCompanyAccess>>,
  TError,
  PersonaUpdatePersonaCompanyAccessMutationVariables,
  TContext
> => {
  return useMutation(getPersonaUpdatePersonaCompanyAccessMutationOptions(options));
};

/**
 * @summary Retrieves all personas accessible to a specific company.
 */
export const personaGetPersonasByCompany = (companyId: number, signal?: AbortSignal) => {
  return customAxiosInstance<PersonaDto[]>({ url: `/api/personas/by-company/${companyId}`, method: 'GET', signal });
};

export const getPersonaGetPersonasByCompanyQueryKey = (companyId: number) => {
  return [`/api/personas/by-company/${companyId}`] as const;
};

export const getPersonaGetPersonasByCompanyQueryOptions = <
  TData = Awaited<ReturnType<typeof personaGetPersonasByCompany>>,
  TError = void
>(
  companyId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof personaGetPersonasByCompany>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPersonaGetPersonasByCompanyQueryKey(companyId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof personaGetPersonasByCompany>>> = ({ signal }) =>
    personaGetPersonasByCompany(companyId, signal);

  return {
    queryKey,
    queryFn,
    enabled: companyId !== null && companyId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof personaGetPersonasByCompany>>, TError, TData> & { queryKey: QueryKey };
};

export type PersonaGetPersonasByCompanyQueryResult = NonNullable<
  Awaited<ReturnType<typeof personaGetPersonasByCompany>>
>;
export type PersonaGetPersonasByCompanyQueryError = void;

/**
 * @summary Retrieves all personas accessible to a specific company.
 */

export function usePersonaGetPersonasByCompany<
  TData = Awaited<ReturnType<typeof personaGetPersonasByCompany>>,
  TError = void
>(
  companyId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof personaGetPersonasByCompany>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPersonaGetPersonasByCompanyQueryOptions(companyId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Returns whether the persona can be deleted and why/why not, plus list of scenarios referencing it.
 */
export const personaGetPersonaDeletionValidation = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<PersonaDeletionValidationDto>({
    url: `/api/personas/${id}/deletion-validation`,
    method: 'GET',
    signal
  });
};

export const getPersonaGetPersonaDeletionValidationQueryKey = (id: number) => {
  return [`/api/personas/${id}/deletion-validation`] as const;
};

export const getPersonaGetPersonaDeletionValidationQueryOptions = <
  TData = Awaited<ReturnType<typeof personaGetPersonaDeletionValidation>>,
  TError = void
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof personaGetPersonaDeletionValidation>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPersonaGetPersonaDeletionValidationQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof personaGetPersonaDeletionValidation>>> = ({ signal }) =>
    personaGetPersonaDeletionValidation(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof personaGetPersonaDeletionValidation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PersonaGetPersonaDeletionValidationQueryResult = NonNullable<
  Awaited<ReturnType<typeof personaGetPersonaDeletionValidation>>
>;
export type PersonaGetPersonaDeletionValidationQueryError = void;

/**
 * @summary Returns whether the persona can be deleted and why/why not, plus list of scenarios referencing it.
 */

export function usePersonaGetPersonaDeletionValidation<
  TData = Awaited<ReturnType<typeof personaGetPersonaDeletionValidation>>,
  TError = void
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof personaGetPersonaDeletionValidation>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPersonaGetPersonaDeletionValidationQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const processProcessDialog = (processDialogCommand?: ProcessDialogCommand, signal?: AbortSignal) => {
  return customAxiosInstance<ProcessResultDto>({
    url: `/api/Process/ProcessDialog`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: processDialogCommand,
    signal
  });
};

export const getProcessProcessDialogMutationKey = () => ['processProcessDialog'] as const;

export const getProcessProcessDialogMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processProcessDialog>>,
    TError,
    ProcessProcessDialogMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof processProcessDialog>>,
  TError,
  ProcessProcessDialogMutationVariables,
  TContext
> => {
  const mutationKey = getProcessProcessDialogMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof processProcessDialog>>,
    ProcessProcessDialogMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return processProcessDialog(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProcessProcessDialogMutationResult = NonNullable<Awaited<ReturnType<typeof processProcessDialog>>>;
export type ProcessProcessDialogMutationBody = ProcessDialogCommand | undefined;
export type ProcessProcessDialogMutationError = unknown;
export type ProcessProcessDialogMutationVariables = { data?: ProcessDialogCommand };

export const useProcessProcessDialog = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processProcessDialog>>,
    TError,
    ProcessProcessDialogMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof processProcessDialog>>,
  TError,
  ProcessProcessDialogMutationVariables,
  TContext
> => {
  return useMutation(getProcessProcessDialogMutationOptions(options));
};

export const processRespondToUser = (processDialogCommand?: ProcessDialogCommand, signal?: AbortSignal) => {
  return customAxiosInstance<AudioResponseDto>({
    url: `/api/Process/RespondToUser`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: processDialogCommand,
    signal
  });
};

export const getProcessRespondToUserMutationKey = () => ['processRespondToUser'] as const;

export const getProcessRespondToUserMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processRespondToUser>>,
    TError,
    ProcessRespondToUserMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof processRespondToUser>>,
  TError,
  ProcessRespondToUserMutationVariables,
  TContext
> => {
  const mutationKey = getProcessRespondToUserMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof processRespondToUser>>,
    ProcessRespondToUserMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return processRespondToUser(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProcessRespondToUserMutationResult = NonNullable<Awaited<ReturnType<typeof processRespondToUser>>>;
export type ProcessRespondToUserMutationBody = ProcessDialogCommand | undefined;
export type ProcessRespondToUserMutationError = unknown;
export type ProcessRespondToUserMutationVariables = { data?: ProcessDialogCommand };

export const useProcessRespondToUser = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processRespondToUser>>,
    TError,
    ProcessRespondToUserMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof processRespondToUser>>,
  TError,
  ProcessRespondToUserMutationVariables,
  TContext
> => {
  return useMutation(getProcessRespondToUserMutationOptions(options));
};

export const processRespondToUserTurn = (respondToUserTurnCommand?: RespondToUserTurnCommand, signal?: AbortSignal) => {
  return customAxiosInstance<RespondToUserTurnDto>({
    url: `/api/Process/RespondToUserTurn`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: respondToUserTurnCommand,
    signal
  });
};

export const getProcessRespondToUserTurnMutationKey = () => ['processRespondToUserTurn'] as const;

export const getProcessRespondToUserTurnMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processRespondToUserTurn>>,
    TError,
    ProcessRespondToUserTurnMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof processRespondToUserTurn>>,
  TError,
  ProcessRespondToUserTurnMutationVariables,
  TContext
> => {
  const mutationKey = getProcessRespondToUserTurnMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof processRespondToUserTurn>>,
    ProcessRespondToUserTurnMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return processRespondToUserTurn(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProcessRespondToUserTurnMutationResult = NonNullable<Awaited<ReturnType<typeof processRespondToUserTurn>>>;
export type ProcessRespondToUserTurnMutationBody = RespondToUserTurnCommand | undefined;
export type ProcessRespondToUserTurnMutationError = unknown;
export type ProcessRespondToUserTurnMutationVariables = { data?: RespondToUserTurnCommand };

export const useProcessRespondToUserTurn = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processRespondToUserTurn>>,
    TError,
    ProcessRespondToUserTurnMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof processRespondToUserTurn>>,
  TError,
  ProcessRespondToUserTurnMutationVariables,
  TContext
> => {
  return useMutation(getProcessRespondToUserTurnMutationOptions(options));
};

export const processScenarioChatTurnStatus = (params?: ProcessScenarioChatTurnStatusParams, signal?: AbortSignal) => {
  return customAxiosInstance<ScenarioChatTurnStatusDto>({
    url: `/api/Process/ScenarioChatTurnStatus`,
    method: 'GET',
    params,
    signal
  });
};

export const getProcessScenarioChatTurnStatusQueryKey = (params?: ProcessScenarioChatTurnStatusParams) => {
  return [`/api/Process/ScenarioChatTurnStatus`, ...(params ? [params] : [])] as const;
};

export const getProcessScenarioChatTurnStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof processScenarioChatTurnStatus>>,
  TError = unknown
>(
  params?: ProcessScenarioChatTurnStatusParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof processScenarioChatTurnStatus>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getProcessScenarioChatTurnStatusQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof processScenarioChatTurnStatus>>> = ({ signal }) =>
    processScenarioChatTurnStatus(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof processScenarioChatTurnStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ProcessScenarioChatTurnStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof processScenarioChatTurnStatus>>
>;
export type ProcessScenarioChatTurnStatusQueryError = unknown;

export function useProcessScenarioChatTurnStatus<
  TData = Awaited<ReturnType<typeof processScenarioChatTurnStatus>>,
  TError = unknown
>(
  params?: ProcessScenarioChatTurnStatusParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof processScenarioChatTurnStatus>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getProcessScenarioChatTurnStatusQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const processTurnAudio = (turnId: string, params?: ProcessTurnAudioParams, signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/Process/TurnAudio/${turnId}`, method: 'GET', params, signal });
};

export const getProcessTurnAudioQueryKey = (turnId: string, params?: ProcessTurnAudioParams) => {
  return [`/api/Process/TurnAudio/${turnId}`, ...(params ? [params] : [])] as const;
};

export const getProcessTurnAudioQueryOptions = <TData = Awaited<ReturnType<typeof processTurnAudio>>, TError = unknown>(
  turnId: string,
  params?: ProcessTurnAudioParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof processTurnAudio>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getProcessTurnAudioQueryKey(turnId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof processTurnAudio>>> = ({ signal }) =>
    processTurnAudio(turnId, params, signal);

  return { queryKey, queryFn, enabled: turnId !== null && turnId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof processTurnAudio>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ProcessTurnAudioQueryResult = NonNullable<Awaited<ReturnType<typeof processTurnAudio>>>;
export type ProcessTurnAudioQueryError = unknown;

export function useProcessTurnAudio<TData = Awaited<ReturnType<typeof processTurnAudio>>, TError = unknown>(
  turnId: string,
  params?: ProcessTurnAudioParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof processTurnAudio>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getProcessTurnAudioQueryOptions(turnId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const processTurnAudioStream = (turnId: string, params?: ProcessTurnAudioStreamParams, signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/Process/TurnAudioStream/${turnId}`, method: 'GET', params, signal });
};

export const getProcessTurnAudioStreamQueryKey = (turnId: string, params?: ProcessTurnAudioStreamParams) => {
  return [`/api/Process/TurnAudioStream/${turnId}`, ...(params ? [params] : [])] as const;
};

export const getProcessTurnAudioStreamQueryOptions = <
  TData = Awaited<ReturnType<typeof processTurnAudioStream>>,
  TError = unknown
>(
  turnId: string,
  params?: ProcessTurnAudioStreamParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof processTurnAudioStream>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getProcessTurnAudioStreamQueryKey(turnId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof processTurnAudioStream>>> = ({ signal }) =>
    processTurnAudioStream(turnId, params, signal);

  return { queryKey, queryFn, enabled: turnId !== null && turnId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof processTurnAudioStream>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ProcessTurnAudioStreamQueryResult = NonNullable<Awaited<ReturnType<typeof processTurnAudioStream>>>;
export type ProcessTurnAudioStreamQueryError = unknown;

export function useProcessTurnAudioStream<TData = Awaited<ReturnType<typeof processTurnAudioStream>>, TError = unknown>(
  turnId: string,
  params?: ProcessTurnAudioStreamParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof processTurnAudioStream>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getProcessTurnAudioStreamQueryOptions(turnId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const processProcessCall = (textToSpeechCommand?: TextToSpeechCommand, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/Process/ProcessCall`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: textToSpeechCommand,
    signal
  });
};

export const getProcessProcessCallMutationKey = () => ['processProcessCall'] as const;

export const getProcessProcessCallMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processProcessCall>>,
    TError,
    ProcessProcessCallMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof processProcessCall>>,
  TError,
  ProcessProcessCallMutationVariables,
  TContext
> => {
  const mutationKey = getProcessProcessCallMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof processProcessCall>>,
    ProcessProcessCallMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return processProcessCall(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProcessProcessCallMutationResult = NonNullable<Awaited<ReturnType<typeof processProcessCall>>>;
export type ProcessProcessCallMutationBody = TextToSpeechCommand | undefined;
export type ProcessProcessCallMutationError = unknown;
export type ProcessProcessCallMutationVariables = { data?: TextToSpeechCommand };

export const useProcessProcessCall = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processProcessCall>>,
    TError,
    ProcessProcessCallMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof processProcessCall>>,
  TError,
  ProcessProcessCallMutationVariables,
  TContext
> => {
  return useMutation(getProcessProcessCallMutationOptions(options));
};

export const processProcessCallStream = (textToSpeechCommand?: TextToSpeechCommand, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/Process/ProcessCallStream`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: textToSpeechCommand,
    signal
  });
};

export const getProcessProcessCallStreamMutationKey = () => ['processProcessCallStream'] as const;

export const getProcessProcessCallStreamMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processProcessCallStream>>,
    TError,
    ProcessProcessCallStreamMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof processProcessCallStream>>,
  TError,
  ProcessProcessCallStreamMutationVariables,
  TContext
> => {
  const mutationKey = getProcessProcessCallStreamMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof processProcessCallStream>>,
    ProcessProcessCallStreamMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return processProcessCallStream(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProcessProcessCallStreamMutationResult = NonNullable<Awaited<ReturnType<typeof processProcessCallStream>>>;
export type ProcessProcessCallStreamMutationBody = TextToSpeechCommand | undefined;
export type ProcessProcessCallStreamMutationError = unknown;
export type ProcessProcessCallStreamMutationVariables = { data?: TextToSpeechCommand };

export const useProcessProcessCallStream = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processProcessCallStream>>,
    TError,
    ProcessProcessCallStreamMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof processProcessCallStream>>,
  TError,
  ProcessProcessCallStreamMutationVariables,
  TContext
> => {
  return useMutation(getProcessProcessCallStreamMutationOptions(options));
};

export const processEndCall = (endCallCommand?: EndCallCommand, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/Process/EndCall`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: endCallCommand,
    signal
  });
};

export const getProcessEndCallMutationKey = () => ['processEndCall'] as const;

export const getProcessEndCallMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processEndCall>>,
    TError,
    ProcessEndCallMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof processEndCall>>,
  TError,
  ProcessEndCallMutationVariables,
  TContext
> => {
  const mutationKey = getProcessEndCallMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof processEndCall>>, ProcessEndCallMutationVariables> = (
    props
  ) => {
    const { data } = props ?? {};

    return processEndCall(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProcessEndCallMutationResult = NonNullable<Awaited<ReturnType<typeof processEndCall>>>;
export type ProcessEndCallMutationBody = EndCallCommand | undefined;
export type ProcessEndCallMutationError = unknown;
export type ProcessEndCallMutationVariables = { data?: EndCallCommand };

export const useProcessEndCall = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processEndCall>>,
    TError,
    ProcessEndCallMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof processEndCall>>,
  TError,
  ProcessEndCallMutationVariables,
  TContext
> => {
  return useMutation(getProcessEndCallMutationOptions(options));
};

export const processStartInboundCall = (
  processStartInboundCallBody?: ProcessStartInboundCallBodyOne | ProcessStartInboundCallBodyTwo,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/Process/StartInboundCall`,
    method: 'POST',
    data: processStartInboundCallBody,
    signal
  });
};

export const getProcessStartInboundCallMutationKey = () => ['processStartInboundCall'] as const;

export const getProcessStartInboundCallMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processStartInboundCall>>,
    TError,
    ProcessStartInboundCallMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof processStartInboundCall>>,
  TError,
  ProcessStartInboundCallMutationVariables,
  TContext
> => {
  const mutationKey = getProcessStartInboundCallMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof processStartInboundCall>>,
    ProcessStartInboundCallMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return processStartInboundCall(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProcessStartInboundCallMutationResult = NonNullable<Awaited<ReturnType<typeof processStartInboundCall>>>;
export type ProcessStartInboundCallMutationBody =
  | ProcessStartInboundCallBodyOne
  | ProcessStartInboundCallBodyTwo
  | undefined;
export type ProcessStartInboundCallMutationError = unknown;
export type ProcessStartInboundCallMutationVariables = {
  data?: ProcessStartInboundCallBodyOne | ProcessStartInboundCallBodyTwo;
};

export const useProcessStartInboundCall = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof processStartInboundCall>>,
    TError,
    ProcessStartInboundCallMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof processStartInboundCall>>,
  TError,
  ProcessStartInboundCallMutationVariables,
  TContext
> => {
  return useMutation(getProcessStartInboundCallMutationOptions(options));
};

export const processCallStatus = (signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/Process/CallStatus`, method: 'POST', signal });
};

export const getProcessCallStatusMutationKey = () => ['processCallStatus'] as const;

export const getProcessCallStatusMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof processCallStatus>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof processCallStatus>>, TError, void, TContext> => {
  const mutationKey = getProcessCallStatusMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof processCallStatus>>, void> = () => {
    return processCallStatus();
  };

  return { mutationFn, ...mutationOptions };
};

export type ProcessCallStatusMutationResult = NonNullable<Awaited<ReturnType<typeof processCallStatus>>>;

export type ProcessCallStatusMutationError = unknown;

export const useProcessCallStatus = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof processCallStatus>>, TError, void, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof processCallStatus>>, TError, void, TContext> => {
  return useMutation(getProcessCallStatusMutationOptions(options));
};

/**
 * @summary The sound's telephony copy: raw 16-bit little-endian PCM, 8 kHz mono, no header, one loop period. Copies
come from upload and the startup backfill; 404 when the sound does not exist or has no copy. The bytes
behind an id never change.
 */
export const processBackgroundSoundsTelephony = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<Blob>({
    url: `/api/Process/background-sounds/${id}/telephony`,
    method: 'GET',
    responseType: 'blob',
    signal
  });
};

export const getProcessBackgroundSoundsTelephonyQueryKey = (id: number) => {
  return [`/api/Process/background-sounds/${id}/telephony`] as const;
};

export const getProcessBackgroundSoundsTelephonyQueryOptions = <
  TData = Awaited<ReturnType<typeof processBackgroundSoundsTelephony>>,
  TError = Blob | ProblemDetails
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof processBackgroundSoundsTelephony>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getProcessBackgroundSoundsTelephonyQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof processBackgroundSoundsTelephony>>> = ({ signal }) =>
    processBackgroundSoundsTelephony(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof processBackgroundSoundsTelephony>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ProcessBackgroundSoundsTelephonyQueryResult = NonNullable<
  Awaited<ReturnType<typeof processBackgroundSoundsTelephony>>
>;
export type ProcessBackgroundSoundsTelephonyQueryError = Blob | ProblemDetails;

/**
 * @summary The sound's telephony copy: raw 16-bit little-endian PCM, 8 kHz mono, no header, one loop period. Copies
come from upload and the startup backfill; 404 when the sound does not exist or has no copy. The bytes
behind an id never change.
 */

export function useProcessBackgroundSoundsTelephony<
  TData = Awaited<ReturnType<typeof processBackgroundSoundsTelephony>>,
  TError = Blob | ProblemDetails
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof processBackgroundSoundsTelephony>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getProcessBackgroundSoundsTelephonyQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Uploads a recording and queues transcription. Criteria ids create the first evaluation run.
 */
export const recordingsUpload = (
  recordingsUploadBody?: RecordingsUploadBodyOne | RecordingsUploadBodyTwo,
  signal?: AbortSignal
) => {
  return customAxiosInstance<RecordingDetailDto>({
    url: `/api/recordings`,
    method: 'POST',
    data: recordingsUploadBody,
    signal
  });
};

export const getRecordingsUploadMutationKey = () => ['recordingsUpload'] as const;

export const getRecordingsUploadMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordingsUpload>>,
    TError,
    RecordingsUploadMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recordingsUpload>>,
  TError,
  RecordingsUploadMutationVariables,
  TContext
> => {
  const mutationKey = getRecordingsUploadMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordingsUpload>>,
    RecordingsUploadMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return recordingsUpload(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecordingsUploadMutationResult = NonNullable<Awaited<ReturnType<typeof recordingsUpload>>>;
export type RecordingsUploadMutationBody = RecordingsUploadBodyOne | RecordingsUploadBodyTwo | undefined;
export type RecordingsUploadMutationError = unknown;
export type RecordingsUploadMutationVariables = { data?: RecordingsUploadBodyOne | RecordingsUploadBodyTwo };

/**
 * @summary Uploads a recording and queues transcription. Criteria ids create the first evaluation run.
 */
export const useRecordingsUpload = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordingsUpload>>,
    TError,
    RecordingsUploadMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof recordingsUpload>>,
  TError,
  RecordingsUploadMutationVariables,
  TContext
> => {
  return useMutation(getRecordingsUploadMutationOptions(options));
};

export const recordingsList = (params?: RecordingsListParams, signal?: AbortSignal) => {
  return customAxiosInstance<PagedResultDtoRecordingListItemDto>({
    url: `/api/recordings`,
    method: 'GET',
    params,
    signal
  });
};

export const getRecordingsListQueryKey = (params?: RecordingsListParams) => {
  return [`/api/recordings`, ...(params ? [params] : [])] as const;
};

export const getRecordingsListQueryOptions = <TData = Awaited<ReturnType<typeof recordingsList>>, TError = unknown>(
  params?: RecordingsListParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof recordingsList>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRecordingsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof recordingsList>>> = ({ signal }) =>
    recordingsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof recordingsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type RecordingsListQueryResult = NonNullable<Awaited<ReturnType<typeof recordingsList>>>;
export type RecordingsListQueryError = unknown;

export function useRecordingsList<TData = Awaited<ReturnType<typeof recordingsList>>, TError = unknown>(
  params?: RecordingsListParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof recordingsList>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getRecordingsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const recordingsGet = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<RecordingDetailDto>({ url: `/api/recordings/${id}`, method: 'GET', signal });
};

export const getRecordingsGetQueryKey = (id: number) => {
  return [`/api/recordings/${id}`] as const;
};

export const getRecordingsGetQueryOptions = <TData = Awaited<ReturnType<typeof recordingsGet>>, TError = unknown>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof recordingsGet>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRecordingsGetQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof recordingsGet>>> = ({ signal }) => recordingsGet(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof recordingsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type RecordingsGetQueryResult = NonNullable<Awaited<ReturnType<typeof recordingsGet>>>;
export type RecordingsGetQueryError = unknown;

export function useRecordingsGet<TData = Awaited<ReturnType<typeof recordingsGet>>, TError = unknown>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof recordingsGet>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getRecordingsGetQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Renames the recording or changes the person who handled the call. Nothing is re-run.
 */
export const recordingsUpdate = (id: number, updateRecordingRequest?: UpdateRecordingRequest, signal?: AbortSignal) => {
  return customAxiosInstance<RecordingDetailDto>({
    url: `/api/recordings/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateRecordingRequest,
    signal
  });
};

export const getRecordingsUpdateMutationKey = () => ['recordingsUpdate'] as const;

export const getRecordingsUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordingsUpdate>>,
    TError,
    RecordingsUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recordingsUpdate>>,
  TError,
  RecordingsUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getRecordingsUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordingsUpdate>>,
    RecordingsUpdateMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return recordingsUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecordingsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof recordingsUpdate>>>;
export type RecordingsUpdateMutationBody = UpdateRecordingRequest | undefined;
export type RecordingsUpdateMutationError = unknown;
export type RecordingsUpdateMutationVariables = { id: number; data?: UpdateRecordingRequest };

/**
 * @summary Renames the recording or changes the person who handled the call. Nothing is re-run.
 */
export const useRecordingsUpdate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordingsUpdate>>,
    TError,
    RecordingsUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof recordingsUpdate>>,
  TError,
  RecordingsUpdateMutationVariables,
  TContext
> => {
  return useMutation(getRecordingsUpdateMutationOptions(options));
};

export const recordingsDelete = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/recordings/${id}`, method: 'DELETE', signal });
};

export const getRecordingsDeleteMutationKey = () => ['recordingsDelete'] as const;

export const getRecordingsDeleteMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordingsDelete>>,
    TError,
    RecordingsDeleteMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recordingsDelete>>,
  TError,
  RecordingsDeleteMutationVariables,
  TContext
> => {
  const mutationKey = getRecordingsDeleteMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordingsDelete>>,
    RecordingsDeleteMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return recordingsDelete(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecordingsDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof recordingsDelete>>>;

export type RecordingsDeleteMutationError = unknown;
export type RecordingsDeleteMutationVariables = { id: number };

export const useRecordingsDelete = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordingsDelete>>,
    TError,
    RecordingsDeleteMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof recordingsDelete>>,
  TError,
  RecordingsDeleteMutationVariables,
  TContext
> => {
  return useMutation(getRecordingsDeleteMutationOptions(options));
};

/**
 * @summary Re-queues transcription for a failed recording whose audio is still stored.
 */
export const recordingsRetryTranscription = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/recordings/${id}/retry`, method: 'POST', signal });
};

export const getRecordingsRetryTranscriptionMutationKey = () => ['recordingsRetryTranscription'] as const;

export const getRecordingsRetryTranscriptionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordingsRetryTranscription>>,
    TError,
    RecordingsRetryTranscriptionMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recordingsRetryTranscription>>,
  TError,
  RecordingsRetryTranscriptionMutationVariables,
  TContext
> => {
  const mutationKey = getRecordingsRetryTranscriptionMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordingsRetryTranscription>>,
    RecordingsRetryTranscriptionMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return recordingsRetryTranscription(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecordingsRetryTranscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof recordingsRetryTranscription>>
>;

export type RecordingsRetryTranscriptionMutationError = unknown;
export type RecordingsRetryTranscriptionMutationVariables = { id: number };

/**
 * @summary Re-queues transcription for a failed recording whose audio is still stored.
 */
export const useRecordingsRetryTranscription = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordingsRetryTranscription>>,
    TError,
    RecordingsRetryTranscriptionMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof recordingsRetryTranscription>>,
  TError,
  RecordingsRetryTranscriptionMutationVariables,
  TContext
> => {
  return useMutation(getRecordingsRetryTranscriptionMutationOptions(options));
};

/**
 * @summary Returns a short-lived link to the stored audio for an audio player. 404 when the audio was not kept.
 */
export const recordingsAudio = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<RecordingAudioLinkDto>({ url: `/api/recordings/${id}/audio`, method: 'GET', signal });
};

export const getRecordingsAudioQueryKey = (id: number) => {
  return [`/api/recordings/${id}/audio`] as const;
};

export const getRecordingsAudioQueryOptions = <
  TData = Awaited<ReturnType<typeof recordingsAudio>>,
  TError = ProblemDetails
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof recordingsAudio>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRecordingsAudioQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof recordingsAudio>>> = ({ signal }) =>
    recordingsAudio(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof recordingsAudio>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type RecordingsAudioQueryResult = NonNullable<Awaited<ReturnType<typeof recordingsAudio>>>;
export type RecordingsAudioQueryError = ProblemDetails;

/**
 * @summary Returns a short-lived link to the stored audio for an audio player. 404 when the audio was not kept.
 */

export function useRecordingsAudio<TData = Awaited<ReturnType<typeof recordingsAudio>>, TError = ProblemDetails>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof recordingsAudio>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getRecordingsAudioQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Plain-text transcript in the same "[mm:ss] Role: text" shape as scenario runs.
 */
export const recordingsTranscript = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<string>({ url: `/api/recordings/${id}/transcript`, method: 'GET', signal });
};

export const getRecordingsTranscriptQueryKey = (id: number) => {
  return [`/api/recordings/${id}/transcript`] as const;
};

export const getRecordingsTranscriptQueryOptions = <
  TData = Awaited<ReturnType<typeof recordingsTranscript>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof recordingsTranscript>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRecordingsTranscriptQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof recordingsTranscript>>> = ({ signal }) =>
    recordingsTranscript(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof recordingsTranscript>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type RecordingsTranscriptQueryResult = NonNullable<Awaited<ReturnType<typeof recordingsTranscript>>>;
export type RecordingsTranscriptQueryError = unknown;

/**
 * @summary Plain-text transcript in the same "[mm:ss] Role: text" shape as scenario runs.
 */

export function useRecordingsTranscript<TData = Awaited<ReturnType<typeof recordingsTranscript>>, TError = unknown>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof recordingsTranscript>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getRecordingsTranscriptQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Starts a new evaluation run. Earlier runs are kept untouched.
 */
export const recordingsCreateEvaluationRun = (
  id: number,
  createRecordingEvaluationRunRequest?: CreateRecordingEvaluationRunRequest,
  signal?: AbortSignal
) => {
  return customAxiosInstance<RecordingEvaluationRunDto>({
    url: `/api/recordings/${id}/evaluation-runs`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createRecordingEvaluationRunRequest,
    signal
  });
};

export const getRecordingsCreateEvaluationRunMutationKey = () => ['recordingsCreateEvaluationRun'] as const;

export const getRecordingsCreateEvaluationRunMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordingsCreateEvaluationRun>>,
    TError,
    RecordingsCreateEvaluationRunMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recordingsCreateEvaluationRun>>,
  TError,
  RecordingsCreateEvaluationRunMutationVariables,
  TContext
> => {
  const mutationKey = getRecordingsCreateEvaluationRunMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordingsCreateEvaluationRun>>,
    RecordingsCreateEvaluationRunMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return recordingsCreateEvaluationRun(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecordingsCreateEvaluationRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof recordingsCreateEvaluationRun>>
>;
export type RecordingsCreateEvaluationRunMutationBody = CreateRecordingEvaluationRunRequest | undefined;
export type RecordingsCreateEvaluationRunMutationError = unknown;
export type RecordingsCreateEvaluationRunMutationVariables = { id: number; data?: CreateRecordingEvaluationRunRequest };

/**
 * @summary Starts a new evaluation run. Earlier runs are kept untouched.
 */
export const useRecordingsCreateEvaluationRun = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordingsCreateEvaluationRun>>,
    TError,
    RecordingsCreateEvaluationRunMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof recordingsCreateEvaluationRun>>,
  TError,
  RecordingsCreateEvaluationRunMutationVariables,
  TContext
> => {
  return useMutation(getRecordingsCreateEvaluationRunMutationOptions(options));
};

export const recordingsRetryEvaluationRun = (id: number, runId: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/recordings/${id}/evaluation-runs/${runId}/retry`,
    method: 'POST',
    signal
  });
};

export const getRecordingsRetryEvaluationRunMutationKey = () => ['recordingsRetryEvaluationRun'] as const;

export const getRecordingsRetryEvaluationRunMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordingsRetryEvaluationRun>>,
    TError,
    RecordingsRetryEvaluationRunMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recordingsRetryEvaluationRun>>,
  TError,
  RecordingsRetryEvaluationRunMutationVariables,
  TContext
> => {
  const mutationKey = getRecordingsRetryEvaluationRunMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordingsRetryEvaluationRun>>,
    RecordingsRetryEvaluationRunMutationVariables
  > = (props) => {
    const { id, runId } = props ?? {};

    return recordingsRetryEvaluationRun(id, runId);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecordingsRetryEvaluationRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof recordingsRetryEvaluationRun>>
>;

export type RecordingsRetryEvaluationRunMutationError = unknown;
export type RecordingsRetryEvaluationRunMutationVariables = { id: number; runId: number };

export const useRecordingsRetryEvaluationRun = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordingsRetryEvaluationRun>>,
    TError,
    RecordingsRetryEvaluationRunMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof recordingsRetryEvaluationRun>>,
  TError,
  RecordingsRetryEvaluationRunMutationVariables,
  TContext
> => {
  return useMutation(getRecordingsRetryEvaluationRunMutationOptions(options));
};

export const recordingsDeleteEvaluationRun = (id: number, runId: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/recordings/${id}/evaluation-runs/${runId}`, method: 'DELETE', signal });
};

export const getRecordingsDeleteEvaluationRunMutationKey = () => ['recordingsDeleteEvaluationRun'] as const;

export const getRecordingsDeleteEvaluationRunMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordingsDeleteEvaluationRun>>,
    TError,
    RecordingsDeleteEvaluationRunMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recordingsDeleteEvaluationRun>>,
  TError,
  RecordingsDeleteEvaluationRunMutationVariables,
  TContext
> => {
  const mutationKey = getRecordingsDeleteEvaluationRunMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordingsDeleteEvaluationRun>>,
    RecordingsDeleteEvaluationRunMutationVariables
  > = (props) => {
    const { id, runId } = props ?? {};

    return recordingsDeleteEvaluationRun(id, runId);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecordingsDeleteEvaluationRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof recordingsDeleteEvaluationRun>>
>;

export type RecordingsDeleteEvaluationRunMutationError = unknown;
export type RecordingsDeleteEvaluationRunMutationVariables = { id: number; runId: number };

export const useRecordingsDeleteEvaluationRun = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordingsDeleteEvaluationRun>>,
    TError,
    RecordingsDeleteEvaluationRunMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof recordingsDeleteEvaluationRun>>,
  TError,
  RecordingsDeleteEvaluationRunMutationVariables,
  TContext
> => {
  return useMutation(getRecordingsDeleteEvaluationRunMutationOptions(options));
};

export const rolesGenerateMagicRolePrompt = (
  generateMagicRolePromptCommand?: GenerateMagicRolePromptCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<string>({
    url: `/api/Roles/GenerateMagicRolePrompt`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: generateMagicRolePromptCommand,
    signal
  });
};

export const getRolesGenerateMagicRolePromptMutationKey = () => ['rolesGenerateMagicRolePrompt'] as const;

export const getRolesGenerateMagicRolePromptMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesGenerateMagicRolePrompt>>,
    TError,
    RolesGenerateMagicRolePromptMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rolesGenerateMagicRolePrompt>>,
  TError,
  RolesGenerateMagicRolePromptMutationVariables,
  TContext
> => {
  const mutationKey = getRolesGenerateMagicRolePromptMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rolesGenerateMagicRolePrompt>>,
    RolesGenerateMagicRolePromptMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return rolesGenerateMagicRolePrompt(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RolesGenerateMagicRolePromptMutationResult = NonNullable<
  Awaited<ReturnType<typeof rolesGenerateMagicRolePrompt>>
>;
export type RolesGenerateMagicRolePromptMutationBody = GenerateMagicRolePromptCommand | undefined;
export type RolesGenerateMagicRolePromptMutationError = unknown;
export type RolesGenerateMagicRolePromptMutationVariables = { data?: GenerateMagicRolePromptCommand };

export const useRolesGenerateMagicRolePrompt = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesGenerateMagicRolePrompt>>,
    TError,
    RolesGenerateMagicRolePromptMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof rolesGenerateMagicRolePrompt>>,
  TError,
  RolesGenerateMagicRolePromptMutationVariables,
  TContext
> => {
  return useMutation(getRolesGenerateMagicRolePromptMutationOptions(options));
};

export const rolesGetRoles = (params?: RolesGetRolesParams, signal?: AbortSignal) => {
  return customAxiosInstance<RoleDto[]>({ url: `/api/Roles`, method: 'GET', params, signal });
};

export const getRolesGetRolesQueryKey = (params?: RolesGetRolesParams) => {
  return [`/api/Roles`, ...(params ? [params] : [])] as const;
};

export const getRolesGetRolesQueryOptions = <TData = Awaited<ReturnType<typeof rolesGetRoles>>, TError = unknown>(
  params?: RolesGetRolesParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof rolesGetRoles>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRolesGetRolesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesGetRoles>>> = ({ signal }) =>
    rolesGetRoles(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof rolesGetRoles>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type RolesGetRolesQueryResult = NonNullable<Awaited<ReturnType<typeof rolesGetRoles>>>;
export type RolesGetRolesQueryError = unknown;

export function useRolesGetRoles<TData = Awaited<ReturnType<typeof rolesGetRoles>>, TError = unknown>(
  params?: RolesGetRolesParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof rolesGetRoles>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getRolesGetRolesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const rolesCreateRole = (createRoleDto?: CreateRoleDto, signal?: AbortSignal) => {
  return customAxiosInstance<RoleDto>({
    url: `/api/Roles`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createRoleDto,
    signal
  });
};

export const getRolesCreateRoleMutationKey = () => ['rolesCreateRole'] as const;

export const getRolesCreateRoleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesCreateRole>>,
    TError,
    RolesCreateRoleMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rolesCreateRole>>,
  TError,
  RolesCreateRoleMutationVariables,
  TContext
> => {
  const mutationKey = getRolesCreateRoleMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof rolesCreateRole>>, RolesCreateRoleMutationVariables> = (
    props
  ) => {
    const { data } = props ?? {};

    return rolesCreateRole(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RolesCreateRoleMutationResult = NonNullable<Awaited<ReturnType<typeof rolesCreateRole>>>;
export type RolesCreateRoleMutationBody = CreateRoleDto | undefined;
export type RolesCreateRoleMutationError = unknown;
export type RolesCreateRoleMutationVariables = { data?: CreateRoleDto };

export const useRolesCreateRole = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesCreateRole>>,
    TError,
    RolesCreateRoleMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof rolesCreateRole>>,
  TError,
  RolesCreateRoleMutationVariables,
  TContext
> => {
  return useMutation(getRolesCreateRoleMutationOptions(options));
};

export const rolesGetRoleCompanies = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<RoleCompanyDto[]>({ url: `/api/Roles/${id}/companies`, method: 'GET', signal });
};

export const getRolesGetRoleCompaniesQueryKey = (id: number) => {
  return [`/api/Roles/${id}/companies`] as const;
};

export const getRolesGetRoleCompaniesQueryOptions = <
  TData = Awaited<ReturnType<typeof rolesGetRoleCompanies>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof rolesGetRoleCompanies>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRolesGetRoleCompaniesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesGetRoleCompanies>>> = ({ signal }) =>
    rolesGetRoleCompanies(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof rolesGetRoleCompanies>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type RolesGetRoleCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof rolesGetRoleCompanies>>>;
export type RolesGetRoleCompaniesQueryError = unknown;

export function useRolesGetRoleCompanies<TData = Awaited<ReturnType<typeof rolesGetRoleCompanies>>, TError = unknown>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof rolesGetRoleCompanies>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getRolesGetRoleCompaniesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const rolesUpdateRole = (id: number, updateRoleDto?: UpdateRoleDto, signal?: AbortSignal) => {
  return customAxiosInstance<RoleDto>({
    url: `/api/Roles/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateRoleDto,
    signal
  });
};

export const getRolesUpdateRoleMutationKey = () => ['rolesUpdateRole'] as const;

export const getRolesUpdateRoleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesUpdateRole>>,
    TError,
    RolesUpdateRoleMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rolesUpdateRole>>,
  TError,
  RolesUpdateRoleMutationVariables,
  TContext
> => {
  const mutationKey = getRolesUpdateRoleMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof rolesUpdateRole>>, RolesUpdateRoleMutationVariables> = (
    props
  ) => {
    const { id, data } = props ?? {};

    return rolesUpdateRole(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RolesUpdateRoleMutationResult = NonNullable<Awaited<ReturnType<typeof rolesUpdateRole>>>;
export type RolesUpdateRoleMutationBody = UpdateRoleDto | undefined;
export type RolesUpdateRoleMutationError = unknown;
export type RolesUpdateRoleMutationVariables = { id: number; data?: UpdateRoleDto };

export const useRolesUpdateRole = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesUpdateRole>>,
    TError,
    RolesUpdateRoleMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof rolesUpdateRole>>,
  TError,
  RolesUpdateRoleMutationVariables,
  TContext
> => {
  return useMutation(getRolesUpdateRoleMutationOptions(options));
};

export const rolesDeleteRole = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/Roles/${id}`, method: 'DELETE', signal });
};

export const getRolesDeleteRoleMutationKey = () => ['rolesDeleteRole'] as const;

export const getRolesDeleteRoleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesDeleteRole>>,
    TError,
    RolesDeleteRoleMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rolesDeleteRole>>,
  TError,
  RolesDeleteRoleMutationVariables,
  TContext
> => {
  const mutationKey = getRolesDeleteRoleMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof rolesDeleteRole>>, RolesDeleteRoleMutationVariables> = (
    props
  ) => {
    const { id } = props ?? {};

    return rolesDeleteRole(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type RolesDeleteRoleMutationResult = NonNullable<Awaited<ReturnType<typeof rolesDeleteRole>>>;

export type RolesDeleteRoleMutationError = unknown;
export type RolesDeleteRoleMutationVariables = { id: number };

export const useRolesDeleteRole = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesDeleteRole>>,
    TError,
    RolesDeleteRoleMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof rolesDeleteRole>>,
  TError,
  RolesDeleteRoleMutationVariables,
  TContext
> => {
  return useMutation(getRolesDeleteRoleMutationOptions(options));
};

export const rolesShareRole = (id: number, shareRoleDto?: ShareRoleDto, signal?: AbortSignal) => {
  return customAxiosInstance<RoleDto>({
    url: `/api/Roles/${id}/share`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: shareRoleDto,
    signal
  });
};

export const getRolesShareRoleMutationKey = () => ['rolesShareRole'] as const;

export const getRolesShareRoleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesShareRole>>,
    TError,
    RolesShareRoleMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rolesShareRole>>,
  TError,
  RolesShareRoleMutationVariables,
  TContext
> => {
  const mutationKey = getRolesShareRoleMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof rolesShareRole>>, RolesShareRoleMutationVariables> = (
    props
  ) => {
    const { id, data } = props ?? {};

    return rolesShareRole(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RolesShareRoleMutationResult = NonNullable<Awaited<ReturnType<typeof rolesShareRole>>>;
export type RolesShareRoleMutationBody = ShareRoleDto | undefined;
export type RolesShareRoleMutationError = unknown;
export type RolesShareRoleMutationVariables = { id: number; data?: ShareRoleDto };

export const useRolesShareRole = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesShareRole>>,
    TError,
    RolesShareRoleMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof rolesShareRole>>,
  TError,
  RolesShareRoleMutationVariables,
  TContext
> => {
  return useMutation(getRolesShareRoleMutationOptions(options));
};

export const rolesUnshareRole = (id: number, unshareRoleDto?: UnshareRoleDto, signal?: AbortSignal) => {
  return customAxiosInstance<RoleDto>({
    url: `/api/Roles/${id}/unshare`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: unshareRoleDto,
    signal
  });
};

export const getRolesUnshareRoleMutationKey = () => ['rolesUnshareRole'] as const;

export const getRolesUnshareRoleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesUnshareRole>>,
    TError,
    RolesUnshareRoleMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rolesUnshareRole>>,
  TError,
  RolesUnshareRoleMutationVariables,
  TContext
> => {
  const mutationKey = getRolesUnshareRoleMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rolesUnshareRole>>,
    RolesUnshareRoleMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return rolesUnshareRole(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RolesUnshareRoleMutationResult = NonNullable<Awaited<ReturnType<typeof rolesUnshareRole>>>;
export type RolesUnshareRoleMutationBody = UnshareRoleDto | undefined;
export type RolesUnshareRoleMutationError = unknown;
export type RolesUnshareRoleMutationVariables = { id: number; data?: UnshareRoleDto };

export const useRolesUnshareRole = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesUnshareRole>>,
    TError,
    RolesUnshareRoleMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof rolesUnshareRole>>,
  TError,
  RolesUnshareRoleMutationVariables,
  TContext
> => {
  return useMutation(getRolesUnshareRoleMutationOptions(options));
};

export const rolesUpdateRoleCompanyAccess = (
  id: number,
  companyId: number,
  accessLevel?: AccessLevel,
  signal?: AbortSignal
) => {
  return customAxiosInstance<RoleCompanyDto>({
    url: `/api/Roles/${id}/companies/${companyId}/access`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: accessLevel,
    signal
  });
};

export const getRolesUpdateRoleCompanyAccessMutationKey = () => ['rolesUpdateRoleCompanyAccess'] as const;

export const getRolesUpdateRoleCompanyAccessMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesUpdateRoleCompanyAccess>>,
    TError,
    RolesUpdateRoleCompanyAccessMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rolesUpdateRoleCompanyAccess>>,
  TError,
  RolesUpdateRoleCompanyAccessMutationVariables,
  TContext
> => {
  const mutationKey = getRolesUpdateRoleCompanyAccessMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rolesUpdateRoleCompanyAccess>>,
    RolesUpdateRoleCompanyAccessMutationVariables
  > = (props) => {
    const { id, companyId, data } = props ?? {};

    return rolesUpdateRoleCompanyAccess(id, companyId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RolesUpdateRoleCompanyAccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof rolesUpdateRoleCompanyAccess>>
>;
export type RolesUpdateRoleCompanyAccessMutationBody = AccessLevel | undefined;
export type RolesUpdateRoleCompanyAccessMutationError = unknown;
export type RolesUpdateRoleCompanyAccessMutationVariables = { id: number; companyId: number; data?: AccessLevel };

export const useRolesUpdateRoleCompanyAccess = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesUpdateRoleCompanyAccess>>,
    TError,
    RolesUpdateRoleCompanyAccessMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof rolesUpdateRoleCompanyAccess>>,
  TError,
  RolesUpdateRoleCompanyAccessMutationVariables,
  TContext
> => {
  return useMutation(getRolesUpdateRoleCompanyAccessMutationOptions(options));
};

export const scenarioGroupGetScenarioGroups = (signal?: AbortSignal) => {
  return customAxiosInstance<ScenarioGroupDto[]>({ url: `/api/Scene/GetScenarioGroups/groups`, method: 'GET', signal });
};

export const getScenarioGroupGetScenarioGroupsQueryKey = () => {
  return [`/api/Scene/GetScenarioGroups/groups`] as const;
};

export const getScenarioGroupGetScenarioGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof scenarioGroupGetScenarioGroups>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof scenarioGroupGetScenarioGroups>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScenarioGroupGetScenarioGroupsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenarioGroupGetScenarioGroups>>> = ({ signal }) =>
    scenarioGroupGetScenarioGroups(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof scenarioGroupGetScenarioGroups>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ScenarioGroupGetScenarioGroupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof scenarioGroupGetScenarioGroups>>
>;
export type ScenarioGroupGetScenarioGroupsQueryError = unknown;

export function useScenarioGroupGetScenarioGroups<
  TData = Awaited<ReturnType<typeof scenarioGroupGetScenarioGroups>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof scenarioGroupGetScenarioGroups>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenarioGroupGetScenarioGroupsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const scenarioGroupCreateGroup = (
  scenarioGroupCreateGroupBody?: string,
  params?: ScenarioGroupCreateGroupParams,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScenarioGroupDto>({
    url: `/api/Scene/CreateGroup/groups`,
    method: 'PUT',
    headers: { 'Content-Type': 'text/plain' },
    data: scenarioGroupCreateGroupBody,
    params,
    signal
  });
};

export const getScenarioGroupCreateGroupMutationKey = () => ['scenarioGroupCreateGroup'] as const;

export const getScenarioGroupCreateGroupMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenarioGroupCreateGroup>>,
    TError,
    ScenarioGroupCreateGroupMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenarioGroupCreateGroup>>,
  TError,
  ScenarioGroupCreateGroupMutationVariables,
  TContext
> => {
  const mutationKey = getScenarioGroupCreateGroupMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenarioGroupCreateGroup>>,
    ScenarioGroupCreateGroupMutationVariables
  > = (props) => {
    const { data, params } = props ?? {};

    return scenarioGroupCreateGroup(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenarioGroupCreateGroupMutationResult = NonNullable<Awaited<ReturnType<typeof scenarioGroupCreateGroup>>>;
export type ScenarioGroupCreateGroupMutationBody = string | undefined;
export type ScenarioGroupCreateGroupMutationError = unknown;
export type ScenarioGroupCreateGroupMutationVariables = { data?: string; params?: ScenarioGroupCreateGroupParams };

export const useScenarioGroupCreateGroup = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenarioGroupCreateGroup>>,
    TError,
    ScenarioGroupCreateGroupMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenarioGroupCreateGroup>>,
  TError,
  ScenarioGroupCreateGroupMutationVariables,
  TContext
> => {
  return useMutation(getScenarioGroupCreateGroupMutationOptions(options));
};

export const scenarioGroupAddScenarioToGroup = (
  groupId: number,
  params?: ScenarioGroupAddScenarioToGroupParams,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScenarioGroupDto>({
    url: `/api/Scene/AddScenarioToGroup/groups/${groupId}`,
    method: 'POST',
    params,
    signal
  });
};

export const getScenarioGroupAddScenarioToGroupMutationKey = () => ['scenarioGroupAddScenarioToGroup'] as const;

export const getScenarioGroupAddScenarioToGroupMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenarioGroupAddScenarioToGroup>>,
    TError,
    ScenarioGroupAddScenarioToGroupMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenarioGroupAddScenarioToGroup>>,
  TError,
  ScenarioGroupAddScenarioToGroupMutationVariables,
  TContext
> => {
  const mutationKey = getScenarioGroupAddScenarioToGroupMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenarioGroupAddScenarioToGroup>>,
    ScenarioGroupAddScenarioToGroupMutationVariables
  > = (props) => {
    const { groupId, params } = props ?? {};

    return scenarioGroupAddScenarioToGroup(groupId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenarioGroupAddScenarioToGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenarioGroupAddScenarioToGroup>>
>;

export type ScenarioGroupAddScenarioToGroupMutationError = unknown;
export type ScenarioGroupAddScenarioToGroupMutationVariables = {
  groupId: number;
  params?: ScenarioGroupAddScenarioToGroupParams;
};

export const useScenarioGroupAddScenarioToGroup = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenarioGroupAddScenarioToGroup>>,
    TError,
    ScenarioGroupAddScenarioToGroupMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenarioGroupAddScenarioToGroup>>,
  TError,
  ScenarioGroupAddScenarioToGroupMutationVariables,
  TContext
> => {
  return useMutation(getScenarioGroupAddScenarioToGroupMutationOptions(options));
};

export const scenarioGroupDeleteGroup = (groupId: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/Scene/DeleteGroup/groups/${groupId}`, method: 'DELETE', signal });
};

export const getScenarioGroupDeleteGroupMutationKey = () => ['scenarioGroupDeleteGroup'] as const;

export const getScenarioGroupDeleteGroupMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenarioGroupDeleteGroup>>,
    TError,
    ScenarioGroupDeleteGroupMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenarioGroupDeleteGroup>>,
  TError,
  ScenarioGroupDeleteGroupMutationVariables,
  TContext
> => {
  const mutationKey = getScenarioGroupDeleteGroupMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenarioGroupDeleteGroup>>,
    ScenarioGroupDeleteGroupMutationVariables
  > = (props) => {
    const { groupId } = props ?? {};

    return scenarioGroupDeleteGroup(groupId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenarioGroupDeleteGroupMutationResult = NonNullable<Awaited<ReturnType<typeof scenarioGroupDeleteGroup>>>;

export type ScenarioGroupDeleteGroupMutationError = unknown;
export type ScenarioGroupDeleteGroupMutationVariables = { groupId: number };

export const useScenarioGroupDeleteGroup = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenarioGroupDeleteGroup>>,
    TError,
    ScenarioGroupDeleteGroupMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenarioGroupDeleteGroup>>,
  TError,
  ScenarioGroupDeleteGroupMutationVariables,
  TContext
> => {
  return useMutation(getScenarioGroupDeleteGroupMutationOptions(options));
};

export const scenarioGroupUpdateGroup = (
  groupId: number,
  updateScenarioGroupCommand?: UpdateScenarioGroupCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScenarioGroupDto>({
    url: `/api/Scene/UpdateGroup/groups/${groupId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateScenarioGroupCommand,
    signal
  });
};

export const getScenarioGroupUpdateGroupMutationKey = () => ['scenarioGroupUpdateGroup'] as const;

export const getScenarioGroupUpdateGroupMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenarioGroupUpdateGroup>>,
    TError,
    ScenarioGroupUpdateGroupMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenarioGroupUpdateGroup>>,
  TError,
  ScenarioGroupUpdateGroupMutationVariables,
  TContext
> => {
  const mutationKey = getScenarioGroupUpdateGroupMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenarioGroupUpdateGroup>>,
    ScenarioGroupUpdateGroupMutationVariables
  > = (props) => {
    const { groupId, data } = props ?? {};

    return scenarioGroupUpdateGroup(groupId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenarioGroupUpdateGroupMutationResult = NonNullable<Awaited<ReturnType<typeof scenarioGroupUpdateGroup>>>;
export type ScenarioGroupUpdateGroupMutationBody = UpdateScenarioGroupCommand | undefined;
export type ScenarioGroupUpdateGroupMutationError = unknown;
export type ScenarioGroupUpdateGroupMutationVariables = { groupId: number; data?: UpdateScenarioGroupCommand };

export const useScenarioGroupUpdateGroup = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenarioGroupUpdateGroup>>,
    TError,
    ScenarioGroupUpdateGroupMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenarioGroupUpdateGroup>>,
  TError,
  ScenarioGroupUpdateGroupMutationVariables,
  TContext
> => {
  return useMutation(getScenarioGroupUpdateGroupMutationOptions(options));
};

export const scenarioGroupRemoveScenesFromGroup = (
  groupId: number,
  params?: ScenarioGroupRemoveScenesFromGroupParams,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScenarioGroupDto>({
    url: `/api/Scene/RemoveScenesFromGroup/groups/${groupId}/scenes`,
    method: 'DELETE',
    params,
    signal
  });
};

export const getScenarioGroupRemoveScenesFromGroupMutationKey = () => ['scenarioGroupRemoveScenesFromGroup'] as const;

export const getScenarioGroupRemoveScenesFromGroupMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenarioGroupRemoveScenesFromGroup>>,
    TError,
    ScenarioGroupRemoveScenesFromGroupMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenarioGroupRemoveScenesFromGroup>>,
  TError,
  ScenarioGroupRemoveScenesFromGroupMutationVariables,
  TContext
> => {
  const mutationKey = getScenarioGroupRemoveScenesFromGroupMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenarioGroupRemoveScenesFromGroup>>,
    ScenarioGroupRemoveScenesFromGroupMutationVariables
  > = (props) => {
    const { groupId, params } = props ?? {};

    return scenarioGroupRemoveScenesFromGroup(groupId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenarioGroupRemoveScenesFromGroupMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenarioGroupRemoveScenesFromGroup>>
>;

export type ScenarioGroupRemoveScenesFromGroupMutationError = unknown;
export type ScenarioGroupRemoveScenesFromGroupMutationVariables = {
  groupId: number;
  params?: ScenarioGroupRemoveScenesFromGroupParams;
};

export const useScenarioGroupRemoveScenesFromGroup = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenarioGroupRemoveScenesFromGroup>>,
    TError,
    ScenarioGroupRemoveScenesFromGroupMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenarioGroupRemoveScenesFromGroup>>,
  TError,
  ScenarioGroupRemoveScenesFromGroupMutationVariables,
  TContext
> => {
  return useMutation(getScenarioGroupRemoveScenesFromGroupMutationOptions(options));
};

/**
 * @summary The health of every scenario. Cached for 10 minutes; `refresh` runs the checks again.
 */
export const scenarioHealthGetReport = (params?: ScenarioHealthGetReportParams, signal?: AbortSignal) => {
  return customAxiosInstance<ScenarioHealthReportDto>({ url: `/api/scenario-health`, method: 'GET', params, signal });
};

export const getScenarioHealthGetReportQueryKey = (params?: ScenarioHealthGetReportParams) => {
  return [`/api/scenario-health`, ...(params ? [params] : [])] as const;
};

export const getScenarioHealthGetReportQueryOptions = <
  TData = Awaited<ReturnType<typeof scenarioHealthGetReport>>,
  TError = unknown
>(
  params?: ScenarioHealthGetReportParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenarioHealthGetReport>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScenarioHealthGetReportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenarioHealthGetReport>>> = ({ signal }) =>
    scenarioHealthGetReport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof scenarioHealthGetReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ScenarioHealthGetReportQueryResult = NonNullable<Awaited<ReturnType<typeof scenarioHealthGetReport>>>;
export type ScenarioHealthGetReportQueryError = unknown;

/**
 * @summary The health of every scenario. Cached for 10 minutes; `refresh` runs the checks again.
 */

export function useScenarioHealthGetReport<
  TData = Awaited<ReturnType<typeof scenarioHealthGetReport>>,
  TError = unknown
>(
  params?: ScenarioHealthGetReportParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenarioHealthGetReport>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenarioHealthGetReportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const scenariosGetScenariosRouteHint = (signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/Scenarios`, method: 'GET', signal });
};

export const getScenariosGetScenariosRouteHintQueryKey = () => {
  return [`/api/Scenarios`] as const;
};

export const getScenariosGetScenariosRouteHintQueryOptions = <
  TData = Awaited<ReturnType<typeof scenariosGetScenariosRouteHint>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetScenariosRouteHint>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScenariosGetScenariosRouteHintQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenariosGetScenariosRouteHint>>> = ({ signal }) =>
    scenariosGetScenariosRouteHint(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof scenariosGetScenariosRouteHint>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ScenariosGetScenariosRouteHintQueryResult = NonNullable<
  Awaited<ReturnType<typeof scenariosGetScenariosRouteHint>>
>;
export type ScenariosGetScenariosRouteHintQueryError = unknown;

export function useScenariosGetScenariosRouteHint<
  TData = Awaited<ReturnType<typeof scenariosGetScenariosRouteHint>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetScenariosRouteHint>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenariosGetScenariosRouteHintQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const scenariosFilterScenarios = (signal?: AbortSignal) => {
  return customAxiosInstance<SimpleScenarioDto[]>({ url: `/api/Scenarios/FilterScenarios`, method: 'GET', signal });
};

export const getScenariosFilterScenariosQueryKey = () => {
  return [`/api/Scenarios/FilterScenarios`] as const;
};

export const getScenariosFilterScenariosQueryOptions = <
  TData = Awaited<ReturnType<typeof scenariosFilterScenarios>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosFilterScenarios>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScenariosFilterScenariosQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenariosFilterScenarios>>> = ({ signal }) =>
    scenariosFilterScenarios(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof scenariosFilterScenarios>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ScenariosFilterScenariosQueryResult = NonNullable<Awaited<ReturnType<typeof scenariosFilterScenarios>>>;
export type ScenariosFilterScenariosQueryError = unknown;

export function useScenariosFilterScenarios<
  TData = Awaited<ReturnType<typeof scenariosFilterScenarios>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosFilterScenarios>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenariosFilterScenariosQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Searches scenarios accessible to the current user and returns a compact paged result.
 */
export const scenariosSearchScenarios = (params?: ScenariosSearchScenariosParams, signal?: AbortSignal) => {
  return customAxiosInstance<PagedResultDtoScenarioSearchItemDto>({
    url: `/api/Scenarios/Search`,
    method: 'GET',
    params,
    signal
  });
};

export const getScenariosSearchScenariosQueryKey = (params?: ScenariosSearchScenariosParams) => {
  return [`/api/Scenarios/Search`, ...(params ? [params] : [])] as const;
};

export const getScenariosSearchScenariosQueryOptions = <
  TData = Awaited<ReturnType<typeof scenariosSearchScenarios>>,
  TError = void
>(
  params?: ScenariosSearchScenariosParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosSearchScenarios>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScenariosSearchScenariosQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenariosSearchScenarios>>> = ({ signal }) =>
    scenariosSearchScenarios(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof scenariosSearchScenarios>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ScenariosSearchScenariosQueryResult = NonNullable<Awaited<ReturnType<typeof scenariosSearchScenarios>>>;
export type ScenariosSearchScenariosQueryError = void;

/**
 * @summary Searches scenarios accessible to the current user and returns a compact paged result.
 */

export function useScenariosSearchScenarios<
  TData = Awaited<ReturnType<typeof scenariosSearchScenarios>>,
  TError = void
>(
  params?: ScenariosSearchScenariosParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosSearchScenarios>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenariosSearchScenariosQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const scenariosAddScenario = (addScenarioCommand?: NonReadonly<AddScenarioCommand>, signal?: AbortSignal) => {
  return customAxiosInstance<ScenarioDto>({
    url: `/api/Scenarios/AddScenario`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: addScenarioCommand,
    signal
  });
};

export const getScenariosAddScenarioMutationKey = () => ['scenariosAddScenario'] as const;

export const getScenariosAddScenarioMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosAddScenario>>,
    TError,
    ScenariosAddScenarioMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosAddScenario>>,
  TError,
  ScenariosAddScenarioMutationVariables,
  TContext
> => {
  const mutationKey = getScenariosAddScenarioMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenariosAddScenario>>,
    ScenariosAddScenarioMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return scenariosAddScenario(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosAddScenarioMutationResult = NonNullable<Awaited<ReturnType<typeof scenariosAddScenario>>>;
export type ScenariosAddScenarioMutationBody = NonReadonly<AddScenarioCommand> | undefined;
export type ScenariosAddScenarioMutationError = unknown;
export type ScenariosAddScenarioMutationVariables = { data?: NonReadonly<AddScenarioCommand> };

export const useScenariosAddScenario = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosAddScenario>>,
    TError,
    ScenariosAddScenarioMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosAddScenario>>,
  TError,
  ScenariosAddScenarioMutationVariables,
  TContext
> => {
  return useMutation(getScenariosAddScenarioMutationOptions(options));
};

export const scenariosEditScenarioContent = (
  updateScenarioContentCommand?: UpdateScenarioContentCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScenarioDto>({
    url: `/api/Scenarios/EditScenarioContent/editContent`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateScenarioContentCommand,
    signal
  });
};

export const getScenariosEditScenarioContentMutationKey = () => ['scenariosEditScenarioContent'] as const;

export const getScenariosEditScenarioContentMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosEditScenarioContent>>,
    TError,
    ScenariosEditScenarioContentMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosEditScenarioContent>>,
  TError,
  ScenariosEditScenarioContentMutationVariables,
  TContext
> => {
  const mutationKey = getScenariosEditScenarioContentMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenariosEditScenarioContent>>,
    ScenariosEditScenarioContentMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return scenariosEditScenarioContent(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosEditScenarioContentMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenariosEditScenarioContent>>
>;
export type ScenariosEditScenarioContentMutationBody = UpdateScenarioContentCommand | undefined;
export type ScenariosEditScenarioContentMutationError = unknown;
export type ScenariosEditScenarioContentMutationVariables = { data?: UpdateScenarioContentCommand };

export const useScenariosEditScenarioContent = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosEditScenarioContent>>,
    TError,
    ScenariosEditScenarioContentMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosEditScenarioContent>>,
  TError,
  ScenariosEditScenarioContentMutationVariables,
  TContext
> => {
  return useMutation(getScenariosEditScenarioContentMutationOptions(options));
};

export const scenariosEditScenarioInfo = (
  updateScenarioSettingsCommand?: UpdateScenarioSettingsCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScenarioDto>({
    url: `/api/Scenarios/EditScenarioInfo/info`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateScenarioSettingsCommand,
    signal
  });
};

export const getScenariosEditScenarioInfoMutationKey = () => ['scenariosEditScenarioInfo'] as const;

export const getScenariosEditScenarioInfoMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosEditScenarioInfo>>,
    TError,
    ScenariosEditScenarioInfoMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosEditScenarioInfo>>,
  TError,
  ScenariosEditScenarioInfoMutationVariables,
  TContext
> => {
  const mutationKey = getScenariosEditScenarioInfoMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenariosEditScenarioInfo>>,
    ScenariosEditScenarioInfoMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return scenariosEditScenarioInfo(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosEditScenarioInfoMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenariosEditScenarioInfo>>
>;
export type ScenariosEditScenarioInfoMutationBody = UpdateScenarioSettingsCommand | undefined;
export type ScenariosEditScenarioInfoMutationError = unknown;
export type ScenariosEditScenarioInfoMutationVariables = { data?: UpdateScenarioSettingsCommand };

export const useScenariosEditScenarioInfo = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosEditScenarioInfo>>,
    TError,
    ScenariosEditScenarioInfoMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosEditScenarioInfo>>,
  TError,
  ScenariosEditScenarioInfoMutationVariables,
  TContext
> => {
  return useMutation(getScenariosEditScenarioInfoMutationOptions(options));
};

export const scenariosRestoreScenarioVersion = (
  restoreScenarioVersionCommand?: RestoreScenarioVersionCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScenarioDto>({
    url: `/api/Scenarios/RestoreScenarioVersion/restoreScenario`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: restoreScenarioVersionCommand,
    signal
  });
};

export const getScenariosRestoreScenarioVersionMutationKey = () => ['scenariosRestoreScenarioVersion'] as const;

export const getScenariosRestoreScenarioVersionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosRestoreScenarioVersion>>,
    TError,
    ScenariosRestoreScenarioVersionMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosRestoreScenarioVersion>>,
  TError,
  ScenariosRestoreScenarioVersionMutationVariables,
  TContext
> => {
  const mutationKey = getScenariosRestoreScenarioVersionMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenariosRestoreScenarioVersion>>,
    ScenariosRestoreScenarioVersionMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return scenariosRestoreScenarioVersion(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosRestoreScenarioVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenariosRestoreScenarioVersion>>
>;
export type ScenariosRestoreScenarioVersionMutationBody = RestoreScenarioVersionCommand | undefined;
export type ScenariosRestoreScenarioVersionMutationError = unknown;
export type ScenariosRestoreScenarioVersionMutationVariables = { data?: RestoreScenarioVersionCommand };

export const useScenariosRestoreScenarioVersion = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosRestoreScenarioVersion>>,
    TError,
    ScenariosRestoreScenarioVersionMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosRestoreScenarioVersion>>,
  TError,
  ScenariosRestoreScenarioVersionMutationVariables,
  TContext
> => {
  return useMutation(getScenariosRestoreScenarioVersionMutationOptions(options));
};

export const scenariosRemoveScenario = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/Scenarios/RemoveScenario/${id}`, method: 'DELETE', signal });
};

export const getScenariosRemoveScenarioMutationKey = () => ['scenariosRemoveScenario'] as const;

export const getScenariosRemoveScenarioMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosRemoveScenario>>,
    TError,
    ScenariosRemoveScenarioMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosRemoveScenario>>,
  TError,
  ScenariosRemoveScenarioMutationVariables,
  TContext
> => {
  const mutationKey = getScenariosRemoveScenarioMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenariosRemoveScenario>>,
    ScenariosRemoveScenarioMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return scenariosRemoveScenario(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosRemoveScenarioMutationResult = NonNullable<Awaited<ReturnType<typeof scenariosRemoveScenario>>>;

export type ScenariosRemoveScenarioMutationError = unknown;
export type ScenariosRemoveScenarioMutationVariables = { id: number };

export const useScenariosRemoveScenario = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosRemoveScenario>>,
    TError,
    ScenariosRemoveScenarioMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosRemoveScenario>>,
  TError,
  ScenariosRemoveScenarioMutationVariables,
  TContext
> => {
  return useMutation(getScenariosRemoveScenarioMutationOptions(options));
};

export const scenariosGetScenario = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<ScenarioDto>({ url: `/api/Scenarios/GetScenario/${id}`, method: 'GET', signal });
};

export const getScenariosGetScenarioQueryKey = (id: number) => {
  return [`/api/Scenarios/GetScenario/${id}`] as const;
};

export const getScenariosGetScenarioQueryOptions = <
  TData = Awaited<ReturnType<typeof scenariosGetScenario>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetScenario>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScenariosGetScenarioQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenariosGetScenario>>> = ({ signal }) =>
    scenariosGetScenario(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof scenariosGetScenario>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ScenariosGetScenarioQueryResult = NonNullable<Awaited<ReturnType<typeof scenariosGetScenario>>>;
export type ScenariosGetScenarioQueryError = unknown;

export function useScenariosGetScenario<TData = Awaited<ReturnType<typeof scenariosGetScenario>>, TError = unknown>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetScenario>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenariosGetScenarioQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const scenariosGetMissingPersonaCompanyAccess = (
  scenarioId: number,
  personaId: number,
  signal?: AbortSignal
) => {
  return customAxiosInstance<PersonaCompanyAccessInfoDto>({
    url: `/api/Scenarios/GetMissingPersonaCompanyAccess/${scenarioId}/personas/${personaId}/missing-companies`,
    method: 'GET',
    signal
  });
};

export const getScenariosGetMissingPersonaCompanyAccessQueryKey = (scenarioId: number, personaId: number) => {
  return [
    `/api/Scenarios/GetMissingPersonaCompanyAccess/${scenarioId}/personas/${personaId}/missing-companies`
  ] as const;
};

export const getScenariosGetMissingPersonaCompanyAccessQueryOptions = <
  TData = Awaited<ReturnType<typeof scenariosGetMissingPersonaCompanyAccess>>,
  TError = unknown
>(
  scenarioId: number,
  personaId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetMissingPersonaCompanyAccess>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScenariosGetMissingPersonaCompanyAccessQueryKey(scenarioId, personaId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenariosGetMissingPersonaCompanyAccess>>> = ({ signal }) =>
    scenariosGetMissingPersonaCompanyAccess(scenarioId, personaId, signal);

  return {
    queryKey,
    queryFn,
    enabled: scenarioId !== null && scenarioId !== undefined && personaId !== null && personaId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof scenariosGetMissingPersonaCompanyAccess>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ScenariosGetMissingPersonaCompanyAccessQueryResult = NonNullable<
  Awaited<ReturnType<typeof scenariosGetMissingPersonaCompanyAccess>>
>;
export type ScenariosGetMissingPersonaCompanyAccessQueryError = unknown;

export function useScenariosGetMissingPersonaCompanyAccess<
  TData = Awaited<ReturnType<typeof scenariosGetMissingPersonaCompanyAccess>>,
  TError = unknown
>(
  scenarioId: number,
  personaId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetMissingPersonaCompanyAccess>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenariosGetMissingPersonaCompanyAccessQueryOptions(scenarioId, personaId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const scenariosGetScenarioVersion = (scenarioId: number, versionId: number, signal?: AbortSignal) => {
  return customAxiosInstance<ScenarioDto>({
    url: `/api/Scenarios/GetScenarioVersion/${scenarioId}/${versionId}`,
    method: 'GET',
    signal
  });
};

export const getScenariosGetScenarioVersionQueryKey = (scenarioId: number, versionId: number) => {
  return [`/api/Scenarios/GetScenarioVersion/${scenarioId}/${versionId}`] as const;
};

export const getScenariosGetScenarioVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof scenariosGetScenarioVersion>>,
  TError = unknown
>(
  scenarioId: number,
  versionId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetScenarioVersion>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScenariosGetScenarioVersionQueryKey(scenarioId, versionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenariosGetScenarioVersion>>> = ({ signal }) =>
    scenariosGetScenarioVersion(scenarioId, versionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: scenarioId !== null && scenarioId !== undefined && versionId !== null && versionId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof scenariosGetScenarioVersion>>, TError, TData> & { queryKey: QueryKey };
};

export type ScenariosGetScenarioVersionQueryResult = NonNullable<
  Awaited<ReturnType<typeof scenariosGetScenarioVersion>>
>;
export type ScenariosGetScenarioVersionQueryError = unknown;

export function useScenariosGetScenarioVersion<
  TData = Awaited<ReturnType<typeof scenariosGetScenarioVersion>>,
  TError = unknown
>(
  scenarioId: number,
  versionId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetScenarioVersion>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenariosGetScenarioVersionQueryOptions(scenarioId, versionId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const scenariosGetDialogStatisticScenarioVersion = (
  scenarioId: number,
  versionId: number,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScenarioDialogStatisticDto>({
    url: `/api/Scenarios/GetDialogStatisticScenarioVersion/${scenarioId}/${versionId}/dialogStatistic`,
    method: 'GET',
    signal
  });
};

export const getScenariosGetDialogStatisticScenarioVersionQueryKey = (scenarioId: number, versionId: number) => {
  return [`/api/Scenarios/GetDialogStatisticScenarioVersion/${scenarioId}/${versionId}/dialogStatistic`] as const;
};

export const getScenariosGetDialogStatisticScenarioVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof scenariosGetDialogStatisticScenarioVersion>>,
  TError = unknown
>(
  scenarioId: number,
  versionId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetDialogStatisticScenarioVersion>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getScenariosGetDialogStatisticScenarioVersionQueryKey(scenarioId, versionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenariosGetDialogStatisticScenarioVersion>>> = ({ signal }) =>
    scenariosGetDialogStatisticScenarioVersion(scenarioId, versionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: scenarioId !== null && scenarioId !== undefined && versionId !== null && versionId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof scenariosGetDialogStatisticScenarioVersion>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ScenariosGetDialogStatisticScenarioVersionQueryResult = NonNullable<
  Awaited<ReturnType<typeof scenariosGetDialogStatisticScenarioVersion>>
>;
export type ScenariosGetDialogStatisticScenarioVersionQueryError = unknown;

export function useScenariosGetDialogStatisticScenarioVersion<
  TData = Awaited<ReturnType<typeof scenariosGetDialogStatisticScenarioVersion>>,
  TError = unknown
>(
  scenarioId: number,
  versionId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetDialogStatisticScenarioVersion>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenariosGetDialogStatisticScenarioVersionQueryOptions(scenarioId, versionId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const scenariosGetScenarioUpdates = (scenarioId: number, signal?: AbortSignal) => {
  return customAxiosInstance<ScenarioUpdateDto[]>({
    url: `/api/Scenarios/GetScenarioUpdates/updates/${scenarioId}`,
    method: 'GET',
    signal
  });
};

export const getScenariosGetScenarioUpdatesQueryKey = (scenarioId: number) => {
  return [`/api/Scenarios/GetScenarioUpdates/updates/${scenarioId}`] as const;
};

export const getScenariosGetScenarioUpdatesQueryOptions = <
  TData = Awaited<ReturnType<typeof scenariosGetScenarioUpdates>>,
  TError = unknown
>(
  scenarioId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetScenarioUpdates>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScenariosGetScenarioUpdatesQueryKey(scenarioId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenariosGetScenarioUpdates>>> = ({ signal }) =>
    scenariosGetScenarioUpdates(scenarioId, signal);

  return {
    queryKey,
    queryFn,
    enabled: scenarioId !== null && scenarioId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof scenariosGetScenarioUpdates>>, TError, TData> & { queryKey: QueryKey };
};

export type ScenariosGetScenarioUpdatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof scenariosGetScenarioUpdates>>
>;
export type ScenariosGetScenarioUpdatesQueryError = unknown;

export function useScenariosGetScenarioUpdates<
  TData = Awaited<ReturnType<typeof scenariosGetScenarioUpdates>>,
  TError = unknown
>(
  scenarioId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetScenarioUpdates>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenariosGetScenarioUpdatesQueryOptions(scenarioId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const scenariosGetLatestVersionForDeletedScenario = (scenarioId: number, signal?: AbortSignal) => {
  return customAxiosInstance<number>({
    url: `/api/Scenarios/GetLatestVersionForDeletedScenario/deleted/${scenarioId}/latestVersion`,
    method: 'GET',
    signal
  });
};

export const getScenariosGetLatestVersionForDeletedScenarioQueryKey = (scenarioId: number) => {
  return [`/api/Scenarios/GetLatestVersionForDeletedScenario/deleted/${scenarioId}/latestVersion`] as const;
};

export const getScenariosGetLatestVersionForDeletedScenarioQueryOptions = <
  TData = Awaited<ReturnType<typeof scenariosGetLatestVersionForDeletedScenario>>,
  TError = ProblemDetails
>(
  scenarioId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetLatestVersionForDeletedScenario>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScenariosGetLatestVersionForDeletedScenarioQueryKey(scenarioId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenariosGetLatestVersionForDeletedScenario>>> = ({
    signal
  }) => scenariosGetLatestVersionForDeletedScenario(scenarioId, signal);

  return {
    queryKey,
    queryFn,
    enabled: scenarioId !== null && scenarioId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof scenariosGetLatestVersionForDeletedScenario>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ScenariosGetLatestVersionForDeletedScenarioQueryResult = NonNullable<
  Awaited<ReturnType<typeof scenariosGetLatestVersionForDeletedScenario>>
>;
export type ScenariosGetLatestVersionForDeletedScenarioQueryError = ProblemDetails;

export function useScenariosGetLatestVersionForDeletedScenario<
  TData = Awaited<ReturnType<typeof scenariosGetLatestVersionForDeletedScenario>>,
  TError = ProblemDetails
>(
  scenarioId: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetLatestVersionForDeletedScenario>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenariosGetLatestVersionForDeletedScenarioQueryOptions(scenarioId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const scenariosCopyScenario = (copyScenarioCommand?: CopyScenarioCommand, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/Scenarios/CopyScenario/copy`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: copyScenarioCommand,
    signal
  });
};

export const getScenariosCopyScenarioMutationKey = () => ['scenariosCopyScenario'] as const;

export const getScenariosCopyScenarioMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosCopyScenario>>,
    TError,
    ScenariosCopyScenarioMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosCopyScenario>>,
  TError,
  ScenariosCopyScenarioMutationVariables,
  TContext
> => {
  const mutationKey = getScenariosCopyScenarioMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenariosCopyScenario>>,
    ScenariosCopyScenarioMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return scenariosCopyScenario(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosCopyScenarioMutationResult = NonNullable<Awaited<ReturnType<typeof scenariosCopyScenario>>>;
export type ScenariosCopyScenarioMutationBody = CopyScenarioCommand | undefined;
export type ScenariosCopyScenarioMutationError = unknown;
export type ScenariosCopyScenarioMutationVariables = { data?: CopyScenarioCommand };

export const useScenariosCopyScenario = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosCopyScenario>>,
    TError,
    ScenariosCopyScenarioMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosCopyScenario>>,
  TError,
  ScenariosCopyScenarioMutationVariables,
  TContext
> => {
  return useMutation(getScenariosCopyScenarioMutationOptions(options));
};

export const scenariosConvertScenarioToSharedScenario = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/Scenarios/ConvertScenarioToSharedScenario/${id}/convertToShared`,
    method: 'POST',
    signal
  });
};

export const getScenariosConvertScenarioToSharedScenarioMutationKey = () =>
  ['scenariosConvertScenarioToSharedScenario'] as const;

export const getScenariosConvertScenarioToSharedScenarioMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosConvertScenarioToSharedScenario>>,
    TError,
    ScenariosConvertScenarioToSharedScenarioMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosConvertScenarioToSharedScenario>>,
  TError,
  ScenariosConvertScenarioToSharedScenarioMutationVariables,
  TContext
> => {
  const mutationKey = getScenariosConvertScenarioToSharedScenarioMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenariosConvertScenarioToSharedScenario>>,
    ScenariosConvertScenarioToSharedScenarioMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return scenariosConvertScenarioToSharedScenario(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosConvertScenarioToSharedScenarioMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenariosConvertScenarioToSharedScenario>>
>;

export type ScenariosConvertScenarioToSharedScenarioMutationError = unknown;
export type ScenariosConvertScenarioToSharedScenarioMutationVariables = { id: number };

export const useScenariosConvertScenarioToSharedScenario = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosConvertScenarioToSharedScenario>>,
    TError,
    ScenariosConvertScenarioToSharedScenarioMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosConvertScenarioToSharedScenario>>,
  TError,
  ScenariosConvertScenarioToSharedScenarioMutationVariables,
  TContext
> => {
  return useMutation(getScenariosConvertScenarioToSharedScenarioMutationOptions(options));
};

export const scenariosConvertSharedScenarioToScenario = (
  id: number,
  convertFromSharedScenarioCommand?: ConvertFromSharedScenarioCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/Scenarios/ConvertSharedScenarioToScenario/${id}/convertFromShared`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: convertFromSharedScenarioCommand,
    signal
  });
};

export const getScenariosConvertSharedScenarioToScenarioMutationKey = () =>
  ['scenariosConvertSharedScenarioToScenario'] as const;

export const getScenariosConvertSharedScenarioToScenarioMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosConvertSharedScenarioToScenario>>,
    TError,
    ScenariosConvertSharedScenarioToScenarioMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosConvertSharedScenarioToScenario>>,
  TError,
  ScenariosConvertSharedScenarioToScenarioMutationVariables,
  TContext
> => {
  const mutationKey = getScenariosConvertSharedScenarioToScenarioMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenariosConvertSharedScenarioToScenario>>,
    ScenariosConvertSharedScenarioToScenarioMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return scenariosConvertSharedScenarioToScenario(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosConvertSharedScenarioToScenarioMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenariosConvertSharedScenarioToScenario>>
>;
export type ScenariosConvertSharedScenarioToScenarioMutationBody = ConvertFromSharedScenarioCommand | undefined;
export type ScenariosConvertSharedScenarioToScenarioMutationError = unknown;
export type ScenariosConvertSharedScenarioToScenarioMutationVariables = {
  id: number;
  data?: ConvertFromSharedScenarioCommand;
};

export const useScenariosConvertSharedScenarioToScenario = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosConvertSharedScenarioToScenario>>,
    TError,
    ScenariosConvertSharedScenarioToScenarioMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosConvertSharedScenarioToScenario>>,
  TError,
  ScenariosConvertSharedScenarioToScenarioMutationVariables,
  TContext
> => {
  return useMutation(getScenariosConvertSharedScenarioToScenarioMutationOptions(options));
};

export const scenariosAddCompaniesToSharedScenario = (
  id: number,
  scenariosAddCompaniesToSharedScenarioBody?: number[],
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/Scenarios/AddCompaniesToSharedScenario/${id}/sharedCompany`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: scenariosAddCompaniesToSharedScenarioBody,
    signal
  });
};

export const getScenariosAddCompaniesToSharedScenarioMutationKey = () =>
  ['scenariosAddCompaniesToSharedScenario'] as const;

export const getScenariosAddCompaniesToSharedScenarioMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosAddCompaniesToSharedScenario>>,
    TError,
    ScenariosAddCompaniesToSharedScenarioMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosAddCompaniesToSharedScenario>>,
  TError,
  ScenariosAddCompaniesToSharedScenarioMutationVariables,
  TContext
> => {
  const mutationKey = getScenariosAddCompaniesToSharedScenarioMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenariosAddCompaniesToSharedScenario>>,
    ScenariosAddCompaniesToSharedScenarioMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return scenariosAddCompaniesToSharedScenario(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosAddCompaniesToSharedScenarioMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenariosAddCompaniesToSharedScenario>>
>;
export type ScenariosAddCompaniesToSharedScenarioMutationBody = number[] | undefined;
export type ScenariosAddCompaniesToSharedScenarioMutationError = unknown;
export type ScenariosAddCompaniesToSharedScenarioMutationVariables = { id: number; data?: number[] };

export const useScenariosAddCompaniesToSharedScenario = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosAddCompaniesToSharedScenario>>,
    TError,
    ScenariosAddCompaniesToSharedScenarioMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosAddCompaniesToSharedScenario>>,
  TError,
  ScenariosAddCompaniesToSharedScenarioMutationVariables,
  TContext
> => {
  return useMutation(getScenariosAddCompaniesToSharedScenarioMutationOptions(options));
};

export const scenariosRemoveCompaniesFromSharedScenario = (
  id: number,
  scenariosRemoveCompaniesFromSharedScenarioBody?: number[],
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/Scenarios/RemoveCompaniesFromSharedScenario/${id}/sharedCompany`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: scenariosRemoveCompaniesFromSharedScenarioBody,
    signal
  });
};

export const getScenariosRemoveCompaniesFromSharedScenarioMutationKey = () =>
  ['scenariosRemoveCompaniesFromSharedScenario'] as const;

export const getScenariosRemoveCompaniesFromSharedScenarioMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosRemoveCompaniesFromSharedScenario>>,
    TError,
    ScenariosRemoveCompaniesFromSharedScenarioMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosRemoveCompaniesFromSharedScenario>>,
  TError,
  ScenariosRemoveCompaniesFromSharedScenarioMutationVariables,
  TContext
> => {
  const mutationKey = getScenariosRemoveCompaniesFromSharedScenarioMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenariosRemoveCompaniesFromSharedScenario>>,
    ScenariosRemoveCompaniesFromSharedScenarioMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return scenariosRemoveCompaniesFromSharedScenario(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosRemoveCompaniesFromSharedScenarioMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenariosRemoveCompaniesFromSharedScenario>>
>;
export type ScenariosRemoveCompaniesFromSharedScenarioMutationBody = number[] | undefined;
export type ScenariosRemoveCompaniesFromSharedScenarioMutationError = unknown;
export type ScenariosRemoveCompaniesFromSharedScenarioMutationVariables = { id: number; data?: number[] };

export const useScenariosRemoveCompaniesFromSharedScenario = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosRemoveCompaniesFromSharedScenario>>,
    TError,
    ScenariosRemoveCompaniesFromSharedScenarioMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosRemoveCompaniesFromSharedScenario>>,
  TError,
  ScenariosRemoveCompaniesFromSharedScenarioMutationVariables,
  TContext
> => {
  return useMutation(getScenariosRemoveCompaniesFromSharedScenarioMutationOptions(options));
};

export const scenariosGetDefaultScenarioGender = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<Gender>({
    url: `/api/Scenarios/GetDefaultScenarioGender/${id}/gender`,
    method: 'GET',
    signal
  });
};

export const getScenariosGetDefaultScenarioGenderQueryKey = (id: number) => {
  return [`/api/Scenarios/GetDefaultScenarioGender/${id}/gender`] as const;
};

export const getScenariosGetDefaultScenarioGenderQueryOptions = <
  TData = Awaited<ReturnType<typeof scenariosGetDefaultScenarioGender>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetDefaultScenarioGender>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScenariosGetDefaultScenarioGenderQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenariosGetDefaultScenarioGender>>> = ({ signal }) =>
    scenariosGetDefaultScenarioGender(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof scenariosGetDefaultScenarioGender>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ScenariosGetDefaultScenarioGenderQueryResult = NonNullable<
  Awaited<ReturnType<typeof scenariosGetDefaultScenarioGender>>
>;
export type ScenariosGetDefaultScenarioGenderQueryError = unknown;

export function useScenariosGetDefaultScenarioGender<
  TData = Awaited<ReturnType<typeof scenariosGetDefaultScenarioGender>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetDefaultScenarioGender>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenariosGetDefaultScenarioGenderQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const scenariosGetTrendingScenarioIds = (
  trendingScenariosCommand?: TrendingScenariosCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<number[]>({
    url: `/api/Scenarios/GetTrendingScenarioIds/trending`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: trendingScenariosCommand,
    signal
  });
};

export const getScenariosGetTrendingScenarioIdsMutationKey = () => ['scenariosGetTrendingScenarioIds'] as const;

export const getScenariosGetTrendingScenarioIdsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosGetTrendingScenarioIds>>,
    TError,
    ScenariosGetTrendingScenarioIdsMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosGetTrendingScenarioIds>>,
  TError,
  ScenariosGetTrendingScenarioIdsMutationVariables,
  TContext
> => {
  const mutationKey = getScenariosGetTrendingScenarioIdsMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenariosGetTrendingScenarioIds>>,
    ScenariosGetTrendingScenarioIdsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return scenariosGetTrendingScenarioIds(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosGetTrendingScenarioIdsMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenariosGetTrendingScenarioIds>>
>;
export type ScenariosGetTrendingScenarioIdsMutationBody = TrendingScenariosCommand | undefined;
export type ScenariosGetTrendingScenarioIdsMutationError = unknown;
export type ScenariosGetTrendingScenarioIdsMutationVariables = { data?: TrendingScenariosCommand };

export const useScenariosGetTrendingScenarioIds = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosGetTrendingScenarioIds>>,
    TError,
    ScenariosGetTrendingScenarioIdsMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosGetTrendingScenarioIds>>,
  TError,
  ScenariosGetTrendingScenarioIdsMutationVariables,
  TContext
> => {
  return useMutation(getScenariosGetTrendingScenarioIdsMutationOptions(options));
};

export const scenariosUpdateScenarioPdf = (
  id: number,
  scenariosUpdateScenarioPdfBody?: ScenariosUpdateScenarioPdfBodyOne | ScenariosUpdateScenarioPdfBodyTwo,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScenarioDto>({
    url: `/api/Scenarios/UpdateScenarioPdf/${id}/pdf`,
    method: 'PUT',
    data: scenariosUpdateScenarioPdfBody,
    signal
  });
};

export const getScenariosUpdateScenarioPdfMutationKey = () => ['scenariosUpdateScenarioPdf'] as const;

export const getScenariosUpdateScenarioPdfMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosUpdateScenarioPdf>>,
    TError,
    ScenariosUpdateScenarioPdfMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosUpdateScenarioPdf>>,
  TError,
  ScenariosUpdateScenarioPdfMutationVariables,
  TContext
> => {
  const mutationKey = getScenariosUpdateScenarioPdfMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenariosUpdateScenarioPdf>>,
    ScenariosUpdateScenarioPdfMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return scenariosUpdateScenarioPdf(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosUpdateScenarioPdfMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenariosUpdateScenarioPdf>>
>;
export type ScenariosUpdateScenarioPdfMutationBody =
  | ScenariosUpdateScenarioPdfBodyOne
  | ScenariosUpdateScenarioPdfBodyTwo
  | undefined;
export type ScenariosUpdateScenarioPdfMutationError = unknown;
export type ScenariosUpdateScenarioPdfMutationVariables = {
  id: number;
  data?: ScenariosUpdateScenarioPdfBodyOne | ScenariosUpdateScenarioPdfBodyTwo;
};

export const useScenariosUpdateScenarioPdf = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosUpdateScenarioPdf>>,
    TError,
    ScenariosUpdateScenarioPdfMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosUpdateScenarioPdf>>,
  TError,
  ScenariosUpdateScenarioPdfMutationVariables,
  TContext
> => {
  return useMutation(getScenariosUpdateScenarioPdfMutationOptions(options));
};

export const scenariosRemoveScenarioPdf = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/Scenarios/RemoveScenarioPdf/${id}/pdf`, method: 'DELETE', signal });
};

export const getScenariosRemoveScenarioPdfMutationKey = () => ['scenariosRemoveScenarioPdf'] as const;

export const getScenariosRemoveScenarioPdfMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosRemoveScenarioPdf>>,
    TError,
    ScenariosRemoveScenarioPdfMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scenariosRemoveScenarioPdf>>,
  TError,
  ScenariosRemoveScenarioPdfMutationVariables,
  TContext
> => {
  const mutationKey = getScenariosRemoveScenarioPdfMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scenariosRemoveScenarioPdf>>,
    ScenariosRemoveScenarioPdfMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return scenariosRemoveScenarioPdf(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScenariosRemoveScenarioPdfMutationResult = NonNullable<
  Awaited<ReturnType<typeof scenariosRemoveScenarioPdf>>
>;

export type ScenariosRemoveScenarioPdfMutationError = unknown;
export type ScenariosRemoveScenarioPdfMutationVariables = { id: number };

export const useScenariosRemoveScenarioPdf = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scenariosRemoveScenarioPdf>>,
    TError,
    ScenariosRemoveScenarioPdfMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scenariosRemoveScenarioPdf>>,
  TError,
  ScenariosRemoveScenarioPdfMutationVariables,
  TContext
> => {
  return useMutation(getScenariosRemoveScenarioPdfMutationOptions(options));
};

export const scenariosGetScenarioPdf = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<AttachmentDto>({ url: `/api/Scenarios/GetScenarioPdf/${id}/pdf`, method: 'GET', signal });
};

export const getScenariosGetScenarioPdfQueryKey = (id: number) => {
  return [`/api/Scenarios/GetScenarioPdf/${id}/pdf`] as const;
};

export const getScenariosGetScenarioPdfQueryOptions = <
  TData = Awaited<ReturnType<typeof scenariosGetScenarioPdf>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetScenarioPdf>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScenariosGetScenarioPdfQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenariosGetScenarioPdf>>> = ({ signal }) =>
    scenariosGetScenarioPdf(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof scenariosGetScenarioPdf>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ScenariosGetScenarioPdfQueryResult = NonNullable<Awaited<ReturnType<typeof scenariosGetScenarioPdf>>>;
export type ScenariosGetScenarioPdfQueryError = unknown;

export function useScenariosGetScenarioPdf<
  TData = Awaited<ReturnType<typeof scenariosGetScenarioPdf>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetScenarioPdf>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenariosGetScenarioPdfQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const scenariosGetRecommendedScenarios = (signal?: AbortSignal) => {
  return customAxiosInstance<number[]>({
    url: `/api/Scenarios/GetRecommendedScenarios/recommendations`,
    method: 'GET',
    signal
  });
};

export const getScenariosGetRecommendedScenariosQueryKey = () => {
  return [`/api/Scenarios/GetRecommendedScenarios/recommendations`] as const;
};

export const getScenariosGetRecommendedScenariosQueryOptions = <
  TData = Awaited<ReturnType<typeof scenariosGetRecommendedScenarios>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetRecommendedScenarios>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScenariosGetRecommendedScenariosQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scenariosGetRecommendedScenarios>>> = ({ signal }) =>
    scenariosGetRecommendedScenarios(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof scenariosGetRecommendedScenarios>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ScenariosGetRecommendedScenariosQueryResult = NonNullable<
  Awaited<ReturnType<typeof scenariosGetRecommendedScenarios>>
>;
export type ScenariosGetRecommendedScenariosQueryError = unknown;

export function useScenariosGetRecommendedScenarios<
  TData = Awaited<ReturnType<typeof scenariosGetRecommendedScenarios>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof scenariosGetRecommendedScenarios>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScenariosGetRecommendedScenariosQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const scheduledCallsGet = (params?: ScheduledCallsGetParams, signal?: AbortSignal) => {
  return customAxiosInstance<PartialListScheduledCallDto>({
    url: `/api/ScheduledCalls/Get`,
    method: 'GET',
    params,
    signal
  });
};

export const getScheduledCallsGetQueryKey = (params?: ScheduledCallsGetParams) => {
  return [`/api/ScheduledCalls/Get`, ...(params ? [params] : [])] as const;
};

export const getScheduledCallsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof scheduledCallsGet>>,
  TError = unknown
>(
  params?: ScheduledCallsGetParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scheduledCallsGet>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getScheduledCallsGetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof scheduledCallsGet>>> = ({ signal }) =>
    scheduledCallsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof scheduledCallsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ScheduledCallsGetQueryResult = NonNullable<Awaited<ReturnType<typeof scheduledCallsGet>>>;
export type ScheduledCallsGetQueryError = unknown;

export function useScheduledCallsGet<TData = Awaited<ReturnType<typeof scheduledCallsGet>>, TError = unknown>(
  params?: ScheduledCallsGetParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof scheduledCallsGet>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getScheduledCallsGetQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const scheduledCallsCreate = (createScheduledCallCommand?: CreateScheduledCallCommand, signal?: AbortSignal) => {
  return customAxiosInstance<ScheduledCallDto>({
    url: `/api/ScheduledCalls/Create`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createScheduledCallCommand,
    signal
  });
};

export const getScheduledCallsCreateMutationKey = () => ['scheduledCallsCreate'] as const;

export const getScheduledCallsCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduledCallsCreate>>,
    TError,
    ScheduledCallsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scheduledCallsCreate>>,
  TError,
  ScheduledCallsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getScheduledCallsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scheduledCallsCreate>>,
    ScheduledCallsCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return scheduledCallsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScheduledCallsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof scheduledCallsCreate>>>;
export type ScheduledCallsCreateMutationBody = CreateScheduledCallCommand | undefined;
export type ScheduledCallsCreateMutationError = void;
export type ScheduledCallsCreateMutationVariables = { data?: CreateScheduledCallCommand };

export const useScheduledCallsCreate = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduledCallsCreate>>,
    TError,
    ScheduledCallsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scheduledCallsCreate>>,
  TError,
  ScheduledCallsCreateMutationVariables,
  TContext
> => {
  return useMutation(getScheduledCallsCreateMutationOptions(options));
};

export const scheduledCallsUpdate = (
  scheduledCallId: number,
  updateScheduledCallCommand?: UpdateScheduledCallCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScheduledCallDto>({
    url: `/api/ScheduledCalls/Update/${scheduledCallId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateScheduledCallCommand,
    signal
  });
};

export const getScheduledCallsUpdateMutationKey = () => ['scheduledCallsUpdate'] as const;

export const getScheduledCallsUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduledCallsUpdate>>,
    TError,
    ScheduledCallsUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scheduledCallsUpdate>>,
  TError,
  ScheduledCallsUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getScheduledCallsUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scheduledCallsUpdate>>,
    ScheduledCallsUpdateMutationVariables
  > = (props) => {
    const { scheduledCallId, data } = props ?? {};

    return scheduledCallsUpdate(scheduledCallId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScheduledCallsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof scheduledCallsUpdate>>>;
export type ScheduledCallsUpdateMutationBody = UpdateScheduledCallCommand | undefined;
export type ScheduledCallsUpdateMutationError = unknown;
export type ScheduledCallsUpdateMutationVariables = { scheduledCallId: number; data?: UpdateScheduledCallCommand };

export const useScheduledCallsUpdate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduledCallsUpdate>>,
    TError,
    ScheduledCallsUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scheduledCallsUpdate>>,
  TError,
  ScheduledCallsUpdateMutationVariables,
  TContext
> => {
  return useMutation(getScheduledCallsUpdateMutationOptions(options));
};

export const scheduledCallsUpdateStatus = (
  scheduledCallId: number,
  params?: ScheduledCallsUpdateStatusParams,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ScheduledCallDto>({
    url: `/api/ScheduledCalls/UpdateStatus/${scheduledCallId}/status`,
    method: 'PUT',
    params,
    signal
  });
};

export const getScheduledCallsUpdateStatusMutationKey = () => ['scheduledCallsUpdateStatus'] as const;

export const getScheduledCallsUpdateStatusMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduledCallsUpdateStatus>>,
    TError,
    ScheduledCallsUpdateStatusMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scheduledCallsUpdateStatus>>,
  TError,
  ScheduledCallsUpdateStatusMutationVariables,
  TContext
> => {
  const mutationKey = getScheduledCallsUpdateStatusMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scheduledCallsUpdateStatus>>,
    ScheduledCallsUpdateStatusMutationVariables
  > = (props) => {
    const { scheduledCallId, params } = props ?? {};

    return scheduledCallsUpdateStatus(scheduledCallId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScheduledCallsUpdateStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof scheduledCallsUpdateStatus>>
>;

export type ScheduledCallsUpdateStatusMutationError = unknown;
export type ScheduledCallsUpdateStatusMutationVariables = {
  scheduledCallId: number;
  params?: ScheduledCallsUpdateStatusParams;
};

export const useScheduledCallsUpdateStatus = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduledCallsUpdateStatus>>,
    TError,
    ScheduledCallsUpdateStatusMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scheduledCallsUpdateStatus>>,
  TError,
  ScheduledCallsUpdateStatusMutationVariables,
  TContext
> => {
  return useMutation(getScheduledCallsUpdateStatusMutationOptions(options));
};

export const scheduledCallsDelete = (
  deleteScheduledCallsCommand?: DeleteScheduledCallsCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/ScheduledCalls/Delete`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: deleteScheduledCallsCommand,
    signal
  });
};

export const getScheduledCallsDeleteMutationKey = () => ['scheduledCallsDelete'] as const;

export const getScheduledCallsDeleteMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduledCallsDelete>>,
    TError,
    ScheduledCallsDeleteMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scheduledCallsDelete>>,
  TError,
  ScheduledCallsDeleteMutationVariables,
  TContext
> => {
  const mutationKey = getScheduledCallsDeleteMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scheduledCallsDelete>>,
    ScheduledCallsDeleteMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return scheduledCallsDelete(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScheduledCallsDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof scheduledCallsDelete>>>;
export type ScheduledCallsDeleteMutationBody = DeleteScheduledCallsCommand | undefined;
export type ScheduledCallsDeleteMutationError = unknown;
export type ScheduledCallsDeleteMutationVariables = { data?: DeleteScheduledCallsCommand };

export const useScheduledCallsDelete = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduledCallsDelete>>,
    TError,
    ScheduledCallsDeleteMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scheduledCallsDelete>>,
  TError,
  ScheduledCallsDeleteMutationVariables,
  TContext
> => {
  return useMutation(getScheduledCallsDeleteMutationOptions(options));
};

export const simulationGetAll = (signal?: AbortSignal) => {
  return customAxiosInstance<SimulationDto[]>({ url: `/api/Simulation`, method: 'GET', signal });
};

export const getSimulationGetAllQueryKey = () => {
  return [`/api/Simulation`] as const;
};

export const getSimulationGetAllQueryOptions = <
  TData = Awaited<ReturnType<typeof simulationGetAll>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof simulationGetAll>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSimulationGetAllQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof simulationGetAll>>> = ({ signal }) => simulationGetAll(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof simulationGetAll>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SimulationGetAllQueryResult = NonNullable<Awaited<ReturnType<typeof simulationGetAll>>>;
export type SimulationGetAllQueryError = unknown;

export function useSimulationGetAll<TData = Awaited<ReturnType<typeof simulationGetAll>>, TError = unknown>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof simulationGetAll>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSimulationGetAllQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const simulationCreate = (createSimulationDto?: CreateSimulationDto, signal?: AbortSignal) => {
  return customAxiosInstance<SimulationDto>({
    url: `/api/Simulation`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createSimulationDto,
    signal
  });
};

export const getSimulationCreateMutationKey = () => ['simulationCreate'] as const;

export const getSimulationCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationCreate>>,
    TError,
    SimulationCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof simulationCreate>>,
  TError,
  SimulationCreateMutationVariables,
  TContext
> => {
  const mutationKey = getSimulationCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof simulationCreate>>,
    SimulationCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return simulationCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SimulationCreateMutationResult = NonNullable<Awaited<ReturnType<typeof simulationCreate>>>;
export type SimulationCreateMutationBody = CreateSimulationDto | undefined;
export type SimulationCreateMutationError = unknown;
export type SimulationCreateMutationVariables = { data?: CreateSimulationDto };

export const useSimulationCreate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationCreate>>,
    TError,
    SimulationCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof simulationCreate>>,
  TError,
  SimulationCreateMutationVariables,
  TContext
> => {
  return useMutation(getSimulationCreateMutationOptions(options));
};

export const simulationGetById = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<SimulationDto>({ url: `/api/Simulation/${id}`, method: 'GET', signal });
};

export const getSimulationGetByIdQueryKey = (id: number) => {
  return [`/api/Simulation/${id}`] as const;
};

export const getSimulationGetByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof simulationGetById>>,
  TError = unknown
>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof simulationGetById>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSimulationGetByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof simulationGetById>>> = ({ signal }) =>
    simulationGetById(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof simulationGetById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SimulationGetByIdQueryResult = NonNullable<Awaited<ReturnType<typeof simulationGetById>>>;
export type SimulationGetByIdQueryError = unknown;

export function useSimulationGetById<TData = Awaited<ReturnType<typeof simulationGetById>>, TError = unknown>(
  id: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof simulationGetById>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSimulationGetByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const simulationUpdate = (id: number, updateSimulationDto?: UpdateSimulationDto, signal?: AbortSignal) => {
  return customAxiosInstance<SimulationDto>({
    url: `/api/Simulation/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateSimulationDto,
    signal
  });
};

export const getSimulationUpdateMutationKey = () => ['simulationUpdate'] as const;

export const getSimulationUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationUpdate>>,
    TError,
    SimulationUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof simulationUpdate>>,
  TError,
  SimulationUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getSimulationUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof simulationUpdate>>,
    SimulationUpdateMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return simulationUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SimulationUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof simulationUpdate>>>;
export type SimulationUpdateMutationBody = UpdateSimulationDto | undefined;
export type SimulationUpdateMutationError = unknown;
export type SimulationUpdateMutationVariables = { id: number; data?: UpdateSimulationDto };

export const useSimulationUpdate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationUpdate>>,
    TError,
    SimulationUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof simulationUpdate>>,
  TError,
  SimulationUpdateMutationVariables,
  TContext
> => {
  return useMutation(getSimulationUpdateMutationOptions(options));
};

export const simulationDelete = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/Simulation/${id}`, method: 'DELETE', signal });
};

export const getSimulationDeleteMutationKey = () => ['simulationDelete'] as const;

export const getSimulationDeleteMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationDelete>>,
    TError,
    SimulationDeleteMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof simulationDelete>>,
  TError,
  SimulationDeleteMutationVariables,
  TContext
> => {
  const mutationKey = getSimulationDeleteMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof simulationDelete>>,
    SimulationDeleteMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return simulationDelete(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type SimulationDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof simulationDelete>>>;

export type SimulationDeleteMutationError = unknown;
export type SimulationDeleteMutationVariables = { id: number };

export const useSimulationDelete = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationDelete>>,
    TError,
    SimulationDeleteMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof simulationDelete>>,
  TError,
  SimulationDeleteMutationVariables,
  TContext
> => {
  return useMutation(getSimulationDeleteMutationOptions(options));
};

export const simulationCreateVital = (createVitalSimulationDto?: CreateVitalSimulationDto, signal?: AbortSignal) => {
  return customAxiosInstance<SimulationDto>({
    url: `/api/Simulation/vital`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createVitalSimulationDto,
    signal
  });
};

export const getSimulationCreateVitalMutationKey = () => ['simulationCreateVital'] as const;

export const getSimulationCreateVitalMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationCreateVital>>,
    TError,
    SimulationCreateVitalMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof simulationCreateVital>>,
  TError,
  SimulationCreateVitalMutationVariables,
  TContext
> => {
  const mutationKey = getSimulationCreateVitalMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof simulationCreateVital>>,
    SimulationCreateVitalMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return simulationCreateVital(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SimulationCreateVitalMutationResult = NonNullable<Awaited<ReturnType<typeof simulationCreateVital>>>;
export type SimulationCreateVitalMutationBody = CreateVitalSimulationDto | undefined;
export type SimulationCreateVitalMutationError = unknown;
export type SimulationCreateVitalMutationVariables = { data?: CreateVitalSimulationDto };

export const useSimulationCreateVital = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationCreateVital>>,
    TError,
    SimulationCreateVitalMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof simulationCreateVital>>,
  TError,
  SimulationCreateVitalMutationVariables,
  TContext
> => {
  return useMutation(getSimulationCreateVitalMutationOptions(options));
};

export const simulationClone = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<SimulationDto>({ url: `/api/Simulation/${id}/clone`, method: 'POST', signal });
};

export const getSimulationCloneMutationKey = () => ['simulationClone'] as const;

export const getSimulationCloneMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationClone>>,
    TError,
    SimulationCloneMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof simulationClone>>,
  TError,
  SimulationCloneMutationVariables,
  TContext
> => {
  const mutationKey = getSimulationCloneMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof simulationClone>>, SimulationCloneMutationVariables> = (
    props
  ) => {
    const { id } = props ?? {};

    return simulationClone(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type SimulationCloneMutationResult = NonNullable<Awaited<ReturnType<typeof simulationClone>>>;

export type SimulationCloneMutationError = unknown;
export type SimulationCloneMutationVariables = { id: number };

export const useSimulationClone = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationClone>>,
    TError,
    SimulationCloneMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof simulationClone>>,
  TError,
  SimulationCloneMutationVariables,
  TContext
> => {
  return useMutation(getSimulationCloneMutationOptions(options));
};

export const simulationStart = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<SimulationDto>({ url: `/api/Simulation/${id}/start`, method: 'POST', signal });
};

export const getSimulationStartMutationKey = () => ['simulationStart'] as const;

export const getSimulationStartMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationStart>>,
    TError,
    SimulationStartMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof simulationStart>>,
  TError,
  SimulationStartMutationVariables,
  TContext
> => {
  const mutationKey = getSimulationStartMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof simulationStart>>, SimulationStartMutationVariables> = (
    props
  ) => {
    const { id } = props ?? {};

    return simulationStart(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type SimulationStartMutationResult = NonNullable<Awaited<ReturnType<typeof simulationStart>>>;

export type SimulationStartMutationError = unknown;
export type SimulationStartMutationVariables = { id: number };

export const useSimulationStart = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationStart>>,
    TError,
    SimulationStartMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof simulationStart>>,
  TError,
  SimulationStartMutationVariables,
  TContext
> => {
  return useMutation(getSimulationStartMutationOptions(options));
};

export const simulationEnd = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<SimulationDto>({ url: `/api/Simulation/${id}/end`, method: 'POST', signal });
};

export const getSimulationEndMutationKey = () => ['simulationEnd'] as const;

export const getSimulationEndMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationEnd>>,
    TError,
    SimulationEndMutationVariables,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof simulationEnd>>, TError, SimulationEndMutationVariables, TContext> => {
  const mutationKey = getSimulationEndMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof simulationEnd>>, SimulationEndMutationVariables> = (
    props
  ) => {
    const { id } = props ?? {};

    return simulationEnd(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type SimulationEndMutationResult = NonNullable<Awaited<ReturnType<typeof simulationEnd>>>;

export type SimulationEndMutationError = unknown;
export type SimulationEndMutationVariables = { id: number };

export const useSimulationEnd = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationEnd>>,
    TError,
    SimulationEndMutationVariables,
    TContext
  >;
}): UseMutationResult<Awaited<ReturnType<typeof simulationEnd>>, TError, SimulationEndMutationVariables, TContext> => {
  return useMutation(getSimulationEndMutationOptions(options));
};

export const simulationUpdateStageRunState = (
  id: number,
  stageId: number,
  updateSimulationStageRunStateDto?: UpdateSimulationStageRunStateDto,
  signal?: AbortSignal
) => {
  return customAxiosInstance<SimulationStageDto>({
    url: `/api/Simulation/${id}/stages/${stageId}/run`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateSimulationStageRunStateDto,
    signal
  });
};

export const getSimulationUpdateStageRunStateMutationKey = () => ['simulationUpdateStageRunState'] as const;

export const getSimulationUpdateStageRunStateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationUpdateStageRunState>>,
    TError,
    SimulationUpdateStageRunStateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof simulationUpdateStageRunState>>,
  TError,
  SimulationUpdateStageRunStateMutationVariables,
  TContext
> => {
  const mutationKey = getSimulationUpdateStageRunStateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof simulationUpdateStageRunState>>,
    SimulationUpdateStageRunStateMutationVariables
  > = (props) => {
    const { id, stageId, data } = props ?? {};

    return simulationUpdateStageRunState(id, stageId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SimulationUpdateStageRunStateMutationResult = NonNullable<
  Awaited<ReturnType<typeof simulationUpdateStageRunState>>
>;
export type SimulationUpdateStageRunStateMutationBody = UpdateSimulationStageRunStateDto | undefined;
export type SimulationUpdateStageRunStateMutationError = unknown;
export type SimulationUpdateStageRunStateMutationVariables = {
  id: number;
  stageId: number;
  data?: UpdateSimulationStageRunStateDto;
};

export const useSimulationUpdateStageRunState = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationUpdateStageRunState>>,
    TError,
    SimulationUpdateStageRunStateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof simulationUpdateStageRunState>>,
  TError,
  SimulationUpdateStageRunStateMutationVariables,
  TContext
> => {
  return useMutation(getSimulationUpdateStageRunStateMutationOptions(options));
};

export const simulationResetStage = (id: number, stageId: number, signal?: AbortSignal) => {
  return customAxiosInstance<SimulationDto>({
    url: `/api/Simulation/${id}/stages/${stageId}/reset`,
    method: 'POST',
    signal
  });
};

export const getSimulationResetStageMutationKey = () => ['simulationResetStage'] as const;

export const getSimulationResetStageMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationResetStage>>,
    TError,
    SimulationResetStageMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof simulationResetStage>>,
  TError,
  SimulationResetStageMutationVariables,
  TContext
> => {
  const mutationKey = getSimulationResetStageMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof simulationResetStage>>,
    SimulationResetStageMutationVariables
  > = (props) => {
    const { id, stageId } = props ?? {};

    return simulationResetStage(id, stageId);
  };

  return { mutationFn, ...mutationOptions };
};

export type SimulationResetStageMutationResult = NonNullable<Awaited<ReturnType<typeof simulationResetStage>>>;

export type SimulationResetStageMutationError = unknown;
export type SimulationResetStageMutationVariables = { id: number; stageId: number };

export const useSimulationResetStage = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationResetStage>>,
    TError,
    SimulationResetStageMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof simulationResetStage>>,
  TError,
  SimulationResetStageMutationVariables,
  TContext
> => {
  return useMutation(getSimulationResetStageMutationOptions(options));
};

export const simulationGetActiveCases = (signal?: AbortSignal) => {
  return customAxiosInstance<ActiveCaseDto[]>({ url: `/api/Simulation/active`, method: 'GET', signal });
};

export const getSimulationGetActiveCasesQueryKey = () => {
  return [`/api/Simulation/active`] as const;
};

export const getSimulationGetActiveCasesQueryOptions = <
  TData = Awaited<ReturnType<typeof simulationGetActiveCases>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof simulationGetActiveCases>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSimulationGetActiveCasesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof simulationGetActiveCases>>> = ({ signal }) =>
    simulationGetActiveCases(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof simulationGetActiveCases>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SimulationGetActiveCasesQueryResult = NonNullable<Awaited<ReturnType<typeof simulationGetActiveCases>>>;
export type SimulationGetActiveCasesQueryError = unknown;

export function useSimulationGetActiveCases<
  TData = Awaited<ReturnType<typeof simulationGetActiveCases>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof simulationGetActiveCases>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSimulationGetActiveCasesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const simulationGetByCaseId = (caseId: string, signal?: AbortSignal) => {
  return customAxiosInstance<ActiveCaseDto>({ url: `/api/Simulation/by-case/${caseId}`, method: 'GET', signal });
};

export const getSimulationGetByCaseIdQueryKey = (caseId: string) => {
  return [`/api/Simulation/by-case/${caseId}`] as const;
};

export const getSimulationGetByCaseIdQueryOptions = <
  TData = Awaited<ReturnType<typeof simulationGetByCaseId>>,
  TError = unknown
>(
  caseId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof simulationGetByCaseId>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSimulationGetByCaseIdQueryKey(caseId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof simulationGetByCaseId>>> = ({ signal }) =>
    simulationGetByCaseId(caseId, signal);

  return { queryKey, queryFn, enabled: caseId !== null && caseId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof simulationGetByCaseId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SimulationGetByCaseIdQueryResult = NonNullable<Awaited<ReturnType<typeof simulationGetByCaseId>>>;
export type SimulationGetByCaseIdQueryError = unknown;

export function useSimulationGetByCaseId<TData = Awaited<ReturnType<typeof simulationGetByCaseId>>, TError = unknown>(
  caseId: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof simulationGetByCaseId>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSimulationGetByCaseIdQueryOptions(caseId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const simulationDispatchAmbulance = (
  id: number,
  dispatchAmbulanceDto?: DispatchAmbulanceDto,
  signal?: AbortSignal
) => {
  return customAxiosInstance<SimulationDto>({
    url: `/api/Simulation/${id}/dispatch-ambulance`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: dispatchAmbulanceDto,
    signal
  });
};

export const getSimulationDispatchAmbulanceMutationKey = () => ['simulationDispatchAmbulance'] as const;

export const getSimulationDispatchAmbulanceMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationDispatchAmbulance>>,
    TError,
    SimulationDispatchAmbulanceMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof simulationDispatchAmbulance>>,
  TError,
  SimulationDispatchAmbulanceMutationVariables,
  TContext
> => {
  const mutationKey = getSimulationDispatchAmbulanceMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof simulationDispatchAmbulance>>,
    SimulationDispatchAmbulanceMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return simulationDispatchAmbulance(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SimulationDispatchAmbulanceMutationResult = NonNullable<
  Awaited<ReturnType<typeof simulationDispatchAmbulance>>
>;
export type SimulationDispatchAmbulanceMutationBody = DispatchAmbulanceDto | undefined;
export type SimulationDispatchAmbulanceMutationError = unknown;
export type SimulationDispatchAmbulanceMutationVariables = { id: number; data?: DispatchAmbulanceDto };

export const useSimulationDispatchAmbulance = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationDispatchAmbulance>>,
    TError,
    SimulationDispatchAmbulanceMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof simulationDispatchAmbulance>>,
  TError,
  SimulationDispatchAmbulanceMutationVariables,
  TContext
> => {
  return useMutation(getSimulationDispatchAmbulanceMutationOptions(options));
};

export const simulationAdvanceStage = (id: number, advanceStageDto?: AdvanceStageDto, signal?: AbortSignal) => {
  return customAxiosInstance<SimulationDto>({
    url: `/api/Simulation/${id}/handover/advance`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: advanceStageDto,
    signal
  });
};

export const getSimulationAdvanceStageMutationKey = () => ['simulationAdvanceStage'] as const;

export const getSimulationAdvanceStageMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationAdvanceStage>>,
    TError,
    SimulationAdvanceStageMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof simulationAdvanceStage>>,
  TError,
  SimulationAdvanceStageMutationVariables,
  TContext
> => {
  const mutationKey = getSimulationAdvanceStageMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof simulationAdvanceStage>>,
    SimulationAdvanceStageMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return simulationAdvanceStage(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SimulationAdvanceStageMutationResult = NonNullable<Awaited<ReturnType<typeof simulationAdvanceStage>>>;
export type SimulationAdvanceStageMutationBody = AdvanceStageDto | undefined;
export type SimulationAdvanceStageMutationError = unknown;
export type SimulationAdvanceStageMutationVariables = { id: number; data?: AdvanceStageDto };

export const useSimulationAdvanceStage = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationAdvanceStage>>,
    TError,
    SimulationAdvanceStageMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof simulationAdvanceStage>>,
  TError,
  SimulationAdvanceStageMutationVariables,
  TContext
> => {
  return useMutation(getSimulationAdvanceStageMutationOptions(options));
};

export const simulationProcessSimulatorDialog = (
  processSimulatorDialogDto?: ProcessSimulatorDialogDto,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ProcessResultDto>({
    url: `/api/Simulation/ProcessSimulationDialog`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: processSimulatorDialogDto,
    signal
  });
};

export const getSimulationProcessSimulatorDialogMutationKey = () => ['simulationProcessSimulatorDialog'] as const;

export const getSimulationProcessSimulatorDialogMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationProcessSimulatorDialog>>,
    TError,
    SimulationProcessSimulatorDialogMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof simulationProcessSimulatorDialog>>,
  TError,
  SimulationProcessSimulatorDialogMutationVariables,
  TContext
> => {
  const mutationKey = getSimulationProcessSimulatorDialogMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof simulationProcessSimulatorDialog>>,
    SimulationProcessSimulatorDialogMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return simulationProcessSimulatorDialog(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SimulationProcessSimulatorDialogMutationResult = NonNullable<
  Awaited<ReturnType<typeof simulationProcessSimulatorDialog>>
>;
export type SimulationProcessSimulatorDialogMutationBody = ProcessSimulatorDialogDto | undefined;
export type SimulationProcessSimulatorDialogMutationError = unknown;
export type SimulationProcessSimulatorDialogMutationVariables = { data?: ProcessSimulatorDialogDto };

export const useSimulationProcessSimulatorDialog = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationProcessSimulatorDialog>>,
    TError,
    SimulationProcessSimulatorDialogMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof simulationProcessSimulatorDialog>>,
  TError,
  SimulationProcessSimulatorDialogMutationVariables,
  TContext
> => {
  return useMutation(getSimulationProcessSimulatorDialogMutationOptions(options));
};

export const simulationRespondToUser = (
  processSimulatorAudioDialogDto?: ProcessSimulatorAudioDialogDto,
  signal?: AbortSignal
) => {
  return customAxiosInstance<AudioResponseDto>({
    url: `/api/Simulation/respond`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: processSimulatorAudioDialogDto,
    signal
  });
};

export const getSimulationRespondToUserMutationKey = () => ['simulationRespondToUser'] as const;

export const getSimulationRespondToUserMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationRespondToUser>>,
    TError,
    SimulationRespondToUserMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof simulationRespondToUser>>,
  TError,
  SimulationRespondToUserMutationVariables,
  TContext
> => {
  const mutationKey = getSimulationRespondToUserMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof simulationRespondToUser>>,
    SimulationRespondToUserMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return simulationRespondToUser(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SimulationRespondToUserMutationResult = NonNullable<Awaited<ReturnType<typeof simulationRespondToUser>>>;
export type SimulationRespondToUserMutationBody = ProcessSimulatorAudioDialogDto | undefined;
export type SimulationRespondToUserMutationError = unknown;
export type SimulationRespondToUserMutationVariables = { data?: ProcessSimulatorAudioDialogDto };

export const useSimulationRespondToUser = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationRespondToUser>>,
    TError,
    SimulationRespondToUserMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof simulationRespondToUser>>,
  TError,
  SimulationRespondToUserMutationVariables,
  TContext
> => {
  return useMutation(getSimulationRespondToUserMutationOptions(options));
};

export const simulationProcessSimulatorAudioTurn = (
  processSimulatorAudioTurnDto?: ProcessSimulatorAudioTurnDto,
  signal?: AbortSignal
) => {
  return customAxiosInstance<RespondToUserTurnDto>({
    url: `/api/Simulation/RespondToUserSimulationTurn`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: processSimulatorAudioTurnDto,
    signal
  });
};

export const getSimulationProcessSimulatorAudioTurnMutationKey = () => ['simulationProcessSimulatorAudioTurn'] as const;

export const getSimulationProcessSimulatorAudioTurnMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationProcessSimulatorAudioTurn>>,
    TError,
    SimulationProcessSimulatorAudioTurnMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof simulationProcessSimulatorAudioTurn>>,
  TError,
  SimulationProcessSimulatorAudioTurnMutationVariables,
  TContext
> => {
  const mutationKey = getSimulationProcessSimulatorAudioTurnMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof simulationProcessSimulatorAudioTurn>>,
    SimulationProcessSimulatorAudioTurnMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return simulationProcessSimulatorAudioTurn(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SimulationProcessSimulatorAudioTurnMutationResult = NonNullable<
  Awaited<ReturnType<typeof simulationProcessSimulatorAudioTurn>>
>;
export type SimulationProcessSimulatorAudioTurnMutationBody = ProcessSimulatorAudioTurnDto | undefined;
export type SimulationProcessSimulatorAudioTurnMutationError = unknown;
export type SimulationProcessSimulatorAudioTurnMutationVariables = { data?: ProcessSimulatorAudioTurnDto };

export const useSimulationProcessSimulatorAudioTurn = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulationProcessSimulatorAudioTurn>>,
    TError,
    SimulationProcessSimulatorAudioTurnMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof simulationProcessSimulatorAudioTurn>>,
  TError,
  SimulationProcessSimulatorAudioTurnMutationVariables,
  TContext
> => {
  return useMutation(getSimulationProcessSimulatorAudioTurnMutationOptions(options));
};

export const speechSynthesizeSpeech = (synthesizeSpeechCommand?: SynthesizeSpeechCommand, signal?: AbortSignal) => {
  return customAxiosInstance<string>({
    url: `/api/Speech/SynthesizeSpeech/synthesizeSpeech`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: synthesizeSpeechCommand,
    signal
  });
};

export const getSpeechSynthesizeSpeechMutationKey = () => ['speechSynthesizeSpeech'] as const;

export const getSpeechSynthesizeSpeechMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof speechSynthesizeSpeech>>,
    TError,
    SpeechSynthesizeSpeechMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof speechSynthesizeSpeech>>,
  TError,
  SpeechSynthesizeSpeechMutationVariables,
  TContext
> => {
  const mutationKey = getSpeechSynthesizeSpeechMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof speechSynthesizeSpeech>>,
    SpeechSynthesizeSpeechMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return speechSynthesizeSpeech(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SpeechSynthesizeSpeechMutationResult = NonNullable<Awaited<ReturnType<typeof speechSynthesizeSpeech>>>;
export type SpeechSynthesizeSpeechMutationBody = SynthesizeSpeechCommand | undefined;
export type SpeechSynthesizeSpeechMutationError = unknown;
export type SpeechSynthesizeSpeechMutationVariables = { data?: SynthesizeSpeechCommand };

export const useSpeechSynthesizeSpeech = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof speechSynthesizeSpeech>>,
    TError,
    SpeechSynthesizeSpeechMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof speechSynthesizeSpeech>>,
  TError,
  SpeechSynthesizeSpeechMutationVariables,
  TContext
> => {
  return useMutation(getSpeechSynthesizeSpeechMutationOptions(options));
};

/**
 * @summary Streams the synthesized speech as raw PCM (s16le, 22050 Hz, mono), flushing per chunk so
playback can start on the first bytes instead of waiting for the whole clip like
M:ScenarioEditor.Api.SpeechController.SynthesizeSpeech(ScenarioEditor.Core.SpeechSynthesis.Commands.SynthesizeSpeechCommand). Returns 404 when the voice provider cannot stream.
The absolute route keeps the path clean; the class template would otherwise nest the
action name twice.
 */
export const speechSynthesizeSpeechStream = (
  synthesizeSpeechCommand?: SynthesizeSpeechCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/Speech/synthesizeSpeechStream`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: synthesizeSpeechCommand,
    signal
  });
};

export const getSpeechSynthesizeSpeechStreamMutationKey = () => ['speechSynthesizeSpeechStream'] as const;

export const getSpeechSynthesizeSpeechStreamMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof speechSynthesizeSpeechStream>>,
    TError,
    SpeechSynthesizeSpeechStreamMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof speechSynthesizeSpeechStream>>,
  TError,
  SpeechSynthesizeSpeechStreamMutationVariables,
  TContext
> => {
  const mutationKey = getSpeechSynthesizeSpeechStreamMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof speechSynthesizeSpeechStream>>,
    SpeechSynthesizeSpeechStreamMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return speechSynthesizeSpeechStream(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SpeechSynthesizeSpeechStreamMutationResult = NonNullable<
  Awaited<ReturnType<typeof speechSynthesizeSpeechStream>>
>;
export type SpeechSynthesizeSpeechStreamMutationBody = SynthesizeSpeechCommand | undefined;
export type SpeechSynthesizeSpeechStreamMutationError = unknown;
export type SpeechSynthesizeSpeechStreamMutationVariables = { data?: SynthesizeSpeechCommand };

/**
 * @summary Streams the synthesized speech as raw PCM (s16le, 22050 Hz, mono), flushing per chunk so
playback can start on the first bytes instead of waiting for the whole clip like
M:ScenarioEditor.Api.SpeechController.SynthesizeSpeech(ScenarioEditor.Core.SpeechSynthesis.Commands.SynthesizeSpeechCommand). Returns 404 when the voice provider cannot stream.
The absolute route keeps the path clean; the class template would otherwise nest the
action name twice.
 */
export const useSpeechSynthesizeSpeechStream = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof speechSynthesizeSpeechStream>>,
    TError,
    SpeechSynthesizeSpeechStreamMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof speechSynthesizeSpeechStream>>,
  TError,
  SpeechSynthesizeSpeechStreamMutationVariables,
  TContext
> => {
  return useMutation(getSpeechSynthesizeSpeechStreamMutationOptions(options));
};

export const speechRecognizeSpeech = (
  speechRecognizeSpeechBody?: SpeechRecognizeSpeechBodyOne | SpeechRecognizeSpeechBodyTwo,
  params?: SpeechRecognizeSpeechParams,
  signal?: AbortSignal
) => {
  return customAxiosInstance<string>({
    url: `/api/Speech/RecognizeSpeech/stt`,
    method: 'POST',
    data: speechRecognizeSpeechBody,
    params,
    signal
  });
};

export const getSpeechRecognizeSpeechMutationKey = () => ['speechRecognizeSpeech'] as const;

export const getSpeechRecognizeSpeechMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof speechRecognizeSpeech>>,
    TError,
    SpeechRecognizeSpeechMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof speechRecognizeSpeech>>,
  TError,
  SpeechRecognizeSpeechMutationVariables,
  TContext
> => {
  const mutationKey = getSpeechRecognizeSpeechMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof speechRecognizeSpeech>>,
    SpeechRecognizeSpeechMutationVariables
  > = (props) => {
    const { data, params } = props ?? {};

    return speechRecognizeSpeech(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type SpeechRecognizeSpeechMutationResult = NonNullable<Awaited<ReturnType<typeof speechRecognizeSpeech>>>;
export type SpeechRecognizeSpeechMutationBody = SpeechRecognizeSpeechBodyOne | SpeechRecognizeSpeechBodyTwo | undefined;
export type SpeechRecognizeSpeechMutationError = unknown;
export type SpeechRecognizeSpeechMutationVariables = {
  data?: SpeechRecognizeSpeechBodyOne | SpeechRecognizeSpeechBodyTwo;
  params?: SpeechRecognizeSpeechParams;
};

export const useSpeechRecognizeSpeech = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof speechRecognizeSpeech>>,
    TError,
    SpeechRecognizeSpeechMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof speechRecognizeSpeech>>,
  TError,
  SpeechRecognizeSpeechMutationVariables,
  TContext
> => {
  return useMutation(getSpeechRecognizeSpeechMutationOptions(options));
};

export const speechGetVoiceList = (signal?: AbortSignal) => {
  return customAxiosInstance<Speaker[]>({ url: `/api/Speech/GetVoiceList/voices`, method: 'GET', signal });
};

export const getSpeechGetVoiceListQueryKey = () => {
  return [`/api/Speech/GetVoiceList/voices`] as const;
};

export const getSpeechGetVoiceListQueryOptions = <
  TData = Awaited<ReturnType<typeof speechGetVoiceList>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof speechGetVoiceList>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSpeechGetVoiceListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof speechGetVoiceList>>> = ({ signal }) =>
    speechGetVoiceList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof speechGetVoiceList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SpeechGetVoiceListQueryResult = NonNullable<Awaited<ReturnType<typeof speechGetVoiceList>>>;
export type SpeechGetVoiceListQueryError = unknown;

export function useSpeechGetVoiceList<
  TData = Awaited<ReturnType<typeof speechGetVoiceList>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof speechGetVoiceList>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSpeechGetVoiceListQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const summaryUpdateSummary = (summaryRequestDto?: SummaryRequestDto, signal?: AbortSignal) => {
  return customAxiosInstance<SummaryDto>({
    url: `/api/Summary`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: summaryRequestDto,
    signal
  });
};

export const getSummaryUpdateSummaryMutationKey = () => ['summaryUpdateSummary'] as const;

export const getSummaryUpdateSummaryMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof summaryUpdateSummary>>,
    TError,
    SummaryUpdateSummaryMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof summaryUpdateSummary>>,
  TError,
  SummaryUpdateSummaryMutationVariables,
  TContext
> => {
  const mutationKey = getSummaryUpdateSummaryMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof summaryUpdateSummary>>,
    SummaryUpdateSummaryMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return summaryUpdateSummary(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SummaryUpdateSummaryMutationResult = NonNullable<Awaited<ReturnType<typeof summaryUpdateSummary>>>;
export type SummaryUpdateSummaryMutationBody = SummaryRequestDto | undefined;
export type SummaryUpdateSummaryMutationError = unknown;
export type SummaryUpdateSummaryMutationVariables = { data?: SummaryRequestDto };

export const useSummaryUpdateSummary = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof summaryUpdateSummary>>,
    TError,
    SummaryUpdateSummaryMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof summaryUpdateSummary>>,
  TError,
  SummaryUpdateSummaryMutationVariables,
  TContext
> => {
  return useMutation(getSummaryUpdateSummaryMutationOptions(options));
};

export const summaryGetSummary = (simulationId: number, signal?: AbortSignal) => {
  return customAxiosInstance<SummaryDto>({ url: `/api/Summary/${simulationId}`, method: 'GET', signal });
};

export const getSummaryGetSummaryQueryKey = (simulationId: number) => {
  return [`/api/Summary/${simulationId}`] as const;
};

export const getSummaryGetSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof summaryGetSummary>>,
  TError = unknown
>(
  simulationId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof summaryGetSummary>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSummaryGetSummaryQueryKey(simulationId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof summaryGetSummary>>> = ({ signal }) =>
    summaryGetSummary(simulationId, signal);

  return {
    queryKey,
    queryFn,
    enabled: simulationId !== null && simulationId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof summaryGetSummary>>, TError, TData> & { queryKey: QueryKey };
};

export type SummaryGetSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof summaryGetSummary>>>;
export type SummaryGetSummaryQueryError = unknown;

export function useSummaryGetSummary<TData = Awaited<ReturnType<typeof summaryGetSummary>>, TError = unknown>(
  simulationId: number,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof summaryGetSummary>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSummaryGetSummaryQueryOptions(simulationId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const ttsAdminRefreshVoices = (signal?: AbortSignal) => {
  return customAxiosInstance<unknown>({ url: `/api/admin/tts/elevenlabs/refresh-voices`, method: 'POST', signal });
};

export const getTtsAdminRefreshVoicesMutationKey = () => ['ttsAdminRefreshVoices'] as const;

export const getTtsAdminRefreshVoicesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof ttsAdminRefreshVoices>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof ttsAdminRefreshVoices>>, TError, void, TContext> => {
  const mutationKey = getTtsAdminRefreshVoicesMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof ttsAdminRefreshVoices>>, void> = () => {
    return ttsAdminRefreshVoices();
  };

  return { mutationFn, ...mutationOptions };
};

export type TtsAdminRefreshVoicesMutationResult = NonNullable<Awaited<ReturnType<typeof ttsAdminRefreshVoices>>>;

export type TtsAdminRefreshVoicesMutationError = unknown;

export const useTtsAdminRefreshVoices = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof ttsAdminRefreshVoices>>, TError, void, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof ttsAdminRefreshVoices>>, TError, void, TContext> => {
  return useMutation(getTtsAdminRefreshVoicesMutationOptions(options));
};

export const twilioGetPhoneNumbers = (signal?: AbortSignal) => {
  return customAxiosInstance<TwilioPhoneNumberDto[]>({ url: `/api/Twilio/GetPhoneNumbers`, method: 'GET', signal });
};

export const getTwilioGetPhoneNumbersQueryKey = () => {
  return [`/api/Twilio/GetPhoneNumbers`] as const;
};

export const getTwilioGetPhoneNumbersQueryOptions = <
  TData = Awaited<ReturnType<typeof twilioGetPhoneNumbers>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof twilioGetPhoneNumbers>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwilioGetPhoneNumbersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twilioGetPhoneNumbers>>> = ({ signal }) =>
    twilioGetPhoneNumbers(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof twilioGetPhoneNumbers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TwilioGetPhoneNumbersQueryResult = NonNullable<Awaited<ReturnType<typeof twilioGetPhoneNumbers>>>;
export type TwilioGetPhoneNumbersQueryError = unknown;

export function useTwilioGetPhoneNumbers<
  TData = Awaited<ReturnType<typeof twilioGetPhoneNumbers>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof twilioGetPhoneNumbers>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getTwilioGetPhoneNumbersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const usageStatisticsStatistics = (usageStatisticsQuery?: UsageStatisticsQuery, signal?: AbortSignal) => {
  return customAxiosInstance<UsageStatisticsDto>({
    url: `/api/UsageStatistics/Statistics/statistics`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: usageStatisticsQuery,
    signal
  });
};

export const getUsageStatisticsStatisticsMutationKey = () => ['usageStatisticsStatistics'] as const;

export const getUsageStatisticsStatisticsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usageStatisticsStatistics>>,
    TError,
    UsageStatisticsStatisticsMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usageStatisticsStatistics>>,
  TError,
  UsageStatisticsStatisticsMutationVariables,
  TContext
> => {
  const mutationKey = getUsageStatisticsStatisticsMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usageStatisticsStatistics>>,
    UsageStatisticsStatisticsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return usageStatisticsStatistics(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsageStatisticsStatisticsMutationResult = NonNullable<
  Awaited<ReturnType<typeof usageStatisticsStatistics>>
>;
export type UsageStatisticsStatisticsMutationBody = UsageStatisticsQuery | undefined;
export type UsageStatisticsStatisticsMutationError = unknown;
export type UsageStatisticsStatisticsMutationVariables = { data?: UsageStatisticsQuery };

export const useUsageStatisticsStatistics = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usageStatisticsStatistics>>,
    TError,
    UsageStatisticsStatisticsMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof usageStatisticsStatistics>>,
  TError,
  UsageStatisticsStatisticsMutationVariables,
  TContext
> => {
  return useMutation(getUsageStatisticsStatisticsMutationOptions(options));
};

export const userGetUsers = (signal?: AbortSignal) => {
  return customAxiosInstance<UserDto[]>({ url: `/api/User/GetUsers/filter`, method: 'GET', signal });
};

export const getUserGetUsersQueryKey = () => {
  return [`/api/User/GetUsers/filter`] as const;
};

export const getUserGetUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof userGetUsers>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof userGetUsers>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserGetUsersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetUsers>>> = ({ signal }) => userGetUsers(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userGetUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UserGetUsersQueryResult = NonNullable<Awaited<ReturnType<typeof userGetUsers>>>;
export type UserGetUsersQueryError = unknown;

export function useUserGetUsers<TData = Awaited<ReturnType<typeof userGetUsers>>, TError = unknown>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof userGetUsers>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUserGetUsersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const userDeleteUser = (id: number, signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/User/DeleteUser/${id}`, method: 'DELETE', signal });
};

export const getUserDeleteUserMutationKey = () => ['userDeleteUser'] as const;

export const getUserDeleteUserMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userDeleteUser>>,
    TError,
    UserDeleteUserMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userDeleteUser>>,
  TError,
  UserDeleteUserMutationVariables,
  TContext
> => {
  const mutationKey = getUserDeleteUserMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof userDeleteUser>>, UserDeleteUserMutationVariables> = (
    props
  ) => {
    const { id } = props ?? {};

    return userDeleteUser(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserDeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof userDeleteUser>>>;

export type UserDeleteUserMutationError = unknown;
export type UserDeleteUserMutationVariables = { id: number };

export const useUserDeleteUser = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userDeleteUser>>,
    TError,
    UserDeleteUserMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof userDeleteUser>>,
  TError,
  UserDeleteUserMutationVariables,
  TContext
> => {
  return useMutation(getUserDeleteUserMutationOptions(options));
};

export const userDeleteUsers = (userDeleteUsersBody?: number[], signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/User/DeleteUsers/deleteUsers`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: userDeleteUsersBody,
    signal
  });
};

export const getUserDeleteUsersMutationKey = () => ['userDeleteUsers'] as const;

export const getUserDeleteUsersMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userDeleteUsers>>,
    TError,
    UserDeleteUsersMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userDeleteUsers>>,
  TError,
  UserDeleteUsersMutationVariables,
  TContext
> => {
  const mutationKey = getUserDeleteUsersMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof userDeleteUsers>>, UserDeleteUsersMutationVariables> = (
    props
  ) => {
    const { data } = props ?? {};

    return userDeleteUsers(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserDeleteUsersMutationResult = NonNullable<Awaited<ReturnType<typeof userDeleteUsers>>>;
export type UserDeleteUsersMutationBody = number[] | undefined;
export type UserDeleteUsersMutationError = unknown;
export type UserDeleteUsersMutationVariables = { data?: number[] };

export const useUserDeleteUsers = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userDeleteUsers>>,
    TError,
    UserDeleteUsersMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof userDeleteUsers>>,
  TError,
  UserDeleteUsersMutationVariables,
  TContext
> => {
  return useMutation(getUserDeleteUsersMutationOptions(options));
};

export const userCreateOrganizationInvitation = (
  createOrganizationInvitationCommand?: CreateOrganizationInvitationCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/User/CreateOrganizationInvitation/invite`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createOrganizationInvitationCommand,
    signal
  });
};

export const getUserCreateOrganizationInvitationMutationKey = () => ['userCreateOrganizationInvitation'] as const;

export const getUserCreateOrganizationInvitationMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userCreateOrganizationInvitation>>,
    TError,
    UserCreateOrganizationInvitationMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userCreateOrganizationInvitation>>,
  TError,
  UserCreateOrganizationInvitationMutationVariables,
  TContext
> => {
  const mutationKey = getUserCreateOrganizationInvitationMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userCreateOrganizationInvitation>>,
    UserCreateOrganizationInvitationMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return userCreateOrganizationInvitation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserCreateOrganizationInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof userCreateOrganizationInvitation>>
>;
export type UserCreateOrganizationInvitationMutationBody = CreateOrganizationInvitationCommand | undefined;
export type UserCreateOrganizationInvitationMutationError = unknown;
export type UserCreateOrganizationInvitationMutationVariables = { data?: CreateOrganizationInvitationCommand };

export const useUserCreateOrganizationInvitation = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userCreateOrganizationInvitation>>,
    TError,
    UserCreateOrganizationInvitationMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof userCreateOrganizationInvitation>>,
  TError,
  UserCreateOrganizationInvitationMutationVariables,
  TContext
> => {
  return useMutation(getUserCreateOrganizationInvitationMutationOptions(options));
};

export const userInviteMultipleUsers = (
  inviteMultipleUsersCommand?: InviteMultipleUsersCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/User/InviteMultipleUsers/inviteMultiple`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: inviteMultipleUsersCommand,
    signal
  });
};

export const getUserInviteMultipleUsersMutationKey = () => ['userInviteMultipleUsers'] as const;

export const getUserInviteMultipleUsersMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userInviteMultipleUsers>>,
    TError,
    UserInviteMultipleUsersMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userInviteMultipleUsers>>,
  TError,
  UserInviteMultipleUsersMutationVariables,
  TContext
> => {
  const mutationKey = getUserInviteMultipleUsersMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userInviteMultipleUsers>>,
    UserInviteMultipleUsersMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return userInviteMultipleUsers(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserInviteMultipleUsersMutationResult = NonNullable<Awaited<ReturnType<typeof userInviteMultipleUsers>>>;
export type UserInviteMultipleUsersMutationBody = InviteMultipleUsersCommand | undefined;
export type UserInviteMultipleUsersMutationError = unknown;
export type UserInviteMultipleUsersMutationVariables = { data?: InviteMultipleUsersCommand };

export const useUserInviteMultipleUsers = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userInviteMultipleUsers>>,
    TError,
    UserInviteMultipleUsersMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof userInviteMultipleUsers>>,
  TError,
  UserInviteMultipleUsersMutationVariables,
  TContext
> => {
  return useMutation(getUserInviteMultipleUsersMutationOptions(options));
};

export const userDeleteInvitation = (email: string, signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/User/DeleteInvitation/invitation/${email}`, method: 'DELETE', signal });
};

export const getUserDeleteInvitationMutationKey = () => ['userDeleteInvitation'] as const;

export const getUserDeleteInvitationMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userDeleteInvitation>>,
    TError,
    UserDeleteInvitationMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userDeleteInvitation>>,
  TError,
  UserDeleteInvitationMutationVariables,
  TContext
> => {
  const mutationKey = getUserDeleteInvitationMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userDeleteInvitation>>,
    UserDeleteInvitationMutationVariables
  > = (props) => {
    const { email } = props ?? {};

    return userDeleteInvitation(email);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserDeleteInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof userDeleteInvitation>>>;

export type UserDeleteInvitationMutationError = unknown;
export type UserDeleteInvitationMutationVariables = { email: string };

export const useUserDeleteInvitation = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userDeleteInvitation>>,
    TError,
    UserDeleteInvitationMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof userDeleteInvitation>>,
  TError,
  UserDeleteInvitationMutationVariables,
  TContext
> => {
  return useMutation(getUserDeleteInvitationMutationOptions(options));
};

export const userGetCurrentUser = (signal?: AbortSignal) => {
  return customAxiosInstance<UserDto>({ url: `/api/User/GetCurrentUser/current`, method: 'GET', signal });
};

export const getUserGetCurrentUserQueryKey = () => {
  return [`/api/User/GetCurrentUser/current`] as const;
};

export const getUserGetCurrentUserQueryOptions = <
  TData = Awaited<ReturnType<typeof userGetCurrentUser>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof userGetCurrentUser>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserGetCurrentUserQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetCurrentUser>>> = ({ signal }) =>
    userGetCurrentUser(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userGetCurrentUser>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UserGetCurrentUserQueryResult = NonNullable<Awaited<ReturnType<typeof userGetCurrentUser>>>;
export type UserGetCurrentUserQueryError = unknown;

export function useUserGetCurrentUser<
  TData = Awaited<ReturnType<typeof userGetCurrentUser>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof userGetCurrentUser>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUserGetCurrentUserQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const userGetTenants = (signal?: AbortSignal) => {
  return customAxiosInstance<TenantDto[]>({ url: `/api/User/GetTenants/tenants`, method: 'GET', signal });
};

export const getUserGetTenantsQueryKey = () => {
  return [`/api/User/GetTenants/tenants`] as const;
};

export const getUserGetTenantsQueryOptions = <
  TData = Awaited<ReturnType<typeof userGetTenants>>,
  TError = unknown
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof userGetTenants>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserGetTenantsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetTenants>>> = ({ signal }) => userGetTenants(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userGetTenants>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UserGetTenantsQueryResult = NonNullable<Awaited<ReturnType<typeof userGetTenants>>>;
export type UserGetTenantsQueryError = unknown;

export function useUserGetTenants<TData = Awaited<ReturnType<typeof userGetTenants>>, TError = unknown>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof userGetTenants>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUserGetTenantsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const userGroupGet = (params?: UserGroupGetParams, signal?: AbortSignal) => {
  return customAxiosInstance<PartialListUserGroupDto>({ url: `/api/UserGroup/Get`, method: 'GET', params, signal });
};

export const getUserGroupGetQueryKey = (params?: UserGroupGetParams) => {
  return [`/api/UserGroup/Get`, ...(params ? [params] : [])] as const;
};

export const getUserGroupGetQueryOptions = <TData = Awaited<ReturnType<typeof userGroupGet>>, TError = unknown>(
  params?: UserGroupGetParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof userGroupGet>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserGroupGetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userGroupGet>>> = ({ signal }) => userGroupGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userGroupGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UserGroupGetQueryResult = NonNullable<Awaited<ReturnType<typeof userGroupGet>>>;
export type UserGroupGetQueryError = unknown;

export function useUserGroupGet<TData = Awaited<ReturnType<typeof userGroupGet>>, TError = unknown>(
  params?: UserGroupGetParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof userGroupGet>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUserGroupGetQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const userGroupCreate = (createUserGroupCommand?: CreateUserGroupCommand, signal?: AbortSignal) => {
  return customAxiosInstance<UserGroupDto>({
    url: `/api/UserGroup/Create`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: createUserGroupCommand,
    signal
  });
};

export const getUserGroupCreateMutationKey = () => ['userGroupCreate'] as const;

export const getUserGroupCreateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userGroupCreate>>,
    TError,
    UserGroupCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userGroupCreate>>,
  TError,
  UserGroupCreateMutationVariables,
  TContext
> => {
  const mutationKey = getUserGroupCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof userGroupCreate>>, UserGroupCreateMutationVariables> = (
    props
  ) => {
    const { data } = props ?? {};

    return userGroupCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserGroupCreateMutationResult = NonNullable<Awaited<ReturnType<typeof userGroupCreate>>>;
export type UserGroupCreateMutationBody = CreateUserGroupCommand | undefined;
export type UserGroupCreateMutationError = void;
export type UserGroupCreateMutationVariables = { data?: CreateUserGroupCommand };

export const useUserGroupCreate = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userGroupCreate>>,
    TError,
    UserGroupCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof userGroupCreate>>,
  TError,
  UserGroupCreateMutationVariables,
  TContext
> => {
  return useMutation(getUserGroupCreateMutationOptions(options));
};

export const userGroupUpdate = (
  groupId: number,
  updateUserGroupCommand?: UpdateUserGroupCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<UserGroupDto>({
    url: `/api/UserGroup/Update/${groupId}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateUserGroupCommand,
    signal
  });
};

export const getUserGroupUpdateMutationKey = () => ['userGroupUpdate'] as const;

export const getUserGroupUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userGroupUpdate>>,
    TError,
    UserGroupUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userGroupUpdate>>,
  TError,
  UserGroupUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getUserGroupUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof userGroupUpdate>>, UserGroupUpdateMutationVariables> = (
    props
  ) => {
    const { groupId, data } = props ?? {};

    return userGroupUpdate(groupId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserGroupUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof userGroupUpdate>>>;
export type UserGroupUpdateMutationBody = UpdateUserGroupCommand | undefined;
export type UserGroupUpdateMutationError = unknown;
export type UserGroupUpdateMutationVariables = { groupId: number; data?: UpdateUserGroupCommand };

export const useUserGroupUpdate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userGroupUpdate>>,
    TError,
    UserGroupUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof userGroupUpdate>>,
  TError,
  UserGroupUpdateMutationVariables,
  TContext
> => {
  return useMutation(getUserGroupUpdateMutationOptions(options));
};

export const userGroupAddUsers = (
  groupId: number,
  addUsersToGroupCommand?: AddUsersToGroupCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<UserGroupDto>({
    url: `/api/UserGroup/AddUsers/${groupId}/users`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: addUsersToGroupCommand,
    signal
  });
};

export const getUserGroupAddUsersMutationKey = () => ['userGroupAddUsers'] as const;

export const getUserGroupAddUsersMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userGroupAddUsers>>,
    TError,
    UserGroupAddUsersMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userGroupAddUsers>>,
  TError,
  UserGroupAddUsersMutationVariables,
  TContext
> => {
  const mutationKey = getUserGroupAddUsersMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userGroupAddUsers>>,
    UserGroupAddUsersMutationVariables
  > = (props) => {
    const { groupId, data } = props ?? {};

    return userGroupAddUsers(groupId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserGroupAddUsersMutationResult = NonNullable<Awaited<ReturnType<typeof userGroupAddUsers>>>;
export type UserGroupAddUsersMutationBody = AddUsersToGroupCommand | undefined;
export type UserGroupAddUsersMutationError = unknown;
export type UserGroupAddUsersMutationVariables = { groupId: number; data?: AddUsersToGroupCommand };

export const useUserGroupAddUsers = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userGroupAddUsers>>,
    TError,
    UserGroupAddUsersMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof userGroupAddUsers>>,
  TError,
  UserGroupAddUsersMutationVariables,
  TContext
> => {
  return useMutation(getUserGroupAddUsersMutationOptions(options));
};

export const userGroupDeleteUsers = (
  groupId: number,
  deleteUsersFromGroupCommand?: DeleteUsersFromGroupCommand,
  signal?: AbortSignal
) => {
  return customAxiosInstance<void>({
    url: `/api/UserGroup/DeleteUsers/${groupId}/users`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: deleteUsersFromGroupCommand,
    signal
  });
};

export const getUserGroupDeleteUsersMutationKey = () => ['userGroupDeleteUsers'] as const;

export const getUserGroupDeleteUsersMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userGroupDeleteUsers>>,
    TError,
    UserGroupDeleteUsersMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userGroupDeleteUsers>>,
  TError,
  UserGroupDeleteUsersMutationVariables,
  TContext
> => {
  const mutationKey = getUserGroupDeleteUsersMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userGroupDeleteUsers>>,
    UserGroupDeleteUsersMutationVariables
  > = (props) => {
    const { groupId, data } = props ?? {};

    return userGroupDeleteUsers(groupId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserGroupDeleteUsersMutationResult = NonNullable<Awaited<ReturnType<typeof userGroupDeleteUsers>>>;
export type UserGroupDeleteUsersMutationBody = DeleteUsersFromGroupCommand | undefined;
export type UserGroupDeleteUsersMutationError = unknown;
export type UserGroupDeleteUsersMutationVariables = { groupId: number; data?: DeleteUsersFromGroupCommand };

export const useUserGroupDeleteUsers = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userGroupDeleteUsers>>,
    TError,
    UserGroupDeleteUsersMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof userGroupDeleteUsers>>,
  TError,
  UserGroupDeleteUsersMutationVariables,
  TContext
> => {
  return useMutation(getUserGroupDeleteUsersMutationOptions(options));
};

export const userGroupDeleteGroups = (deleteUserGroupCommand?: DeleteUserGroupCommand, signal?: AbortSignal) => {
  return customAxiosInstance<void>({
    url: `/api/UserGroup/DeleteGroups`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: deleteUserGroupCommand,
    signal
  });
};

export const getUserGroupDeleteGroupsMutationKey = () => ['userGroupDeleteGroups'] as const;

export const getUserGroupDeleteGroupsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userGroupDeleteGroups>>,
    TError,
    UserGroupDeleteGroupsMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userGroupDeleteGroups>>,
  TError,
  UserGroupDeleteGroupsMutationVariables,
  TContext
> => {
  const mutationKey = getUserGroupDeleteGroupsMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userGroupDeleteGroups>>,
    UserGroupDeleteGroupsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return userGroupDeleteGroups(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserGroupDeleteGroupsMutationResult = NonNullable<Awaited<ReturnType<typeof userGroupDeleteGroups>>>;
export type UserGroupDeleteGroupsMutationBody = DeleteUserGroupCommand | undefined;
export type UserGroupDeleteGroupsMutationError = unknown;
export type UserGroupDeleteGroupsMutationVariables = { data?: DeleteUserGroupCommand };

export const useUserGroupDeleteGroups = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userGroupDeleteGroups>>,
    TError,
    UserGroupDeleteGroupsMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof userGroupDeleteGroups>>,
  TError,
  UserGroupDeleteGroupsMutationVariables,
  TContext
> => {
  return useMutation(getUserGroupDeleteGroupsMutationOptions(options));
};

export const voicesGetVoice = (id: string, signal?: AbortSignal) => {
  return customAxiosInstance<string>({ url: `/api/Voices/GetVoice/${id}`, method: 'GET', signal });
};

export const getVoicesGetVoiceQueryKey = (id: string) => {
  return [`/api/Voices/GetVoice/${id}`] as const;
};

export const getVoicesGetVoiceQueryOptions = <TData = Awaited<ReturnType<typeof voicesGetVoice>>, TError = unknown>(
  id: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof voicesGetVoice>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getVoicesGetVoiceQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof voicesGetVoice>>> = ({ signal }) => voicesGetVoice(id, signal);

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof voicesGetVoice>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type VoicesGetVoiceQueryResult = NonNullable<Awaited<ReturnType<typeof voicesGetVoice>>>;
export type VoicesGetVoiceQueryError = unknown;

export function useVoicesGetVoice<TData = Awaited<ReturnType<typeof voicesGetVoice>>, TError = unknown>(
  id: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof voicesGetVoice>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getVoicesGetVoiceQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const voicesDeleteVoice = (id: string, signal?: AbortSignal) => {
  return customAxiosInstance<void>({ url: `/api/Voices/DeleteVoice/${id}`, method: 'DELETE', signal });
};

export const getVoicesDeleteVoiceMutationKey = () => ['voicesDeleteVoice'] as const;

export const getVoicesDeleteVoiceMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof voicesDeleteVoice>>,
    TError,
    VoicesDeleteVoiceMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof voicesDeleteVoice>>,
  TError,
  VoicesDeleteVoiceMutationVariables,
  TContext
> => {
  const mutationKey = getVoicesDeleteVoiceMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof voicesDeleteVoice>>,
    VoicesDeleteVoiceMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return voicesDeleteVoice(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type VoicesDeleteVoiceMutationResult = NonNullable<Awaited<ReturnType<typeof voicesDeleteVoice>>>;

export type VoicesDeleteVoiceMutationError = unknown;
export type VoicesDeleteVoiceMutationVariables = { id: string };

export const useVoicesDeleteVoice = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof voicesDeleteVoice>>,
    TError,
    VoicesDeleteVoiceMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof voicesDeleteVoice>>,
  TError,
  VoicesDeleteVoiceMutationVariables,
  TContext
> => {
  return useMutation(getVoicesDeleteVoiceMutationOptions(options));
};
